// This file is generated by scripts/build_hiring_contacts_dataset.py
// Do not edit it by hand.

export const HIRING_CONTACTS_DATA = [
  {
    "firstName": "A",
    "lastName": "K",
    "url": "https://www.linkedin.com/in/a-k-a9925920b",
    "company": "Terrabit Consulting",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "A. Soledad",
    "lastName": "Godoy",
    "url": "https://www.linkedin.com/in/asoledadgodoy",
    "company": "Galicia Seguros",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Abdi Ezbai",
    "lastName": "Bernal",
    "url": "https://www.linkedin.com/in/abdi-ezbai-bernal",
    "company": "InfoVision Inc.",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Abigail",
    "lastName": "Sehnem Lima",
    "url": "https://www.linkedin.com/in/abi-s-lima",
    "company": "Paired",
    "position": "Senior Global Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Abigail",
    "lastName": "Suárez",
    "url": "https://www.linkedin.com/in/abiesm",
    "company": "Capgemini",
    "position": "Talent Acquisition Business Partner",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Abril",
    "lastName": "Baranovich",
    "url": "https://www.linkedin.com/in/abril-baranovich-90188b14a",
    "company": "Callao",
    "position": "People Partner Analyst",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Abril",
    "lastName": "Dipace",
    "url": "https://www.linkedin.com/in/abril-dipace-4704bb136",
    "company": "CFOTech",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Abril",
    "lastName": "Marzilli",
    "url": "https://www.linkedin.com/in/abrilmarzilli",
    "company": "ESAB South America",
    "position": "Talent Acquisition & Development Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Adam",
    "lastName": "Chabaa",
    "url": "https://www.linkedin.com/in/adam-chabaa",
    "company": "NTT DATA",
    "position": "HR & Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Adam",
    "lastName": "Nasimoff",
    "url": "https://www.linkedin.com/in/nasimoff",
    "company": "Tecton",
    "position": "Talent Ops Specialist & Sourcing Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Adela",
    "lastName": "Czysz",
    "url": "https://www.linkedin.com/in/adela-czysz-21a9a7149",
    "company": "Caravelo",
    "position": "People Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Adolyimar",
    "lastName": "Petit",
    "url": "https://www.linkedin.com/in/adolyimarpetit-recruiterit",
    "company": "Amedia",
    "position": "Recruitment Sourcing Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Adrian",
    "lastName": "Hillebrand",
    "url": "https://www.linkedin.com/in/adrian-hillebrand",
    "company": "Profesional independiente",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Adrian",
    "lastName": "Moreno",
    "url": "https://www.linkedin.com/in/adrian-moreno-179a8654",
    "company": "Microsoft",
    "position": "HR Service Line Manager (Offboarding & External Staff Operations",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Adriana",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/psicologaadrianagarcia",
    "company": "Connaxis Talent Solutions",
    "position": "Business Unit Lead – Talent Solutions | Connaxis",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Adriana (Adi)",
    "lastName": "Blanco",
    "url": "https://www.linkedin.com/in/adicca",
    "company": "Payoneer",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Advisory Capital",
    "lastName": "RRHH",
    "url": "https://www.linkedin.com/in/advisorycapitalrecursoshumanos",
    "company": "Clickittech Consulting Services SC",
    "position": "Senior Human Resources Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agostina",
    "lastName": "Anelli",
    "url": "https://www.linkedin.com/in/agostina-anelli-82a685239",
    "company": "Solvo Global",
    "position": "Talent Acquisition Leader - LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agostina",
    "lastName": "Bazzolo",
    "url": "https://www.linkedin.com/in/agostina-bazzolo",
    "company": "La Agrícola Regional Coop Ltda",
    "position": "Analista en Selección y Desarrollo",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Agostina",
    "lastName": "Cabrini",
    "url": "https://www.linkedin.com/in/agostina-cabrini-9a445b164",
    "company": "Techunting.net",
    "position": "Talent Acquisition Manager | Culture & People Experience",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agostina",
    "lastName": "Grayeb",
    "url": "https://www.linkedin.com/in/agostina-grayeb-",
    "company": "Remotely.works",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Agostina",
    "lastName": "Lucentini",
    "url": "https://www.linkedin.com/in/agostinalucentini",
    "company": "PwC Argentina",
    "position": "Senior Associate Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agostina",
    "lastName": "Marassa",
    "url": "https://www.linkedin.com/in/agostina-marassa",
    "company": "Solvo Global",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Bacchini",
    "url": "https://www.linkedin.com/in/agustin-bacchini-958080b8",
    "company": "Applicant - IT Talent Management",
    "position": "IT Recruiter - Talent Manager",
    "keywords": [
      "recruiter",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Bellini",
    "url": "https://www.linkedin.com/in/agustinbelliniit",
    "company": "OneSeven Tech (OST)",
    "position": "Sr. IT Recruiter | Growth & Strategic Sales Partner",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Cenizo",
    "url": "https://www.linkedin.com/in/agustin-cenizo-332839208",
    "company": "G&L Group",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Coscia",
    "url": "https://www.linkedin.com/in/aguscoscia",
    "company": "Poincenot",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Damiani",
    "url": "https://www.linkedin.com/in/agustin-damiani-7771a7a0",
    "company": "Empirical LLC",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Maisonnave",
    "url": "https://www.linkedin.com/in/agustin-maisonnave-2a7baa119",
    "company": "TopNave",
    "position": "IT Recruiter | Global IT Positions",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Pirani",
    "url": "https://www.linkedin.com/in/piranialexisagustin",
    "company": "Ketos Delphin",
    "position": "Coordinador de Reclutamiento LATAM",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Rey",
    "url": "https://www.linkedin.com/in/agustin-rey-36aaa4a3",
    "company": "PLURALIT - Inclusive Technology",
    "position": "Talent Acquisition Specialist - IT Business",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Vergara Eyzaguirre",
    "url": "https://www.linkedin.com/in/agustin-vergara-eyzaguirre-8b219816a",
    "company": "Buk",
    "position": "Head of People Strategy",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Agustin",
    "lastName": "Weich",
    "url": "https://www.linkedin.com/in/agustinweich",
    "company": "Lana Talent",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustin Nahuel",
    "lastName": "Dana",
    "url": "https://www.linkedin.com/in/agustinnahueldana",
    "company": "Centro Médico Integral Fitz Roy",
    "position": "HRBP / Labor Relations",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Adrogue",
    "url": "https://www.linkedin.com/in/agustinaadrogue",
    "company": "Knight Therapeutics Argentina",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "B.",
    "url": "https://www.linkedin.com/in/agustinablengino",
    "company": "Freelance (Self employed)",
    "position": "IT Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Barron",
    "url": "https://www.linkedin.com/in/agustinabarron",
    "company": "GlobalLogic Latinoamerica",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Bezek",
    "url": "https://www.linkedin.com/in/agustinabezek",
    "company": "Softtek",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Blasi",
    "url": "https://www.linkedin.com/in/agustinablasi60",
    "company": "CPIM",
    "position": "Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Breit",
    "url": "https://www.linkedin.com/in/agustinabreit",
    "company": "Zila Consulting",
    "position": "Selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Cabases",
    "url": "https://www.linkedin.com/in/agustina-cabases",
    "company": "Cloud(x);",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Calcagno",
    "url": "https://www.linkedin.com/in/agustina-calcagno-8a1976162",
    "company": "Galileo Financial Technologies",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Caldevilla",
    "url": "https://www.linkedin.com/in/agustina-caldevilla-3871a5a3",
    "company": "Growen HR",
    "position": "Founder | Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Chichizola",
    "url": "https://www.linkedin.com/in/agustina-chichizola-83884252",
    "company": "Endava",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Coluccio",
    "url": "https://www.linkedin.com/in/agustinacoluccio",
    "company": "Distillery",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Copello",
    "url": "https://www.linkedin.com/in/agustina-copello-7b7b5842",
    "company": "Lumenalta",
    "position": "Senior Technical Recruiter @Lumenalta",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Correa",
    "url": "https://www.linkedin.com/in/agustina-correa-748036a6",
    "company": "ConecSI RH",
    "position": "IT Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Di Lelle",
    "url": "https://www.linkedin.com/in/agustina-di-lelle-159540138",
    "company": "Conexa",
    "position": "TA Coordinator & HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Fox (She/Her)",
    "url": "https://www.linkedin.com/in/agustina-lacoste",
    "company": "Kainos",
    "position": "Sr Workday Recruiter at Kainos (a Workday Partner) email: agustina.fox@kainos.com",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Gil",
    "url": "https://www.linkedin.com/in/maria-agustina-gil",
    "company": "CFOTech",
    "position": "Talent Acquisition Ssr",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Godoy",
    "url": "https://www.linkedin.com/in/agustinagodoy210",
    "company": "Mercado Libre",
    "position": "Talent Acquisition Regional IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Goldemberg",
    "url": "https://www.linkedin.com/in/agustinagoldemberg",
    "company": "Athyna",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Gutierrez",
    "url": "https://www.linkedin.com/in/agustina-gutierrez-it-recruiter",
    "company": "Garli",
    "position": "IT Recruitment and Institutional Psychology",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Huarte",
    "url": "https://www.linkedin.com/in/agustina-huarte-0a051a1b2",
    "company": "Raona",
    "position": "People & Culture - Talent Acquisition and Development Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Jorcin",
    "url": "https://www.linkedin.com/in/agustina-jorcin",
    "company": "Gambito",
    "position": "Head of People Care & Talent",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Lanza",
    "url": "https://www.linkedin.com/in/agustina-lanza",
    "company": "ARCOS LLC",
    "position": "Senior Technical Recruiter (via SecureVision)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Larrosa",
    "url": "https://www.linkedin.com/in/agustina-larrosa",
    "company": "hireLander",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Lazzaro",
    "url": "https://www.linkedin.com/in/agustinalazzaro",
    "company": "Mercado Libre",
    "position": "People Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Lemucchi",
    "url": "https://www.linkedin.com/in/agustina-lemucchi",
    "company": "deRecruiters.com",
    "position": "Tech Recruiter Sr",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Loyola",
    "url": "https://www.linkedin.com/in/agustinaloyola11",
    "company": "SQUIRE",
    "position": "Sr. Recruiter & ARG Country Manager",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Martinez Lezcano",
    "url": "https://www.linkedin.com/in/fabiaagustinamartinez",
    "company": "MatchTalent",
    "position": "Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Martinez Noseda",
    "url": "https://www.linkedin.com/in/agustinamartineznoseda",
    "company": "Ximple Human Resources",
    "position": "Recruiting Analyst/ Recruiter",
    "keywords": [
      "recruiter",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Miner",
    "url": "https://www.linkedin.com/in/agustina-miner-b0b4a967",
    "company": "Mercado Libre",
    "position": "Talent Acquisition IT & Product Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Miralles",
    "url": "https://www.linkedin.com/in/agustina-miralles",
    "company": "Accenture",
    "position": "Recruiting Analyst | RPO BU&Staff México | Client: Mercado Libre",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Novo",
    "url": "https://www.linkedin.com/in/agustinanovo",
    "company": "Prediktive",
    "position": "Talent Acquisition Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Pintor",
    "url": "https://www.linkedin.com/in/agustinapintor",
    "company": "Accenture Argentina",
    "position": "Recruiting Senior Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Rodriguez Caivano",
    "url": "https://www.linkedin.com/in/agustinarodriguezcaivano",
    "company": "Accenture",
    "position": "HR Business Partner / Talent Strategy Manager",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Saavedra",
    "url": "https://www.linkedin.com/in/agustina-belen-saavedra-peralta",
    "company": "PinApp",
    "position": "Recruiter It",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Tacchini",
    "url": "https://www.linkedin.com/in/agustina-tacchini",
    "company": "GlobalLogic",
    "position": "Talent Acquisition Analyst SSR at GlobalLogic",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Taddeo",
    "url": "https://www.linkedin.com/in/agustina-taddeo",
    "company": "BullMetrix",
    "position": "Sr People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Agustina",
    "lastName": "Tálamo",
    "url": "https://www.linkedin.com/in/agustina-t%C3%A1lamo-78b55a5a",
    "company": "Mercado Libre",
    "position": "Regional Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina Abril",
    "lastName": "Marcico",
    "url": "https://www.linkedin.com/in/agustina-abril-marcico-2887b1186",
    "company": "A FACTORY",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina B.",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/agustinabelengonz",
    "company": "GlobalTask",
    "position": "IT Recruiter & Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustina G.",
    "lastName": "Mannella",
    "url": "https://www.linkedin.com/in/agustina-mannella",
    "company": "Hutrit",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Agustina Micaela",
    "lastName": "Navarro",
    "url": "https://www.linkedin.com/in/agustina-micaela-navarro-a8826017a",
    "company": "Accenture",
    "position": "Procurement Operations - Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Agustina Rocio",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/agustinarociogonzalez",
    "company": "Acciona IT",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Agustín",
    "lastName": "Giardini",
    "url": "https://www.linkedin.com/in/agust%C3%ADn-giardini",
    "company": "Gather HR",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Agustín",
    "lastName": "Villarreal",
    "url": "https://www.linkedin.com/in/agust%C3%ADn-villarreal",
    "company": "Accenture Argentina",
    "position": "Recruiter Analyst",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ailin Belen",
    "lastName": "Dodero",
    "url": "https://www.linkedin.com/in/ailin-belen-dodero-40066877",
    "company": "Accenture Argentina",
    "position": "Recruiter Senior Analyst",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ailén",
    "lastName": "Simon",
    "url": "https://www.linkedin.com/in/ailensimon",
    "company": "GIGA IT",
    "position": "Talent Hub Associate Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Aina",
    "lastName": "Busquets Morera",
    "url": "https://www.linkedin.com/in/aina-busquets-morera-7482b6146",
    "company": "ISPROX",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Aira",
    "lastName": "Levaro",
    "url": "https://www.linkedin.com/in/aira-levaro",
    "company": "Workera Contracting",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Aixa",
    "lastName": "Silva",
    "url": "https://www.linkedin.com/in/aixasilva23",
    "company": "Ketos Delphin",
    "position": "Recrutier IT/Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alan",
    "lastName": "Caminetsky",
    "url": "https://www.linkedin.com/in/alancaminetsky",
    "company": "Autónomo",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alan",
    "lastName": "Castro",
    "url": "https://www.linkedin.com/in/castala",
    "company": "BA TECHNOLOGIES- IT solutions/Staff Augmentation",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alan",
    "lastName": "Ojeda",
    "url": "https://www.linkedin.com/in/alan-ojeda-6071221bb",
    "company": "DevSavant",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Albertina",
    "lastName": "Arla",
    "url": "https://www.linkedin.com/in/albertina-arla",
    "company": "Globant",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alberto",
    "lastName": "Villa Segura",
    "url": "https://www.linkedin.com/in/alberto-villa-segura-460870214",
    "company": "IT Talent Recruiters",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Aldana",
    "lastName": "Alvarenga",
    "url": "https://www.linkedin.com/in/aldana-alvarenga-387242140",
    "company": "aliantec",
    "position": "IT Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Aldana",
    "lastName": "Correa",
    "url": "https://www.linkedin.com/in/aldanacorrea",
    "company": "Proper AI",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Aldana",
    "lastName": "Larretchart⚡",
    "url": "https://www.linkedin.com/in/aldana-larretchart-agroselecciondepersonal",
    "company": "Redes Rurales",
    "position": "Selección de personal agropecuario | Reclutamiento de personal agropecuario",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Aldana",
    "lastName": "Paoltroni",
    "url": "https://www.linkedin.com/in/aldana-paoltroni",
    "company": "Osana Salud",
    "position": "Talent Partner & People Operations Lead (IC)",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Aldana",
    "lastName": "Vacirca",
    "url": "https://www.linkedin.com/in/aldana-vacirca-ba20a31b9",
    "company": "EPAM Systems",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Aldo",
    "lastName": "Caneppa Sepulveda",
    "url": "https://www.linkedin.com/in/aldocaneppas",
    "company": "Nisum Latam",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Aldo",
    "lastName": "Flores Flores",
    "url": "https://www.linkedin.com/in/afloresf",
    "company": "Independiente / Freelance",
    "position": "Senior IT Recruiter | Executive Search (Freelance | Híbrido)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Aldo",
    "lastName": "Ruiz",
    "url": "https://www.linkedin.com/in/aldo-ruiz-a78b0468",
    "company": "Profesional independiente",
    "position": "Técnica de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Arango García",
    "url": "https://www.linkedin.com/in/alejandraarango-empleabilidad",
    "company": "TECLA",
    "position": "Recruiter @Tecla | Hiring the Best Talent in LATAM 🚀",
    "keywords": [
      "recruiter",
      "hiring"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Calivar",
    "url": "https://www.linkedin.com/in/alejandra-calivar",
    "company": "TGV",
    "position": "IT Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Deluca",
    "url": "https://www.linkedin.com/in/madeluca",
    "company": "Baja Nearshore",
    "position": "Professional Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Echenique",
    "url": "https://www.linkedin.com/in/alejandra-echenique-b656b7b1",
    "company": "Kopius, Inc.",
    "position": "Technical Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/alejandra-fernandez-rrhh",
    "company": "Talento Capital Humano - Argentina",
    "position": "IT Recruiter / Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Giménez",
    "url": "https://www.linkedin.com/in/alejandra-gim%C3%A9nez-33aa9221b",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Goldstein",
    "url": "https://www.linkedin.com/in/alejandra-goldstein-89731556",
    "company": "Newsan",
    "position": "HR Head Unidad de Negocio Consumo Masivo / Head Talento, Desarrollo, Clima y Cultura Grupo Newsan",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Goncalvez",
    "url": "https://www.linkedin.com/in/psicologa-alejandra-goncalvez",
    "company": "Facultad de Ciencias Económicas del Rosario UCA",
    "position": "Adjunct Professor – Talent Acquisition & Selection",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Guillén",
    "url": "https://www.linkedin.com/in/alejndraguillen",
    "company": "Applaudo",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Hernando",
    "url": "https://www.linkedin.com/in/alejandra-hernando",
    "company": "mindset",
    "position": "Sr IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Londoño",
    "url": "https://www.linkedin.com/in/alejandra-londo%C3%B1o-48a106275",
    "company": "Temple family health",
    "position": "Talent sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "M.",
    "url": "https://www.linkedin.com/in/alejandra-m-92069a1a4",
    "company": "Binaia by Bosonit",
    "position": "IT Recruiter & Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Manrique",
    "url": "https://www.linkedin.com/in/maalemanrique",
    "company": "Encora Inc.",
    "position": "Talent Acquisition Coordinator - Central & South America",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Marín",
    "url": "https://www.linkedin.com/in/alerecruiter",
    "company": "Insight Assurance",
    "position": "Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Miranda",
    "url": "https://www.linkedin.com/in/alejandra-miranda-58589656",
    "company": "Konecta",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Molina",
    "url": "https://www.linkedin.com/in/alemolinap",
    "company": "OpenDev Pro",
    "position": "Tech Recruiter | Selectora IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Mosquera",
    "url": "https://www.linkedin.com/in/alejandra-mosquera-74a1a6221",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Muschitiello",
    "url": "https://www.linkedin.com/in/alejandra-muschitiello",
    "company": "Alejandra Muschitiello",
    "position": "People Partner | Talento & Cultura | Consultora y Emprendedora",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Pedernera",
    "url": "https://www.linkedin.com/in/alejandra-pedernera",
    "company": "Independent Professional",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Pesallaccia",
    "url": "https://www.linkedin.com/in/alejandra-pesallaccia-225b7a144",
    "company": "MPA CONSULTORA",
    "position": "Talent Acquisition - IT Recruiter MPA CONSULTORA",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "R.",
    "url": "https://www.linkedin.com/in/a-a-r",
    "company": "Accenture",
    "position": "Global People Analytics Advisor Manager, I&D & V&A",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alejandra",
    "lastName": "Zolty",
    "url": "https://www.linkedin.com/in/alejandra-zolty-cofounder-headhunter-ipsumhr",
    "company": "IpsumHR",
    "position": "Co Founder & Expert Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alejandrina",
    "lastName": "Mourrut de Beauverger",
    "url": "https://www.linkedin.com/in/alejandrinamourrutdebeauverger",
    "company": "Plexus Tech",
    "position": "Technical Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandro",
    "lastName": "Allario",
    "url": "https://www.linkedin.com/in/alejandro-allario-37801a89",
    "company": "MPA Consultora",
    "position": "Talent Acquisition - IT Recruiter MPA CONSULTORA",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandro",
    "lastName": "Brollo",
    "url": "https://www.linkedin.com/in/alejandro-brollo-recruiting",
    "company": "Connectist",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandro",
    "lastName": "Castellote",
    "url": "https://www.linkedin.com/in/a-castellote",
    "company": "Serquo",
    "position": "HRBP | Talent & People Development | HR Analytics & Culture",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Alejandro",
    "lastName": "Condeme",
    "url": "https://www.linkedin.com/in/alecondeme",
    "company": "Korn Ferry",
    "position": "Talent Acquisition Expert at Bayer",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alejandro",
    "lastName": "Ferreira",
    "url": "https://www.linkedin.com/in/alejandro-fer",
    "company": "HomeTeam Network",
    "position": "Project Manager & Recruiting Operations",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alejandro",
    "lastName": "Label",
    "url": "https://www.linkedin.com/in/alejandro-label",
    "company": "PSh | Providing Digital Transformation",
    "position": "Recruiting & People Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Alejandro",
    "lastName": "Rubio",
    "url": "https://www.linkedin.com/in/alejandro-rubio",
    "company": "Alejandro Rubio RRHH",
    "position": "Headhunter & IT Recruiter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Alejandro",
    "lastName": "Treglia",
    "url": "https://www.linkedin.com/in/alejandro-treglia-",
    "company": "GRUPO CETROGAR",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Alejandro",
    "lastName": "Vela",
    "url": "https://www.linkedin.com/in/alejandro-vela-castro",
    "company": "Sutherland",
    "position": "Lead IT Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alejo",
    "lastName": "Dominguez",
    "url": "https://www.linkedin.com/in/alejo-dominguez-045a8978",
    "company": "itti",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alejo",
    "lastName": "Tudino",
    "url": "https://www.linkedin.com/in/alejotudino",
    "company": "Freelance",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Aleksandra",
    "lastName": "Gawda",
    "url": "https://www.linkedin.com/in/aleksandra-gawda-208183221",
    "company": "Tango",
    "position": "Global Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Aleksandra",
    "lastName": "Tarasova",
    "url": "https://www.linkedin.com/in/aleksandra-tarasova-recruiter",
    "company": "Группа компаний Орбита",
    "position": "Recruitment Consultant (Remote)",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Alena",
    "lastName": "Oitova",
    "url": "https://www.linkedin.com/in/alena-oitova-515b6b219",
    "company": "HRS Hospitality & Retail Systems",
    "position": "Senior IT-Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alena",
    "lastName": "Priluckaya",
    "url": "https://www.linkedin.com/in/alena-priluckaya-6a366a1b2",
    "company": "Basket Entertainment",
    "position": "HRBP/ Chief of Staff at the Saint Petersburg Office",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Alessandra",
    "lastName": "Huilca",
    "url": "https://www.linkedin.com/in/alessandra-h-81794a193",
    "company": "SEK - Security Ecosystem Knowledge | Hispanoamérica",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alessandra",
    "lastName": "Martínez Mercado",
    "url": "https://www.linkedin.com/in/alemartinezm",
    "company": "Improving",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alesya",
    "lastName": "Lyakh",
    "url": "https://www.linkedin.com/in/alesya-lyakh-37a8b5267",
    "company": "Personalinvest",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alex",
    "lastName": "Cedano",
    "url": "https://www.linkedin.com/in/alecedano",
    "company": "People and Talent Lab",
    "position": "Talent Acquisition | Career Optimization Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alex",
    "lastName": "D",
    "url": "https://www.linkedin.com/in/alex--d",
    "company": "Imperial Brands PLC",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alex",
    "lastName": "Dixon",
    "url": "https://www.linkedin.com/in/alex-dixon-controlhub",
    "company": "ControlHub",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alexandra",
    "lastName": "Bedoya Cass",
    "url": "https://www.linkedin.com/in/alexandra-bedoya7",
    "company": "Luflox LLC",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alexandra",
    "lastName": "Caragia",
    "url": "https://www.linkedin.com/in/alexandra-caragia",
    "company": "Lago Event Park",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alexandra",
    "lastName": "Flor Moron",
    "url": "https://www.linkedin.com/in/alexandra-flor-moron-44592019b",
    "company": "Resolute Solutions",
    "position": "Employment Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alexandra",
    "lastName": "Hernández",
    "url": "https://www.linkedin.com/in/alexandra-hernandez-itrecruiter",
    "company": "GOIAR",
    "position": "IT Recruitment Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alexia",
    "lastName": "Maldonado",
    "url": "https://www.linkedin.com/in/alexia-maldonado-271721274",
    "company": "Chelsea Labs",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alexis",
    "lastName": "Carril De Matthaeis",
    "url": "https://www.linkedin.com/in/alexis-carril-de-matthaeis",
    "company": "Capitole",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alexis",
    "lastName": "Hackl",
    "url": "https://www.linkedin.com/in/alexis-hackl-0302b9196",
    "company": "Mercado Libre",
    "position": "Regional Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alexis",
    "lastName": "Ricker",
    "url": "https://www.linkedin.com/in/alexisricker",
    "company": "Medtronic",
    "position": "Senior HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alexsandro",
    "lastName": "Robles Serradilla",
    "url": "https://www.linkedin.com/in/alexsandro-robles-serradilla",
    "company": "Logicalis Spain",
    "position": "Responsable Selección / Talento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Aleysant",
    "lastName": "Limon",
    "url": "https://www.linkedin.com/in/aleysant-limon-292303176",
    "company": "Toshiba Global Commerce Solutions",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alfonso",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/alfonsogarciac31",
    "company": "Apcon Consultoria",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alfonso",
    "lastName": "Medina",
    "url": "https://www.linkedin.com/in/alfonso-medina-53b427124",
    "company": "Stori",
    "position": "Sr Tech Recruiter / International Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alice",
    "lastName": "Doak",
    "url": "https://www.linkedin.com/in/alice-doak-2751bb222",
    "company": "torre.co",
    "position": "Senior Recruiting Advisor",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Alicia",
    "lastName": "Ritacco",
    "url": "https://www.linkedin.com/in/alicia-ritacco-58b38718",
    "company": "AR Consultora",
    "position": "Consultor en RRHH / Selección / Formación / Coach Ontológico",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Alicia",
    "lastName": "Sandra",
    "url": "https://www.linkedin.com/in/alicia-sandra-46877b16b",
    "company": "Paired",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alicia Mariela",
    "lastName": "Mogliani",
    "url": "https://www.linkedin.com/in/aliciamarielamogliani",
    "company": "Neginet",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alina",
    "lastName": "Astapova",
    "url": "https://www.linkedin.com/in/alina-astapova-149967212",
    "company": "TEAM International",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alina",
    "lastName": "N.",
    "url": "https://www.linkedin.com/in/alina-nv",
    "company": "SiliconMint",
    "position": "Recruitment Business Partner",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Alison",
    "lastName": "Rodríguez",
    "url": "https://www.linkedin.com/in/alison-rodr%C3%ADguez-7436571a7",
    "company": "Hitss México",
    "position": "Technical Recruiter Jr.",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alla",
    "lastName": "Zhorova",
    "url": "https://www.linkedin.com/in/allazhorova",
    "company": "Aventus Group",
    "position": "International Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Allison",
    "lastName": "Laguna maravi",
    "url": "https://www.linkedin.com/in/allison-laguna-maravi-747801166",
    "company": "QDS - Group",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Alma",
    "lastName": "Pedemonte",
    "url": "https://www.linkedin.com/in/alma-pedemonte-b1a0811ba",
    "company": "Accenture",
    "position": "Candidate Source & Screen Analyst Europe Talent Sourcing",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Alok",
    "lastName": "k",
    "url": "https://www.linkedin.com/in/alok-k-2619241a0",
    "company": "Epsilon Solutions Ltd.",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Alonso",
    "lastName": "Molina Godoy",
    "url": "https://www.linkedin.com/in/alonsomolina",
    "company": "CMPC",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Alvaro",
    "lastName": "Espinoza",
    "url": "https://www.linkedin.com/in/alvaro-espinoza-628241b4",
    "company": "Consultora KINGDOM",
    "position": "IT Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alvaro",
    "lastName": "Fernandez Rio",
    "url": "https://www.linkedin.com/in/alvarofernandezrio",
    "company": "PwC Argentina",
    "position": "Talent Acquisition Senior Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Alya",
    "lastName": "Nuruzzati",
    "url": "https://www.linkedin.com/in/alya-nuruzzati-35074b221",
    "company": "AMK Group",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Amalia",
    "lastName": "Budzinski",
    "url": "https://www.linkedin.com/in/amalia-budzinski-7a7b4618",
    "company": "Talent Centric - Metta Humana",
    "position": "Co-Founder & HR Advisor - Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Aman",
    "lastName": "Kumar",
    "url": "https://www.linkedin.com/in/aman-kumar-065854232",
    "company": "Epsilon Solutions Ltd. SA de CV.",
    "position": "Information Technology Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Amanda",
    "lastName": "Perez",
    "url": "https://www.linkedin.com/in/amanda-perez-57753294",
    "company": "INSPYR Solutions",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Amanda",
    "lastName": "Quintero",
    "url": "https://www.linkedin.com/in/amy-amandaquintero",
    "company": "Clear Tech",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Amanda",
    "lastName": "Robertson",
    "url": "https://www.linkedin.com/in/amanda-robertson-868756178",
    "company": "Specialized Bicycle Components",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Amilkan",
    "lastName": "Thiruchelvam",
    "url": "https://www.linkedin.com/in/amilkan-thiruchelvam-374169170",
    "company": "GeorgiaTEK Systems Inc.",
    "position": "Senior Technical Recruiter & Talent Consulting Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Amir",
    "lastName": "Abramovich",
    "url": "https://www.linkedin.com/in/amir-abramovich-hr",
    "company": "InnoIT Consulting",
    "position": "IT Sr. Talent Acquisition / Process Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Amir",
    "lastName": "Naim",
    "url": "https://www.linkedin.com/in/amir-naim-a8b207247",
    "company": "Dikshatek Malaysia",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Amita",
    "lastName": "Mishra",
    "url": "https://www.linkedin.com/in/amita-mishra-2207a",
    "company": "Skill Quotient",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Amna",
    "lastName": "Khan",
    "url": "https://www.linkedin.com/in/amna-khan-29417522a",
    "company": "Globhunter",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Amparo",
    "lastName": "Martinez",
    "url": "https://www.linkedin.com/in/amparo-martinez",
    "company": "Lithium",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "América",
    "lastName": "Castañeda Arrioja",
    "url": "https://www.linkedin.com/in/americastarrioja",
    "company": "Mars",
    "position": "Talent Acquisition Expert",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Alonzo",
    "url": "https://www.linkedin.com/in/anaisabel-alonzo",
    "company": "Allied Global Technology Services",
    "position": "IT Recruiter USA, LATAM, ASIA.",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Camino",
    "url": "https://www.linkedin.com/in/ana-valentina-camino",
    "company": "Allianz Technology",
    "position": "Talent Acquisition Partner - RPO",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Chirinos",
    "url": "https://www.linkedin.com/in/ana-chirinos",
    "company": "BEON.tech",
    "position": "Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Delgado de la Flor",
    "url": "https://www.linkedin.com/in/anadelgadodelaflor",
    "company": "Banco de Crédito BCP",
    "position": "Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Gregoret",
    "url": "https://www.linkedin.com/in/anagregoret",
    "company": "Qservices",
    "position": "Especialista en selección de personal informático",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Márquez",
    "url": "https://www.linkedin.com/in/ana-m%C3%A1rquez-ab96a6174",
    "company": "Newsan",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Nava",
    "url": "https://www.linkedin.com/in/anacarolinava25",
    "company": "Axxon Consulting",
    "position": "IT Recruiter | Talent Acquisition Analyst",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Pantano",
    "url": "https://www.linkedin.com/in/ana-pantano-8169b5b2",
    "company": "Zapp",
    "position": "Sr. Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Posada",
    "url": "https://www.linkedin.com/in/ana-posada-6a1a3866",
    "company": "Experis España",
    "position": "IT Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Quevedo",
    "url": "https://www.linkedin.com/in/analauraquevedo",
    "company": "Prosigliere",
    "position": "HR & Talent Acquisition Manager",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Rivera",
    "url": "https://www.linkedin.com/in/ana-rivera-402711224",
    "company": "Dev4IT",
    "position": "IT Recruiter | HR Advisor",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Tabanera",
    "url": "https://www.linkedin.com/in/anatabanera-mindithr",
    "company": "mindIT",
    "position": "Founder and Global IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Valera",
    "url": "https://www.linkedin.com/in/anavaleras",
    "company": "TELUS Digital",
    "position": "Talent Acquisition Specialist - Senior Talent Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Villagra",
    "url": "https://www.linkedin.com/in/ana-villagra-11118866",
    "company": "Nestlé",
    "position": "HRBS Recruitment Sr. Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ana",
    "lastName": "Wilverth (Ella/She/Her)",
    "url": "https://www.linkedin.com/in/ana-wilverth",
    "company": "Hire With Near",
    "position": "IT Talent Acquisition Advisor",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana Azul",
    "lastName": "Ledesma",
    "url": "https://www.linkedin.com/in/ana-azul-ledesma",
    "company": "BePartners",
    "position": "Recruiting Team Lead & HR Consultant",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ana Belén",
    "lastName": "Fernández",
    "url": "https://www.linkedin.com/in/ana-bel%C3%A9n-fern%C3%A1ndez-86b1a633",
    "company": "Bumeran Selecta",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ana Carolina",
    "lastName": "Petrucci Gonzalez",
    "url": "https://www.linkedin.com/in/ana-carolina-petrucci-gonzalez-9b422693",
    "company": "Wippie",
    "position": "IT Recruiter | Talent Acquisition IT | Tech Hiring | Recruiting end-to-end",
    "keywords": [
      "recruiter",
      "recruiting/recruitment",
      "talent acquisition",
      "hiring"
    ]
  },
  {
    "firstName": "Ana Carolina",
    "lastName": "Ruffo",
    "url": "https://www.linkedin.com/in/anacarolinaruffo",
    "company": "Grid Dynamics",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana Halina",
    "lastName": "Pyra",
    "url": "https://www.linkedin.com/in/ana-halina-pyra",
    "company": "Super",
    "position": "Tech Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana Ines",
    "lastName": "Larroude",
    "url": "https://www.linkedin.com/in/ana-ines-larroude-2089a595",
    "company": "People studio I language partner",
    "position": "Co-founder at peoplestudio.io I Recruiting I Language partner",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ana Inés",
    "lastName": "Costa",
    "url": "https://www.linkedin.com/in/ana-in%C3%A9s-costa",
    "company": "WPP Production",
    "position": "Senior Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana Laura",
    "lastName": "Barrionuevo",
    "url": "https://www.linkedin.com/in/ana-laura-barrionuevo-626661b3",
    "company": "Tiprome",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ana Laura",
    "lastName": "Ilardo",
    "url": "https://www.linkedin.com/in/analaurailardo",
    "company": "Phinx Lab",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Ana Lilia",
    "lastName": "Malfavón Olguín",
    "url": "https://www.linkedin.com/in/analiliamo",
    "company": "Praxis",
    "position": "Recruitment and Selection Leader",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ana Luisa",
    "lastName": "Cuevas López",
    "url": "https://www.linkedin.com/in/analuisacuevas",
    "company": "Terra",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ana Paula",
    "lastName": "Seltzer",
    "url": "https://www.linkedin.com/in/anapaulaseltzer",
    "company": "FLEX TECH Arg.",
    "position": "Head of Recruiting - Office Manager en FLEX TECH Arg. | Gestión de Talento y Cultura Organizacional",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Anabela",
    "lastName": "Quevedo",
    "url": "https://www.linkedin.com/in/anabela-quevedo-098b5a32",
    "company": "Contabilium",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Anabella",
    "lastName": "Davicino",
    "url": "https://www.linkedin.com/in/anabella-davicino-b4702a205",
    "company": "Consultora ConfiaRH",
    "position": "Reclutamiento y selección de Personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Anabella",
    "lastName": "Marini",
    "url": "https://www.linkedin.com/in/anabellamarini",
    "company": "Veralto",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Anabella",
    "lastName": "Pacheco Castillo",
    "url": "https://www.linkedin.com/in/anabella-pacheco-castillo",
    "company": "AUREN",
    "position": "Talent Acquisition | People Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Anabella",
    "lastName": "Paradisi",
    "url": "https://www.linkedin.com/in/anabella-paradisi",
    "company": "ZirconTech",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Anahi",
    "lastName": "Ariño",
    "url": "https://www.linkedin.com/in/anahi-ari%C3%B1o",
    "company": "AMA Stay",
    "position": "People and Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Anahi",
    "lastName": "Villamil",
    "url": "https://www.linkedin.com/in/anahi-villamil-643078b7",
    "company": "Grupo Abans",
    "position": "Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Analia",
    "lastName": "Ibanez",
    "url": "https://www.linkedin.com/in/aibanez",
    "company": "Pandit",
    "position": "RPO & Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Analia",
    "lastName": "Ramos",
    "url": "https://www.linkedin.com/in/analia-ramos",
    "company": "OfficeTwo",
    "position": "Hiring Manager",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Analia P.",
    "lastName": "Nogueira",
    "url": "https://www.linkedin.com/in/analia-p-nogueira-881a2392",
    "company": "Navent",
    "position": "HRBP (Tecnología&Producto + Comercial)",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Analía",
    "lastName": "Alvarez",
    "url": "https://www.linkedin.com/in/analiaveronicaalvarez",
    "company": "Acid Labs",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Analía",
    "lastName": "Segado",
    "url": "https://www.linkedin.com/in/anal%C3%ADa-segado-a38341228",
    "company": "Profesional independiente",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Anand",
    "lastName": "Waleski",
    "url": "https://www.linkedin.com/in/anand-waleski",
    "company": "AMK Group",
    "position": "Delivery & Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Anastasia",
    "lastName": "Havrylenko",
    "url": "https://www.linkedin.com/in/anastasia-h-041860214",
    "company": "Independent Consultant",
    "position": "Talent Acquisition Partner | Global Hiring Strategy",
    "keywords": [
      "talent acquisition",
      "hiring"
    ]
  },
  {
    "firstName": "Anastasia",
    "lastName": "Petrosyan",
    "url": "https://www.linkedin.com/in/anastasia-petrosyan-03b512208",
    "company": "Soshace",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Anastasia",
    "lastName": "Sidiakina",
    "url": "https://www.linkedin.com/in/anastasia-sidiakina",
    "company": "EasySoftGroup",
    "position": "IT Recruitment Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Anastasiia",
    "lastName": "Mekhonoshyna",
    "url": "https://www.linkedin.com/in/anastasiia-mekhonoshyna-887509197",
    "company": "Akvelon, Inc.",
    "position": "Recruitment Researcher",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Anastasiia",
    "lastName": "Vybyvanets",
    "url": "https://www.linkedin.com/in/anastasiia-vybyvanets-34018a1a3",
    "company": "TurnKey Tech Staffing",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Anastasiya",
    "lastName": "Sokolovskaya",
    "url": "https://www.linkedin.com/in/anastasiya-sokolovskaya-051603198",
    "company": "SiliconMint",
    "position": "Recruiting Sourcer",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Andina Febriana",
    "lastName": "Syahputri",
    "url": "https://www.linkedin.com/in/andina-febriana-syahputri-263596b3",
    "company": "ITCAN Pte Ltd",
    "position": "Talent Acquisition Specialist (SEA)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Acciardi",
    "url": "https://www.linkedin.com/in/andrea-acciardi",
    "company": "SIDOM",
    "position": "Talent & People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Albarracin Angel",
    "url": "https://www.linkedin.com/in/andreaalbarracinangel",
    "company": "SoftwareONE Colombia",
    "position": "Talent Acquisition Specialist/Psicologa de Atracción y Selección de Talentos",
    "keywords": [
      "talent acquisition",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Ayala",
    "url": "https://www.linkedin.com/in/andrea-ayala-93311653",
    "company": "aliantec",
    "position": "IT Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Beltrán Guevara",
    "url": "https://www.linkedin.com/in/andrea-beltr%C3%A1n-guevara-94591b65",
    "company": "Second Window",
    "position": "Head of People & Culture",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Carihua",
    "url": "https://www.linkedin.com/in/andrea-carihua-j",
    "company": "Consultor Independiente.",
    "position": "Consultora asociada / Headhunter freelance",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Catacho",
    "url": "https://www.linkedin.com/in/andrea-catacho",
    "company": "Sapphire Labs",
    "position": "People Ops Management l IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Escobar",
    "url": "https://www.linkedin.com/in/andrea-escobar-acevedo",
    "company": "micro1",
    "position": "Senior Human Data Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Fanelli",
    "url": "https://www.linkedin.com/in/andrea-f-654ba113b",
    "company": "MOOD Human Resources",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Flores",
    "url": "https://www.linkedin.com/in/andreafloresdelcarpio",
    "company": "TRM Labs",
    "position": "Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Guerra",
    "url": "https://www.linkedin.com/in/andreacgv",
    "company": "Strider",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Marotta",
    "url": "https://www.linkedin.com/in/andrea-marotta-acosta",
    "company": "Global66",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Martínez",
    "url": "https://www.linkedin.com/in/andrea-mart%C3%ADnez-aa453326b",
    "company": "Zipdev",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Oliveros",
    "url": "https://www.linkedin.com/in/andrea-oliveros",
    "company": "Accenture Argentina",
    "position": "Applicant Sourcer Analyst",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Palos",
    "url": "https://www.linkedin.com/in/andrea-palos-925845b5",
    "company": "Ventus Technology SA de CV",
    "position": "Sr IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Perfetti",
    "url": "https://www.linkedin.com/in/andrea-perfetti-aa32a3114",
    "company": "Streambe",
    "position": "People head IT | Desarrollo humano | Comunicación & cultura",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Ponce Carrera (She/Her)",
    "url": "https://www.linkedin.com/in/andreaponcerecruitmentservices",
    "company": "Propel",
    "position": "Strategic Recruiting Advisor",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Rojas Barboza",
    "url": "https://www.linkedin.com/in/andrea-rojas-barboza",
    "company": "Hakuna",
    "position": "People & Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Seniuk",
    "url": "https://www.linkedin.com/in/andreaseniuk",
    "company": "Resilient Co.",
    "position": "Global Talent Acquisition Partner | LATAM, US & EMEA",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Toledo",
    "url": "https://www.linkedin.com/in/rrll",
    "company": "Bnka",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Vina",
    "url": "https://www.linkedin.com/in/andrea-vina",
    "company": "E-Solutions",
    "position": "HR Director - LATAM Region",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Andrea",
    "lastName": "Völker",
    "url": "https://www.linkedin.com/in/andrea-v%C3%B6lker-99b66939",
    "company": "AYIGROUP",
    "position": "HRBP - Human Capital",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Andrea Deniss",
    "lastName": "Lopez Mejia",
    "url": "https://www.linkedin.com/in/andrea-deniss-l-7406251a9",
    "company": "Auxis",
    "position": "Recruiting Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Andrea Judith",
    "lastName": "Krivoruk",
    "url": "https://www.linkedin.com/in/andrea-krivoruk",
    "company": "Allot",
    "position": "Global Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Andreea",
    "lastName": "Nazarovici",
    "url": "https://www.linkedin.com/in/andreea-nazarovici-3b0358208",
    "company": "Randstad Digital España",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Andreina",
    "lastName": "Dun Avendaño",
    "url": "https://www.linkedin.com/in/andreina-dun-avenda%C3%B1o",
    "company": "Autónomo",
    "position": "IT Recruiter SR - Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Andres",
    "lastName": "Arenas",
    "url": "https://www.linkedin.com/in/andresmarelo",
    "company": "CONEXIONHR - Recruiting Company",
    "position": "Freelance IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Andres",
    "lastName": "Beramendi",
    "url": "https://www.linkedin.com/in/andres-beramendi-822612116",
    "company": "HV Talent",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Andres",
    "lastName": "Guerrero",
    "url": "https://www.linkedin.com/in/andrguerrero",
    "company": "Unilabs",
    "position": "Global Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Andres",
    "lastName": "Pisani Astorga ⚡",
    "url": "https://www.linkedin.com/in/hr-itrecruiter-andres-pisani",
    "company": "Globant",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Andrew",
    "lastName": "Asamonye",
    "url": "https://www.linkedin.com/in/andrew-asamonye---jobexpert",
    "company": "AA CAREER MANAGEMENT",
    "position": "Recruitment Officer",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "André",
    "lastName": "Shigemori",
    "url": "https://www.linkedin.com/in/andreshigemori",
    "company": "Andina Tech",
    "position": "Tech Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Andrés",
    "lastName": "Deveaux",
    "url": "https://www.linkedin.com/in/andresdeveaux",
    "company": "Nexus",
    "position": "Sr Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Andrés",
    "lastName": "Parra",
    "url": "https://www.linkedin.com/in/andr%C3%A9s-parra-1b163a6a",
    "company": "Dichter & Neira Research",
    "position": "Gerente de atracción y selección de talento Latam y el Caribe",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Andrés",
    "lastName": "Santamaría",
    "url": "https://www.linkedin.com/in/andr%C3%A9s-santamar%C3%ADa-232b32228",
    "company": "Remote Talent LATAM",
    "position": "Full Cycle Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Andy",
    "lastName": "P.",
    "url": "https://www.linkedin.com/in/lic-andres-pithod-saez",
    "company": "Modernize",
    "position": "LatAm Recruitment Lead - Modernizing Global Teams Through Nearshore Talent",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Anellia",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/anellia-romero-88b68a225",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Angela",
    "lastName": "Torres Sagredo",
    "url": "https://www.linkedin.com/in/angela-torres-sagredo-05b116215",
    "company": "Korn Ferry",
    "position": "IT Tech Talent Recruiter | Talent Acquisition Specialist",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Angela",
    "lastName": "Torres Sagredo 🌻",
    "url": "https://www.linkedin.com/in/angela-torres-sagredo-%F0%9F%8C%BB-019864207",
    "company": "Korn Ferry",
    "position": "IT Tech Talent Recruiter | Talent Acquisition Specialist",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Angeles",
    "lastName": "Donnelly",
    "url": "https://www.linkedin.com/in/angeles-donnelly-6a91ba118",
    "company": "Pomelo",
    "position": "Regional Talent Partner Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Angeles",
    "lastName": "Garzón",
    "url": "https://www.linkedin.com/in/angiegarzon",
    "company": "Mercado Libre",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Angeles",
    "lastName": "Gomez",
    "url": "https://www.linkedin.com/in/angeles-gomez-53252757",
    "company": "Accion Point",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Angeles",
    "lastName": "Gonzalez Molina",
    "url": "https://www.linkedin.com/in/talentsourcer-angelesgonzalezm",
    "company": "Randstad Argentina",
    "position": "Recruiter RPO",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Angeles",
    "lastName": "Pitrelli",
    "url": "https://www.linkedin.com/in/angeles-pitrelli-84bba46a",
    "company": "Accenture Argentina",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Angelina",
    "lastName": "Chinque",
    "url": "https://www.linkedin.com/in/angelina-chinque",
    "company": "Quorum IT",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Angelina",
    "lastName": "Iatchenko",
    "url": "https://www.linkedin.com/in/angelina-iatchenko",
    "company": "Wisebits Group",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Angie",
    "lastName": "Bortule",
    "url": "https://www.linkedin.com/in/angelesbortule",
    "company": "Stealth Startup",
    "position": "Lead Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Angie Carolina",
    "lastName": "Zarate Zapata",
    "url": "https://www.linkedin.com/in/carolina-zarate-tech-recruiter",
    "company": "WorkCapIT",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Anis",
    "lastName": "Suraiya",
    "url": "https://www.linkedin.com/in/anis-suraiya-46434130b",
    "company": "Kamlax Global Technologies",
    "position": "Talent Acquisition Executive",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Aniuska",
    "lastName": "Pacheco Martinez",
    "url": "https://www.linkedin.com/in/aniuskapm",
    "company": "Stefanini LATAM",
    "position": "LATAM IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Anna",
    "lastName": "Kalinikova 🇺🇦",
    "url": "https://www.linkedin.com/in/anna-kalinikova",
    "company": "3E",
    "position": "Talent Sourcer (via Matchr)",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Anna",
    "lastName": "Kuklinska",
    "url": "https://www.linkedin.com/in/anna-kuklinska-902031113",
    "company": "Sodexo",
    "position": "HR Project Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Anna",
    "lastName": "Minina",
    "url": "https://www.linkedin.com/in/annaminina",
    "company": "Grid Dynamics",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Anna",
    "lastName": "Miroshina",
    "url": "https://www.linkedin.com/in/anna-miroshina",
    "company": "TechLinks",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Anna",
    "lastName": "Topchu 🕵🏻",
    "url": "https://www.linkedin.com/in/anna-topchu",
    "company": "Index",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Anna",
    "lastName": "Yasa",
    "url": "https://www.linkedin.com/in/anna-yasa",
    "company": "Agurotech",
    "position": "Internal Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Anna María",
    "lastName": "Moreno",
    "url": "https://www.linkedin.com/in/anna-mar%C3%ADa-moreno-83988a183",
    "company": "Hire With Near",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Anselmo",
    "lastName": "Geremias",
    "url": "https://www.linkedin.com/in/anselmo-geremias-81b27b1b4",
    "company": "Clowit",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Anto",
    "lastName": "Batista",
    "url": "https://www.linkedin.com/in/antonelabatista",
    "company": "Pomelo",
    "position": "Culture, Engagement & Talent Development Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Antonela",
    "lastName": "D'Ambrosio",
    "url": "https://www.linkedin.com/in/antonela-d-ambrosio-04a774235",
    "company": "recruitedia",
    "position": "Especialista en selección de personal informático",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Antonela",
    "lastName": "Fantin",
    "url": "https://www.linkedin.com/in/antonela-fantin",
    "company": "CIPITRIA",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Antonela",
    "lastName": "Giuffra",
    "url": "https://www.linkedin.com/in/antonelagiuffra",
    "company": "Nerdy",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Antonela",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/antonela-rodriguez-03410997",
    "company": "Improntus",
    "position": "Head of HR / HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Antonela V.",
    "lastName": "Perez",
    "url": "https://www.linkedin.com/in/perezantonelavictoria",
    "company": "HOTOVO",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Avetrani",
    "url": "https://www.linkedin.com/in/antonella-avetrani",
    "company": "Acoru",
    "position": "Director of People Operations",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Bogado",
    "url": "https://www.linkedin.com/in/bogadoantonella",
    "company": "BGH Tech Partner",
    "position": "HR Business Partner | Talent Acquistion Specialist",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Brunelli",
    "url": "https://www.linkedin.com/in/it-recruiter-antonella-brunelli",
    "company": "Service Club",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Bruno",
    "url": "https://www.linkedin.com/in/antonellabruno20",
    "company": "SSPV",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Cardozo",
    "url": "https://www.linkedin.com/in/antonella-cardozo-187562b7",
    "company": "Freelancer",
    "position": "Technical Recruiter (Project-Based)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Coluccini",
    "url": "https://www.linkedin.com/in/antonella-coluccini-41027b18b",
    "company": "Acid Labs",
    "position": "People Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Garbarino",
    "url": "https://www.linkedin.com/in/antonellagarbarino",
    "company": "Proppel",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Graef",
    "url": "https://www.linkedin.com/in/antonellagraef",
    "company": "MAVI",
    "position": "Talent Platform Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Lemos",
    "url": "https://www.linkedin.com/in/antonella-lemos-itrecruiter",
    "company": "CJ Recruitment",
    "position": "Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Mancini",
    "url": "https://www.linkedin.com/in/am-talentacquisition",
    "company": "Coderio | Software Company",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Mazzeo",
    "url": "https://www.linkedin.com/in/antonellamazzeo",
    "company": "Stefanini LATAM",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Murillas",
    "url": "https://www.linkedin.com/in/antonella-murillas",
    "company": "Assurant",
    "position": "Talent Acquisition Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Nanni",
    "url": "https://www.linkedin.com/in/antonella-nanni",
    "company": "Autónomo",
    "position": "Tecnical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Ojuez",
    "url": "https://www.linkedin.com/in/antonellaojuez",
    "company": "South",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Pugliano",
    "url": "https://www.linkedin.com/in/antonellapugliano-rrhh",
    "company": "Ctrl365",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Rizzieri",
    "url": "https://www.linkedin.com/in/antonella-rizzieri",
    "company": "Distillery",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Antonella",
    "lastName": "Stagliano",
    "url": "https://www.linkedin.com/in/antonellastagliano",
    "company": "Accenture",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Antonella D.",
    "lastName": "Obiols",
    "url": "https://www.linkedin.com/in/antonellaobiols",
    "company": "FHM Consulting",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Antonio",
    "lastName": "Gutiérrez Pigazos",
    "url": "https://www.linkedin.com/in/antonio-guti%C3%A9rrez-pigazos",
    "company": "UST España & Latam",
    "position": "Global Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Antonio",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/antonio-l%C3%B3pez-49b09620b",
    "company": "Ryscode",
    "position": "IT & Marketing Recruiter en Ryscode",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Antonio",
    "lastName": "Moreno",
    "url": "https://www.linkedin.com/in/antonio-moreno-763674190",
    "company": "IT-TALENT Headhunter SENIOR TI",
    "position": "HeadHunter TI",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Antuaned",
    "lastName": "Miranda Torres",
    "url": "https://www.linkedin.com/in/antuaned-miranda-torres-a6b321183",
    "company": "Praxis",
    "position": "Senior IT Recruiter - USA",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Anuj",
    "lastName": "K.",
    "url": "https://www.linkedin.com/in/anuj-kumar-pandit",
    "company": "Avenues International Inc.",
    "position": "US IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Anyelly",
    "lastName": "Flórez",
    "url": "https://www.linkedin.com/in/anyelly",
    "company": "CBTW Americas",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Araceli",
    "lastName": "Montagano",
    "url": "https://www.linkedin.com/in/araceli-montagano",
    "company": "Proxet",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Araceli",
    "lastName": "Ponce",
    "url": "https://www.linkedin.com/in/araceliponce11",
    "company": "Clasing",
    "position": "People Partner Specialist",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Araceli",
    "lastName": "Rivera",
    "url": "https://www.linkedin.com/in/araceli-rivera-4a1205236",
    "company": "Tsoft",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Araceli",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/araceli-romero",
    "company": "Baires HR",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Araceli Soledad",
    "lastName": "Charro",
    "url": "https://www.linkedin.com/in/araceli-soledad-charro-45140a146",
    "company": "BIG Language Solutions",
    "position": "Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Aracely",
    "lastName": "Ocón",
    "url": "https://www.linkedin.com/in/aracely-oc%C3%B3n-557a2260",
    "company": "Feelathome",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Arancha",
    "lastName": "García Roces",
    "url": "https://www.linkedin.com/in/arancha-garc%C3%ADa-roces-b02563185",
    "company": "Mecalux Software Solutions",
    "position": "Talent Acquisition Specialist – IT Senior Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Aravind",
    "lastName": "Chappa",
    "url": "https://www.linkedin.com/in/aravind-chappa-193688157",
    "company": "L&T Technology Services",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "aravind",
    "lastName": "reddy",
    "url": "https://www.linkedin.com/in/aravind-reddy-081970243",
    "company": "NAAS Technologies",
    "position": "Senior Lead Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ariadna",
    "lastName": "Ganzitano",
    "url": "https://www.linkedin.com/in/ariadna-ganzitano-3a0a07100",
    "company": "Potentiality Group",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ariana",
    "lastName": "Fratte",
    "url": "https://www.linkedin.com/in/carlafratte",
    "company": "Boreal IT Solutions",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ariana",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/ariana-garcia-lopez-recursos-humanos",
    "company": "SASA",
    "position": "Head of Human Resources",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ariana",
    "lastName": "Penayo",
    "url": "https://www.linkedin.com/in/ariana-penayo",
    "company": "EY",
    "position": "Talent Discovery Recruiter - Senior Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ariana",
    "lastName": "Tomasin",
    "url": "https://www.linkedin.com/in/ariana-tomasin-",
    "company": "Accenture",
    "position": "Sr IT Recruiter | RPO (Cliente: Mercado Libre)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ariana Sol",
    "lastName": "Geraci",
    "url": "https://www.linkedin.com/in/recruiter-arianasolgeraci",
    "company": "South",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ariana Victoria",
    "lastName": "Villena",
    "url": "https://www.linkedin.com/in/arianavictoriavillena",
    "company": "Distillery",
    "position": "Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Arianna",
    "lastName": "López Valverde",
    "url": "https://www.linkedin.com/in/arianna-valverde",
    "company": "AVASA",
    "position": "HR Business Partner Agencias",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Ariel",
    "lastName": "Castro",
    "url": "https://www.linkedin.com/in/ari-castro",
    "company": "Softensity Inc",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ariel",
    "lastName": "Castro ▶️",
    "url": "https://www.linkedin.com/in/ariel-castro",
    "company": "intermedia",
    "position": "Head of People & Culture",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ariel",
    "lastName": "Galán",
    "url": "https://www.linkedin.com/in/arielgalans",
    "company": "BEST TALENTS CONSULTING - LATAM",
    "position": "Asistente de Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Ariel",
    "lastName": "Kaplan",
    "url": "https://www.linkedin.com/in/arielkaplanhr",
    "company": "GlobalLogic",
    "position": "Global HR Operations Practices Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ariel",
    "lastName": "Linarte",
    "url": "https://www.linkedin.com/in/arielinarte",
    "company": "Hollis Cobb Associates",
    "position": "Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ariel D.",
    "lastName": "Pérez Pulero",
    "url": "https://www.linkedin.com/in/arieldarioperez",
    "company": "Prodigio Chile",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ariela",
    "lastName": "Buscetti",
    "url": "https://www.linkedin.com/in/arielabuscetti",
    "company": "Talentopia",
    "position": "HRBP - Co Founder",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Arilda",
    "lastName": "Loaiza",
    "url": "https://www.linkedin.com/in/arilda-loaiza-a3697a56",
    "company": "iStorming - Consultoría IT - Argentina",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Armando Randú",
    "lastName": "Martínez Ramírez",
    "url": "https://www.linkedin.com/in/psic-armandomtz",
    "company": "Takeda",
    "position": "Senior Recruiter (Korn Ferry - RPO)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Arsen",
    "lastName": "Dushaj",
    "url": "https://www.linkedin.com/in/arsen-dushaj-69a012223",
    "company": "CARDO AI",
    "position": "Hiring Partner | Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "hiring",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Arturo",
    "lastName": "Bussolo",
    "url": "https://www.linkedin.com/in/arturo-bussolo-1a173627",
    "company": "Mode Mobile",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Arturo",
    "lastName": "Ortiz",
    "url": "https://www.linkedin.com/in/arturo-ortiz",
    "company": "Mercado Libre",
    "position": "IT Regional Talent Acquisition Sr Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Arturo",
    "lastName": "Sanchez Tomaselli",
    "url": "https://www.linkedin.com/in/itrecruiter-arturo-sanchez-tomaselli-psicologo-psychologist",
    "company": "NIAGE",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Aruna",
    "lastName": "Devi Rao",
    "url": "https://www.linkedin.com/in/aruna-devi-rao-08aa3513b",
    "company": "ITCAN Pte Ltd",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ashika",
    "lastName": "Thapa",
    "url": "https://www.linkedin.com/in/ashika-thapa-392b482a",
    "company": "Terrabit Consulting",
    "position": "Senior Executive Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ashly",
    "lastName": "Esquivel",
    "url": "https://www.linkedin.com/in/ashly-esquivel-0b42b218b",
    "company": "Estrategia Tecnológica",
    "position": "Becaria de reclutamiento IT en Estrategia Tecnológica",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Astrid Lorena",
    "lastName": "Mujica Diaz",
    "url": "https://www.linkedin.com/in/astrid-mujica-reclutamiento",
    "company": "Interfell",
    "position": "RECRUITER IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Aswathi",
    "lastName": "Radhakrishnan",
    "url": "https://www.linkedin.com/in/aswathi-radhakrishnan-078256196",
    "company": "eJAmerica",
    "position": "Team Lead-Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Athisuaran",
    "lastName": "Ratnam",
    "url": "https://www.linkedin.com/in/athisuaran-ratnam-173a141a6",
    "company": "Denave",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Aurora",
    "lastName": "Sáez",
    "url": "https://www.linkedin.com/in/aurora-s%C3%A1ez-21987b217",
    "company": "Startups",
    "position": "Recruiter in Latam for Bay Area",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Avinash",
    "lastName": "Rana (Addy.r)",
    "url": "https://www.linkedin.com/in/avinash-rana-addy-r-623617220",
    "company": "E-Solutions",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Avril",
    "lastName": "Cardozo Ramírez",
    "url": "https://www.linkedin.com/in/avrilcardozoram%C3%ADrez",
    "company": "ERON International",
    "position": "HRBP | HR Business Partner & Talent - Global",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Aya",
    "lastName": "Khattab",
    "url": "https://www.linkedin.com/in/aya-khattab-169a56315",
    "company": "TOWN TEAM",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ayelen",
    "lastName": "Giofre",
    "url": "https://www.linkedin.com/in/ayelen-giofre",
    "company": "Resilient Co.",
    "position": "Staffing & Talent Solutions Manager | EMEA · USA · LATAM",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ayelen",
    "lastName": "Latorre",
    "url": "https://www.linkedin.com/in/ayelenlatorre",
    "company": "G&L Group",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Ayelen",
    "lastName": "Laudonio",
    "url": "https://www.linkedin.com/in/ayelen-laudonio-79861278",
    "company": "Mercado Libre",
    "position": "People Business Partner Senior Analyst - Shipping",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Ayelén",
    "lastName": "Loprevite",
    "url": "https://www.linkedin.com/in/aloprevite",
    "company": "Globant",
    "position": "Recruiting Team Lead (South LATAM)",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ayelén",
    "lastName": "Monea",
    "url": "https://www.linkedin.com/in/ayel%C3%A9n-monea-95b92167",
    "company": "Acciona IT",
    "position": "Talent Acquisition IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ayelén",
    "lastName": "Rodríguez",
    "url": "https://www.linkedin.com/in/ayel%C3%A9n",
    "company": "Yumatech",
    "position": "Director | Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Aylén",
    "lastName": "Albornoz",
    "url": "https://www.linkedin.com/in/ayl%C3%A9n-albornoz-289442217",
    "company": "Patagonian",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Aylén Rocío",
    "lastName": "Franco",
    "url": "https://www.linkedin.com/in/ayl%C3%A9n-roc%C3%ADo-franco",
    "company": "Accenture",
    "position": "HR Strategy & Process Optimization Leader | Recruiting Team Lead IT | Client: Mercado Libre Regional",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Azmi",
    "lastName": "Samsuri",
    "url": "https://www.linkedin.com/in/azmi-samsuri-4988721a7",
    "company": "Neuron Solutions Sdn Bhd",
    "position": "Talent Acquisition Executive",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Baldomero",
    "lastName": "Rivadeneira Romero",
    "url": "https://www.linkedin.com/in/baldomero-rivadeneira-romero",
    "company": "Moventi",
    "position": "IT Sr Recruitment Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Barbara",
    "lastName": "Bigetti",
    "url": "https://www.linkedin.com/in/barbara-bigetti",
    "company": "Accenture",
    "position": "Recruiting Associate",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Barbara",
    "lastName": "De Los Santos",
    "url": "https://www.linkedin.com/in/barbaraayelendelossantos",
    "company": "Portal IT Talent Solutions",
    "position": "Recruiter IT Freelance | Talent Partner",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Barbara",
    "lastName": "Ramirez Garzon",
    "url": "https://www.linkedin.com/in/barbararamirezgarzon",
    "company": "EY",
    "position": "Talent Attraction Recruiter - Supervising Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Barbara",
    "lastName": "Vera",
    "url": "https://www.linkedin.com/in/bverafaria",
    "company": "Luflox LLC",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Bautista",
    "lastName": "de la Torre Urizar",
    "url": "https://www.linkedin.com/in/bautistadelatorreu",
    "company": "Avature",
    "position": "Talent Management | HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Bautista",
    "lastName": "Ithurburu",
    "url": "https://www.linkedin.com/in/bautistaithurburu",
    "company": "TOTS",
    "position": "Partner & People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "bbhumikaa",
    "lastName": "A",
    "url": "https://www.linkedin.com/in/bbhumikaa-a-933389245",
    "company": "Global KPO",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Beatriz",
    "lastName": "Kuroki",
    "url": "https://www.linkedin.com/in/beatriz-kuroki-9ba5a313a",
    "company": "Nortal",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belen",
    "lastName": "Alday",
    "url": "https://www.linkedin.com/in/belen-alday-11556a189",
    "company": "TeamUp",
    "position": "Senior Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belen",
    "lastName": "Etchecopar",
    "url": "https://www.linkedin.com/in/belen-etchecopar",
    "company": "Profesional independiente",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belen",
    "lastName": "Godoy Ripoll",
    "url": "https://www.linkedin.com/in/belen-godoy-ripoll-rrhh-it",
    "company": "redbee Studios",
    "position": "Sr Tech & Product Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Belen",
    "lastName": "Lavinia",
    "url": "https://www.linkedin.com/in/belen-lavinia-42a78623",
    "company": "Softtek Argentina",
    "position": "Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Belen",
    "lastName": "Milicich",
    "url": "https://www.linkedin.com/in/belen-milicich-567a67251",
    "company": "Sumarte IT",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belen",
    "lastName": "R",
    "url": "https://www.linkedin.com/in/belen-r-88858923a",
    "company": "Humanitas IT",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Belen",
    "lastName": "Ronchino",
    "url": "https://www.linkedin.com/in/belen-ronchino-89b9b9127",
    "company": "Manly Pacific Sydney MGallery Collection",
    "position": "People & Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Belen",
    "lastName": "Torres",
    "url": "https://www.linkedin.com/in/mbelentorres",
    "company": "Proxet",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Belen Quimey",
    "lastName": "Sotelo",
    "url": "https://www.linkedin.com/in/bquimeysotelo",
    "company": "Assurant",
    "position": "Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Belkis M.",
    "lastName": "Ledesma",
    "url": "https://www.linkedin.com/in/belkismledesma",
    "company": "Artekium Technology",
    "position": "Talent Acquisition Specialist IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Bella",
    "lastName": "Ruiz",
    "url": "https://www.linkedin.com/in/bella-ruiz-6a898817b",
    "company": "SOUTHWORKS",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Arias",
    "url": "https://www.linkedin.com/in/bel%C3%A9n-arias-667274133",
    "company": "LoopStudio",
    "position": "Sr Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Bustamante (she/her)",
    "url": "https://www.linkedin.com/in/mariabelenbustamante",
    "company": "Aon",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Castellano",
    "url": "https://www.linkedin.com/in/rrhh-belen-castellano",
    "company": "Kinetic Corp",
    "position": "HRBP - IT Talent Acquisition Specialist.",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Castillo C",
    "url": "https://www.linkedin.com/in/belencastilloc",
    "company": "SoftServe",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/bel%C3%A9n-diaz-49422b230",
    "company": "Rather Labs, Inc",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Garzón",
    "url": "https://www.linkedin.com/in/bel%C3%A9ngarz%C3%B3n-rhvision-staff-augmentation-reclutamiento-it-seleccion-talentoit-outsourcing",
    "company": "RH Visión - Tecnología en Recursos Humanos",
    "position": "Head of Talent / Lead People Growth",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Gelormini",
    "url": "https://www.linkedin.com/in/belengelormini",
    "company": "NTT DATA Europe & Latam",
    "position": "Analista de Staffing | HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Gorbea",
    "url": "https://www.linkedin.com/in/bel%C3%A9n-gorbea-9b4199125",
    "company": "Qaracter - Beyond your Challenge",
    "position": "Talent Acquisition Expert",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Mafuresco",
    "url": "https://www.linkedin.com/in/belen-mafuresco",
    "company": "InvGate",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Maldonado",
    "url": "https://www.linkedin.com/in/belen-maldonado",
    "company": "Axonier Consultores",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Musolino",
    "url": "https://www.linkedin.com/in/belenmusolino",
    "company": "Kavak.com",
    "position": "Talent Acquisition Senior Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Ochoa",
    "url": "https://www.linkedin.com/in/lara-belen-ochoa",
    "company": "Steinhardt",
    "position": "Selección de Personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Pregelj",
    "url": "https://www.linkedin.com/in/belenpregelj",
    "company": "Prex",
    "position": "People Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Rastelletti",
    "url": "https://www.linkedin.com/in/bel%C3%A9n-rastelletti-908a2b33",
    "company": "Consultora BR",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/bel%C3%A9nrodriguezrrhh",
    "company": "Tandem",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Rossi",
    "url": "https://www.linkedin.com/in/belenrossi95",
    "company": "Humand",
    "position": "Human Resources Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Santellán (She/Her)",
    "url": "https://www.linkedin.com/in/bel%C3%A9n-santell%C3%A1n-she-her-7b055b121",
    "company": "Shifta",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Sotelo",
    "url": "https://www.linkedin.com/in/bel%C3%A9n-sotelo-21b3a5210",
    "company": "Virtualmind",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Tardivo",
    "url": "https://www.linkedin.com/in/bel%C3%A9n-tardivo-442660186",
    "company": "Ualá",
    "position": "People Business Partner | Specialist",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Videla",
    "url": "https://www.linkedin.com/in/belenviidela",
    "company": "Grupo Prominente",
    "position": "People & Customer Success Manager | Staff Augmentation",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Belén",
    "lastName": "Álvarez",
    "url": "https://www.linkedin.com/in/bel%C3%A9n-%C3%A1lvarez-0ba509224",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Belén Milagros",
    "lastName": "Picchioni",
    "url": "https://www.linkedin.com/in/belenpicchioni",
    "company": "Streambe",
    "position": "Recruiter IT & Culture",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ben",
    "lastName": "Serrat",
    "url": "https://www.linkedin.com/in/ben-serrat",
    "company": "Independent Consultant",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Beniamino",
    "lastName": "Cervi Entrala",
    "url": "https://www.linkedin.com/in/beniamino-cervi-entrala-3a4534146",
    "company": "NTT DATA Europe & Latam",
    "position": "HR & Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Benito",
    "lastName": "Mon",
    "url": "https://www.linkedin.com/in/benito-mon-a738a7264",
    "company": "Salution HR",
    "position": "IT & Digital Business Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Benjamín",
    "lastName": "Figueroa",
    "url": "https://www.linkedin.com/in/figueroab",
    "company": "Zagged",
    "position": "UGC & Influencer Marketing Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Berenice",
    "lastName": "de San Martin",
    "url": "https://www.linkedin.com/in/bsanmartin",
    "company": "FASTENER TOOLS S.A.",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Berenice",
    "lastName": "Marcoppido",
    "url": "https://www.linkedin.com/in/berenice-marcoppido",
    "company": "Ryz Labs",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Berenice",
    "lastName": "Spinelli",
    "url": "https://www.linkedin.com/in/berenice-spinelli-7b8a15164",
    "company": "Accenture",
    "position": "IT Recruiting Analyst LATAM | Cliente: Mercado Libre",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Betina",
    "lastName": "Fleita",
    "url": "https://www.linkedin.com/in/betinafleita",
    "company": "Avalian",
    "position": "Analista de Reclutamiento y Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Bettina",
    "lastName": "Cozzarín",
    "url": "https://www.linkedin.com/in/bettinacozzarin",
    "company": "Becas IT",
    "position": "Recruitment Manager",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Betzimar",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/betzi-gonzalez",
    "company": "Carryer",
    "position": "IT Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Bhaaveenashini",
    "lastName": "Arul Selven",
    "url": "https://www.linkedin.com/in/bhaaveenashini-arul-selven-a7aab61b5",
    "company": "Laurelsoft (M) Sdn Bhd",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Bianca",
    "lastName": "Leticia Campos da Silva",
    "url": "https://www.linkedin.com/in/bianca-leticia-campos-da-silva",
    "company": "Amazon",
    "position": "Tech Sourcing Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Bianca",
    "lastName": "Miranda",
    "url": "https://www.linkedin.com/in/bimiranda1",
    "company": "Ayesa Digital",
    "position": "Senior IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Blas",
    "lastName": "Atencio",
    "url": "https://www.linkedin.com/in/batencio",
    "company": "Metyis",
    "position": "Global Talent Acquisition Senior Manager | Internal TA Consultant",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Aguilar Belmont",
    "url": "https://www.linkedin.com/in/brendaaguilarb",
    "company": "Spin",
    "position": "Sr. Tech Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Arias",
    "url": "https://www.linkedin.com/in/brendarias",
    "company": "Asap Consulting S.A.",
    "position": "IT Recruiter Analyst | People Care",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Beetar",
    "url": "https://www.linkedin.com/in/brenda-beetar-1ba690110",
    "company": "PersonalSoft",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Iñiguez",
    "url": "https://www.linkedin.com/in/brenda-i%C3%B1iguez-883a69222",
    "company": "RECLUTAMIENTO KDN",
    "position": "Talent Acquisition TI",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Lopes",
    "url": "https://www.linkedin.com/in/brenda011m",
    "company": "Remote Crew",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Manccini",
    "url": "https://www.linkedin.com/in/brenda-manccini-9aba1a149",
    "company": "Clever For Tech",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Ochoa",
    "url": "https://www.linkedin.com/in/brenda-ochoa16",
    "company": "Xcapit",
    "position": "HR Business Partner | People Experience",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Olguin",
    "url": "https://www.linkedin.com/in/brenda-olguin-1814b683",
    "company": "Vigorita",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Ruiz",
    "url": "https://www.linkedin.com/in/brenda-ruiz-597a76a2",
    "company": "Accusys Technology",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Scarfo",
    "url": "https://www.linkedin.com/in/brenda-scarfo",
    "company": "Santa Catalina - Neurorehabilitación Clínica",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Brenda",
    "lastName": "Valerga",
    "url": "https://www.linkedin.com/in/brendavalerga",
    "company": "Kingdom",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Brenda A",
    "lastName": "Mores",
    "url": "https://www.linkedin.com/in/brenda-a-mores-",
    "company": "Grupo Resonancias",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Brenda Lizbeth",
    "lastName": "Rico Aguayo",
    "url": "https://www.linkedin.com/in/brendarico",
    "company": "Dresden Partners",
    "position": "Recruitment Management Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Brian",
    "lastName": "Ritter",
    "url": "https://www.linkedin.com/in/brian-ritter-8146898b",
    "company": "Vaan - Shopify Platinum Agency",
    "position": "HR Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Brian",
    "lastName": "Rosenfeld",
    "url": "https://www.linkedin.com/in/brian-rosenfeld",
    "company": "Accenture Argentina",
    "position": "HRBP Technology",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Brigitte",
    "lastName": "Cardozo Stabile",
    "url": "https://www.linkedin.com/in/brigitte-cardozo-stabile",
    "company": "Opdenergy",
    "position": "Talent, Branding & Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Bruna",
    "lastName": "Tonetto",
    "url": "https://www.linkedin.com/in/brunatonetto",
    "company": "Ambush",
    "position": "People Team · Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Bruno",
    "lastName": "De Castro",
    "url": "https://www.linkedin.com/in/bruno-de-castro-ab208a146",
    "company": "Xmartlabs",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Bárbara",
    "lastName": "Abramovsky",
    "url": "https://www.linkedin.com/in/barbarabramovsky",
    "company": "Fever",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Bárbara",
    "lastName": "Bohórquez",
    "url": "https://www.linkedin.com/in/barbarabohorquez",
    "company": "Hutrit",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Bárbara",
    "lastName": "Cabaleiro",
    "url": "https://www.linkedin.com/in/b%C3%A1rbara-cabaleiro-2a471b127",
    "company": "Interbanking",
    "position": "IT Talent Acquisition Specialist Sr.",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Bárbara",
    "lastName": "Caparrós",
    "url": "https://www.linkedin.com/in/b%C3%A1rbara-caparr%C3%B3s",
    "company": "Accenture",
    "position": "Team Lead | Talent Planning & Analytics",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Bárbara",
    "lastName": "Lopardo",
    "url": "https://www.linkedin.com/in/b%C3%A1rbara-lopardo",
    "company": "Potentiality Group",
    "position": "Senior Talent Acquisition SR",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Bárbara",
    "lastName": "Pons",
    "url": "https://www.linkedin.com/in/barbarafp",
    "company": "We Match",
    "position": "Talent Acquisition & Business Development",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Bárbara",
    "lastName": "Witek",
    "url": "https://www.linkedin.com/in/barbarawitek",
    "company": "Avature",
    "position": "Talent Management Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Bárbara Maria",
    "lastName": "Saenz",
    "url": "https://www.linkedin.com/in/b%C3%A1rbara-maria-saenz-23b07b92",
    "company": "Kosten Digital",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cambio Laboral",
    "lastName": "IT",
    "url": "https://www.linkedin.com/in/cambiolaboralit",
    "company": "Cambio Laboral IT Consultora en RRHH - Búsqueda y Selección de Talentos IT",
    "position": "Owner | IT Talent Acquisition Director",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cami",
    "lastName": "Carrique",
    "url": "https://www.linkedin.com/in/cami-carrique-a07b971a5",
    "company": "Expand",
    "position": "Recruiter Coordinator",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Aftyka",
    "url": "https://www.linkedin.com/in/camilaaftyka",
    "company": "Mercado Libre",
    "position": "Regional Talent Acquisition Sr Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Alcaraz",
    "url": "https://www.linkedin.com/in/camilaalcaraz",
    "company": "Techwarely",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Andres",
    "url": "https://www.linkedin.com/in/camila-andres-450850247",
    "company": "Sybox",
    "position": "Talent Acquisition Analyst.",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Aponte Alcaráz",
    "url": "https://www.linkedin.com/in/camila-aponte-alcar%C3%A1z-3a8289142",
    "company": "Nestlé",
    "position": "Recruitment Sr. Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Bonetto",
    "url": "https://www.linkedin.com/in/camila-bonetto",
    "company": "Accenture",
    "position": "Regional Talent Acquisition Senior - Executive Search | Mercado Libre",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Caram",
    "url": "https://www.linkedin.com/in/camilacaram",
    "company": "Callao",
    "position": "Talent Acquisition lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Carballido",
    "url": "https://www.linkedin.com/in/camilacarballido",
    "company": "Pitcheers",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Carol",
    "url": "https://www.linkedin.com/in/camila-carol",
    "company": "Humanbloom",
    "position": "Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Cipollino",
    "url": "https://www.linkedin.com/in/camila-sol-cipollino",
    "company": "Flux IT",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Cornejo Larco",
    "url": "https://www.linkedin.com/in/camila-cornejo-larco",
    "company": "Boston Consulting Group (BCG)",
    "position": "Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Cortés Leal",
    "url": "https://www.linkedin.com/in/camila-cort%C3%A9s-leal-b7616b117",
    "company": "Coderio | Software Company",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Dattellis",
    "url": "https://www.linkedin.com/in/camila-dattellis",
    "company": "GlobalLogic",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "De Luise",
    "url": "https://www.linkedin.com/in/camila-de-luise-803821199",
    "company": "ECOSISTEMAS",
    "position": "Analista de Selección & Empleos",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Delettieres",
    "url": "https://www.linkedin.com/in/camila-delettieres",
    "company": "Accenture Argentina",
    "position": "Recruiting Tech Lead",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Dupont",
    "url": "https://www.linkedin.com/in/camiladupont",
    "company": "So Shall We",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Elicabide",
    "url": "https://www.linkedin.com/in/camila-elicabide-",
    "company": "ITR",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Farias",
    "url": "https://www.linkedin.com/in/camila-farias99",
    "company": "MedVision Solutions",
    "position": "Head of People and Culture",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/camila-garc%C3%ADa-baa8b7216",
    "company": "CFOTech",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "González",
    "url": "https://www.linkedin.com/in/camila-gonz%C3%A1lez",
    "company": "Mercado Libre",
    "position": "Senior IT Talent Acquisition Regional",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Guido y Spano",
    "url": "https://www.linkedin.com/in/camila-guido-y-spano-213a871b7",
    "company": "Bridgenext",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Herraiz",
    "url": "https://www.linkedin.com/in/camila-herraiz-2055b0229",
    "company": "Pacifica Continental",
    "position": "Recruitment Consultant / Talent Acquistion Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Irribarra",
    "url": "https://www.linkedin.com/in/camilairribarra",
    "company": "Randstad Argentina",
    "position": "Recruiter (Consultora asignada) - RPO",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Lamberti",
    "url": "https://www.linkedin.com/in/camila-lamberti-87a33aa8",
    "company": "Kopius",
    "position": "Recruiting Manager, LatAm",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Martínez Cattaneo",
    "url": "https://www.linkedin.com/in/camila-martinez-cattaneo",
    "company": "Golabs",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Milazzotto",
    "url": "https://www.linkedin.com/in/camilamilazzotto",
    "company": "belo",
    "position": "TA LATAM & People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Mojavik",
    "url": "https://www.linkedin.com/in/camila-mojavik",
    "company": "Coderhouse",
    "position": "People & Operations Manager (HQ-Brasil)",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Monjes",
    "url": "https://www.linkedin.com/in/camila-monjes-940536185",
    "company": "Accenture",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Montenegro",
    "url": "https://www.linkedin.com/in/camila-montenegro-ba2243251",
    "company": "Ravn",
    "position": "Talent Acquisition Associate",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Peinado",
    "url": "https://www.linkedin.com/in/camila-peinado-50b51416a",
    "company": "ICARO",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Pelegrina",
    "url": "https://www.linkedin.com/in/camila-pelegrina",
    "company": "BEON.tech",
    "position": "Technical Talent Acquisition - Advanced Searches",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Piqueras",
    "url": "https://www.linkedin.com/in/camila-piqueras-93336b31",
    "company": "Salesforce",
    "position": "Sr Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Ramallo",
    "url": "https://www.linkedin.com/in/camilaramallo",
    "company": "Talently",
    "position": "IT Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Ramirez",
    "url": "https://www.linkedin.com/in/camilabramirez",
    "company": "venon.ai",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Rinaldi",
    "url": "https://www.linkedin.com/in/camrinaldi",
    "company": "BBVA en Argentina",
    "position": "IT Talent Acquisition - BBVA",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Rios",
    "url": "https://www.linkedin.com/in/camila-rios-54492719b",
    "company": "DFRG | ROUGE",
    "position": "Human Resources | Recruiter | HR Operations",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Rivas",
    "url": "https://www.linkedin.com/in/rivascamila",
    "company": "Entropy",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Rodrigues",
    "url": "https://www.linkedin.com/in/camiladsrodrigues",
    "company": "Sigma Software Group",
    "position": "International Recruiter |Tech and Product Recruiter for Latam | Career Mentor",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/-camila-romero-",
    "company": "Serendipia Consultora",
    "position": "Head Hunter & Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Sotelo",
    "url": "https://www.linkedin.com/in/camilasotelo",
    "company": "Welo Data",
    "position": "Senior Manager, Talent Aquisition",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Szyszczyc",
    "url": "https://www.linkedin.com/in/camilaszy",
    "company": "belo",
    "position": "People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Camila",
    "lastName": "Terrera",
    "url": "https://www.linkedin.com/in/camila-terrera",
    "company": "Filomeni Desarrollos Inmobiliarios",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Camila Juana",
    "lastName": "Wahnon",
    "url": "https://www.linkedin.com/in/camila-wahnon",
    "company": "deRecruiters",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila Lourdes",
    "lastName": "Gomez",
    "url": "https://www.linkedin.com/in/gomezccami27",
    "company": "Softtek",
    "position": "Talent Acquisition Sr",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Camila María",
    "lastName": "Ferretti",
    "url": "https://www.linkedin.com/in/camila-mar%C3%ADa-ferretti-75498297",
    "company": "Gather HR",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camila Virginia",
    "lastName": "Farías",
    "url": "https://www.linkedin.com/in/camila-virginia-farias",
    "company": "micro1",
    "position": "Core Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Camilla",
    "lastName": "Benito",
    "url": "https://www.linkedin.com/in/camilla-benito-33a5771a8",
    "company": "Southern Code",
    "position": "Recruitment Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Camilo",
    "lastName": "Valderrama Rico",
    "url": "https://www.linkedin.com/in/camilovalderramarico",
    "company": "Experian",
    "position": "Talent Acquisition Specialist SPLATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Bruno",
    "url": "https://www.linkedin.com/in/candela-bruno",
    "company": "Proppel",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Ferreyra",
    "url": "https://www.linkedin.com/in/candelaferreyra",
    "company": "DinoCloud",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Gabriel",
    "url": "https://www.linkedin.com/in/candela-gabriel-4355b6188",
    "company": "Kenility",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Garcia Carot",
    "url": "https://www.linkedin.com/in/candela-garcia-carot-recruiter",
    "company": "Scale Up Recruiting Partners",
    "position": "IT Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Gimenez Rey",
    "url": "https://www.linkedin.com/in/candela-gimenez-rey-40b110164",
    "company": "Qubika",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Krochik",
    "url": "https://www.linkedin.com/in/candela-krochik",
    "company": "Danone",
    "position": "HRBP Jr",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Rivero",
    "url": "https://www.linkedin.com/in/mcandelarivero",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst Ssr. | Client: Mercado Libre",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Rocca",
    "url": "https://www.linkedin.com/in/candelarocca",
    "company": "Solvd, Inc.",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Souto",
    "url": "https://www.linkedin.com/in/candela-souto-333723bb",
    "company": "AgileEngine",
    "position": "Recruiting Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Suayter",
    "url": "https://www.linkedin.com/in/candela-suayter-b61526157",
    "company": "OpenDev Pro",
    "position": "Talent Acquisition Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Candela",
    "lastName": "Wilson",
    "url": "https://www.linkedin.com/in/candela-wilson-83695217a",
    "company": "Howdy.com",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Candela Aylen",
    "lastName": "Vasarotto",
    "url": "https://www.linkedin.com/in/candela-aylen-vasarotto-8a806b208",
    "company": "ADN - Recursos Humanos",
    "position": "Analista de selección | Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Candela Belén",
    "lastName": "Sánchez",
    "url": "https://www.linkedin.com/in/candela-s%C3%A1nchez",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst - Operations Costa Rica",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Candela Lucia",
    "lastName": "Magenta",
    "url": "https://www.linkedin.com/in/candela-lucia-magenta-b5ba73233",
    "company": "Boreal IT Solutions",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Candela Sofía",
    "lastName": "Varela",
    "url": "https://www.linkedin.com/in/candela-sof%C3%ADa-varela-7214861ba",
    "company": "CIO Landing",
    "position": "HRBP Ssr",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Candelaria",
    "lastName": "Máspero Castro",
    "url": "https://www.linkedin.com/in/candelaria-m%C3%A1spero-castro-b87a184b",
    "company": "Digital Motus",
    "position": "CPO & Co-Founder en Digital Motus. Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Candelaria",
    "lastName": "Tonelli",
    "url": "https://www.linkedin.com/in/candelaria-tonelli",
    "company": "NaNLABS",
    "position": "People Operations Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carina",
    "lastName": "Cortinez",
    "url": "https://www.linkedin.com/in/carinacortinez",
    "company": "Holding Grupo NTGS",
    "position": "Head of Talent & Culture | NTGS",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carina",
    "lastName": "Hirschhorn",
    "url": "https://www.linkedin.com/in/carinahhh",
    "company": "Adecco (cliente Accenture)",
    "position": "Recruitment sourcer - IT",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Carina",
    "lastName": "Logioco",
    "url": "https://www.linkedin.com/in/carina-logioco",
    "company": "TIVIT LATAM",
    "position": "Tech Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carina",
    "lastName": "Mouronte",
    "url": "https://www.linkedin.com/in/carina-mouronte",
    "company": "Mercado Libre",
    "position": "Talent Acquisition Expert - Executive Search",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carina Ayelén",
    "lastName": "Domínguez",
    "url": "https://www.linkedin.com/in/carina-ayel%C3%A9n-dom%C3%ADnguez-916b93146",
    "company": "EPAM Systems",
    "position": "IT Talent Acquisition Analyst - Human Capital",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Azar",
    "url": "https://www.linkedin.com/in/azarcarla",
    "company": "QuadLayers",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Carrizo Álvarez",
    "url": "https://www.linkedin.com/in/carla-carrizo-%C3%A1lvarez-8971a7151",
    "company": "aliantec",
    "position": "Sr. IT Recruiter | Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Costantini",
    "url": "https://www.linkedin.com/in/carlacostantini",
    "company": "dLocal",
    "position": "Data & AI Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Daniela",
    "url": "https://www.linkedin.com/in/carladanielabroggi",
    "company": "Intelletec",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Magris",
    "url": "https://www.linkedin.com/in/carla-magris-8a33a090",
    "company": "Qurable",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Paredes",
    "url": "https://www.linkedin.com/in/carla-paredes-84786813b",
    "company": "Multiplica Talent",
    "position": "HR Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Peralta",
    "url": "https://www.linkedin.com/in/carla-peralta-p",
    "company": "PAGOS360",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Reyes",
    "url": "https://www.linkedin.com/in/carla-reyes-177599283",
    "company": "Epidata",
    "position": "Recruiting Sourcer",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Salguero",
    "url": "https://www.linkedin.com/in/salguerocarla",
    "company": "Apollo.io",
    "position": "Senior Trilingual Business Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Salva",
    "url": "https://www.linkedin.com/in/carlasalva",
    "company": "Exomindset",
    "position": "IT Recruiter | Talent Acquisition Specialist",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carla",
    "lastName": "Vitaloni",
    "url": "https://www.linkedin.com/in/carlavitaloni",
    "company": "Xylem",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carla Antonella",
    "lastName": "Lascano",
    "url": "https://www.linkedin.com/in/carlalascano",
    "company": "Deep Creek Solutions",
    "position": "IT Recruiter - HR Analyst",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carla Magali",
    "lastName": "Lurgo",
    "url": "https://www.linkedin.com/in/carlalurgo",
    "company": "Folks.Rocks",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Carla Paola",
    "lastName": "Vera Albornoz",
    "url": "https://www.linkedin.com/in/cpva87",
    "company": "Option",
    "position": "IT Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carla Sofia",
    "lastName": "Candia",
    "url": "https://www.linkedin.com/in/carla-sofia-candia-24a419203",
    "company": "DevLinkers",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carlin",
    "lastName": "Acosta",
    "url": "https://www.linkedin.com/in/carlin-acosta",
    "company": "Sombra",
    "position": "Middle Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carlos",
    "lastName": "Felix",
    "url": "https://www.linkedin.com/in/pscarlosfelix",
    "company": "Infosys",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carlos",
    "lastName": "Martínez",
    "url": "https://www.linkedin.com/in/carlos-mart%C3%ADnez-735a34269",
    "company": "Akvelon, Inc.",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carlos",
    "lastName": "Martínez Correa",
    "url": "https://www.linkedin.com/in/cacorrea",
    "company": "LTM",
    "position": "Talent Acquisition Manager LATAM",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carlos",
    "lastName": "Palacio",
    "url": "https://www.linkedin.com/in/cpalacio",
    "company": "Profesional independiente",
    "position": "HR Consultant | HR Manager | Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carlos",
    "lastName": "Rincón Macea",
    "url": "https://www.linkedin.com/in/carlos-rinc%C3%B3n-macea",
    "company": "Tech First",
    "position": "Technical Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Carlos",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/carlosromerohr",
    "company": "SWAROVSKI",
    "position": "HR Manager Argentina & Chile",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carmen",
    "lastName": "Araujo",
    "url": "https://www.linkedin.com/in/carmenaraujoe",
    "company": "CAF -banco de desarrollo de América Latina y el Caribe-",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carmen",
    "lastName": "Castillo",
    "url": "https://www.linkedin.com/in/carmen-castillo-424b731b6",
    "company": "GoFasti",
    "position": "Talent Acquisition Specialist & HRBP",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Carmen",
    "lastName": "Vilachá",
    "url": "https://www.linkedin.com/in/carmen-vilach%C3%A1-a5622b27",
    "company": "Mismo",
    "position": "Recruitment Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Acuña",
    "url": "https://www.linkedin.com/in/carolina-acu%C3%B1a-83129799",
    "company": "MinData",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Aguilera Delgado",
    "url": "https://www.linkedin.com/in/carolina-aguilera-delgado-53a48750",
    "company": "X-28 Alarmas",
    "position": "Analista de Selección y Atracción de Talento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Aurora",
    "url": "https://www.linkedin.com/in/caroaurora",
    "company": "Rockcruit",
    "position": "Tech Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Barrios",
    "url": "https://www.linkedin.com/in/carolinaelizabethbarrios",
    "company": "Profesional independiente",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Bergalli",
    "url": "https://www.linkedin.com/in/carolina-bergalli-8994136b",
    "company": "itti",
    "position": "HRBP | Fintech - Ingeniería",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Cocconi",
    "url": "https://www.linkedin.com/in/carolina-cocconi-926ab91b2",
    "company": "Iveco Group",
    "position": "Hiring, Training & TD Specialist",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Corbellini",
    "url": "https://www.linkedin.com/in/carocorbellini",
    "company": "Rombit",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Cottonaro",
    "url": "https://www.linkedin.com/in/carolinacottonaro",
    "company": "Baja Nearshore",
    "position": "Recruitment Team Lead & Account Manager",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Decicco",
    "url": "https://www.linkedin.com/in/carolina-decicco",
    "company": "deRecruiters.com",
    "position": "Ops and Sr IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "di Michele",
    "url": "https://www.linkedin.com/in/carolinadimichele",
    "company": "Social Learning",
    "position": "Regional Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Dobler",
    "url": "https://www.linkedin.com/in/carolina-dobler",
    "company": "Epidata",
    "position": "Service Delivery Lead - Selección, Desarrollo Comercial y Gestión de Talento IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Ferreira",
    "url": "https://www.linkedin.com/in/carolina-ferreira-1666161b5",
    "company": "weKnow Inc",
    "position": "Talent Acquisition Analyst Jr And Administrative analyst Ssr",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Gros",
    "url": "https://www.linkedin.com/in/carolina-gros",
    "company": "South",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Lancelotti",
    "url": "https://www.linkedin.com/in/carolancelotti",
    "company": "Globant",
    "position": "Recruiting Marketing, Global Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Leiva",
    "url": "https://www.linkedin.com/in/carolina-leiva-36094224b",
    "company": "Itrio SA",
    "position": "Administración de personal y reclutamiento IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Marcalain",
    "url": "https://www.linkedin.com/in/cmarcalain",
    "company": "Globy",
    "position": "Recruitment Team Leader",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "March",
    "url": "https://www.linkedin.com/in/carolina-march-3556933a",
    "company": "Babel Profiles",
    "position": "Tech Talent Partner - IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Masucci Nanini",
    "url": "https://www.linkedin.com/in/itrecruiter-carolina-masuccinanini",
    "company": "Autonomo",
    "position": "IT Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Mognoni",
    "url": "https://www.linkedin.com/in/carolinamognoni",
    "company": "Sur",
    "position": "SR Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Pelosi",
    "url": "https://www.linkedin.com/in/carolinapelosi",
    "company": "Staffy",
    "position": "Recruiting Lead",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Pierotti",
    "url": "https://www.linkedin.com/in/carolina-pierotti",
    "company": "TEAM International",
    "position": "Human Resources Specialist / Human Resources People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Quirós Sánchez",
    "url": "https://www.linkedin.com/in/carolina-quir%C3%B3s-s%C3%A1nchez",
    "company": "GFT Technologies LATAM",
    "position": "Talent Acquisition Manager Región Andina",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Reil",
    "url": "https://www.linkedin.com/in/carolina-reil-5889726",
    "company": "Freelance",
    "position": "Senior IT Recruiter - Selección de Personal",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Robles",
    "url": "https://www.linkedin.com/in/carorobles",
    "company": "Rad Hires",
    "position": "Head of Recruiting",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Rodriguez Diz",
    "url": "https://www.linkedin.com/in/carodiz",
    "company": "GoFundMe",
    "position": "Lead Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Roldán",
    "url": "https://www.linkedin.com/in/carolinaroldaan",
    "company": "MindTech",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Romanelli",
    "url": "https://www.linkedin.com/in/caioromanelli",
    "company": "Midnight AM",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Sponchiado",
    "url": "https://www.linkedin.com/in/carolinasponchiado",
    "company": "hiberus",
    "position": "HRBP | Talent Attraction Specialist | People & Culture",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "t",
    "url": "https://www.linkedin.com/in/carolina-taurozzi-",
    "company": "Autónomo",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Uriola Niebles",
    "url": "https://www.linkedin.com/in/carolina-uriola-niebles-796601180",
    "company": "Alegra sistema contable, administrativo y de facturación",
    "position": "Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "V",
    "url": "https://www.linkedin.com/in/carolina-v-72b570145",
    "company": "Reeon Software Engineering",
    "position": "Recruiter it Talent Adquisition",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Velayos",
    "url": "https://www.linkedin.com/in/cvelayos",
    "company": "Axxon Consulting",
    "position": "Talent Development Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Carolina",
    "lastName": "Viola",
    "url": "https://www.linkedin.com/in/carolinaviola",
    "company": "Lic. Carolina Viola",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carolina Anabel",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/carolinaanabelrp",
    "company": "Clarika Software + Innovation",
    "position": "IT Recruiter/ Talent Acquisition/ Hunter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carolina Anahí",
    "lastName": "Moreno",
    "url": "https://www.linkedin.com/in/carolinaanahimoreno",
    "company": "Grupo Prominente",
    "position": "IT Recruiting Analyst Senior",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Carolina Beatriz",
    "lastName": "Pena",
    "url": "https://www.linkedin.com/in/carolinabeatrizpena",
    "company": "Zup Innovation",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carolina Sánchez",
    "lastName": "(Ella/Ela/She)",
    "url": "https://www.linkedin.com/in/carolina-nancy-sanchez",
    "company": "Salesforce",
    "position": "Sr Recruiter - Customer Success Group",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Carolina Victoria",
    "lastName": "Mena",
    "url": "https://www.linkedin.com/in/carolina-victoria-mena-50927497",
    "company": "GM2",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Caroline",
    "lastName": "Vilchez Mimbela",
    "url": "https://www.linkedin.com/in/caroline-vilchez-mimbela-5a8a49a8",
    "company": "Inetum",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Carolyn",
    "lastName": "Pimentel, SHRM-CP",
    "url": "https://www.linkedin.com/in/carolynpimentel",
    "company": "Emory Healthcare",
    "position": "Talent Acquisition Operations Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Catalina",
    "lastName": "Acevedo Montoya",
    "url": "https://www.linkedin.com/in/catalina-acevedo-montoya-968a4771",
    "company": "TEAM International",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Catalina",
    "lastName": "Arqueros (she/her)",
    "url": "https://www.linkedin.com/in/catalinaarqueros",
    "company": "Ecolab",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Catalina",
    "lastName": "Costanzello",
    "url": "https://www.linkedin.com/in/catalina-costanzello",
    "company": "CFOTech",
    "position": "Talent Acquisition Sr en CFOTech",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Catalina",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/catalina-gonzalez-",
    "company": "Averro",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Catalina",
    "lastName": "Massenzana",
    "url": "https://www.linkedin.com/in/catalina-massenzana-725622219",
    "company": "Howdy.com",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Catalina",
    "lastName": "Michela",
    "url": "https://www.linkedin.com/in/catalina-michela",
    "company": "ENG",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Catalina",
    "lastName": "Pichler",
    "url": "https://www.linkedin.com/in/catalinapichler",
    "company": "MARC-IBER",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Catalina",
    "lastName": "Venosta",
    "url": "https://www.linkedin.com/in/catalina-venosta",
    "company": "V+V | Talento a medida",
    "position": "Talent Recruiter | Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ceci",
    "lastName": "Bolzán",
    "url": "https://www.linkedin.com/in/ceciliabolzan",
    "company": "Vitaver and Associates, Inc. (dba Vitaver Staffing)",
    "position": "Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Algarve",
    "url": "https://www.linkedin.com/in/cecilia-algarve",
    "company": "CONEXIONHR - Recruiting Company",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Avila",
    "url": "https://www.linkedin.com/in/ceci-avila",
    "company": "Profesional independiente",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Caballero",
    "url": "https://www.linkedin.com/in/cabceci",
    "company": "Howard Financial Services",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Cedeño Hossne",
    "url": "https://www.linkedin.com/in/cecihossne",
    "company": "Manage Resources Recursos Humanos",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "DiazAndrade",
    "url": "https://www.linkedin.com/in/cecilia-diazandrade-840193104",
    "company": "Intelifaz",
    "position": "Director of Talent Acquisition, Culture and Talent Management",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Ferreyra",
    "url": "https://www.linkedin.com/in/cecilia-ferreyra-72485755",
    "company": "Biomás S.A.",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Finale",
    "url": "https://www.linkedin.com/in/cecilia-finale-",
    "company": "Hutrit",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Garcia",
    "url": "https://www.linkedin.com/in/cecilia-garcia-b577b732",
    "company": "Vaitty",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Lepin C.",
    "url": "https://www.linkedin.com/in/cecilialepin",
    "company": "ADA 4 Solutions & Head Hunting",
    "position": "Líder de Selección y Gestión de Talento TI",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Mora",
    "url": "https://www.linkedin.com/in/ceciliamora",
    "company": "Bidcom",
    "position": "Talent Acquisition Specialist - HRBP",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Paz Soldán",
    "url": "https://www.linkedin.com/in/cecilia-paz-sold%C3%A1n-b967b8217",
    "company": "Velozient",
    "position": "Sr Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Cecilia",
    "lastName": "Porta Guardia",
    "url": "https://www.linkedin.com/in/cecilia-porta-guardia-1a26181ba",
    "company": "Glofy",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter",
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Cecilia Inés",
    "lastName": "Fibbiani",
    "url": "https://www.linkedin.com/in/ceciliafibbiani",
    "company": "SAM Sistemas",
    "position": "Head of HR en SAM Sistemas – Building Software®",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cecilia M.",
    "lastName": "Lema",
    "url": "https://www.linkedin.com/in/celema",
    "company": "Tonic3",
    "position": "Especialista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Cecilia Pilar",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/ceciliafernandezpilarhumano",
    "company": "Pilar Humano",
    "position": "Talent Acquisition CoFounder & CoOwner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Celeste",
    "lastName": "Argüello",
    "url": "https://www.linkedin.com/in/celeste-arguello",
    "company": "Folder IT",
    "position": "Recruiter at Folder IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Celeste",
    "lastName": "Lagomarsino",
    "url": "https://www.linkedin.com/in/celestelagomarsino",
    "company": "Consultoriait.com.ar",
    "position": "Recruiter it",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Celeste",
    "lastName": "Maggiore",
    "url": "https://www.linkedin.com/in/celeste-maggiore-3a730a157",
    "company": "freelance",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Celeste",
    "lastName": "Monje",
    "url": "https://www.linkedin.com/in/celeste-monje-1aa784169",
    "company": "DonWeb",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Celeste",
    "lastName": "Reyes",
    "url": "https://www.linkedin.com/in/reyesceleste",
    "company": "Endava",
    "position": "Senior Regional Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Celeste",
    "lastName": "Selent",
    "url": "https://www.linkedin.com/in/celeste-selent",
    "company": "SeaJah",
    "position": "Job Finder & Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Celeste",
    "lastName": "Sidan",
    "url": "https://www.linkedin.com/in/celeste-sidan",
    "company": "Proxify",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Celeste",
    "lastName": "Zucchi",
    "url": "https://www.linkedin.com/in/celeste-zucchi",
    "company": "G2i Inc.",
    "position": "Senior Recruiting Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Cesar",
    "lastName": "Degollado",
    "url": "https://www.linkedin.com/in/cesar-degollado-1a4201137",
    "company": "HireIn Cloud",
    "position": "Senior Recruitment Operations Manager | Staffing & Talent Operations | Tech | Remote",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cesar Santiago",
    "lastName": "Tenorio Silva",
    "url": "https://www.linkedin.com/in/c%C3%A9sar-santiago-tenorio-silva",
    "company": "Bain & Company",
    "position": "Americas Talent Acquisition Operations, Coordinator - Recruit Enablement | Global Business Services",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Chiara",
    "lastName": "Barreira",
    "url": "https://www.linkedin.com/in/chiarabarreira17",
    "company": "4WAYSTECH",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Chiara",
    "lastName": "Ferro (She/Her)",
    "url": "https://www.linkedin.com/in/chiara-ferro-she-her-910971255",
    "company": "Terra",
    "position": "Global Bilingual Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Chiara",
    "lastName": "Geri",
    "url": "https://www.linkedin.com/in/chiara-geri-7233ba1b6",
    "company": "Rigby AG",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Chris",
    "lastName": "Giles",
    "url": "https://www.linkedin.com/in/cgiles1717",
    "company": "Oxford Global Resources",
    "position": "Senior IT Recruiting Executive",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Christian",
    "lastName": "Mancini",
    "url": "https://www.linkedin.com/in/christianmancini",
    "company": "Capgemini",
    "position": "Gerente de Reclutamiento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Christian Camilo",
    "lastName": "Cano Muñoz",
    "url": "https://www.linkedin.com/in/christian-camilo-cano-munoz",
    "company": "Amrize",
    "position": "IT Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Christy",
    "lastName": "Muñoz",
    "url": "https://www.linkedin.com/in/christymunoz",
    "company": "Bluetab, an IBM Company (América)",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Cindy",
    "lastName": "Luna",
    "url": "https://www.linkedin.com/in/cindy-luna-a64825137",
    "company": "EX Squared LATAM",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Cindy",
    "lastName": "Trietsch",
    "url": "https://www.linkedin.com/in/cindy-trietsch",
    "company": "PedidosYa",
    "position": "People Partner Tech Sr Manager",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cinthia",
    "lastName": "Armenta",
    "url": "https://www.linkedin.com/in/cinthiarmenta",
    "company": "Gila Software",
    "position": "Talent Acquisition & Success Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cintia",
    "lastName": "Boffa",
    "url": "https://www.linkedin.com/in/cintia-boffa",
    "company": "LaPieza",
    "position": "Senior Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Cintia",
    "lastName": "Herrera",
    "url": "https://www.linkedin.com/in/cintia-herrera-99698236",
    "company": "ECOSISTEMAS",
    "position": "Líder de Selección y Empleos",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Cintia",
    "lastName": "Kravetz",
    "url": "https://www.linkedin.com/in/cintia-kravetz-2b55b654",
    "company": "Grupo Mercel S.A",
    "position": "Responsable de RRHH / Líder de Selección IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Cintia",
    "lastName": "Suarez",
    "url": "https://www.linkedin.com/in/cintia-agustina-suarez",
    "company": "Gestion Compartida",
    "position": "Consultor IT Sr en Selección de Talento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Clara",
    "lastName": "Aberastain Diz",
    "url": "https://www.linkedin.com/in/claraaberastain",
    "company": "Freelance | Self-Employed",
    "position": "Recruitment and Process Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Clara",
    "lastName": "Berisso",
    "url": "https://www.linkedin.com/in/claraberisso",
    "company": "UP.Labs",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Clara",
    "lastName": "Díaz Bonilla",
    "url": "https://www.linkedin.com/in/clara-d%C3%ADaz-bonilla-15330a107",
    "company": "Proppel",
    "position": "Recruiting Team Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Clara",
    "lastName": "Gioffre",
    "url": "https://www.linkedin.com/in/claragioffre",
    "company": "Grow UP HR",
    "position": "Founder & IT Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Clara",
    "lastName": "Kabala",
    "url": "https://www.linkedin.com/in/clara-kabala-80b113116",
    "company": "Outsource Argentina",
    "position": "IT Recruting - Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Clara",
    "lastName": "Rodríguez Alcobendas",
    "url": "https://www.linkedin.com/in/clara-rodriguez-alcobendas",
    "company": "Coding Giants Spain",
    "position": "Team Lead People Operations",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Clarika",
    "lastName": "People Care",
    "url": "https://www.linkedin.com/in/clarika-people-care-967598207",
    "company": "Clarika Software + Innovation",
    "position": "IT RECRUITER",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Clarisa",
    "lastName": "Cue",
    "url": "https://www.linkedin.com/in/clarisa-c-b4188414a",
    "company": "Clau",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Clarita",
    "lastName": "Aleman Rodriguez",
    "url": "https://www.linkedin.com/in/claritaaleman",
    "company": "Manpower Perú",
    "position": "Business Professional Senior Recruiter - Permanent Placement",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Claudia",
    "lastName": "Chirinos Aguilar",
    "url": "https://www.linkedin.com/in/claudia-chirinos-aguilar",
    "company": "Baubap",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Claudia",
    "lastName": "Cruz",
    "url": "https://www.linkedin.com/in/claudia-cruz-73332496",
    "company": "Quo Digital",
    "position": "IT Recruiter LATAM & People OPS",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Claudia",
    "lastName": "Dos Santos",
    "url": "https://www.linkedin.com/in/claudiadossantos",
    "company": "Compinche",
    "position": "Talent & Hiring Manager",
    "keywords": [
      "hiring",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Claudia",
    "lastName": "Kumpel Fierro",
    "url": "https://www.linkedin.com/in/claudiakumpel",
    "company": "CK People",
    "position": "Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Claudia",
    "lastName": "Ossio",
    "url": "https://www.linkedin.com/in/claudiaossiobb535619",
    "company": "Velozient",
    "position": "Senior Recruiting Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Claudia",
    "lastName": "Oviedo",
    "url": "https://www.linkedin.com/in/claudia-oviedo",
    "company": "Empirical LLC",
    "position": "HR & Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Claudia",
    "lastName": "Shiera Padrón",
    "url": "https://www.linkedin.com/in/claudia-shiera-padr%C3%B3n-b7bbb3249",
    "company": "Huxley",
    "position": "Candidate Recruitment Consultant | Specializing in IT, Finance & Engineering Talent",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Claudia",
    "lastName": "Willmott",
    "url": "https://www.linkedin.com/in/claudia-willmott-046513217",
    "company": "OneInfo Consulting",
    "position": "Talent Acquisition Specialist IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Claudia",
    "lastName": "Zavaleta",
    "url": "https://www.linkedin.com/in/claudia-zavaletaramirez",
    "company": "Able",
    "position": "Talent Manager / People & Operations",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Claudia A.",
    "lastName": "Blanco",
    "url": "https://www.linkedin.com/in/claudia-a-blanco-689637a3",
    "company": "Infosis",
    "position": "Head of Human Resources - Recruiter IT",
    "keywords": [
      "recruiter",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Claudia Rodriguez",
    "lastName": "Cardoso",
    "url": "https://www.linkedin.com/in/claudia-rodriguez-cardoso-1146974a",
    "company": "Open to work",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Claudio German",
    "lastName": "Lacava",
    "url": "https://www.linkedin.com/in/claudio-german-lacava",
    "company": "Cognizant",
    "position": "Trilingual Campus IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Conrado",
    "lastName": "Tavella",
    "url": "https://www.linkedin.com/in/conradotavella",
    "company": "iDelsoft",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Constanza",
    "lastName": "Geremias",
    "url": "https://www.linkedin.com/in/constanza-geremias-3120b0b5",
    "company": "Nybble Group",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Constanza",
    "lastName": "Silva",
    "url": "https://www.linkedin.com/in/constanza-silva-841086226",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Constanza",
    "lastName": "Vanolli",
    "url": "https://www.linkedin.com/in/constanza-vanolli",
    "company": "MITO AI",
    "position": "Head of Talent",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Constanza Abril",
    "lastName": "Bossi",
    "url": "https://www.linkedin.com/in/constanza-abril-bossi-",
    "company": "Ergittek",
    "position": "IT Recruiter & PeopleCare",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Constanza Micaela",
    "lastName": "Medina",
    "url": "https://www.linkedin.com/in/constanza-micaela-medina",
    "company": "Grupo Consultores de Empresas",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Corina",
    "lastName": "Baldasare",
    "url": "https://www.linkedin.com/in/coribaldasare",
    "company": "Kenility",
    "position": "IT Recruiter Partner",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Craig",
    "lastName": "Guntrip",
    "url": "https://www.linkedin.com/in/craig-guntrip-a3a2b3223",
    "company": "Matchtech",
    "position": "Senior Technology Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Cristian",
    "lastName": "Frers",
    "url": "https://www.linkedin.com/in/cristian-frers-722028215",
    "company": "Agnos Inc.",
    "position": "Lead Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Cristian",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/cristianarielgonzalez-",
    "company": "Localpayment",
    "position": "Head of HR",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cristian",
    "lastName": "Hernandez",
    "url": "https://www.linkedin.com/in/cristian-hernandez07",
    "company": "Mercado Libre",
    "position": "Regional People Business Partner Manager - IT & Product Business",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Cristian",
    "lastName": "Santos",
    "url": "https://www.linkedin.com/in/cristian-santos-aaa4ab261",
    "company": "The Functionary",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Cristina",
    "lastName": "Cotrina Roldán",
    "url": "https://www.linkedin.com/in/cristinacotrina",
    "company": "10Pearls",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Cristina",
    "lastName": "Merino Fernández",
    "url": "https://www.linkedin.com/in/cristina-merino-fern%C3%A1ndez-a52a06b8",
    "company": "Monks",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Cristina",
    "lastName": "Montoya",
    "url": "https://www.linkedin.com/in/cristina-montoya-it",
    "company": "SaaS Talent",
    "position": "Talent Acquisition Specialist | Senior Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Cristina",
    "lastName": "Rosal",
    "url": "https://www.linkedin.com/in/cristina-rosal-garc%C3%ADa",
    "company": "Suntory Beverage & Food Spain",
    "position": "Talent Acquisition Partner Iberia",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Cristina",
    "lastName": "Vimer",
    "url": "https://www.linkedin.com/in/cristinavimer",
    "company": "Consultora CV - Selección, Capacitación y Desarrollo Organizacional",
    "position": "Especialista de selección de talentos | Recruiter IT | Headhunting",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "CY",
    "lastName": "Tang",
    "url": "https://www.linkedin.com/in/cy-tang-687309280",
    "company": "Agensi Perkerjaan Joint Resources",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Cynthia",
    "lastName": "Dominguez",
    "url": "https://www.linkedin.com/in/cyndominguez",
    "company": "WorkIT",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Cynthia",
    "lastName": "Ortiz Cárdenas",
    "url": "https://www.linkedin.com/in/cynthiaortizc",
    "company": "Datadog",
    "position": "Technical Recruiter II",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Cynthia",
    "lastName": "Ramos (She/Her)",
    "url": "https://www.linkedin.com/in/cynthia-ramos-talent-acquisition",
    "company": "Brillio",
    "position": "Senior Talent Acquisition Specialist for Mexico",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Cynthia Andrea",
    "lastName": "Garcia",
    "url": "https://www.linkedin.com/in/cynthia-andrea-garcia-064100301",
    "company": "US Consulting HR",
    "position": "IT Recruiter - Asesorías Personalizadas",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Cynthia Elena",
    "lastName": "Paz",
    "url": "https://www.linkedin.com/in/cynthia-elena-paz-a153545",
    "company": "GlobalLogic",
    "position": "Talent Acquisition Senior Manager - IT Recruitment - LATAM",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Carabelli Cichello",
    "url": "https://www.linkedin.com/in/daianacarabelli",
    "company": "Distillery",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Cazzulo",
    "url": "https://www.linkedin.com/in/daiana-cazzulo-431702248",
    "company": "Ovidio IT Consulting",
    "position": "IT Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Delgado",
    "url": "https://www.linkedin.com/in/daiana-delgado-25659118b",
    "company": "Digital HR.",
    "position": "IT Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/daiana-garc%C3%ADa-200aa221b",
    "company": "Profesional independiente",
    "position": "RECRUITER FREELANCE",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Gómez Monfort",
    "url": "https://www.linkedin.com/in/daiana-g%C3%B3mez-monfort",
    "company": "AppDirect",
    "position": "Talent Acquisition - IT Senior Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Junco",
    "url": "https://www.linkedin.com/in/daianabjunco",
    "company": "Profesional independiente",
    "position": "Sourcer/ Recruiter",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Libonati",
    "url": "https://www.linkedin.com/in/daiana-libonati",
    "company": "Werben HR LLC",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "M.",
    "url": "https://www.linkedin.com/in/daiana-m-b8001b1b5",
    "company": "Infocus",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Martín",
    "url": "https://www.linkedin.com/in/daiana-mart%C3%ADn-2537b5207",
    "company": "MinData",
    "position": "Recruiting Sourcer",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Santillán",
    "url": "https://www.linkedin.com/in/daiana-mara-santillan",
    "company": "Accenture Argentina",
    "position": "Recruiting Sourcer",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Solorzano",
    "url": "https://www.linkedin.com/in/daiana-solorzano-2b9929197",
    "company": "Manage Resources Recursos Humanos",
    "position": "Recruiter IT Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Sosa",
    "url": "https://www.linkedin.com/in/daianasosa",
    "company": "Persat",
    "position": "People Partner TA & Ops",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Taurino",
    "url": "https://www.linkedin.com/in/daianataurino",
    "company": "Impera & Co.",
    "position": "Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Daiana",
    "lastName": "Wyngaard",
    "url": "https://www.linkedin.com/in/daianawyngaard",
    "company": "Randstad Argentina",
    "position": "HR Generalist & Talent acquisition specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Dalia",
    "lastName": "Kaul",
    "url": "https://www.linkedin.com/in/dalia-kaul-5483116",
    "company": "Profesional independiente",
    "position": "Psicologa - Selectora - Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Dalit",
    "lastName": "Goldstein",
    "url": "https://www.linkedin.com/in/dalit-goldstein",
    "company": "Marvik",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Dalma",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/dalma-andrea-diaz",
    "company": "Chipax (YC S21)",
    "position": "People & Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Damian",
    "lastName": "Angel",
    "url": "https://www.linkedin.com/in/xixtech",
    "company": "Xixtech",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Damian",
    "lastName": "Apfelberg",
    "url": "https://www.linkedin.com/in/damianapfelberg",
    "company": "BRIGHTSCOUT",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Damintha",
    "lastName": "Weerasinghe",
    "url": "https://www.linkedin.com/in/damintha",
    "company": "Xelora S",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Dan",
    "lastName": "Kejsefman",
    "url": "https://www.linkedin.com/in/dan-kejsefman-84502164",
    "company": "Avature",
    "position": "Talent Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Dana",
    "lastName": "S. Riera",
    "url": "https://www.linkedin.com/in/dana-s-riera",
    "company": "Oktana Corporation",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Dana",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/dana-sanchez-0a96ab197",
    "company": "Oktana Corporation",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Dana Laura",
    "lastName": "Passanisi",
    "url": "https://www.linkedin.com/in/dana-laura-passanisi-46119955",
    "company": "IQVIA",
    "position": "Senior Talent Acquisition Specialist, LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Chiappero",
    "url": "https://www.linkedin.com/in/daniel-chiappero-0518a612b",
    "company": "Llao Llao Hotel & Resort Golf - Spa",
    "position": "Coordinador de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Delgado",
    "url": "https://www.linkedin.com/in/daniel-delgado-81275b227",
    "company": "Ballast Lane Applications, LLC",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Ferrero",
    "url": "https://www.linkedin.com/in/danielferrero97",
    "company": "Ancient | The Wisdom of Technology",
    "position": "Sr. IT Talent Acquisition Partner | Proyectos Internacionales - US Tech Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Gutierrez",
    "url": "https://www.linkedin.com/in/daniel-gutierrez-174447258",
    "company": "WillDom",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Londoño Vásquez",
    "url": "https://www.linkedin.com/in/daniel-londo%C3%B1o-v%C3%A1squez-5bb2a0266",
    "company": "SoftwareONE Colombia",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Manzaneda",
    "url": "https://www.linkedin.com/in/danielmanzaneda",
    "company": "ALL WORKING",
    "position": "Talent Acquisition Analyst - Preteco",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Nieves",
    "url": "https://www.linkedin.com/in/danielnv",
    "company": "Sonatafy Technology | Software Delivery Done Right",
    "position": "Talent Acquisition Team Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Pomareda Castro",
    "url": "https://www.linkedin.com/in/itrecruiter-daniel-henry-pomareda-castro",
    "company": "Zoluxiones North America",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "R.",
    "url": "https://www.linkedin.com/in/daniel-r-58b4a6229",
    "company": "Castellana Selección Personal IT y Recursos Humanos",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Salazar Celis",
    "url": "https://www.linkedin.com/in/danielsalazar-it-recruiter",
    "company": "IN Groupe",
    "position": "Talent Acquisition Lead Latam",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Samudio",
    "url": "https://www.linkedin.com/in/daniel-samudio",
    "company": "Freelance (Self employed)",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniel",
    "lastName": "Zapata",
    "url": "https://www.linkedin.com/in/danzprecruiter",
    "company": "Activate Talent",
    "position": "Senior Global Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniel Alejandro",
    "lastName": "Pinto Roglia",
    "url": "https://www.linkedin.com/in/danielpintorrhh",
    "company": "ASHER RH",
    "position": "Talent acquisition IT - Freelancer",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Angelini",
    "url": "https://www.linkedin.com/in/daniela-angelini",
    "company": "NaNLABS",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Arrascaeta",
    "url": "https://www.linkedin.com/in/daniela-arrascaeta",
    "company": "EPAM Systems",
    "position": "IT Recruiter - Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "B",
    "url": "https://www.linkedin.com/in/daniela-bodo",
    "company": "Mission",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Bar",
    "url": "https://www.linkedin.com/in/daniela-bar-99868227",
    "company": "Vecttor",
    "position": "Técnica de selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Bolívar",
    "url": "https://www.linkedin.com/in/daniela-bol%C3%ADvar-693376149",
    "company": "BA Global Talent",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Castano",
    "url": "https://www.linkedin.com/in/daniela-castano-3692351b8",
    "company": "Livefront",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "De Castro González",
    "url": "https://www.linkedin.com/in/daniela-de-castro-gonzalez",
    "company": "Wizeline",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Elvira",
    "url": "https://www.linkedin.com/in/danielaelvira",
    "company": "PwC Argentina",
    "position": "Sr. HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Esis",
    "url": "https://www.linkedin.com/in/danielaesis",
    "company": "IT Resources S.A",
    "position": "IT Recruiter & Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Espinal",
    "url": "https://www.linkedin.com/in/daniela-espinal-1ab06b198",
    "company": "Aditi LATAM",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Galvis Sayago (She/ her)",
    "url": "https://www.linkedin.com/in/danielagalvissayago",
    "company": "DoorDash for Business",
    "position": "Technical Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Giannotti",
    "url": "https://www.linkedin.com/in/daniela-giannotti-9228b016",
    "company": "Neginet",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Gimenez",
    "url": "https://www.linkedin.com/in/daniela-gimenez-962372138",
    "company": "EY",
    "position": "Supervising Associate Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Gomez",
    "url": "https://www.linkedin.com/in/daniela-gomez-64979b18a",
    "company": "People IT",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/daniela-gonzalez-00b7921b0",
    "company": "WEEM",
    "position": "Global Talent Acquisition & Recruiting",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Hernandez Moreno",
    "url": "https://www.linkedin.com/in/daniela-hernandez-moreno-175a621a9",
    "company": "MinData",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Lago",
    "url": "https://www.linkedin.com/in/daniela-lucia-lago",
    "company": "GeoPagos",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Mejía Calle",
    "url": "https://www.linkedin.com/in/daniela-mej%C3%ADa-calle",
    "company": "Arvenda LLC",
    "position": "Operations & HR Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Miceli",
    "url": "https://www.linkedin.com/in/daniela-miceli-90379b219",
    "company": "The Flock",
    "position": "Lead Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Morales",
    "url": "https://www.linkedin.com/in/psicdanielamorales",
    "company": "Golabs",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Ogas",
    "url": "https://www.linkedin.com/in/danielaogas",
    "company": "PSh | Providing Digital Transformation",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Poveda Laurito",
    "url": "https://www.linkedin.com/in/danielapoveda0308",
    "company": "UniFirst Corporation",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Quintero M.",
    "url": "https://www.linkedin.com/in/danielaquinterom",
    "company": "Lean Tech",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Rico Castellanos",
    "url": "https://www.linkedin.com/in/daniela-rico-castellanos-4745022a0",
    "company": "Vinali Group",
    "position": "RPO Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Rojas",
    "url": "https://www.linkedin.com/in/danielarojasmendoza",
    "company": "Roca Alliances",
    "position": "Senior Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Ruggeri",
    "url": "https://www.linkedin.com/in/danielaruggeri",
    "company": "DXC Technology",
    "position": "Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Tassile",
    "url": "https://www.linkedin.com/in/danielatassile",
    "company": "Personal",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Vincenzini",
    "url": "https://www.linkedin.com/in/daniela-vincenzini",
    "company": "Daniela Vincenzini RRHH",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Daniela",
    "lastName": "Yanello",
    "url": "https://www.linkedin.com/in/danielayanello",
    "company": "People & Impact",
    "position": "Consultora en Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Daniela Alejandra",
    "lastName": "Muñoz",
    "url": "https://www.linkedin.com/in/daniela-alejandra-mu%C3%B1oz-23640954",
    "company": "Kaizen Recursos Humanos",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Daniela Belén",
    "lastName": "Di Mascio",
    "url": "https://www.linkedin.com/in/danieladimascio",
    "company": "Cooperativa de Trabajo TECSO Ltda.",
    "position": "HR Business Partner Sr.",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Daniella",
    "lastName": "Villalobos Rivero",
    "url": "https://www.linkedin.com/in/daniella-villalobos-rivero-020ab220a",
    "company": "IT4W",
    "position": "IT Talent Acquisition & People Partner",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Danisa",
    "lastName": "Sanjuanbenito",
    "url": "https://www.linkedin.com/in/danisa-sanjuanbenito",
    "company": "VML",
    "position": "Americas Talent HUB Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Danko",
    "lastName": "Lora",
    "url": "https://www.linkedin.com/in/danko-lora",
    "company": "Delinea",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Daria",
    "lastName": "Verbovska",
    "url": "https://www.linkedin.com/in/daria-verbovska-b14820221",
    "company": "Svitla Systems, Inc.",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Dariana",
    "lastName": "Osuch",
    "url": "https://www.linkedin.com/in/dariana-osuch",
    "company": "Rocbird",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Dariana",
    "lastName": "Pelinski",
    "url": "https://www.linkedin.com/in/darianapelinski",
    "company": "Mercado Libre",
    "position": "Talent Acquisition IT & Product",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Darya",
    "lastName": "R.",
    "url": "https://www.linkedin.com/in/daryarud",
    "company": "Buffer Group",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Dave",
    "lastName": "Haynes",
    "url": "https://www.linkedin.com/in/dave-haynes-8992972b6",
    "company": "GENTY recruitment",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "David",
    "lastName": "Epstein",
    "url": "https://www.linkedin.com/in/davidepstein2002",
    "company": "Goodwin Recruiting",
    "position": "Recruiting Partner",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "David",
    "lastName": "Hasan",
    "url": "https://www.linkedin.com/in/david-hasan-865847159",
    "company": "sinaptia",
    "position": "Recruiter and People Manager",
    "keywords": [
      "recruiter",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "David",
    "lastName": "Haynes",
    "url": "https://www.linkedin.com/in/dhaynes3",
    "company": "Haynes consoulting",
    "position": "Sr. Technical Recruiter / HR Consultant",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "David",
    "lastName": "Novelo",
    "url": "https://www.linkedin.com/in/davidnovelo91",
    "company": "Ensitech",
    "position": "IT Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "David",
    "lastName": "Paz",
    "url": "https://www.linkedin.com/in/dapazb",
    "company": "HireLATAM",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "David",
    "lastName": "Perozo R.",
    "url": "https://www.linkedin.com/in/david-perozo-rodriguez",
    "company": "Freelance Latin America",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Dawn R",
    "lastName": "Tefel",
    "url": "https://www.linkedin.com/in/tef24",
    "company": "Verint",
    "position": "Director, Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Debora",
    "lastName": "Perasso",
    "url": "https://www.linkedin.com/in/debora-perasso-231b33191",
    "company": "Who? Consultora Integral",
    "position": "IT Recruiter Jr",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Debora",
    "lastName": "Ramos",
    "url": "https://www.linkedin.com/in/debora-florencia-ramos-",
    "company": "Lemon",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Deborah",
    "lastName": "Irvine",
    "url": "https://www.linkedin.com/in/irvinedeborah",
    "company": "TalentyO",
    "position": "Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Deepak",
    "lastName": "Ojha",
    "url": "https://www.linkedin.com/in/deepak-ojha-5a9041213",
    "company": "E-Solutions",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Deepamalar",
    "lastName": "Sivanesan",
    "url": "https://www.linkedin.com/in/deepamalar-sivanesan-7062459",
    "company": "InfoDrive Solutions",
    "position": "Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Deepika",
    "lastName": "Deepika",
    "url": "https://www.linkedin.com/in/deepika-deepika-75799a210",
    "company": "MSconsult4U",
    "position": "US IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Amadeo",
    "url": "https://www.linkedin.com/in/delfina-amadeo",
    "company": "Capitole Consulting",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Degregori",
    "url": "https://www.linkedin.com/in/delfina-degregori-8a87a7230",
    "company": "numia",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/delfina-diaz",
    "company": "Accenture Argentina",
    "position": "Recruiting Senior Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Galli",
    "url": "https://www.linkedin.com/in/delfina-galli",
    "company": "Accenture España",
    "position": "Sr IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Heilmann",
    "url": "https://www.linkedin.com/in/delfina-heilmann-a2092616a",
    "company": "TELUS Digital",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Ibarra",
    "url": "https://www.linkedin.com/in/delfina-ibarra-936213226",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Pereyra",
    "url": "https://www.linkedin.com/in/pereyradelfina",
    "company": "AS Recursos Humanos",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Perez Caamaño",
    "url": "https://www.linkedin.com/in/delfina-perez-caama%C3%B1o-5120001a7",
    "company": "SEIDOR",
    "position": "Talent Acquisition IT Jr",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Tagtachian",
    "url": "https://www.linkedin.com/in/delfina-tagtachian-1a4742182",
    "company": "Ryz Labs",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Delfina",
    "lastName": "Van Thienen",
    "url": "https://www.linkedin.com/in/delfina-van-thienen-a40a51b1",
    "company": "Accenture Argentina",
    "position": "HR Service Delivery Associate Manager Regional (Client: Mercado Libre)",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Denis Martín",
    "lastName": "Navarro",
    "url": "https://www.linkedin.com/in/navarrodenis",
    "company": "YPF SA",
    "position": "Jefe de Atracción y Selección de Talento Upstream, Gas & Energía",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Denise",
    "lastName": "Hernández",
    "url": "https://www.linkedin.com/in/denise-hern%C3%A1ndez-b50039216",
    "company": "ParallelStaff",
    "position": "Talent Acquisition Executive",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Denise",
    "lastName": "Mecca",
    "url": "https://www.linkedin.com/in/deniseluisamecca",
    "company": "Newfire Global Partners",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Denise",
    "lastName": "Rostkier",
    "url": "https://www.linkedin.com/in/denise-rostkier",
    "company": "Plan-IT",
    "position": "Lider de RRHH | IT Recruiter SR.",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Denisse",
    "lastName": "Jiménez León",
    "url": "https://www.linkedin.com/in/denisse-jim%C3%A9nez-le%C3%B3n-b41876186",
    "company": "10Pearls",
    "position": "People Attraction Specialist | IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Dennis",
    "lastName": "Bernau",
    "url": "https://www.linkedin.com/in/dennisbernau",
    "company": "Apex Social Global Exchange Foundation",
    "position": "Academic & Talent Development Manager, DACH",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Devi",
    "lastName": "Pillai, SHRM-CP",
    "url": "https://www.linkedin.com/in/devi-pillai-shrm-cp-0296b974",
    "company": "Princeton University",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Deyci",
    "lastName": "Gallego",
    "url": "https://www.linkedin.com/in/deyci-gallego-3b4a3615a",
    "company": "TEAM International",
    "position": "Team Lead HR",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Diana",
    "lastName": "Armijo De Souza",
    "url": "https://www.linkedin.com/in/diana-armijo",
    "company": "Grupo CINTE",
    "position": "Talent Attraction Leader & Key Account Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Diana",
    "lastName": "Corigliano",
    "url": "https://www.linkedin.com/in/dianacorigliano",
    "company": "Improving",
    "position": "Recruitment & Selection Analyst IT at Improving South America",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Diana",
    "lastName": "Espinosa",
    "url": "https://www.linkedin.com/in/diana-espinosa-b45403b7",
    "company": "Chronos Consulting",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diana",
    "lastName": "Infante",
    "url": "https://www.linkedin.com/in/dianacinfante",
    "company": "Hublance",
    "position": "Sr Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Diana",
    "lastName": "Mazzuca",
    "url": "https://www.linkedin.com/in/dianamazzuca",
    "company": "ÜMA Salud IA",
    "position": "People & Culture - HRBP ÜMA",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Diana",
    "lastName": "Suarez",
    "url": "https://www.linkedin.com/in/diana-suarez-82bb70152",
    "company": "LinkTIC",
    "position": "Talent Acquisition Expert",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diana",
    "lastName": "Vignale",
    "url": "https://www.linkedin.com/in/diana-vignale-798017224",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diana Belén",
    "lastName": "Díaz",
    "url": "https://www.linkedin.com/in/diana-bel%C3%A9n-d%C3%ADaz-6ab87b56",
    "company": "Manage Resources Recursos Humanos",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Diana Laura",
    "lastName": "Duarte",
    "url": "https://www.linkedin.com/in/diana-laura-duarte-sosa",
    "company": "GoGloby",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Dianela",
    "lastName": "Digiuni",
    "url": "https://www.linkedin.com/in/dianela-digiuni",
    "company": "Policia de la Provincia de Córdoba",
    "position": "Especialista de Selección de Personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Alvarez",
    "url": "https://www.linkedin.com/in/diegoalvarez-arg",
    "company": "Consultora Gestal",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Bellone",
    "url": "https://www.linkedin.com/in/diegobellone",
    "company": "Accenture Argentina",
    "position": "Recruiting Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Castro",
    "url": "https://www.linkedin.com/in/diego-castro-56263812a",
    "company": "CFOTech IT Global Services",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Delgado Jaimes",
    "url": "https://www.linkedin.com/in/diegodelgadoj",
    "company": "Mercado Libre",
    "position": "Talent Acquisition IT & Product Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Gimenez Maliszewski",
    "url": "https://www.linkedin.com/in/diegogimenezmaliszewski",
    "company": "Perficient Latin America",
    "position": "Regional Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Jurfest",
    "url": "https://www.linkedin.com/in/diego-jurfest",
    "company": "AstroPay",
    "position": "People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Lujan",
    "url": "https://www.linkedin.com/in/dielu",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Marques",
    "url": "https://www.linkedin.com/in/diego-marques-1874571b8",
    "company": "Webstarted",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Ortega",
    "url": "https://www.linkedin.com/in/licdiegoortega",
    "company": "Apex Systems",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Palleiro Ferreira",
    "url": "https://www.linkedin.com/in/diego-palleiro-ferreira-6709a2222",
    "company": "BASF",
    "position": "Talent Acquisition Specialist - HR Services Americas",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Pepino",
    "url": "https://www.linkedin.com/in/diegopepino",
    "company": "WillDom",
    "position": "Human Resources Business Partner (HRBP) Manager",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Rosales",
    "url": "https://www.linkedin.com/in/diegorosalest",
    "company": "Akkodis",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Saraidarian",
    "url": "https://www.linkedin.com/in/diegosaraidarian",
    "company": "Zeo Consulting",
    "position": "Executive Associate - Headhunter - Technical Recruiter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Trejo",
    "url": "https://www.linkedin.com/in/diego-trejo-063b1b146",
    "company": "VASS",
    "position": "Hiring Consultant",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Villamarin",
    "url": "https://www.linkedin.com/in/diego-villamarin-b5732713",
    "company": "HR Sanctum",
    "position": "Consultor | Selector Sr | Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Diego",
    "lastName": "Zaldívar",
    "url": "https://www.linkedin.com/in/diego-zald%C3%ADvar-rys",
    "company": "Scitum",
    "position": "Sr IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Diego Andrés",
    "lastName": "B, MSc",
    "url": "https://www.linkedin.com/in/dboterom",
    "company": "Recurly",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Diego Andrés",
    "lastName": "Murmis",
    "url": "https://www.linkedin.com/in/damurmis",
    "company": "Hire Sorz",
    "position": "Managing Recruiter & BD",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Diego Martín",
    "lastName": "Pizzo",
    "url": "https://www.linkedin.com/in/diegopizzo",
    "company": "Corporix HR",
    "position": "HR-consultant recruitment",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Diksha",
    "lastName": "Haryani",
    "url": "https://www.linkedin.com/in/diksha-haryani-a03309109",
    "company": "Verinon",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Dipen",
    "lastName": "Bhardwaj",
    "url": "https://www.linkedin.com/in/dipen-bhardwaj-859052162",
    "company": "Cyberhelp Staffing",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Dmytro",
    "lastName": "Lysenko",
    "url": "https://www.linkedin.com/in/dmytro-lysenko-2487a6a4",
    "company": "Dev.Pro",
    "position": "Recruiting Researcher",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Dominique",
    "lastName": "Guyot",
    "url": "https://www.linkedin.com/in/dominiqueguyot",
    "company": "CourtAvenue",
    "position": "HR Manager – LATAM",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Dragana",
    "lastName": "Delova",
    "url": "https://www.linkedin.com/in/dragana-delova-74a2538a",
    "company": "Aristocrat",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Dulce",
    "lastName": "Garay",
    "url": "https://www.linkedin.com/in/dulce-g-094106170",
    "company": "InfoVision Inc.",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Dusan",
    "lastName": "Senkovic",
    "url": "https://www.linkedin.com/in/dusan-senkovic",
    "company": "Kenility",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Débora",
    "lastName": "Firpo",
    "url": "https://www.linkedin.com/in/deborafirpo",
    "company": "Wayni",
    "position": "People & Culture Head",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Débora Carolina",
    "lastName": "Pisnoy",
    "url": "https://www.linkedin.com/in/d%C3%A9bora-carolina-pisnoy-5697969",
    "company": "Freelance",
    "position": "IT Recruiter/Recruiter y Capacitadora (Freelance)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ed",
    "lastName": "Winstanley",
    "url": "https://www.linkedin.com/in/edwardwinstanley",
    "company": "Datadog",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Eduardo",
    "lastName": "Pinto",
    "url": "https://www.linkedin.com/in/eduardo-pinto-talenthub",
    "company": "TalentHub",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Eduardo",
    "lastName": "R.",
    "url": "https://www.linkedin.com/in/eduardo-r-a486ab208",
    "company": "RHE Consultora - Recursos Humanos Especializados",
    "position": "Staff Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Egle",
    "lastName": "Luque Triguero",
    "url": "https://www.linkedin.com/in/egle-luque-triguero-660420195",
    "company": "Urbetrack",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ekaterina",
    "lastName": "Kovrigina 🤝💻",
    "url": "https://www.linkedin.com/in/kovrigina-ev",
    "company": "Девелоперская компания Брусника",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Elaine",
    "lastName": "Lim",
    "url": "https://www.linkedin.com/in/elainelim07",
    "company": "ViTrox Corporation Berhad",
    "position": "Assistant Manager | People Management",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Elba Maria",
    "lastName": "Caseres",
    "url": "https://www.linkedin.com/in/elba-maria-caseres-887b62217",
    "company": "Cross Border Talents",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Elena",
    "lastName": "B.",
    "url": "https://www.linkedin.com/in/elena-baron",
    "company": "Nexton",
    "position": "Senior Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Elena",
    "lastName": "Gutierrez",
    "url": "https://www.linkedin.com/in/leleg94",
    "company": "Allata",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Elena",
    "lastName": "Netkach",
    "url": "https://www.linkedin.com/in/olenanetkach",
    "company": "Incorra",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Elena",
    "lastName": "Pico",
    "url": "https://www.linkedin.com/in/elenapico",
    "company": "Launch Consulting Group",
    "position": "Senior IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Eleonora",
    "lastName": "Gottifredi",
    "url": "https://www.linkedin.com/in/ele-gottifredi",
    "company": "Pentasia",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Eli",
    "lastName": "Murialdo",
    "url": "https://www.linkedin.com/in/elimurialdo",
    "company": "Solutions García Recruit",
    "position": "Encargada de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Eliana",
    "lastName": "Beo",
    "url": "https://www.linkedin.com/in/eliana-beo",
    "company": "Aditi LATAM",
    "position": "SR IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Eliana",
    "lastName": "Castillo Rengifo",
    "url": "https://www.linkedin.com/in/elianacr",
    "company": "Praxis",
    "position": "IT Recruiter/ Analista de Reclutamiento y Selección",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Eliana",
    "lastName": "Franco Alvarez",
    "url": "https://www.linkedin.com/in/eliana-franco-",
    "company": "Buk",
    "position": "Tech Recruiting Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Eliana",
    "lastName": "Martinez",
    "url": "https://www.linkedin.com/in/eliana-martinez-900a429a",
    "company": "Assertia Solutions",
    "position": "IT Recruiter at Assertia Solutions",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Eliana",
    "lastName": "Pranzetti",
    "url": "https://www.linkedin.com/in/eliana-pranzetti-235458109",
    "company": "Nimble.LA",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Eliana",
    "lastName": "Santini Reyes",
    "url": "https://www.linkedin.com/in/eliana-santini-reyes",
    "company": "QDS - Group",
    "position": "IT Recruiter/ Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Eliana",
    "lastName": "Viña",
    "url": "https://www.linkedin.com/in/eliana-vi%C3%B1a-934920219",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Elias",
    "lastName": "Tami",
    "url": "https://www.linkedin.com/in/eliastami",
    "company": "IT Crowd",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Elina",
    "lastName": "Mantilla",
    "url": "https://www.linkedin.com/in/elina-mantilla-963a9824",
    "company": "Grupo SUESSA - GS",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Elisa",
    "lastName": "Busson",
    "url": "https://www.linkedin.com/in/elisabusson",
    "company": "EY",
    "position": "Senior Associate Talent Discovery Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Elisa",
    "lastName": "Soraire",
    "url": "https://www.linkedin.com/in/elisasoraire",
    "company": "LIM",
    "position": "Senior Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Elisabeth",
    "lastName": "Langer",
    "url": "https://www.linkedin.com/in/langerelisabeth",
    "company": "WES",
    "position": "IT Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Elisabeth",
    "lastName": "Triay",
    "url": "https://www.linkedin.com/in/elisabethtriay",
    "company": "Trima RH",
    "position": "Responsable de selección, evaluación y desarrollo de personas.",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Elkin",
    "lastName": "Giraldo",
    "url": "https://www.linkedin.com/in/elkin-giraldo-arenas",
    "company": "Dyninno Group",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Emanuel",
    "lastName": "Stehr",
    "url": "https://www.linkedin.com/in/emanuel-stehr",
    "company": "Agent",
    "position": "Lead Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Emely Ferrer",
    "lastName": "Lic. en RRHH, Coach - Gestión de Talentos",
    "url": "https://www.linkedin.com/in/emely-ferrer-lic-en-rrhh-coach-gesti%C3%B3n-de-talentos-0131687b",
    "company": "NAEZ",
    "position": "IT Recruiter / Líder Talento Humano - Contractor",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Emi",
    "lastName": "Leon",
    "url": "https://www.linkedin.com/in/emilianoleonc",
    "company": "Palermo Advisors",
    "position": "Co-founder and Head of Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Emilce",
    "lastName": "Perez Zambón",
    "url": "https://www.linkedin.com/in/emilce-perez-zambon",
    "company": "Better Collective",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Emilia",
    "lastName": "Beccari",
    "url": "https://www.linkedin.com/in/emilia-beccari",
    "company": "Selectium",
    "position": "Recruiting Sourcer",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Emilia",
    "lastName": "Conti",
    "url": "https://www.linkedin.com/in/emiliaconti",
    "company": "ITPS ONE",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Emilia",
    "lastName": "Fandiño",
    "url": "https://www.linkedin.com/in/emilia-fandi%C3%B1o-bb57b4226",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Emilia",
    "lastName": "Loket",
    "url": "https://www.linkedin.com/in/emilia-loket-2785172a6",
    "company": "Tech City",
    "position": "IT recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Emilia",
    "lastName": "Sauer",
    "url": "https://www.linkedin.com/in/emiliasauer",
    "company": "Argeniss Software",
    "position": "Talent Acquisition & People Care",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Emilia",
    "lastName": "Soto",
    "url": "https://www.linkedin.com/in/emilia-soto",
    "company": "ExxonMobil",
    "position": "Regional Experienced Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Emilia",
    "lastName": "Vicini",
    "url": "https://www.linkedin.com/in/emilia-vicini",
    "company": "Adaptive Teams",
    "position": "Head of Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Emiliano",
    "lastName": "Mercado",
    "url": "https://www.linkedin.com/in/emiliano-mercado-b0a6231a2",
    "company": "UProfit",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Emiliano",
    "lastName": "Unzeta Santiago",
    "url": "https://www.linkedin.com/in/emiliano-unzeta-santiago",
    "company": "Autónomo",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Emilie",
    "lastName": "Machet",
    "url": "https://www.linkedin.com/in/emiliemachet",
    "company": "Job&Talent",
    "position": "Senior Talent Acquisition Specialist - Sales (Europe, US & Latam)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Emily",
    "lastName": "Lafleche",
    "url": "https://www.linkedin.com/in/emily-lafleche",
    "company": "Studio Hakuna",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Emily",
    "lastName": "Smith",
    "url": "https://www.linkedin.com/in/emily-smith-82aa2b190",
    "company": "Jahnel Group",
    "position": "Director of Recruiting",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Emilyn",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/emilyn-fernandez-562559145",
    "company": "Indra",
    "position": "IT Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Emir",
    "lastName": "Storani",
    "url": "https://www.linkedin.com/in/itrecruiter-emirstorani",
    "company": "Compulsive Coders",
    "position": "IT Talent Recruiter.",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Emma",
    "lastName": "Bracho Antunez",
    "url": "https://www.linkedin.com/in/emma-bracho",
    "company": "CONEXIONHR - Recruiting Company",
    "position": "IT Recruiter & Headhunting",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Emma",
    "lastName": "D.",
    "url": "https://www.linkedin.com/in/emma-d-398989237",
    "company": "Datahrit",
    "position": "Human Resources Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Emmanuel",
    "lastName": "Villafañe",
    "url": "https://www.linkedin.com/in/emmanuel-villafane",
    "company": "Baja Technologies, Inc.",
    "position": "Head of Talent Acquisition",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Emrick",
    "lastName": "ARDISSON",
    "url": "https://www.linkedin.com/in/emrick-ardisson",
    "company": "Sword Group",
    "position": "Talent Acquisition & HR Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Eniuska",
    "lastName": "Sira",
    "url": "https://www.linkedin.com/in/eniuskasira",
    "company": "Developers.Net",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Enrique Carlos",
    "lastName": "De la Garza Muñiz",
    "url": "https://www.linkedin.com/in/enriquedelagarza-ti",
    "company": "Proceti",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ercilia",
    "lastName": "Canale",
    "url": "https://www.linkedin.com/in/ercilia-canale-2383a150",
    "company": "TradeHelm, Inc.",
    "position": "HR Analyst & IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Erica Lucia",
    "lastName": "Callari",
    "url": "https://www.linkedin.com/in/erica-lucia-callari-651951210",
    "company": "Ethos Technology Srl",
    "position": "HR Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ericka",
    "lastName": "Barboza Madrigal",
    "url": "https://www.linkedin.com/in/ericka-barboza-madrigal-91a1ab117",
    "company": "Pfizer",
    "position": "North America Talent Acquisition Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Erika",
    "lastName": "Santa Cruz Patroni",
    "url": "https://www.linkedin.com/in/erikascp",
    "company": "Outcode Software",
    "position": "Recruitment Manager Peru",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ernestina",
    "lastName": "Ibarra",
    "url": "https://www.linkedin.com/in/ernestina-ibarra-a9bb02240",
    "company": "Zafirus Technologies",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ernestina",
    "lastName": "Oyuela Sadino",
    "url": "https://www.linkedin.com/in/ernestina-maria-oyuela-sadino-",
    "company": "JPMorganChase",
    "position": "Recruiting Intern",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ernesto",
    "lastName": "Fabbri Peralta",
    "url": "https://www.linkedin.com/in/ernesto-fabbri-peralta-538bb587",
    "company": "E-Frontiers",
    "position": "International Recruiter Specialist, BD & Account Manager",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ernesto",
    "lastName": "Fiorenza",
    "url": "https://www.linkedin.com/in/ernestofiorenza",
    "company": "Kinetic Corp",
    "position": "Talent Acquisition Manager - Kinetic Talent",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Erwin",
    "lastName": "Montenegro",
    "url": "https://www.linkedin.com/in/erwin-montenegro-622a17174",
    "company": "HireBoost",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Escarleth",
    "lastName": "De anda Ortiz",
    "url": "https://www.linkedin.com/in/escarleth-de-anda-ortiz-4b76b1151",
    "company": "Accenture México",
    "position": "Recruiting Senior Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Esmeralda",
    "lastName": "Cantón",
    "url": "https://www.linkedin.com/in/esmerecluta",
    "company": "Growth Acceleration Partners",
    "position": "Senior IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Estanislao",
    "lastName": "Vega de la Llosa",
    "url": "https://www.linkedin.com/in/estanislaovega",
    "company": "Xometry",
    "position": "Talent Sourcer & IT Recruiter",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Esteban",
    "lastName": "Chiabrando",
    "url": "https://www.linkedin.com/in/esteban-chiabrando-911526207",
    "company": "Infocus",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Esteban",
    "lastName": "Mantero",
    "url": "https://www.linkedin.com/in/estebanmantero",
    "company": "IT Crowd",
    "position": "It Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Esteban",
    "lastName": "Terrabusi",
    "url": "https://www.linkedin.com/in/esteban-terrabusi-15194822",
    "company": "Mercado Libre",
    "position": "Talent Development, Culture & Engagement Lead (IT & Product)",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Estefani",
    "lastName": "Lorente",
    "url": "https://www.linkedin.com/in/estefani-lorente",
    "company": "Caramel Point",
    "position": "People & Talent Acquisition | IT Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Estefania",
    "lastName": "Kañera",
    "url": "https://www.linkedin.com/in/estefania-ka%C3%B1era-ab253395",
    "company": "Known Online",
    "position": "Head of People & Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Estefania",
    "lastName": "La Torre",
    "url": "https://www.linkedin.com/in/estefanial",
    "company": "Stefanini LATAM",
    "position": "LATAM Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Estefania",
    "lastName": "Schoppe",
    "url": "https://www.linkedin.com/in/estefania-schoppe-27b2391b0",
    "company": "iHuman.agency",
    "position": "Global Talent Aquisition Lead- Tech Recruiter",
    "keywords": [
      "people/talent leadership",
      "recruiter"
    ]
  },
  {
    "firstName": "Estefania",
    "lastName": "Toledo",
    "url": "https://www.linkedin.com/in/estefaniatoledob",
    "company": "Kibernum",
    "position": "Tech Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Estefanie",
    "lastName": "Cortez Freudenthal",
    "url": "https://www.linkedin.com/in/estefanie-cortez-freudenthal-88bbb91bb",
    "company": "ZEROGATE",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Estefany",
    "lastName": "De Sousa",
    "url": "https://www.linkedin.com/in/estefanydesousa",
    "company": "Atom",
    "position": "Senior Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Estefany",
    "lastName": "Garcia",
    "url": "https://www.linkedin.com/in/estefany-garcia",
    "company": "TGV Americas",
    "position": "Talent Acquisition Specialist | US & LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Estefany",
    "lastName": "Pleitez Quezada",
    "url": "https://www.linkedin.com/in/estefany-pleitez",
    "company": "Cognizant",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Estefanía",
    "lastName": "Ammirati",
    "url": "https://www.linkedin.com/in/estefaniaammirati",
    "company": "Keep Solutions",
    "position": "Co-Founder | Recruitment Operations Manager",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Estefanía",
    "lastName": "Arango Ospina",
    "url": "https://www.linkedin.com/in/estefan%C3%ADa-arango-ospina",
    "company": "Globant",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Estefanía",
    "lastName": "León Balestra",
    "url": "https://www.linkedin.com/in/tefileon",
    "company": "Wootic",
    "position": "Head of People & Culture",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Estefanía",
    "lastName": "Santinelli",
    "url": "https://www.linkedin.com/in/estefaniasantinelli",
    "company": "Independiente / Freelance",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Estefanía",
    "lastName": "Villada B",
    "url": "https://www.linkedin.com/in/estefan%C3%ADa-villada-b-14569a214",
    "company": "groei-IT",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ester",
    "lastName": "Ninci",
    "url": "https://www.linkedin.com/in/ester-ninci-0825551b7",
    "company": "Lenis",
    "position": "HR- IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Esther",
    "lastName": "Ledesma",
    "url": "https://www.linkedin.com/in/esther-ledesma-8891b3141",
    "company": "Hospiten",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Adalio",
    "url": "https://www.linkedin.com/in/eugenia-adalio",
    "company": "CEVA SALUD ANIMAL",
    "position": "HRBP Jr Cono Sur",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Caracci",
    "url": "https://www.linkedin.com/in/eugenia-caracci-48852113b",
    "company": "WeDevelop",
    "position": "IT Recruiter / HR analyst",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Diaz Balmaceda",
    "url": "https://www.linkedin.com/in/eugenia-diaz-balmaceda",
    "company": "Galileo Financial Technologies",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Galdós",
    "url": "https://www.linkedin.com/in/eugenia-gald%C3%B3s",
    "company": "Profesional independiente",
    "position": "Freelance Recruiter- IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Juarez",
    "url": "https://www.linkedin.com/in/eugeniajuarez",
    "company": "WFSystems",
    "position": "HR Business Partner | IT Recruiter Sr Freelance",
    "keywords": [
      "recruiter",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Luna",
    "url": "https://www.linkedin.com/in/eugenia-victoria-luna",
    "company": "Tiendanube",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Miret",
    "url": "https://www.linkedin.com/in/eugeniamiret",
    "company": "Independent Professional",
    "position": "Senior IT Talent Acquisition Partner | Executive Search | Vocational Guidance",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Pugliesi",
    "url": "https://www.linkedin.com/in/eugenia-pugliesi-57173371",
    "company": "Ah! Consultora en Selección IT",
    "position": "Selección de Personal y Asesora en Empleabilidad",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Rubio",
    "url": "https://www.linkedin.com/in/eugenia-rubio-60983011a",
    "company": "Mercado Libre",
    "position": "Talent Acquisition Operations IT&Product Business Regional Head - Senior Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Serantes Coffey",
    "url": "https://www.linkedin.com/in/eugenia-serantes-coffey-19928a9",
    "company": "FindIT - Talent Hunters",
    "position": "Founder & Global Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Eugenia",
    "lastName": "Zapata",
    "url": "https://www.linkedin.com/in/eugeniazapata",
    "company": "Halo Media",
    "position": "Senior Technical Recruiter / Recruiting Lead & Staffing Specialist",
    "keywords": [
      "recruiter",
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Eugenia Carolina",
    "lastName": "Terruzzi",
    "url": "https://www.linkedin.com/in/eugeniaterruzzi",
    "company": "Baires HR",
    "position": "HR Manager, People Experience & Talent Attraction",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Eulalia",
    "lastName": "Buchaca",
    "url": "https://www.linkedin.com/in/eulaliabuchaca",
    "company": "Workfully",
    "position": "Senior Talent Acquisition Partner | Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Eunice",
    "lastName": "Doroschuk",
    "url": "https://www.linkedin.com/in/eunice-doroschuk-424532235",
    "company": "POSSUMUS",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Eurisha",
    "lastName": "Sivalinggam",
    "url": "https://www.linkedin.com/in/eurisha-sivalinggam-07b32b194",
    "company": "ATF ALTECFLEX",
    "position": "Snr Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Eusebio",
    "lastName": "Portero",
    "url": "https://www.linkedin.com/in/eusebio-portero",
    "company": "WillDom",
    "position": "Sr.Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Eva",
    "lastName": "Ferrer",
    "url": "https://www.linkedin.com/in/evvaferrer",
    "company": "Nortal",
    "position": "Senior IT Recruiter 360",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Eva",
    "lastName": "Sevilla López",
    "url": "https://www.linkedin.com/in/eva-sevilla-l%C3%B3pez-682b18a4",
    "company": "Devoteam",
    "position": "IT Talent Acquisition/Tech Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Evangelina",
    "lastName": "Andina",
    "url": "https://www.linkedin.com/in/evangelinaandina-busit",
    "company": "BUSIT ARGENTINA",
    "position": "Founder & IT Recruiter | Expert in IT & Generalist Recruitment | Serving LatAm & Europe",
    "keywords": [
      "recruiter",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Evangelina",
    "lastName": "Di Giacomo",
    "url": "https://www.linkedin.com/in/frice-consulting",
    "company": "FRICE Consulting",
    "position": "Reclutamiento y Selección de personal IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Evangelina",
    "lastName": "Pinciroli",
    "url": "https://www.linkedin.com/in/evangelina-pinciroli",
    "company": "Ghost Sherpa",
    "position": "Senior Human Resources Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Evelin",
    "lastName": "Lio",
    "url": "https://www.linkedin.com/in/evelin-lio-tiprome",
    "company": "Tiprome",
    "position": "Co-Fundadora y Coordinadora de Selección | Recruiter IT",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Evelyn",
    "lastName": "Castillo Blas",
    "url": "https://www.linkedin.com/in/evelyn-castillo-blas",
    "company": "NTT DATA Europe & LATAM",
    "position": "IT Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Evelyn",
    "lastName": "Feld",
    "url": "https://www.linkedin.com/in/evelynfeld",
    "company": "Atentus",
    "position": "People Manager LATAM",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Evelyn",
    "lastName": "Godoy",
    "url": "https://www.linkedin.com/in/evelynrgodoy",
    "company": "Accenture",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Evelyn",
    "lastName": "Sandri",
    "url": "https://www.linkedin.com/in/evelyn-sandri",
    "company": "Neo-Biz Consultores",
    "position": "Consultora de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Evelyn",
    "lastName": "Serafim",
    "url": "https://www.linkedin.com/in/evelynserafim",
    "company": "Stefanini Brasil",
    "position": "Especialista Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Evelyn M.",
    "lastName": "Maciel",
    "url": "https://www.linkedin.com/in/evelyn-m-maciel-699b421b7",
    "company": "Knezevic & Asociados",
    "position": "IT Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Ezequiel",
    "lastName": "Filighera",
    "url": "https://www.linkedin.com/in/ezequiel-filighera",
    "company": "HTD Health",
    "position": "Senior Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ezequiel",
    "lastName": "Verdun",
    "url": "https://www.linkedin.com/in/ezequiel-verdun-1851a01a1",
    "company": "Adecco",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Fabiana",
    "lastName": "Kosky",
    "url": "https://www.linkedin.com/in/fabiana-kosky-56b530181",
    "company": "Selection Partners – Trabajo en Cruceros",
    "position": "Recruiter Expert",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fabiana",
    "lastName": "Ramirez",
    "url": "https://www.linkedin.com/in/fabiana-ramirez-ruiz23",
    "company": "De Mentes en Mentes",
    "position": "Especialista en Gestión y Selección de Talento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Fabio C.",
    "lastName": "Sottile",
    "url": "https://www.linkedin.com/in/fabiosottile",
    "company": "Sibelco Group",
    "position": "Talent Acquisition Manager Global",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Fabiola",
    "lastName": "Wixsan",
    "url": "https://www.linkedin.com/in/fabiola-wixsan-71b981133",
    "company": "NTT DATA Europe & Latam",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Fabrizia",
    "lastName": "Falá",
    "url": "https://www.linkedin.com/in/fabrizia-fal%C3%A1-a3944a148",
    "company": "Fever",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Facundo",
    "lastName": "Balekjian",
    "url": "https://www.linkedin.com/in/facundo-balekjian",
    "company": "KellyOCG",
    "position": "Senior Technical Recruiter | Global IT & Non-IT Recruiting (KellyOCG + Sevenstep)",
    "keywords": [
      "recruiter",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Facundo",
    "lastName": "Reynoso",
    "url": "https://www.linkedin.com/in/facundo-reynoso-a232ba126",
    "company": "Patagonian",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Facundo",
    "lastName": "Rivadero",
    "url": "https://www.linkedin.com/in/facundo-rivadero-996343231",
    "company": "Freelance | Self-Employed",
    "position": "Freelance IT & SAP Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Facundo",
    "lastName": "Sepúlveda",
    "url": "https://www.linkedin.com/in/facundo-sep%C3%BAlveda-bb7603128",
    "company": "Bondy",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Facundo",
    "lastName": "Tripodi",
    "url": "https://www.linkedin.com/in/facundo-tripodi",
    "company": "Webflow",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Facundo Nicolás",
    "lastName": "Villanueva",
    "url": "https://www.linkedin.com/in/facundo-nicolas-villanueva",
    "company": "JBK Argentina",
    "position": "HR Analyst - Recruiter & Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Farah",
    "lastName": "Zahari",
    "url": "https://www.linkedin.com/in/farah-zahari-39670792",
    "company": "AMK Group",
    "position": "Assistant Manager Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Farhana",
    "lastName": "Diana",
    "url": "https://www.linkedin.com/in/farhana-diana-2207b0191",
    "company": "eSync Software Services",
    "position": "Principal Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Faride",
    "lastName": "Rastegar",
    "url": "https://www.linkedin.com/in/faride-rastegar-4b7154155",
    "company": "AEGIS Consultora Organizacional",
    "position": "Senior Human Resources Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fatima",
    "lastName": "Mogrovejo",
    "url": "https://www.linkedin.com/in/fatimamogrovejo",
    "company": "FRACTAL",
    "position": "Auxiliar de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Fatin",
    "lastName": "Firdaus",
    "url": "https://www.linkedin.com/in/fatinfirdaus",
    "company": "DFI Retail Group",
    "position": "Senior Executive, Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Fausto",
    "lastName": "Erramuspe",
    "url": "https://www.linkedin.com/in/fausto-erramuspe",
    "company": "Superside",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Favio",
    "lastName": "Bolivar Marrero",
    "url": "https://www.linkedin.com/in/favio-bolivar-marrero-",
    "company": "Stefanini LATAM",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Federica",
    "lastName": "Palermo",
    "url": "https://www.linkedin.com/in/federica-palermo-2b717a256",
    "company": "It's Prodigy",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "Dreier",
    "url": "https://www.linkedin.com/in/federico-dreier",
    "company": "ADP",
    "position": "Senior Global Talent Acquisition Business Partner",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "Galvez",
    "url": "https://www.linkedin.com/in/federico-galvez",
    "company": "Innovid",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "Gonzalez Caro",
    "url": "https://www.linkedin.com/in/federicog",
    "company": "FOX Recruiting - Argentina",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "O.",
    "url": "https://www.linkedin.com/in/federico-o-aa482421a",
    "company": "MinData",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "Plenasio",
    "url": "https://www.linkedin.com/in/federico-plenasio-196132248",
    "company": "Lubee",
    "position": "Human Resources Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "Porucini",
    "url": "https://www.linkedin.com/in/federico-porucini-61573a215",
    "company": "Tech City",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "Rhaiel",
    "url": "https://www.linkedin.com/in/federico-rhaiel",
    "company": "Capgemini Engineering",
    "position": "Talent Acquisition Specialist | Recruiter It",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "Sartori",
    "url": "https://www.linkedin.com/in/psfedericosartori",
    "company": "Strategic Staffing Solutions",
    "position": "Sr Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "Suarez",
    "url": "https://www.linkedin.com/in/federico-suarez-",
    "company": "Independiente (freelance)",
    "position": "Consultor de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Federico",
    "lastName": "Tartari",
    "url": "https://www.linkedin.com/in/federico-tartari-3588b1213",
    "company": "HR Oasis Consultora RRHH",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Federico Agustín",
    "lastName": "Moreira",
    "url": "https://www.linkedin.com/in/federicomoreirait",
    "company": "Andela",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Federico Manuel",
    "lastName": "Alvarez Haedo",
    "url": "https://www.linkedin.com/in/fmalvarezhaedo",
    "company": "Nybble Group",
    "position": "Global Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Federico Martín",
    "lastName": "Bilello",
    "url": "https://www.linkedin.com/in/federico-mart%C3%ADn-bilello-5a4a25177",
    "company": "Hire With Near",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Felicitas",
    "lastName": "Bauer Guerrero",
    "url": "https://www.linkedin.com/in/felicitas-bauer-guerrero-a43572274",
    "company": "Howdy.com",
    "position": "Junior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Felicitas",
    "lastName": "Frontini",
    "url": "https://www.linkedin.com/in/felicitas-frontini",
    "company": "CoCreate Talent",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Felicitas",
    "lastName": "Hernández Otaño",
    "url": "https://www.linkedin.com/in/felicitas-hern%C3%A1ndez-ota%C3%B1o-959bb660",
    "company": "Lutron Electronics",
    "position": "Recruiter Team Lead",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Felipe",
    "lastName": "Barral",
    "url": "https://www.linkedin.com/in/felipe-barral-1aa33120b",
    "company": "EY",
    "position": "Talent Recruiter, Senior Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Felipe",
    "lastName": "Frediani Brito",
    "url": "https://www.linkedin.com/in/felipe-frediani-brito-",
    "company": "ScrumLaunch",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Felipe",
    "lastName": "Millán Henao",
    "url": "https://www.linkedin.com/in/felipemillanhenao",
    "company": "Perficient",
    "position": "Senior Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Felipe",
    "lastName": "Rivera",
    "url": "https://www.linkedin.com/in/frtavonatti",
    "company": "Recruitalize",
    "position": "F@under | Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Felipe Antonio",
    "lastName": "Rojas Prieto",
    "url": "https://www.linkedin.com/in/frojasprieto",
    "company": "Tata Consultancy Services",
    "position": "Senior IT Recruiter /Talent Acquisition Specialist",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Felix",
    "lastName": "Camargo",
    "url": "https://www.linkedin.com/in/felix-camargo",
    "company": "KUNAN S.A.",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fer",
    "lastName": "Gago",
    "url": "https://www.linkedin.com/in/fernandoegv",
    "company": "Lupa Hire",
    "position": "Senior Recruiting Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ferdinand",
    "lastName": "Muñoz",
    "url": "https://www.linkedin.com/in/ferdinand-munoz",
    "company": "G2i Inc.",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fernanda",
    "lastName": "Ferrari",
    "url": "https://www.linkedin.com/in/fernandaferrari2",
    "company": "Kake",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fernanda",
    "lastName": "Garcia Utrera",
    "url": "https://www.linkedin.com/in/fergaut",
    "company": "jobs.fergaut.com",
    "position": "Technology Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Fernanda",
    "lastName": "Parra B.",
    "url": "https://www.linkedin.com/in/fernanda-parra-b-992023b",
    "company": "Thomson Reuters",
    "position": "Sr. Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fernanda",
    "lastName": "Pérez Caporelli",
    "url": "https://www.linkedin.com/in/fernanda-caporelli",
    "company": "Tiendanube",
    "position": "Senior Talent Acquisition Analyst LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Fernanda",
    "lastName": "Varela",
    "url": "https://www.linkedin.com/in/fernandapvarela",
    "company": "sovanta AG",
    "position": "HR Lead – People, Culture & Employee Experience",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Fernanda",
    "lastName": "Veiga",
    "url": "https://www.linkedin.com/in/fernandacveiga",
    "company": "Zallpy Digital",
    "position": "Talent Aquisition | Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fernando",
    "lastName": "Hayipanteli",
    "url": "https://www.linkedin.com/in/fernandohayipanteli",
    "company": "Scale Army",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Fernando",
    "lastName": "Legarreta",
    "url": "https://www.linkedin.com/in/fernando-legarreta",
    "company": "Talently",
    "position": "Information Technology Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Fernando",
    "lastName": "Minsky",
    "url": "https://www.linkedin.com/in/fernando-minsky-56b7461b5",
    "company": "Autónomo",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fernando",
    "lastName": "Solano",
    "url": "https://www.linkedin.com/in/fernando-solano-santamaria",
    "company": "BAT",
    "position": "Talent Acquisition Coordinator - Trilingual",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Fernando",
    "lastName": "Sosa",
    "url": "https://www.linkedin.com/in/fernandososa97",
    "company": "Valtech",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Fernando",
    "lastName": "Torres",
    "url": "https://www.linkedin.com/in/fernandotorressrnqn",
    "company": "Humanitas IT",
    "position": "Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Fernando",
    "lastName": "V",
    "url": "https://www.linkedin.com/in/fernando-v-b48928a0",
    "company": "Concentrix Catalyst",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fernando Agustín",
    "lastName": "Benzoni",
    "url": "https://www.linkedin.com/in/fernandoagustinbenzoni",
    "company": "Provincia ART",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Fiamma",
    "lastName": "Laurencio",
    "url": "https://www.linkedin.com/in/fiammalaurencio",
    "company": "Cybele Software, Inc.",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Fin",
    "lastName": "Mosengo",
    "url": "https://www.linkedin.com/in/fineaze-mosengo",
    "company": "Highspring",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fiona",
    "lastName": "Vincenti",
    "url": "https://www.linkedin.com/in/fiona-vincenti-519643171",
    "company": "Accenture",
    "position": "Senior Recruiting Analyst | Cliente Mercado Libre🤝",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Fiorella",
    "lastName": "Aurich Guerrero",
    "url": "https://www.linkedin.com/in/fiorella-aurich",
    "company": "Indra",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Fiorella",
    "lastName": "Caligaris",
    "url": "https://www.linkedin.com/in/fiorella-caligaris-2a0b353a",
    "company": "Humanitas IT",
    "position": "HR & Business Development Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Fiorella",
    "lastName": "Flowers",
    "url": "https://www.linkedin.com/in/fiorellaflowers",
    "company": "Novacomp",
    "position": "Senior IT Recruiter | Perú & LATAM",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fiorella",
    "lastName": "Pellegatta",
    "url": "https://www.linkedin.com/in/fiorepellegatta",
    "company": "Mercado Libre",
    "position": "IT Regional Talent Acquisition Semi Senior",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Fiorella",
    "lastName": "Pizzi",
    "url": "https://www.linkedin.com/in/fiorella-pizzi-48973339",
    "company": "SOUTHWORKS",
    "position": "Talent Acquisition Partner Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "FLAVIA",
    "lastName": "CARDETTI",
    "url": "https://www.linkedin.com/in/flavia-cardetti-b197a51a6",
    "company": "ICOX Web Consulting",
    "position": "Director of Operations & Talent",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Flavia",
    "lastName": "Cima",
    "url": "https://www.linkedin.com/in/flavia-cima",
    "company": "Capitole Consulting",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Flavia",
    "lastName": "Di Renzo",
    "url": "https://www.linkedin.com/in/flaviadirenzo",
    "company": "Hitss Argentina",
    "position": "Talent Acquisition Team Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Flavia",
    "lastName": "Martins",
    "url": "https://www.linkedin.com/in/flavia-martins-3993a9154",
    "company": "KUTIR CORPORATION",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Flavia",
    "lastName": "Orellano",
    "url": "https://www.linkedin.com/in/flavia-orellano-9195a385",
    "company": "Humand",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Flavia",
    "lastName": "Yañez",
    "url": "https://www.linkedin.com/in/flavia-ivana",
    "company": "Tecpetrol",
    "position": "HRBP Analyst",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Flor",
    "lastName": "Gancedo",
    "url": "https://www.linkedin.com/in/talentcross",
    "company": "TalentCross",
    "position": "Senior Human Resources Recruiter / Sr. Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Flor",
    "lastName": "Morales",
    "url": "https://www.linkedin.com/in/flor-morales",
    "company": "Profesional independiente",
    "position": "Senior IT Recruiter | Talent Acquisition Consultant (Remote & Freelance)",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Abilleira",
    "url": "https://www.linkedin.com/in/florencia-abilleira",
    "company": "KellyOCG",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Acosta",
    "url": "https://www.linkedin.com/in/florencia-acosta-16220a51",
    "company": "Banco Supervielle",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Alvarez",
    "url": "https://www.linkedin.com/in/florencia-alvarez-recruiter",
    "company": "venon.ai",
    "position": "Sourcer IT",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Amoruso",
    "url": "https://www.linkedin.com/in/florencia-amoruso-197013227",
    "company": "Accenture",
    "position": "Recruitment Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "B.",
    "url": "https://www.linkedin.com/in/mpaflor",
    "company": "MPA Consultora",
    "position": "Talent Acquisition - IT Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Basile",
    "url": "https://www.linkedin.com/in/florencia-basile",
    "company": "Tsoft",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Batica",
    "url": "https://www.linkedin.com/in/florenciabatica",
    "company": "Grey",
    "position": "People and Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Beltramo",
    "url": "https://www.linkedin.com/in/florenciabeltramo",
    "company": "Dux Software",
    "position": "Talent & Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Benicio",
    "url": "https://www.linkedin.com/in/florencia-benicio",
    "company": "Software Mind LATAM",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Brun",
    "url": "https://www.linkedin.com/in/florenciabrun",
    "company": "HireAR",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Brunori",
    "url": "https://www.linkedin.com/in/florenciabrunorirrhh",
    "company": "AR Consultores",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Castañeda",
    "url": "https://www.linkedin.com/in/florenciacastaneda",
    "company": "Atid B Yisum",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Cerutti",
    "url": "https://www.linkedin.com/in/florenciacerutti99",
    "company": "Yumatech",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Cespedes",
    "url": "https://www.linkedin.com/in/florenc",
    "company": "Solvo Global",
    "position": "Talent Acquisition Specialst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Coronel",
    "url": "https://www.linkedin.com/in/florencia-coronel-46b242140",
    "company": "PlatformX Solutions",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Correa Diaz",
    "url": "https://www.linkedin.com/in/correa-florencia",
    "company": "Hublance",
    "position": "Talent Acquisition IT Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Daziano",
    "url": "https://www.linkedin.com/in/florencia-daziano",
    "company": "Freelance",
    "position": "Freelance IT Recruiter | Connecting Top Tech Talent with Opportunities",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Escalante",
    "url": "https://www.linkedin.com/in/florenciaescalanterecruiterit",
    "company": "Aper",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Escobar",
    "url": "https://www.linkedin.com/in/mflorenciaescobar",
    "company": "CAS Training",
    "position": "IT/SAP Talent Acquisition & HR Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/florencia-fernandez-055136183",
    "company": "E-Saurio",
    "position": "It Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Garcia",
    "url": "https://www.linkedin.com/in/florencia-garcia-156a671b8",
    "company": "Howdy.com",
    "position": "Recruiter Expert",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Gulino",
    "url": "https://www.linkedin.com/in/florencia-gulino-1712a5183",
    "company": "Oktana Corporation",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Jasin",
    "url": "https://www.linkedin.com/in/florencia-jasin",
    "company": "Autónomo",
    "position": "Analista de reclutamiento y selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Larghi",
    "url": "https://www.linkedin.com/in/florencia-larghi-b6343358",
    "company": "Air Liquide",
    "position": "HR CoE Talent Acquisition LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Martínez",
    "url": "https://www.linkedin.com/in/florencia-mart%C3%ADnez-7abb8b14a",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst - Strategy & Consulting",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Matticoli",
    "url": "https://www.linkedin.com/in/florenciamatticoli",
    "company": "CONEXIONHR - Recruiting Company",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Medoro",
    "url": "https://www.linkedin.com/in/florencia-medoro-741495100",
    "company": "Henry",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Mena",
    "url": "https://www.linkedin.com/in/florencia-m-216962151",
    "company": "Engineer Access",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Mercado (She/Her)",
    "url": "https://www.linkedin.com/in/mariaflorenciamercado",
    "company": "Ravegan",
    "position": "People and Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Mirabile [she/her]",
    "url": "https://www.linkedin.com/in/florencia-mirabile",
    "company": "Mujeres en Tecnología",
    "position": "Coordinadora del MeTLab de Recruiting",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Ovejero Rios",
    "url": "https://www.linkedin.com/in/florenciaovejerorios",
    "company": "Silver.dev",
    "position": "Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Pablo",
    "url": "https://www.linkedin.com/in/florencia-pablo-122087245",
    "company": "Adecco",
    "position": "Recruitment and Talent Acquisition (RPO)",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Palavecino",
    "url": "https://www.linkedin.com/in/florpalavecino97",
    "company": "SEIDOR Analytics",
    "position": "Sr Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Parenti",
    "url": "https://www.linkedin.com/in/florencia-parenti-37b015170",
    "company": "Kopius",
    "position": "US Recruiting Manager",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Quiroga",
    "url": "https://www.linkedin.com/in/florencia-quiroga",
    "company": "Arelance",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Ragazzi",
    "url": "https://www.linkedin.com/in/florenciaragazzi",
    "company": "Softensity Inc",
    "position": "HRBP/ People Ops",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Raimondo (CIPD)",
    "url": "https://www.linkedin.com/in/florencia-raimondo-cipd-a73ba188",
    "company": "Royal College of Surgeons in Ireland (RCSI)",
    "position": "Recruitment Partner",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Ramos",
    "url": "https://www.linkedin.com/in/florenciaramos",
    "company": "Accenture",
    "position": "Global HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Ramos Mancilla",
    "url": "https://www.linkedin.com/in/florencia-ramos-mancilla-28ba49140",
    "company": "LUK HR",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Rico",
    "url": "https://www.linkedin.com/in/florenciaericarico",
    "company": "Kopius",
    "position": "People Operations Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Rodriguez Villamil",
    "url": "https://www.linkedin.com/in/florencia-rodriguez-villamil-a68a77a3",
    "company": "Howdy.com",
    "position": "Recruiter Expert",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Romio",
    "url": "https://www.linkedin.com/in/florencia-romio",
    "company": "tecso",
    "position": "Talent Acquisition - HR Business Partner",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Rosendorn",
    "url": "https://www.linkedin.com/in/frosendorn",
    "company": "Independiente / Freelance",
    "position": "Consultora freelance | Recruiting & Talent Search",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Rubio",
    "url": "https://www.linkedin.com/in/mflorenciarubio",
    "company": "Van Hyde International",
    "position": "International Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Ruth",
    "url": "https://www.linkedin.com/in/florencia-ruth-44581413b",
    "company": "Practia Global",
    "position": "Recruiting Regional Leader - LATAM",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Salem Ini",
    "url": "https://www.linkedin.com/in/florenciasalemini",
    "company": "Hiring",
    "position": "Co- Founder | Recruitment Leader",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Schiliro",
    "url": "https://www.linkedin.com/in/florenciaschiliro",
    "company": "Tsoft",
    "position": "Tech Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Tedrós (She/Her)",
    "url": "https://www.linkedin.com/in/florencia-tedros",
    "company": "Veeam Software",
    "position": "Talent Acquisition Partner - LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Teijeiro",
    "url": "https://www.linkedin.com/in/florencia-teijeiro-a63a53180",
    "company": "Grupo Nortempo",
    "position": "International Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Vallejo",
    "url": "https://www.linkedin.com/in/ffvallejo",
    "company": "Dichi Consultores",
    "position": "IT Sourcer - Freelancer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Vasquez Orellana",
    "url": "https://www.linkedin.com/in/florencia-vasquez-orellana",
    "company": "BEON.tech",
    "position": "IT Recruiter & Career Advisor",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Vigo",
    "url": "https://www.linkedin.com/in/florencia-vigo-8830a990",
    "company": "Red Hat",
    "position": "Senior Talent Acquisition Specialist- America",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Florencia",
    "lastName": "Zambianchi",
    "url": "https://www.linkedin.com/in/florencia-zambianchi",
    "company": "JPMorgan Chase & Co.",
    "position": "Senior Associate Technology Recruiter - LATAM",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florencia Sol",
    "lastName": "Gallelli",
    "url": "https://www.linkedin.com/in/fsgallelli",
    "company": "Nexton",
    "position": "Senior Technical Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Florencia Victoria",
    "lastName": "Caravante",
    "url": "https://www.linkedin.com/in/florencia-victoria-caravante",
    "company": "Sofre Digital SA",
    "position": "IT Recruiter/Analista de Talento y Cultura",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Florlis",
    "lastName": "Chópite O. 🚀",
    "url": "https://www.linkedin.com/in/florlis-chopite",
    "company": "Interfell",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Francheska",
    "lastName": "Escalona",
    "url": "https://www.linkedin.com/in/marianescalona",
    "company": "Axxon Consulting",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Francine",
    "lastName": "Silva",
    "url": "https://www.linkedin.com/in/francine-silva-309780169",
    "company": "KIS Solutions",
    "position": "Tech Recruiter | Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Francisco",
    "lastName": "Ahijado",
    "url": "https://www.linkedin.com/in/frankahijado",
    "company": "Devengine.ca",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Francisco",
    "lastName": "Chaker",
    "url": "https://www.linkedin.com/in/francisco-chaker",
    "company": "Staffy",
    "position": "Talent Attraction & IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Francisco",
    "lastName": "Espina",
    "url": "https://www.linkedin.com/in/francisco-espina-58772231",
    "company": "PSRH Digital Consulting",
    "position": "Recruiter It",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Francisco",
    "lastName": "Herdoiza",
    "url": "https://www.linkedin.com/in/franciscoherdoiza",
    "company": "C&S Informática",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Francisco",
    "lastName": "Rodriguez Gugliotta",
    "url": "https://www.linkedin.com/in/franciscorodriguezgugliotta",
    "company": "Bridgenext",
    "position": "IT Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Francisco",
    "lastName": "Rodríguez",
    "url": "https://www.linkedin.com/in/francisco-rodr%C3%ADguez-32368217a",
    "company": "EY",
    "position": "Talent Discovery Recruiter Senior Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Franco",
    "lastName": "Albarracin",
    "url": "https://www.linkedin.com/in/franco-albarracin",
    "company": "Recruitment Hub",
    "position": "Responsable de Proyecto. Team Lead. Selección.",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Franco",
    "lastName": "Maggioni",
    "url": "https://www.linkedin.com/in/franco-maggioni",
    "company": "Zafirus Technologies",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Franco",
    "lastName": "Orellana",
    "url": "https://www.linkedin.com/in/franco-orellana1992",
    "company": "Tiendanube",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Franco",
    "lastName": "Politino",
    "url": "https://www.linkedin.com/in/franco-politino-b018b0152",
    "company": "Softensity Inc",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Franco",
    "lastName": "Roybal",
    "url": "https://www.linkedin.com/in/franco-roybal-02806a240",
    "company": "Tata Consultancy Services",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Franco Agustin",
    "lastName": "Velazco",
    "url": "https://www.linkedin.com/in/francoagustinvelazco",
    "company": "MinData",
    "position": "Referente del área de selección & Líder de equipo",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Franyeli",
    "lastName": "Cárdenas",
    "url": "https://www.linkedin.com/in/franyeli-cardenas",
    "company": "PlanIT",
    "position": "IT Recruiter | Comunicación interna| RRHH",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Fredzaida",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/fredzaida",
    "company": "Binagora",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gabriel",
    "lastName": "Martinez",
    "url": "https://www.linkedin.com/in/gabriel-martinez-6b660918b",
    "company": "Sloane Staffing",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gabriel",
    "lastName": "Pedrón Fajardo",
    "url": "https://www.linkedin.com/in/gabrielpedronfajardo",
    "company": "Gorilla Logic",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gabriel",
    "lastName": "Schwerdtfeger",
    "url": "https://www.linkedin.com/in/shafergabriel",
    "company": "Growth HR",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gabriel",
    "lastName": "Soler",
    "url": "https://www.linkedin.com/in/gabriel-soler-599517213",
    "company": "Workana",
    "position": "Recruiter I",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Agnoli",
    "url": "https://www.linkedin.com/in/gabrielaagnoliq",
    "company": "Destify",
    "position": "Global Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Ave",
    "url": "https://www.linkedin.com/in/2020gb",
    "company": "Confidential",
    "position": "Talent Sourcer & Technical Recruiter (Talent Acquisition)",
    "keywords": [
      "recruiter",
      "talent acquisition",
      "sourcer"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Bautista Cuno",
    "url": "https://www.linkedin.com/in/gabriela-bautista-cuno-a7b74126a",
    "company": "IDM Technology",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Bolivar",
    "url": "https://www.linkedin.com/in/gabriela-bolivar-734195115",
    "company": "Freelance",
    "position": "Consultor Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Breitenberger",
    "url": "https://www.linkedin.com/in/gabriela-breitenberger-76886b17b",
    "company": "Webstarted",
    "position": "IT Talent Acquisition | RECRUITER IT | Interviewer",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Espindola",
    "url": "https://www.linkedin.com/in/gabriela-espindola",
    "company": "EsAPP",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Feiling",
    "url": "https://www.linkedin.com/in/gabriela-feiling-bba9b01a5",
    "company": "Grupo Gestión",
    "position": "HRBP / Inplant",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Goldfeder",
    "url": "https://www.linkedin.com/in/gabriela-goldfeder-a6582351",
    "company": "RecargaPay",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Iellin",
    "url": "https://www.linkedin.com/in/gabrielaiellin",
    "company": "Independent Consultant",
    "position": "HR & Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/gabrielalopezzv",
    "company": "Curv Group",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Moy Montanini",
    "url": "https://www.linkedin.com/in/itrecruiter-gabriela-moy",
    "company": "RecruitingSKULL",
    "position": "IT Recruiter - Talent Sourcer",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Negri",
    "url": "https://www.linkedin.com/in/gabriela-negri",
    "company": "ÜMA Salud IA",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Nigolian",
    "url": "https://www.linkedin.com/in/gabriela-nigolian",
    "company": "Accenture",
    "position": "Mexico & HSA Technology Sourcing & Recruiting Lead at Accenture",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Paludi",
    "url": "https://www.linkedin.com/in/gabrielapaludi",
    "company": "MACHINES LIKE ME",
    "position": "Human Resources Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Quevedo",
    "url": "https://www.linkedin.com/in/recruiter-gabriela-quevedo",
    "company": "Manpower Argentina",
    "position": "Consultora en selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Quiroga",
    "url": "https://www.linkedin.com/in/gabrielaquiroga",
    "company": "Bella Dati",
    "position": "Head of People & Culture",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Rayo",
    "url": "https://www.linkedin.com/in/gabriela-rayo-10b6a262",
    "company": "MKM Distribuidora",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Gabriela",
    "lastName": "Schneider",
    "url": "https://www.linkedin.com/in/gabschneider",
    "company": "Teamcubation",
    "position": "People Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Gabriela A",
    "lastName": "Chitarrini",
    "url": "https://www.linkedin.com/in/gabriela-chitarrini",
    "company": "Mission",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gaby",
    "lastName": "Lechin Hernandez",
    "url": "https://www.linkedin.com/in/gabrielalechin",
    "company": "Outsourced",
    "position": "HR and Senior Recruiting Partner",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Gala",
    "lastName": "Solimo",
    "url": "https://www.linkedin.com/in/galasolimo",
    "company": "gennius xyz",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Galit",
    "lastName": "Israel Lehmann",
    "url": "https://www.linkedin.com/in/galit-israel-lehmann-3b72b6128",
    "company": "Toteat",
    "position": "Senior People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Gary",
    "lastName": "Rivera",
    "url": "https://www.linkedin.com/in/gary-rivera-999419190",
    "company": "DXC Technology",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gaston",
    "lastName": "Berdaguer",
    "url": "https://www.linkedin.com/in/gb-it-recruiter-freelance",
    "company": "WeThink Human Talent",
    "position": "Recruiter IT - freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gaston",
    "lastName": "Latorre",
    "url": "https://www.linkedin.com/in/gastilatorre",
    "company": "Salesforce",
    "position": "Senior Corporate Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gaston",
    "lastName": "Miguel",
    "url": "https://www.linkedin.com/in/gastonmiguel",
    "company": "Afianza Asesores",
    "position": "Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Gastón",
    "lastName": "Aimaro",
    "url": "https://www.linkedin.com/in/gast%C3%B3n-aimaro-67335416b",
    "company": "Exo Mindset",
    "position": "HR & Talent acquisition IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gastón",
    "lastName": "Gimenez",
    "url": "https://www.linkedin.com/in/gast%C3%B3n-gimenez-b66598100",
    "company": "Personal",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gastón",
    "lastName": "Rodríguez",
    "url": "https://www.linkedin.com/in/gastonrodriguezit",
    "company": "aliantec",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gastón",
    "lastName": "Romano",
    "url": "https://www.linkedin.com/in/gast%C3%B3n-romano-71504b238",
    "company": "G&L Group",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gavin",
    "lastName": "Hayes",
    "url": "https://www.linkedin.com/in/gavin-hayes-81206b101",
    "company": "Zero Hash",
    "position": "Lead Talent Partner",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gayatri",
    "lastName": "V",
    "url": "https://www.linkedin.com/in/gayatri-v-3136b7121",
    "company": "Virtual Calibre MSC SDN BHD",
    "position": "Talent Acquisition Specialist @ Virtual Calibre MSC SDN BHD",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Genise",
    "lastName": "Matias",
    "url": "https://www.linkedin.com/in/genisematias",
    "company": "Self Employed",
    "position": "Senior Human Resources Business Partner - Consultant",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Georgina",
    "lastName": "Brizio",
    "url": "https://www.linkedin.com/in/georgina-brizio-79095917b",
    "company": "TeamUp",
    "position": "IT Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Georgina",
    "lastName": "Desentis",
    "url": "https://www.linkedin.com/in/georgina-desentis-a0a30935",
    "company": "EPAM Systems",
    "position": "Lead IT Recruiter / LATAM",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Georgina",
    "lastName": "Giordano",
    "url": "https://www.linkedin.com/in/georgina-giordano-94888455",
    "company": "Loyal Guru",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Geovana",
    "lastName": "Machado Andrade",
    "url": "https://www.linkedin.com/in/geovana-machado-andrade-92bb262b6",
    "company": "FitNext Co.",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Geraldine",
    "lastName": "Couture",
    "url": "https://www.linkedin.com/in/couturegeraldine",
    "company": "Netrix Global LATAM",
    "position": "Talent Acquisition Team Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Geraldine",
    "lastName": "Lemble",
    "url": "https://www.linkedin.com/in/geraldine-lemble",
    "company": "CONEXIONHR Recruiting Company",
    "position": "Recruiter - Procesos de Selección",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Gerardo",
    "lastName": "Asrin",
    "url": "https://www.linkedin.com/in/gerardo-asrin",
    "company": "BetterPros",
    "position": "Recruitment Sourcing Strategist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Gerardo",
    "lastName": "Barra Santayana",
    "url": "https://www.linkedin.com/in/gerardo-barra-santayana-",
    "company": "Encora Inc.",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "German",
    "lastName": "Aguerrido Schang",
    "url": "https://www.linkedin.com/in/german-aguerrido-schang-a5917924",
    "company": "Trick Studio",
    "position": "IT recruiter & Talent Acquisition Analyst",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "German",
    "lastName": "Tomba",
    "url": "https://www.linkedin.com/in/german-t-0b6823b1",
    "company": "LT Consultoría",
    "position": "IT Recruiter & Talent Acquisitión / Headhunter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Gerson",
    "lastName": "Perez Quintanilla",
    "url": "https://www.linkedin.com/in/gersonperezquinta",
    "company": "Remote Leverage",
    "position": "Sourcing Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gerónimo",
    "lastName": "Palacios",
    "url": "https://www.linkedin.com/in/geronimo-palacios",
    "company": "Nimble.LA",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gianella Estefani",
    "lastName": "Monterrey Chávez",
    "url": "https://www.linkedin.com/in/gianella-estefani-monterrey-ch%C3%A1vez-8603a5156",
    "company": "Synopsis S.A.",
    "position": "Analista de Reclutamiento Senior",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Gianfranco",
    "lastName": "Coscarelli",
    "url": "https://www.linkedin.com/in/gianfranco-coscarelli",
    "company": "Mercado Libre",
    "position": "Regional Talent Planning Sr Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gianna",
    "lastName": "Sabbatini",
    "url": "https://www.linkedin.com/in/gianna-sabbatini-ba7359161",
    "company": "Prex",
    "position": "People Business Partner Manager",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gilmar",
    "lastName": "Rodríguez",
    "url": "https://www.linkedin.com/in/gilmar-rodriguez",
    "company": "Grant Solutions",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gime",
    "lastName": "Mecca",
    "url": "https://www.linkedin.com/in/gime-mecca-101303128",
    "company": "EY",
    "position": "US Talent Discovery Recruiter | Senior Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gimena",
    "lastName": "Noce",
    "url": "https://www.linkedin.com/in/gimenanoce",
    "company": "NewCombin",
    "position": "IT Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Gimena",
    "lastName": "Ottado",
    "url": "https://www.linkedin.com/in/gimena-ottado",
    "company": "Vangwe",
    "position": "Head of People & Culture",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gimena",
    "lastName": "Ponzio",
    "url": "https://www.linkedin.com/in/gimena-ponzio-36107220a",
    "company": "Resilient Co.",
    "position": "Global Talent Acquisition Partner | LATAM, US & EMEA",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gimena",
    "lastName": "Segovia",
    "url": "https://www.linkedin.com/in/gimena-segovia",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Gimena",
    "lastName": "Segovia",
    "url": "https://www.linkedin.com/in/gimena-segovia-a81370bb",
    "company": "Gestion Compartida",
    "position": "Analista Sr de Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Gimena Lourdes",
    "lastName": "Cristofano",
    "url": "https://www.linkedin.com/in/gimena-lourdes-cristofano-14a32010b",
    "company": "The Agency IT",
    "position": "IT Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gina",
    "lastName": "Bonilla",
    "url": "https://www.linkedin.com/in/gbonilla33",
    "company": "Hitss Peru",
    "position": "Talent Acquisition Analyst IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gina",
    "lastName": "Caparroz",
    "url": "https://www.linkedin.com/in/ginacaparroz",
    "company": "Xometry",
    "position": "Contract Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Giovana",
    "lastName": "Palafox",
    "url": "https://www.linkedin.com/in/giovanapalafox",
    "company": "QuinStreet",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gisel Antonela",
    "lastName": "Altamura",
    "url": "https://www.linkedin.com/in/giantoaltamura",
    "company": "BASE4 Security",
    "position": "People & Culture Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gisela",
    "lastName": "Corbatta",
    "url": "https://www.linkedin.com/in/gisela-corbatta-5077644",
    "company": "Deloitte",
    "position": "Supervisora de Reclutamiento y Selección IT. Deloitte S-LATAM",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Gisela",
    "lastName": "Hereñu",
    "url": "https://www.linkedin.com/in/gisela-here%C3%B1u-43aa46131",
    "company": "TGV",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gisela",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/gisela-l-51009a14",
    "company": "RH Potencial",
    "position": "HR Consultant / Head of Talent Adquisition / Headhunter",
    "keywords": [
      "headhunter",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gisela",
    "lastName": "Ruiz",
    "url": "https://www.linkedin.com/in/gisela-ruiz-4a40a781",
    "company": "DTC Pages",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gisela",
    "lastName": "Seohanes",
    "url": "https://www.linkedin.com/in/giselaseohanes",
    "company": "Unosquare",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gisela",
    "lastName": "Torrez",
    "url": "https://www.linkedin.com/in/giselatorrez",
    "company": "BA Global Talent",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gisele",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/gisele-gonzalez-48631519a",
    "company": "Consultora Cenit",
    "position": "Talent Acquisition Specialist ~ Consultora en Búsqueda y Selección de Talentos IT",
    "keywords": [
      "talent acquisition",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Gisele",
    "lastName": "Rizzo",
    "url": "https://www.linkedin.com/in/gisele-rizzo-99465a39",
    "company": "PedidosYa",
    "position": "Regional Talent Acquisition Sr Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gisella",
    "lastName": "Carparelli",
    "url": "https://www.linkedin.com/in/gisellacarparelli",
    "company": "Arionkoder",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gisella",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/gisella-fernandez-21809813a",
    "company": "Profesional independiente",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gisella",
    "lastName": "Ortiz",
    "url": "https://www.linkedin.com/in/gisella-ortiz",
    "company": "Freelance",
    "position": "Freelance IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gisella",
    "lastName": "Peláez Moll",
    "url": "https://www.linkedin.com/in/gisellapelaezmoll",
    "company": "Clarika Software + Innovation",
    "position": "IT Recruiter | IT Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giselle",
    "lastName": "Arcaina",
    "url": "https://www.linkedin.com/in/giselle-arcaina-050a76209",
    "company": "Bute Solutions LLC",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giselle",
    "lastName": "Corzo",
    "url": "https://www.linkedin.com/in/gisellecorzo",
    "company": "CDA Informática",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giselle",
    "lastName": "Dalbosco (she/her)",
    "url": "https://www.linkedin.com/in/giselle-dalbosco-she-her-5a452211b",
    "company": "Valtech",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giselle",
    "lastName": "Emma",
    "url": "https://www.linkedin.com/in/gisellaemma",
    "company": "Rescilence and People HR",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giselle",
    "lastName": "Paiva",
    "url": "https://www.linkedin.com/in/giselle-paiva",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Giselle",
    "lastName": "Spera",
    "url": "https://www.linkedin.com/in/giselle-spera-7250992b",
    "company": "Freelance",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giuliana",
    "lastName": "Carnevalle",
    "url": "https://www.linkedin.com/in/giuliana-carnevalle-0311a1231",
    "company": "AR Consultores",
    "position": "Human Resources Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Giuliana",
    "lastName": "de Cara",
    "url": "https://www.linkedin.com/in/giulianadecara",
    "company": "Cobra Studio",
    "position": "HR Leader | Recruitment Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Giuliana",
    "lastName": "Fineschi",
    "url": "https://www.linkedin.com/in/giuliana-fineschi-2b0b93180",
    "company": "Midnight AM",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Giuliana",
    "lastName": "Impieri Gambardelli",
    "url": "https://www.linkedin.com/in/giuliana-impieri",
    "company": "C&S",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Giuliana",
    "lastName": "Murgo",
    "url": "https://www.linkedin.com/in/giuliana-murgo-itrecruiter",
    "company": "FYG | For Your Growth",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giuliana",
    "lastName": "Ramilo",
    "url": "https://www.linkedin.com/in/giuliana-ramilo-275b77b6",
    "company": "GlobalLogic",
    "position": "Middle IT Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giuliana",
    "lastName": "Villalba",
    "url": "https://www.linkedin.com/in/giuliana-villalba-a1a29b15b",
    "company": "Accenture Argentina",
    "position": "Recruiting Sr Analyst | Client: Mercado Libre",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Giuliana Belén",
    "lastName": "Dipierri",
    "url": "https://www.linkedin.com/in/giulianabelendipierri",
    "company": "Deloitte",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giuliana Gabriela",
    "lastName": "Gelbes",
    "url": "https://www.linkedin.com/in/giuliana-gabriela-gelbes-1513691b4",
    "company": "Solvo Global Careers",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Giuliano",
    "lastName": "Panichelli",
    "url": "https://www.linkedin.com/in/giuliano-panichelli",
    "company": "Revelo Network",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gizem",
    "lastName": "Unser",
    "url": "https://www.linkedin.com/in/gizemunser",
    "company": "EMCD: TOP10 Mining pool, Wallet, P2P platform, Coinhold",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gloria",
    "lastName": "Galvez",
    "url": "https://www.linkedin.com/in/gloria-galvez-738109243",
    "company": "Cognizant",
    "position": "IT Recruiter US - Talent Acquisition - North America",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gloria",
    "lastName": "Marquez",
    "url": "https://www.linkedin.com/in/gloriamarquezb",
    "company": "Bandit | The most wanted talent",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Gloria Maria",
    "lastName": "Represas",
    "url": "https://www.linkedin.com/in/grepresas",
    "company": "MSD",
    "position": "Talent Acquisition Advisor - MSD (IBM RPO)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gloribert",
    "lastName": "Acosta Fernández",
    "url": "https://www.linkedin.com/in/gloribertacostafernandez",
    "company": "Imagemaker",
    "position": "Talent Acquisition Executive",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gonzalo",
    "lastName": "Cuesta",
    "url": "https://www.linkedin.com/in/gonzalo-cuesta-83ba0977",
    "company": "Axonier Consultores",
    "position": "Líder de Recruiting",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Gonzalo",
    "lastName": "Franco",
    "url": "https://www.linkedin.com/in/gonzalo-f-a693815b",
    "company": "Infovip srl",
    "position": "Selección de Personal IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Gonzalo",
    "lastName": "Iribarren",
    "url": "https://www.linkedin.com/in/gonzalo-iribarren-a6973224",
    "company": "Wizeline",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gonzalo",
    "lastName": "Tain",
    "url": "https://www.linkedin.com/in/gjtain",
    "company": "Consultor Independiente.",
    "position": "Expert Consultant in IT Recruitment & Personnel Selection",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Gonzalo",
    "lastName": "Taretto",
    "url": "https://www.linkedin.com/in/gonzalo-taretto-96b68358",
    "company": "Accenture",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Gonzalo",
    "lastName": "Vieites",
    "url": "https://www.linkedin.com/in/gonzalovieitesrecruiter",
    "company": "Accenture Argentina",
    "position": "Senior Recruiting Operations Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Gonzalo Martín",
    "lastName": "Ponce",
    "url": "https://www.linkedin.com/in/gonza-recruiter",
    "company": "ACL",
    "position": "IT Technical recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Gonzalo Matías",
    "lastName": "Arriondo",
    "url": "https://www.linkedin.com/in/gonzalo-mat%C3%ADas-arriondo-6747b5230",
    "company": "Kenility",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gowthami",
    "lastName": "Sukha jeevan",
    "url": "https://www.linkedin.com/in/gowthami-sukha-jeevan-0966b8194",
    "company": "CognoWiz",
    "position": "Us IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Grace",
    "lastName": "Abad",
    "url": "https://www.linkedin.com/in/grace-aabad",
    "company": "LegalMatch",
    "position": "Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Graciana",
    "lastName": "Almada",
    "url": "https://www.linkedin.com/in/graciana-almada",
    "company": "belo",
    "position": "People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Graciela",
    "lastName": "Burgos",
    "url": "https://www.linkedin.com/in/graciela-burgos-91745b184",
    "company": "Unosquare",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Graciela",
    "lastName": "Trabucco",
    "url": "https://www.linkedin.com/in/graciela-trabucco-a4071485",
    "company": "Graciela Trabucco IT Recruitment",
    "position": "IT Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Grecia",
    "lastName": "Colmenares",
    "url": "https://www.linkedin.com/in/grecia-colmenares",
    "company": "Concentrix",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Greta",
    "lastName": "Spotti",
    "url": "https://www.linkedin.com/in/greta-spotti-47aa8116b",
    "company": "TMF Group",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Grisel",
    "lastName": "Toro",
    "url": "https://www.linkedin.com/in/griseltoro",
    "company": "Lenovo",
    "position": "LAS Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Griselda",
    "lastName": "Saban",
    "url": "https://www.linkedin.com/in/griselda-saban",
    "company": "Profesional independiente",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guadalupe",
    "lastName": "Aguirre Peñaloza",
    "url": "https://www.linkedin.com/in/guadalupe-aguirre-pe%C3%B1aloza-3ab611212",
    "company": "Affirma",
    "position": "Recruiting Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Guadalupe",
    "lastName": "Correa",
    "url": "https://www.linkedin.com/in/guadalupe-correa-",
    "company": "AccelOne",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guadalupe",
    "lastName": "Herrera",
    "url": "https://www.linkedin.com/in/guadalupeh-rrhh",
    "company": "Dicsys",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Guadalupe",
    "lastName": "Maamari",
    "url": "https://www.linkedin.com/in/guadalupe-maamari-496a4b144",
    "company": "Grupo Gestión",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Guadalupe",
    "lastName": "Ricagno",
    "url": "https://www.linkedin.com/in/guadalupericagno",
    "company": "Red River Mutual",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Guadalupe",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/guadalupe-rodriguez714",
    "company": "Despegar",
    "position": "IT&UX Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Guadalupe",
    "lastName": "Roldán",
    "url": "https://www.linkedin.com/in/guadalupe-rold%C3%A1n",
    "company": "Practia Global",
    "position": "IT Recruiter SR",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guadalupe",
    "lastName": "Serra",
    "url": "https://www.linkedin.com/in/guadalupeserra",
    "company": "BITLOGIC.io",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guadalupe D.",
    "lastName": "Vuelta",
    "url": "https://www.linkedin.com/in/guadalupe-d-vuelta-499110124",
    "company": "ABstract",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guido",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/guido-fernandez-951b57225",
    "company": "Jobsity",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Guido",
    "lastName": "Salvatori",
    "url": "https://www.linkedin.com/in/guido-salvatori",
    "company": "Nexton",
    "position": "Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Guido Ignacio",
    "lastName": "Ferrari",
    "url": "https://www.linkedin.com/in/guido-ignacio-ferrari",
    "company": "EY",
    "position": "Talent Attraction & Acquisition Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guilherme",
    "lastName": "Gomes",
    "url": "https://www.linkedin.com/in/guitechrecruiter",
    "company": "Accenture Brasil",
    "position": "Senior Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guillermina",
    "lastName": "Coronel",
    "url": "https://www.linkedin.com/in/guillermina-coronel-bb05541a3",
    "company": "Tsoft",
    "position": "TECH RECRUITER SPECIALIST",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guillermina",
    "lastName": "Corrado",
    "url": "https://www.linkedin.com/in/guillerminac",
    "company": "Kadre",
    "position": "Lead Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guillermina",
    "lastName": "Dutto",
    "url": "https://www.linkedin.com/in/guillerminadutto",
    "company": "Crombie",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guillermina",
    "lastName": "Galarza",
    "url": "https://www.linkedin.com/in/guillermina-galarza-a8a8038a",
    "company": "Chubut IT",
    "position": "People & Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Guillermina",
    "lastName": "Rodríguez (ella/she/her)",
    "url": "https://www.linkedin.com/in/guillermina-mara-rodriguez",
    "company": "Globant",
    "position": "Talent & Culture Business Partner, Team Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Guillermina",
    "lastName": "Vela",
    "url": "https://www.linkedin.com/in/guillerminavelarrhh-altconsultores",
    "company": "ALT Consultores",
    "position": "Responsable de IT Recruiter - RRHH en ALT Consultores",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Guillermo",
    "lastName": "Dausá",
    "url": "https://www.linkedin.com/in/guillermo-dausa",
    "company": "ITPS One",
    "position": "Director of Talent Acquisition LATAM",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Guillermo",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/guillermolopgon",
    "company": "VEMO",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Gustavo",
    "lastName": "Jimenez",
    "url": "https://www.linkedin.com/in/gustavo-jimenez-77043a173",
    "company": "Konecta",
    "position": "Technical Talent Acquisition Specialist IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "H. A.",
    "lastName": "Ruposh",
    "url": "https://www.linkedin.com/in/ruposh",
    "company": "Fiverr",
    "position": "Talent Sourcing Specialist and Digital Marketer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Hafsa",
    "lastName": "Iqbal (CHRP)",
    "url": "https://www.linkedin.com/in/hafsa-iqbal-chrp-38b96117a",
    "company": "Wizdaa",
    "position": "Senior Global Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Halyna",
    "lastName": "Shumada",
    "url": "https://www.linkedin.com/in/halyna-shumada-621144220",
    "company": "TurnKey Tech Staffing",
    "position": "Tech Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Hanan",
    "lastName": "Arraiss",
    "url": "https://www.linkedin.com/in/hanan-arraiss-20984b36a",
    "company": "Grupo TECDATA Engineering",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Hardik",
    "lastName": "Varshney",
    "url": "https://www.linkedin.com/in/hardik-varshney-ab776212a",
    "company": "Roadzen",
    "position": "Assistant Manager - HR",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Harish",
    "lastName": "Kunapareddy",
    "url": "https://www.linkedin.com/in/harish-kunapareddy-2779ba142",
    "company": "Sigmasoft",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Harsha",
    "lastName": "M",
    "url": "https://www.linkedin.com/in/harsha-m-611435103",
    "company": "Interas Labs",
    "position": "Sr.Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Hazelle",
    "lastName": "Miguel RPm, CLSSYB",
    "url": "https://www.linkedin.com/in/hazelle-miguel-rpm-clssyb-289045161",
    "company": "Kaptan Talent Solutions",
    "position": "Recruitment and Account Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Helen",
    "lastName": "Rozen",
    "url": "https://www.linkedin.com/in/helen-rozen-36ab0b219",
    "company": "Smartexe",
    "position": "Recruiter for remote team",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Helen Brisette",
    "lastName": "Livano Castillo",
    "url": "https://www.linkedin.com/in/helen-brisette-livano-castillo-38489b78",
    "company": "Tata Consultancy Services",
    "position": "Talent Acquisition Lead - Ecuador",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Helena",
    "lastName": "Moellmann",
    "url": "https://www.linkedin.com/in/helena-moellmann-8a912630",
    "company": "Nortal",
    "position": "Senior IT Recruiter 360",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Hema",
    "lastName": "Narwariya",
    "url": "https://www.linkedin.com/in/hema-narwariya-8ab9301b0",
    "company": "YO HR Consultancy",
    "position": "Sr. Consultant Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Henry",
    "lastName": "Brito",
    "url": "https://www.linkedin.com/in/henryjbrito",
    "company": "Interfell",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Henry",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/henry-fernandez-812239197",
    "company": "Samtel Consultores Colombia",
    "position": "Analista Selección de personal IT | Grupo Digital Profit España (Digital Profit/HorizonCX/ImpulSAP)",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Herbert",
    "lastName": "Perdomo",
    "url": "https://www.linkedin.com/in/herbert-perdomof",
    "company": "Elaniin",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Hernan",
    "lastName": "Vargas",
    "url": "https://www.linkedin.com/in/hernan-vargas-a505a5207",
    "company": "Autónomo",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Hernan Felipe",
    "lastName": "Linares Rodriguez",
    "url": "https://www.linkedin.com/in/hflinares",
    "company": "Devlane",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Hernán",
    "lastName": "Concordano",
    "url": "https://www.linkedin.com/in/hern%C3%A1n-concordano-8106a8146",
    "company": "TransPerfect",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Hernán Andrés",
    "lastName": "Orjuela",
    "url": "https://www.linkedin.com/in/hern%C3%A1n-andr%C3%A9s-orjuela-632420a4",
    "company": "DataArt",
    "position": "Regional IT Recruitment & HR Expert Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Hirdesh",
    "lastName": "Yadav ✅",
    "url": "https://www.linkedin.com/in/hirdesh-yadav-%E2%9C%85-6a5791141",
    "company": "Netorbit Inc",
    "position": "Lead Us IT recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Horacio",
    "lastName": "Beltran Simo",
    "url": "https://www.linkedin.com/in/horacio-beltran-simo-a8131116",
    "company": "Profesional independiente",
    "position": "CONSULTOR EN RR HH - BUSQUEDA Y SELECCION DE PERSONAL",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Horacio",
    "lastName": "Danieli",
    "url": "https://www.linkedin.com/in/horacio-danieli",
    "company": "Profesional Independiente",
    "position": "Talent Acquisition - IT Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Horacio Francisco",
    "lastName": "Melano",
    "url": "https://www.linkedin.com/in/hfm-",
    "company": "Kolektor UT",
    "position": "IT Recruiter / Gestión de Talento",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Humberto",
    "lastName": "Carballo",
    "url": "https://www.linkedin.com/in/humberto-carballo-b5381b72",
    "company": "DistantJob",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Héctor Manuel",
    "lastName": "Molina Ariza",
    "url": "https://www.linkedin.com/in/h%C3%A9ctor-manuel-molina-ariza-b6709b51",
    "company": "DaVita Colombia",
    "position": "Talent Acquisition Coordinator | Coordinador de atracción del talento",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Iael",
    "lastName": "Livchich",
    "url": "https://www.linkedin.com/in/iael-livchich",
    "company": "Lognext",
    "position": "Senior Technical Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ian",
    "lastName": "Quiroga",
    "url": "https://www.linkedin.com/in/ianbquiroga",
    "company": "Azumo.co",
    "position": "Senior Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Iara",
    "lastName": "Ayzemberg",
    "url": "https://www.linkedin.com/in/iara-ayzemberg",
    "company": "Motum",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Iara",
    "lastName": "Feferkowicz",
    "url": "https://www.linkedin.com/in/iara-feferkowicz-4030bb201",
    "company": "It-techgroup",
    "position": "Head Of Human Resources",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Iara",
    "lastName": "Merelas",
    "url": "https://www.linkedin.com/in/iara-merelas-836015211",
    "company": "EY",
    "position": "Talent Discovery Recruiter - Senior Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Iara",
    "lastName": "Torres",
    "url": "https://www.linkedin.com/in/iara-torresr",
    "company": "Inclusion. The Cloud Company",
    "position": "LATAM ⇄ USA Tech Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Iara Florencia",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/iaragonzalez",
    "company": "Natural Tech House",
    "position": "People and Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ibne",
    "lastName": "Ahmad",
    "url": "https://www.linkedin.com/in/ibne-ahmad-909a88179",
    "company": "US Tech Solutions",
    "position": "Senior Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Icabaru",
    "lastName": "Artigas",
    "url": "https://www.linkedin.com/in/icabaruartigas",
    "company": "Vesta Software Group",
    "position": "HR Business Partner - Chile",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Ignacio",
    "lastName": "Gomez Fernandez",
    "url": "https://www.linkedin.com/in/igomezfernandez",
    "company": "Profesional independiente",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ignacio",
    "lastName": "Granatelli",
    "url": "https://www.linkedin.com/in/ignaciogranatelli",
    "company": "Toolbox",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ignacio",
    "lastName": "Latella Frias",
    "url": "https://www.linkedin.com/in/ignacio-latella-frias-b161b4218",
    "company": "ZIELTECK S.A.",
    "position": "Selector de personal / Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ignacio",
    "lastName": "Mendivil Moore",
    "url": "https://www.linkedin.com/in/ignacio-mendivil-moore-a0a23b21a",
    "company": "Talently",
    "position": "Tech Recruitment Specialist | US Market | 15 placements & $51,500 USD in revenue",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ignacio",
    "lastName": "Nigro",
    "url": "https://www.linkedin.com/in/ignacio-nigro",
    "company": "Alumus Healthcare",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ignacio",
    "lastName": "Pardi",
    "url": "https://www.linkedin.com/in/ignacio-pardi",
    "company": "Quadion Technologies",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ignacio",
    "lastName": "Rodríguez",
    "url": "https://www.linkedin.com/in/ignacio-rodr%C3%ADguez-488856182",
    "company": "Stefanini LATAM",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ignacio",
    "lastName": "Rossini",
    "url": "https://www.linkedin.com/in/ignaciorossini",
    "company": "Akuaro",
    "position": "IT & Digital Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ignacio",
    "lastName": "Sarsfield",
    "url": "https://www.linkedin.com/in/ignasars",
    "company": "ENG",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Illse",
    "lastName": "Rodriguez Lazcano",
    "url": "https://www.linkedin.com/in/illse-rodriguez-lazcano-89b03a137",
    "company": "Hexaware Technologies",
    "position": "Sr. IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ilse",
    "lastName": "Arellano Torres",
    "url": "https://www.linkedin.com/in/ilse-leticia-arellano-torres",
    "company": "Parallel Staff",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Indira",
    "lastName": "Pico Castaño",
    "url": "https://www.linkedin.com/in/indirapicocasta%C3%B1o",
    "company": "SoftwareOne",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ines",
    "lastName": "Bidondo",
    "url": "https://www.linkedin.com/in/ines-bidondo-b535a319",
    "company": "MindTech",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ines",
    "lastName": "Landa Musacchio (she/her)",
    "url": "https://www.linkedin.com/in/ineslm",
    "company": "Forte Group",
    "position": "Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ines",
    "lastName": "Parodi",
    "url": "https://www.linkedin.com/in/inesparodi",
    "company": "Danone",
    "position": "Global HR Business Partner Cycles & Procurement",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Ines",
    "lastName": "Viola",
    "url": "https://www.linkedin.com/in/ines-v-",
    "company": "Adviters",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ingrid",
    "lastName": "Puglisi Heinrich (She/Her/Hers)",
    "url": "https://www.linkedin.com/in/ingridpuglisiheinrich",
    "company": "TRG Latam",
    "position": "HRBP Manager Latam",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Inés",
    "lastName": "Balada",
    "url": "https://www.linkedin.com/in/inesbalada",
    "company": "Self-Employed",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Inés",
    "lastName": "Castro",
    "url": "https://www.linkedin.com/in/inescastrob",
    "company": "CookUnity",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Inés",
    "lastName": "Izard",
    "url": "https://www.linkedin.com/in/in%C3%A9s-izard-13b002172",
    "company": "Belatrix Software",
    "position": "Recruiting Specialist IT",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Inés",
    "lastName": "Martinez",
    "url": "https://www.linkedin.com/in/in%C3%A9s-martinez-b27a9a15",
    "company": "Profesional independiente",
    "position": "Recruiter IT - Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Inés",
    "lastName": "Rodríguez Marengo",
    "url": "https://www.linkedin.com/in/in%C3%A9s-rodr%C3%ADguez-marengo-7a2485197",
    "company": "Howdy.com",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Inês",
    "lastName": "Maravalhas",
    "url": "https://www.linkedin.com/in/in%C3%AAsmaravalhas",
    "company": "DXC Technology",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Iosef",
    "lastName": "Zylberberg",
    "url": "https://www.linkedin.com/in/iosef-zylberberg",
    "company": "Green House Agency, Inc",
    "position": "Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Iramar Teresa",
    "lastName": "González Gómez",
    "url": "https://www.linkedin.com/in/iramar-teresa-gonz%C3%A1lez-g%C3%B3mez-b81460ba",
    "company": "Autónomo",
    "position": "Senior Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Irene",
    "lastName": "Benítez",
    "url": "https://www.linkedin.com/in/irene-benitez",
    "company": "Wilson",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Irene",
    "lastName": "Castillo",
    "url": "https://www.linkedin.com/in/busquedasitydigital",
    "company": "5411 Hub - LATAM Talents",
    "position": "Talent Sourcing Specialist | Corporate Communications & Training Expert",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Irene",
    "lastName": "Durán García",
    "url": "https://www.linkedin.com/in/ireneduran",
    "company": "DotGainen Consulting",
    "position": "Freelance IT Talent Acquisition & People Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "IRENE",
    "lastName": "GIRARDI",
    "url": "https://www.linkedin.com/in/irenegirardi",
    "company": "Irene Girardi Consultoría",
    "position": "Selección de personal y orientación laboral",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Irene",
    "lastName": "Melo (She/ Her)",
    "url": "https://www.linkedin.com/in/meloirene",
    "company": "Ledesma",
    "position": "Talent Acquisition Sr Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Irene",
    "lastName": "Trofimova",
    "url": "https://www.linkedin.com/in/trofimovairina",
    "company": "GENTY Recruitment",
    "position": "IT recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Irene Alicia",
    "lastName": "Scarso",
    "url": "https://www.linkedin.com/in/irenescarso",
    "company": "EPAM Systems",
    "position": "Lead IT Talent Acquisition Analyst | IT Recruiter",
    "keywords": [
      "people/talent leadership",
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ireri Sarai",
    "lastName": "Garcia",
    "url": "https://www.linkedin.com/in/ireri-sarai-garcia-846845305",
    "company": "Reclu IT",
    "position": "Técnico de selección de personal informático",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Irina",
    "lastName": "Olmos",
    "url": "https://www.linkedin.com/in/irinaolmos",
    "company": "IO - Servicios de reclutamiento y asesoría laboral",
    "position": "IT Talent Recruiter 🌐⚡️",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Irina Sol",
    "lastName": "Antonelli",
    "url": "https://www.linkedin.com/in/irina-sol-antonelli",
    "company": "Globant",
    "position": "IT Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Irupé",
    "lastName": "Cereguetti",
    "url": "https://www.linkedin.com/in/irup%C3%A9-c-a3540419",
    "company": "Free lance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Iryna",
    "lastName": "Kis",
    "url": "https://www.linkedin.com/in/iryna-k-683599b4",
    "company": "Freelance Projects",
    "position": "Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Iryna",
    "lastName": "Safulko",
    "url": "https://www.linkedin.com/in/ira-safulko",
    "company": "DistantJob",
    "position": "Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Isabel",
    "lastName": "Casimiro",
    "url": "https://www.linkedin.com/in/isabelg25",
    "company": "Distillery",
    "position": "IT Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Isabel",
    "lastName": "Cordova",
    "url": "https://www.linkedin.com/in/isabel-cordova-r",
    "company": "Globant",
    "position": "Senior IT Recruiting Coordinator Perú y Ecuador",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Isabel",
    "lastName": "Tezanos Pinto",
    "url": "https://www.linkedin.com/in/isabeltezanos",
    "company": "Grupo Bimbo",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Isabela María",
    "lastName": "Fiorentini",
    "url": "https://www.linkedin.com/in/ifiorentini",
    "company": "Folder IT",
    "position": "Recruitment and Selection Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Isabella",
    "lastName": "Arduvino (She/Her)",
    "url": "https://www.linkedin.com/in/isabella-arduvino",
    "company": "Distillery",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Isabella",
    "lastName": "Castiblanco Silva",
    "url": "https://www.linkedin.com/in/isabella-castiblanco-silva-a87971190",
    "company": "Capitole",
    "position": "Sr. HR Specialist & IT Talent Acquisition Coach",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Isabella",
    "lastName": "Vera",
    "url": "https://www.linkedin.com/in/isabella-vera-916256171",
    "company": "Voxelmaps",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Isabelle",
    "lastName": "Tiecher",
    "url": "https://www.linkedin.com/in/isabelletiecher",
    "company": "Skeelo",
    "position": "Senior Talent Acquisition LATAM & Candidate Experience",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Isidora",
    "lastName": "Díaz Mandiola",
    "url": "https://www.linkedin.com/in/isidora-d%C3%ADaz-mandiola-4835b41b5",
    "company": "ANDRITZ",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Isidro",
    "lastName": "Gallino",
    "url": "https://www.linkedin.com/in/isidro-gallino",
    "company": "Professional Resources BA",
    "position": "Hiring Partner & Advisor.",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Israel",
    "lastName": "Pinto",
    "url": "https://www.linkedin.com/in/israelpinto92",
    "company": "Motivus",
    "position": "Talent Acquisiton Manager - México & Costa Rica",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "IT Recruiter",
    "lastName": "Clarika",
    "url": "https://www.linkedin.com/in/rocio-clarika-software-innovation",
    "company": "Clarika Software + Innovation",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "IT Recruiter - Marcela",
    "lastName": "L.",
    "url": "https://www.linkedin.com/in/it-recruiter-marcela-l-a53b29223",
    "company": "ML Human Resources",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Italo",
    "lastName": "Aranda Egusquiza",
    "url": "https://www.linkedin.com/in/italo-aranda",
    "company": "Encora Inc.",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Itzel",
    "lastName": "Sánchez",
    "url": "https://www.linkedin.com/in/itzel-sanchez-guz",
    "company": "Kueski",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ivan",
    "lastName": "Da Ruos",
    "url": "https://www.linkedin.com/in/ivan-da-ruos",
    "company": "Averro",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ivan",
    "lastName": "Delvitto",
    "url": "https://www.linkedin.com/in/ivandelvitto",
    "company": "Muxon",
    "position": "Co-Founder and Recruitment Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ivan",
    "lastName": "Gomez Carabajal",
    "url": "https://www.linkedin.com/in/ivanhr",
    "company": "AspenView Technology Partners",
    "position": "Senior Manager - Talent Operations",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ivan",
    "lastName": "Jovicic",
    "url": "https://www.linkedin.com/in/ivanjovicic777",
    "company": "Frederick Fox",
    "position": "Senior Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ivan",
    "lastName": "Mihura",
    "url": "https://www.linkedin.com/in/ivanmihura",
    "company": "Cerboni Accounting and Financial Services",
    "position": "Human Resources Assistant / Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ivan Federico",
    "lastName": "Perichon",
    "url": "https://www.linkedin.com/in/hrivanperichon",
    "company": "Accenture Argentina",
    "position": "Associate Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ivana",
    "lastName": "Andrusiak",
    "url": "https://www.linkedin.com/in/iandrusiak",
    "company": "Autónomo",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ivana",
    "lastName": "Gesuitti",
    "url": "https://www.linkedin.com/in/igesuitti",
    "company": "Cronnos Consulting",
    "position": "HR Consultant - Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ivana",
    "lastName": "Spadotto",
    "url": "https://www.linkedin.com/in/ivana-spadotto-4472b0201",
    "company": "Coderio | Software Company",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ivana",
    "lastName": "Vega",
    "url": "https://www.linkedin.com/in/deniseivanavega",
    "company": "Tsoft",
    "position": "Talent IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ivani",
    "lastName": "Veronezi",
    "url": "https://www.linkedin.com/in/ivani-veronezi-577a6376",
    "company": "Mavila Consulting",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Iveth",
    "lastName": "Torrez Juarez",
    "url": "https://www.linkedin.com/in/iveth-torrez-juarez-051544128",
    "company": "Puzzle",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ivonne Aylén",
    "lastName": "Catauro Nardella",
    "url": "https://www.linkedin.com/in/ivonne-ayl%C3%A9n-catauro-nardella",
    "company": "Infracommerce Latam",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jackeline",
    "lastName": "Chuquipoma",
    "url": "https://www.linkedin.com/in/jackelinechuquipoma",
    "company": "Protiviti Perú",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jacopo Augusto",
    "lastName": "Cabini",
    "url": "https://www.linkedin.com/in/jacopo-augusto-cabini",
    "company": "Arxada",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jael",
    "lastName": "Layun (She/Her) 👩🏽‍💻",
    "url": "https://www.linkedin.com/in/talentsourcerlayunjael",
    "company": "ALIANDO",
    "position": "Recruitment & Development Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Jael",
    "lastName": "Lezama",
    "url": "https://www.linkedin.com/in/jael-lezama-a74953a6",
    "company": "NTT DATA Europe & LATAM",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jairo",
    "lastName": "Suarez",
    "url": "https://www.linkedin.com/in/jairo-suarez-4a8bb7162",
    "company": "Awana (formerly Hire Llama)",
    "position": "Senior Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Janet",
    "lastName": "Montero",
    "url": "https://www.linkedin.com/in/it-recruiter-janet-montero",
    "company": "Tech City",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Janire",
    "lastName": "Campo",
    "url": "https://www.linkedin.com/in/janire-campo-8147b3b4",
    "company": "IZERTIS",
    "position": "IT Recruiter Consultant",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Janmesh",
    "lastName": "Sirohi",
    "url": "https://www.linkedin.com/in/janmesh-sirohi-638b4181",
    "company": "Verinon Technology Solutions Sdn Bhd.",
    "position": "Senior IT Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jannina",
    "lastName": "Chirinos Chang",
    "url": "https://www.linkedin.com/in/janninachirinos",
    "company": "Freelance | Self-Employed",
    "position": "Senior Talent Acquisition | Selección de Perfiles IT",
    "keywords": [
      "talent acquisition",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Jaqueline",
    "lastName": "Mignoli",
    "url": "https://www.linkedin.com/in/jaqueline-mignoli",
    "company": "Who? Consultora Integral",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jaqui",
    "lastName": "Osorio",
    "url": "https://www.linkedin.com/in/jaquelin-zayleth-ho",
    "company": "Praxis España",
    "position": "Técnico de selección de personal técnico",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Javier",
    "lastName": "Alegre",
    "url": "https://www.linkedin.com/in/javieralegrer",
    "company": "GHIMPROVE",
    "position": "HR Manager | Recruiter",
    "keywords": [
      "recruiter",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Javier",
    "lastName": "Hecker",
    "url": "https://www.linkedin.com/in/javier-hecker-69b88a8",
    "company": "DevReady",
    "position": "Technical Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Javier",
    "lastName": "Llaña",
    "url": "https://www.linkedin.com/in/javier-lla%C3%B1a-loredo",
    "company": "ABENIS CONSULTORES",
    "position": "Ejecutivo de Reclutamiento y Selección Sr.",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Javier",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/javier-rodriguez-6a88785",
    "company": "CDA Informática",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Javier",
    "lastName": "Settembrini",
    "url": "https://www.linkedin.com/in/javier-settembrini",
    "company": "Mixtura Talent",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Javiera",
    "lastName": "Nuñez Petit",
    "url": "https://www.linkedin.com/in/javieranunezpetit",
    "company": "Falabella",
    "position": "Senior IT Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jayasurya",
    "lastName": "Alaguraj",
    "url": "https://www.linkedin.com/in/jayasurya-alaguraj",
    "company": "Tata Consultancy Services",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Jazmin",
    "lastName": "Aguado",
    "url": "https://www.linkedin.com/in/melanie-jazmin-aguado",
    "company": "Flux IT",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Jazmin",
    "lastName": "Bonillo",
    "url": "https://www.linkedin.com/in/jazmin-bonillo-704b59173",
    "company": "Profesional independiente",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jazmin",
    "lastName": "Mena",
    "url": "https://www.linkedin.com/in/jazmin-mena-48997017b",
    "company": "Stefanini LATAM",
    "position": "Senior IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jazmin",
    "lastName": "Romano",
    "url": "https://www.linkedin.com/in/jazmin-romano-470ab5290",
    "company": "Aditi LATAM",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jazmín",
    "lastName": "Cuello",
    "url": "https://www.linkedin.com/in/jazmin-cuello",
    "company": "Quales",
    "position": "Senior Talent Acquisition & Culture Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jeanette",
    "lastName": "Mamani",
    "url": "https://www.linkedin.com/in/jeanette-talentrecruiter",
    "company": "Believe Solutions",
    "position": "Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jeanette",
    "lastName": "Rossi",
    "url": "https://www.linkedin.com/in/jeanette-rossi",
    "company": "MOOD Human Resources",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jefferson",
    "lastName": "Borja Quispe",
    "url": "https://www.linkedin.com/in/jefferson-borja-quispe-47585522b",
    "company": "CSTI Corp",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jeisy Andrea",
    "lastName": "Mazo Peña",
    "url": "https://www.linkedin.com/in/jeisyandreamazope%C3%B1a",
    "company": "SoftwareOne",
    "position": "Talent Acquisition Partner/ Psicóloga de atracción y selección",
    "keywords": [
      "talent acquisition",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Jeniffer",
    "lastName": "Mamani Colquehuanca",
    "url": "https://www.linkedin.com/in/jeniffer-mamani-colquehuanca-966b4540",
    "company": "NTT DATA Europe & LATAM",
    "position": "Jefa de Reclutamiento y Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Jenipher",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/jenipher-romero",
    "company": "Len & Nyle",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jennifer",
    "lastName": "Arrieta",
    "url": "https://www.linkedin.com/in/jennifer-arrieta-265b81166",
    "company": "IBM Accelalpha",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jennifer",
    "lastName": "Restrepo",
    "url": "https://www.linkedin.com/in/jennifer-restrepob",
    "company": "Odisea Cultura",
    "position": "Senior People Operations & Recruiting",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Jennifer",
    "lastName": "Rodriguez Valencia",
    "url": "https://www.linkedin.com/in/jennifer-rodriguez-valencia-b077ab64",
    "company": "TOPTALENTLATAM",
    "position": "Recruitment Selection Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jennifer",
    "lastName": "Villota Quintero 💻 📣",
    "url": "https://www.linkedin.com/in/jennifervq",
    "company": "IT Patagonia",
    "position": "People Business Partner Specialist",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Jennifer",
    "lastName": "Xing ❄",
    "url": "https://www.linkedin.com/in/jennifer-xing",
    "company": "Snowflake",
    "position": "Sr Tech Recruiter II",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jennifer Sofia",
    "lastName": "Nuñez",
    "url": "https://www.linkedin.com/in/jennifersofianu%C3%B1ez95",
    "company": "Yumatech",
    "position": "Ssr Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jensy",
    "lastName": "Thomas",
    "url": "https://www.linkedin.com/in/jensythomas",
    "company": "Pan Asia Resources",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jeronimo",
    "lastName": "Tabanera",
    "url": "https://www.linkedin.com/in/jeronimo-tabanera",
    "company": "mindIT HR Agency",
    "position": "Sales Developer Representative | IT Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Jerry",
    "lastName": "Tang",
    "url": "https://www.linkedin.com/in/jerry-tang-972666209",
    "company": "Bestinet",
    "position": "Senior Talent Acquisition (IT Specialist APAC)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jerusa",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/jerusa-diaz-0744bb15a",
    "company": "MAS Global Consulting",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Jesennia",
    "lastName": "Barriga Huamán",
    "url": "https://www.linkedin.com/in/jesennia-barriga",
    "company": "Encora Inc.",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jesica",
    "lastName": "Bacaicoa",
    "url": "https://www.linkedin.com/in/jesica-bacaicoa",
    "company": "JobCentral",
    "position": "Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jesica",
    "lastName": "Goncalves",
    "url": "https://www.linkedin.com/in/jesica-goncalves-24211610a",
    "company": "Globons | The Digital Innovation Company",
    "position": "HRBP for Multiplica Global",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Jesica",
    "lastName": "Guzman",
    "url": "https://www.linkedin.com/in/jesica-guzman-rodrigues",
    "company": "Corporix HR",
    "position": "IT RECRUITER & TALENT ACQUISITION - LATAM",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jesica",
    "lastName": "Lorenzo",
    "url": "https://www.linkedin.com/in/jesica-lorenzo-b08673138",
    "company": "Profesional independiente",
    "position": "Jefa de operaciones de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Jesica",
    "lastName": "Salgado",
    "url": "https://www.linkedin.com/in/jesicasalgado",
    "company": "Co | Hunters",
    "position": "Talent Acquisition | Co Hunters",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jesica Suyai",
    "lastName": "Ruiz",
    "url": "https://www.linkedin.com/in/jesica-suyai-ruiz",
    "company": "NTT DATA Europe & LATAM",
    "position": "Recruiter at NTT DATA",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jesica Valeria",
    "lastName": "Guzman Rodrigues",
    "url": "https://www.linkedin.com/in/jesica-valeria-guzman-rodrigues",
    "company": "Corporix HR",
    "position": "IT RECRUITMENT LEAD & TALENT ACQUISITION - LATAM",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jesse",
    "lastName": "St-Pierre",
    "url": "https://www.linkedin.com/in/jesse-st-pierre-6b019b2",
    "company": "peoplepath.io",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "de Souza Farias",
    "url": "https://www.linkedin.com/in/jessidesouza",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "Drinkard",
    "url": "https://www.linkedin.com/in/jessica-drinkard-02419b105",
    "company": "Brick Staffing, LLC",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "Durán",
    "url": "https://www.linkedin.com/in/jessica-dur%C3%A1n-280387156",
    "company": "DC Recursos Humanos",
    "position": "Responsable de reclutamiento y selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "Fundora Ferrer",
    "url": "https://www.linkedin.com/in/jessica-fundora-ferrer-5239432a",
    "company": "Autónomo",
    "position": "Global Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "Leiva",
    "url": "https://www.linkedin.com/in/jessicaleiva14",
    "company": "Strider",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "Martell",
    "url": "https://www.linkedin.com/in/jessica-martell-20623211b",
    "company": "Skydropx",
    "position": "Talent Success Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "Ochoa",
    "url": "https://www.linkedin.com/in/jessicaochoabosquez",
    "company": "CQ fluency",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "Perez",
    "url": "https://www.linkedin.com/in/jessica-perez-523803123",
    "company": "Wipro",
    "position": "Talent Acquisition Specialist LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "Tshibangu",
    "url": "https://www.linkedin.com/in/jessica-t-77a1671b4",
    "company": "Wellmore Behavioral Health",
    "position": "Human Resources Recruiter / Onboarding Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jessica",
    "lastName": "Álvarez",
    "url": "https://www.linkedin.com/in/jessica-%C3%A1lvarez-763052a1",
    "company": "Welltech",
    "position": "Senior Talent Acquisition Business Partner",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Jessica Noemi",
    "lastName": "Moscoso",
    "url": "https://www.linkedin.com/in/jessica-noemi-moscoso-183860215",
    "company": "Freelance",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jesus",
    "lastName": "Magaña Villaseñor",
    "url": "https://www.linkedin.com/in/jesus-maga%C3%B1a-villase%C3%B1or-4ab05328",
    "company": "Kettelsen International Recruiting",
    "position": "Talent Acquisition Specialist (Kettelsen Group)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jesús",
    "lastName": "Martín Holgado",
    "url": "https://www.linkedin.com/in/jesusmartinholgado",
    "company": "HACK A BOSS",
    "position": "Especialista en Selección de Perfiles IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Jhennifer",
    "lastName": "Hurtado",
    "url": "https://www.linkedin.com/in/jhenniferhurtado",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jhoan Moises",
    "lastName": "Alayon Meza",
    "url": "https://www.linkedin.com/in/jhoan-moises-alayon-meza-0b6766192",
    "company": "ITProviders",
    "position": "IT Recruiter&HeadHunter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Jhon",
    "lastName": "Niño Sua",
    "url": "https://www.linkedin.com/in/jhonnino-recruiter",
    "company": "Grupo Ditech",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jhonn",
    "lastName": "Vivanco Echevarria",
    "url": "https://www.linkedin.com/in/jvivancoe",
    "company": "NTT DATA Europe & LATAM",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jimena",
    "lastName": "Alcayaga",
    "url": "https://www.linkedin.com/in/jimena-alcayaga-b016932b",
    "company": "Ulead",
    "position": "Global Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jimena",
    "lastName": "Bellini",
    "url": "https://www.linkedin.com/in/jimena-bellini-99563b215",
    "company": "Clever HR",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jimena",
    "lastName": "Jullier",
    "url": "https://www.linkedin.com/in/licjimenajullier",
    "company": "Doorsel",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Jimena",
    "lastName": "Santisteban",
    "url": "https://www.linkedin.com/in/jimena-santisteban-71a4176b",
    "company": "Independiente",
    "position": "Consultora Independiente en Talent Acquisition & People Strategy",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jimena",
    "lastName": "Soto",
    "url": "https://www.linkedin.com/in/jimena-soto-249798b1",
    "company": "menze",
    "position": "People Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jimena Belén",
    "lastName": "Ibarra",
    "url": "https://www.linkedin.com/in/jimena-bel%C3%A9n-ibarra-aba244b4",
    "company": "Growth HR",
    "position": "Talent Acquisition Team Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "jitendra",
    "lastName": "upreity",
    "url": "https://www.linkedin.com/in/jitendra-upreity-96253510a",
    "company": "Technocraft Solutions",
    "position": "Sr USIT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Joana",
    "lastName": "Fantin",
    "url": "https://www.linkedin.com/in/joanafantin",
    "company": "G&L Group",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Joana",
    "lastName": "Luque",
    "url": "https://www.linkedin.com/in/joana-luque",
    "company": "People IT",
    "position": "💻 Team Leader & IT Recruiter | Reclutamiento end to end",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Joanna",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/joanna-rodriguez-recruiter",
    "company": "Palermo Advisors",
    "position": "Senior Sourcer & Recruiter | HR Consultant",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Joanna Narubi",
    "lastName": "Villanueva Zuñiga",
    "url": "https://www.linkedin.com/in/joanna-narubi-villanueva-zu%C3%B1iga-14124a1a3",
    "company": "Tech Mahindra",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Joaquin",
    "lastName": "Canciani",
    "url": "https://www.linkedin.com/in/joaquin-canciani",
    "company": "Glofy",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Joaquin",
    "lastName": "Colomer",
    "url": "https://www.linkedin.com/in/joaquin-colomer-85898b212",
    "company": "Avature",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Joaquin",
    "lastName": "M.",
    "url": "https://www.linkedin.com/in/joaquin-m-82993120b",
    "company": "Findtec",
    "position": "Senior Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Joaquin",
    "lastName": "Pires Diz",
    "url": "https://www.linkedin.com/in/joaquinpiresdiz",
    "company": "EY",
    "position": "US Talent Attraction Recruiter - Supervising Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Joaquin",
    "lastName": "Segovia",
    "url": "https://www.linkedin.com/in/joaquin-segovia",
    "company": "NTT DATA Europe & Latam",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Joaquina",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/joaquina-fernandez",
    "company": "ASORUM Consultora en RRHH",
    "position": "Auxiliar de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Joaquín",
    "lastName": "Durrieu",
    "url": "https://www.linkedin.com/in/joaquin-durrieu",
    "company": "Prediktive",
    "position": "Talent Acquisition Specialist | Tech Sourcing Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Joaquín",
    "lastName": "Peña",
    "url": "https://www.linkedin.com/in/joaquin-recruiter",
    "company": "Kopius, Inc.",
    "position": "Technical Recruiter Analyst",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jocelyn",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/jocelyn-gonzalez-b23a4933",
    "company": "BC Tecnología",
    "position": "Head of Talent Acquisition, LATAM Region",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jodie",
    "lastName": "Blair",
    "url": "https://www.linkedin.com/in/jodie-blair-3273b0b6",
    "company": "M+C Saatchi Group AUNZ",
    "position": "Talent Acquisition Director",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Joel",
    "lastName": "Imsand",
    "url": "https://www.linkedin.com/in/joel-imsand-b50172163",
    "company": "Profesional independiente",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Joel",
    "lastName": "Obando",
    "url": "https://www.linkedin.com/in/joel-obando-500b7455",
    "company": "NTT DATA Services",
    "position": "IT Recruiting Specialist, Senior Talent Acquisition",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Johana",
    "lastName": "Pessano",
    "url": "https://www.linkedin.com/in/johana-pessano-80553b86",
    "company": "JPMorgan Chase & Co.",
    "position": "Technology Recruiting Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Johana",
    "lastName": "Ramirez Sheput",
    "url": "https://www.linkedin.com/in/johana-ramirez-sheput-5b2700140",
    "company": "NTT DATA Europe & Latam",
    "position": "IT Talent Acquisition Coordinador",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Johanna",
    "lastName": "Acuña",
    "url": "https://www.linkedin.com/in/johanna-acu%C3%B1a",
    "company": "Medifé",
    "position": "Head of Talent Attraction & Acquisition",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Johanna",
    "lastName": "Calderon Candia",
    "url": "https://www.linkedin.com/in/johannarecruiter-b70a94117",
    "company": "Zoluxiones",
    "position": "IT Recruitment and Selection Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Johanna",
    "lastName": "Zapaterra",
    "url": "https://www.linkedin.com/in/johanna-zapaterra-9842014b",
    "company": "Mercado Libre",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "John",
    "lastName": "Waid",
    "url": "https://www.linkedin.com/in/johnwaid",
    "company": "Mercedes-Benz U.S. International, Inc.",
    "position": "People Engagement Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jon",
    "lastName": "James",
    "url": "https://www.linkedin.com/in/jonjamesinc",
    "company": "One Community Health",
    "position": "Clinical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jonathan",
    "lastName": "Bello",
    "url": "https://www.linkedin.com/in/jonathan-bello",
    "company": "Ontop",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jonathan",
    "lastName": "Dreyfuss Perdomo",
    "url": "https://www.linkedin.com/in/jdreyfuss",
    "company": "Fulcrum Digital Inc",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jonathan",
    "lastName": "Mejalelaty",
    "url": "https://www.linkedin.com/in/jonathan-mejalelaty-6961a5b5",
    "company": "Valtech",
    "position": "Senior Coordinator, Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jonathan",
    "lastName": "Ortiz, MBA",
    "url": "https://www.linkedin.com/in/jotyortizrodas",
    "company": "Neostella",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jonathan",
    "lastName": "Quiroz",
    "url": "https://www.linkedin.com/in/jonathan-quiroz-42ba46b7",
    "company": "Buk",
    "position": "Sr. Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jorge",
    "lastName": "Bacher",
    "url": "https://www.linkedin.com/in/jorge-bacher-6516bb207",
    "company": "Virtualmind",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jorge",
    "lastName": "BO",
    "url": "https://www.linkedin.com/in/jorgeezebo",
    "company": "Freelancer.com",
    "position": "Talent Acquisition - IT Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jorge",
    "lastName": "Dobrusky Tester Argentina",
    "url": "https://www.linkedin.com/in/jorge-dobrusky-tester-argentina",
    "company": "Tester Smart SRL",
    "position": "Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Jorge",
    "lastName": "González",
    "url": "https://www.linkedin.com/in/jorge-gonz%C3%A1lez-642550108",
    "company": "FPT Software",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jorge",
    "lastName": "Lopez Romero",
    "url": "https://www.linkedin.com/in/jorgedlr89",
    "company": "Kake",
    "position": "Senior Recruitment Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jorge",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/jorge-l%C3%B3pez-recruiting-2023-ret",
    "company": "Accenture",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Jorge",
    "lastName": "Marrero",
    "url": "https://www.linkedin.com/in/jorgemarrero",
    "company": "Here We Go - Talent Consultants",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jorge",
    "lastName": "Martínez Solimano",
    "url": "https://www.linkedin.com/in/jorgemartinezsolimano",
    "company": "Encora Inc.",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jorge",
    "lastName": "Medina Rojas",
    "url": "https://www.linkedin.com/in/jorge-medina-rojas-6a906a59",
    "company": "Independiente",
    "position": "IT Recruiter/Headhunter",
    "keywords": [
      "headhunter",
      "recruiter"
    ]
  },
  {
    "firstName": "Jorge Alberto",
    "lastName": "Valecillo Chacón",
    "url": "https://www.linkedin.com/in/jorgevalecillo",
    "company": "Applica corp.",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jorge L.",
    "lastName": "Robledo",
    "url": "https://www.linkedin.com/in/jorge-l-robledo-79b7905b",
    "company": "Elevate Teams",
    "position": "Director, Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jorgelina Soledad",
    "lastName": "Ivaldis",
    "url": "https://www.linkedin.com/in/jivaldis",
    "company": "ITR",
    "position": "IT Recruiter SR & Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Jose",
    "lastName": "Acosta",
    "url": "https://www.linkedin.com/in/jose-acosta-recruiter",
    "company": "Jahnel Group",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jose",
    "lastName": "Landaeta",
    "url": "https://www.linkedin.com/in/jose-a-landaeta",
    "company": "Amaris Consulting",
    "position": "Talent Acquisition Manager | Brazil",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jose Alvaro",
    "lastName": "Rodríguez",
    "url": "https://www.linkedin.com/in/jose-alvaro-rodriguez-arenas",
    "company": "Recruiter",
    "position": "Senior Recruiter (freelance)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jose Antonio",
    "lastName": "Romero Moscoso",
    "url": "https://www.linkedin.com/in/jose-romero-moscoso",
    "company": "Aditi LATAM",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jose Carlos",
    "lastName": "Loyola",
    "url": "https://www.linkedin.com/in/josecarlosloyola",
    "company": "Ryscode",
    "position": "Tech Recruiter - LATAM",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Jose Gabriel",
    "lastName": "Steinberg Ortiz",
    "url": "https://www.linkedin.com/in/josesteinberg",
    "company": "ZAGALABS",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Jose Luis",
    "lastName": "Torres",
    "url": "https://www.linkedin.com/in/joseltorresm",
    "company": "Globant",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Josefina",
    "lastName": "Albarello Medin",
    "url": "https://www.linkedin.com/in/josefinaalbarello",
    "company": "Kopius, Inc.",
    "position": "Technical Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Josefina",
    "lastName": "Engel",
    "url": "https://www.linkedin.com/in/josefina-engel",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Josefina",
    "lastName": "Marcantonio",
    "url": "https://www.linkedin.com/in/josefinamarcantonio",
    "company": "MARC-IBER",
    "position": "Professional Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Josefina",
    "lastName": "Marchese",
    "url": "https://www.linkedin.com/in/josefina-marchese",
    "company": "deRecruiters",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Josefina",
    "lastName": "Martinez Sanchez",
    "url": "https://www.linkedin.com/in/josefina-martinez-sanchez-a1442320b",
    "company": "JPH LIONS",
    "position": "Recruiter & Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Josefina",
    "lastName": "Saez Johansson",
    "url": "https://www.linkedin.com/in/josefinasaez",
    "company": "Capitole",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Joseline",
    "lastName": "Roca",
    "url": "https://www.linkedin.com/in/joseline-roca-166870108",
    "company": "NEORIS",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Joseph",
    "lastName": "Lim",
    "url": "https://www.linkedin.com/in/joseph-lim-08112312b",
    "company": "Horizontal Talent",
    "position": "Recruiter II",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Josiane",
    "lastName": "Albrecht",
    "url": "https://www.linkedin.com/in/josiane-albrecht-58b271b3",
    "company": "Mercado Libre",
    "position": "IT Talent Acquisition | LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Josue",
    "lastName": "Hernandez",
    "url": "https://www.linkedin.com/in/josue-hernandez-7987ba102",
    "company": "Oowlish",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Josué",
    "lastName": "González",
    "url": "https://www.linkedin.com/in/josuegonzalez426",
    "company": "ITWarp Consulting",
    "position": "Jr IT. Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "José",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/garciarojasjose",
    "company": "Avalith",
    "position": "IT Recruiter 360",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "José",
    "lastName": "Molina",
    "url": "https://www.linkedin.com/in/jos%C3%A9molina",
    "company": "One Recruiting Agency",
    "position": "Talent Acquisition Manager - Senior IT Recruiter",
    "keywords": [
      "people/talent leadership",
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "José A.",
    "lastName": "Mangani",
    "url": "https://www.linkedin.com/in/jos%C3%A9-a-mangani-3005553a",
    "company": "JAM Recruiting",
    "position": "Founder of JAM Recruiting / Talent Acquisition Expert",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "José Antonio",
    "lastName": "Del Rio",
    "url": "https://www.linkedin.com/in/jos%C3%A9-antonio-del-rio-27a321125",
    "company": "Mavila Consulting",
    "position": "Global Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "José Antonio",
    "lastName": "Domínguez Cedeño",
    "url": "https://www.linkedin.com/in/jos%C3%A9-antonio-dom%C3%ADnguez-cede%C3%B1o-2a2636186",
    "company": "Nortal",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "José Emilio",
    "lastName": "Delgado Peña",
    "url": "https://www.linkedin.com/in/jose-emilio-delgado",
    "company": "PIXIE",
    "position": "Senior IT Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "José Pablo",
    "lastName": "Cardoso",
    "url": "https://www.linkedin.com/in/jos%C3%A9-pablo-cardoso-4bb798150",
    "company": "Ovidio IT Consulting",
    "position": "IT Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Joy",
    "lastName": "Rozas",
    "url": "https://www.linkedin.com/in/joy-rozas",
    "company": "Bookahospi",
    "position": "Lead Healthcare Recruiter – Saudi Arabia & Spain / HR Manager",
    "keywords": [
      "recruiter",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Joyce",
    "lastName": "Zarache Puello, HR MBA",
    "url": "https://www.linkedin.com/in/joyce-zarache-puello-hr-mba-273798b5",
    "company": "Lisinski Law Firm",
    "position": "Sr Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "João",
    "lastName": "Freitas",
    "url": "https://www.linkedin.com/in/jmbfreitas",
    "company": "TUI",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan",
    "lastName": "Beltramino",
    "url": "https://www.linkedin.com/in/juan-beltramino-59b69a218",
    "company": "Los Soles Internacional S.A",
    "position": "Lider de reclutamiento y selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Juan",
    "lastName": "Bethencourt",
    "url": "https://www.linkedin.com/in/juansebastianbethencourt",
    "company": "Ford Motor Company",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan",
    "lastName": "Chessa",
    "url": "https://www.linkedin.com/in/juanchessa",
    "company": "Visma Latam",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan",
    "lastName": "Gonzalez de Avellaneda",
    "url": "https://www.linkedin.com/in/juangonzalezterrace-551a21173",
    "company": "Yumatech",
    "position": "Recruitment Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Juan",
    "lastName": "Manrique",
    "url": "https://www.linkedin.com/in/jpmanrique",
    "company": "IQVIA",
    "position": "Direct Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan",
    "lastName": "Olivares",
    "url": "https://www.linkedin.com/in/-juanolivares",
    "company": "MOOVA",
    "position": "Regional HRBP LATAM",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Juan Alejandro",
    "lastName": "Garay",
    "url": "https://www.linkedin.com/in/juan-alejandro-garayit",
    "company": "Profesional independiente",
    "position": "IT Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Andrés",
    "lastName": "Lalama",
    "url": "https://www.linkedin.com/in/juan-andr%C3%A9s-lalama-003361198",
    "company": "TECLA",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Carlos",
    "lastName": "Londoño Vargas",
    "url": "https://www.linkedin.com/in/juan-carlos-londo%C3%B1o-vargas-a680aa245",
    "company": "Maracuya Consulting",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan Cruz",
    "lastName": "Gonzalez Sevilla",
    "url": "https://www.linkedin.com/in/juan-cruz-gonzalez-sevilla-a4854116b",
    "company": "BTR Consulting",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Juan Cruz",
    "lastName": "Luque",
    "url": "https://www.linkedin.com/in/juan-cruz-luque-01b7b197",
    "company": "Ualá",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan David",
    "lastName": "Echeverri Sáenz",
    "url": "https://www.linkedin.com/in/it-jobs-juan-echeverry",
    "company": "Katapult Labs",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Diego",
    "lastName": "Pita Moreno",
    "url": "https://www.linkedin.com/in/juan-diego-pita",
    "company": "Accenture Argentina",
    "position": "Recruiting Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Juan Emilio",
    "lastName": "Szelagowski Schmidt",
    "url": "https://www.linkedin.com/in/juan-emilio-szelagowski-schmidt-59a617207",
    "company": "Paired",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Estanislao",
    "lastName": "de la Vega",
    "url": "https://www.linkedin.com/in/juan-estanislao-de-la-vega-802299136",
    "company": "Freelancer",
    "position": "IT Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Francisco",
    "lastName": "Acevedo",
    "url": "https://www.linkedin.com/in/recruiterjuanfrancisco",
    "company": "PlatformX Solutions",
    "position": "Senior Technical Recruiter & Business Consultant",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Francisco",
    "lastName": "Girotti",
    "url": "https://www.linkedin.com/in/juan-francisco-girotti-7a768b174",
    "company": "Recruitia Group",
    "position": "Consultor & Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan Francisco",
    "lastName": "Pistone",
    "url": "https://www.linkedin.com/in/juan-francisco-pistone-a5b3b91a2",
    "company": "WillDom",
    "position": "Talent Acquisition Sourcer",
    "keywords": [
      "talent acquisition",
      "sourcer"
    ]
  },
  {
    "firstName": "Juan Guillermo",
    "lastName": "Maldonado Munizaga",
    "url": "https://www.linkedin.com/in/juan-guillermo-maldonado-munizaga-400a52143",
    "company": "Link Chase",
    "position": "Freelance Global Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Ignacio",
    "lastName": "Lacasia",
    "url": "https://www.linkedin.com/in/juan-ignacio-lacasia-b55a0b188",
    "company": "HR Oasis Consultora RRHH",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Ignacio",
    "lastName": "Marischi",
    "url": "https://www.linkedin.com/in/juan-ignacio-marischi",
    "company": "CFOTech IT Global Services",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan Ignacio",
    "lastName": "Rovito",
    "url": "https://www.linkedin.com/in/itechcareerr-rd",
    "company": "iTechCareer-RD Latam Search & Selection",
    "position": "IT Recruitment Analyst - iTechCareer-RD Latam Search & Selection (https://rd.itechcareer.com)",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Juan Ignacio",
    "lastName": "Salituri",
    "url": "https://www.linkedin.com/in/juan-ignacio-salituri-460245149",
    "company": "10EQS",
    "position": "Client Delivery Operations & Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan Ignacio",
    "lastName": "Solito",
    "url": "https://www.linkedin.com/in/juan-ignacio-solito-6bb02b118",
    "company": "Intelletec",
    "position": "Sr IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan Jose",
    "lastName": "Juarez",
    "url": "https://www.linkedin.com/in/juanjojuarez",
    "company": "Hutrit",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Juan José",
    "lastName": "Huerta",
    "url": "https://www.linkedin.com/in/juan-jose-huerta",
    "company": "Tekton Labs",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Manuel",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/juan-manuel-gonzalez-a4846239",
    "company": "DEEPTICS",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Manuel",
    "lastName": "Orbuch",
    "url": "https://www.linkedin.com/in/juanorbuch",
    "company": "Movistar Argentina",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan Manuel",
    "lastName": "Roman",
    "url": "https://www.linkedin.com/in/juan-manuel-roman-a9531a21",
    "company": "Who? Consultora Integral",
    "position": "Head of Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Juan Pablo",
    "lastName": "Blandon",
    "url": "https://www.linkedin.com/in/juan-pablo-blandon-8b928869",
    "company": "TEAM International",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan Pablo",
    "lastName": "Castro Mosconi",
    "url": "https://www.linkedin.com/in/juanpablocastromosconi",
    "company": "RevX",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juan Pablo",
    "lastName": "D'Amelio",
    "url": "https://www.linkedin.com/in/jpdamelio",
    "company": "EY",
    "position": "Talent Attraction Recruiter Supervising Associate - (TA²)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juan Pablo",
    "lastName": "Gambarotto",
    "url": "https://www.linkedin.com/in/juan-pablo-gambarotto-6b557153",
    "company": "Accenture",
    "position": "Especialista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Juan Pablo",
    "lastName": "Peirano",
    "url": "https://www.linkedin.com/in/federiconeuman",
    "company": "Tech City",
    "position": "Especialista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Juan Pablo",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/juan-pablo-sanchez-pt",
    "company": "KCS iT",
    "position": "People & Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Juan Santiago",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/juan-santiago-diaz-89a123195",
    "company": "Vacalin",
    "position": "Especialista de Selección y Desarrollo",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Juana",
    "lastName": "Capocasa",
    "url": "https://www.linkedin.com/in/juana-capocasa",
    "company": "Grupo Gestión",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Judit",
    "lastName": "Herrmann",
    "url": "https://www.linkedin.com/in/judit-herrmann",
    "company": "IT Solutions Group",
    "position": "IT Headhunter & Talent Advisor",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Judit",
    "lastName": "Miret",
    "url": "https://www.linkedin.com/in/judit-miret",
    "company": "Block & Capital",
    "position": "Founder & IT Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Judith",
    "lastName": "Centurion",
    "url": "https://www.linkedin.com/in/judith-centurion-6bb48b62",
    "company": "Dakachi",
    "position": "HRBP/ IT Talent Acquisition SR",
    "keywords": [
      "hrbp/business partner",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julia",
    "lastName": "Biliawska",
    "url": "https://www.linkedin.com/in/julia-biliawska-4b037482",
    "company": "DistantJob",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julia",
    "lastName": "De Jesus",
    "url": "https://www.linkedin.com/in/julia-de-jesus-b23a8820b",
    "company": "Cognizant",
    "position": "Team Lead Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Julia",
    "lastName": "Guillén",
    "url": "https://www.linkedin.com/in/juliaguillencst",
    "company": "Hire With Near",
    "position": "IT Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Julia",
    "lastName": "Lanese",
    "url": "https://www.linkedin.com/in/julialanese",
    "company": "Renaiss",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julia",
    "lastName": "Montersino",
    "url": "https://www.linkedin.com/in/juliamontersinoitheadhunter",
    "company": "T-Systems Iberia",
    "position": "International IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julia",
    "lastName": "Murotto",
    "url": "https://www.linkedin.com/in/julia-murotto-21442a3b",
    "company": "Extendeal",
    "position": "HR Manager LATAM | Talent Acquisition & People Operations",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Julia",
    "lastName": "Svaiter",
    "url": "https://www.linkedin.com/in/juliasvaiter",
    "company": "SVAITECH LLC",
    "position": "Founder / International IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julia",
    "lastName": "Vezzulla",
    "url": "https://www.linkedin.com/in/juliavezzulla",
    "company": "JV Talent Hunting",
    "position": "Tech Recruiter - Talent Acquisition - HR Consultant",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julia",
    "lastName": "Voinova",
    "url": "https://www.linkedin.com/in/jvoynova",
    "company": "Dev.Pro",
    "position": "Global Technical Recruiter | Dev-Pro Talent & Dev.Pro",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julian",
    "lastName": "Cortina",
    "url": "https://www.linkedin.com/in/julian-cortina",
    "company": "Accenture",
    "position": "Sr Technical Talent Acquisition (Client: BBVA)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juliana",
    "lastName": "Boufflet",
    "url": "https://www.linkedin.com/in/juliana-boufflet",
    "company": "Tomás Hnos.",
    "position": "Responsable de Selección & Onboarding",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Juliana",
    "lastName": "Martínez C.",
    "url": "https://www.linkedin.com/in/juliana-mart%C3%ADnez-c-b8938324",
    "company": "Primary",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Juliana",
    "lastName": "Mirabelli",
    "url": "https://www.linkedin.com/in/julianamirabelli",
    "company": "Nybble Group",
    "position": "Talent Acquisition Operations Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Juliana",
    "lastName": "Padilla",
    "url": "https://www.linkedin.com/in/juliana-padilla-a4b756225",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Juliana",
    "lastName": "Pereira Nejm",
    "url": "https://www.linkedin.com/in/juliananejm",
    "company": "Minsait",
    "position": "Senior IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Juliana",
    "lastName": "Ruiz",
    "url": "https://www.linkedin.com/in/juliana-ruiz-a08ab6214",
    "company": "Accenture Argentina",
    "position": "Recruiting Senior Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Juliana",
    "lastName": "Verissimo",
    "url": "https://www.linkedin.com/in/julianaverissimosobrinho",
    "company": "Mavila Consulting",
    "position": "Tech recruitment",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Adobato",
    "url": "https://www.linkedin.com/in/itrecruiter-julieta-adobato",
    "company": "Coolhuntech",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Allerotti",
    "url": "https://www.linkedin.com/in/julietallerotti",
    "company": "BBVA en Argentina",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Alonso",
    "url": "https://www.linkedin.com/in/julialonso",
    "company": "itti",
    "position": "Regional Talent Acquisition Specialist & People Partner",
    "keywords": [
      "hrbp/business partner",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Baril",
    "url": "https://www.linkedin.com/in/julieta-baril-4272987",
    "company": "Generación Talento HR",
    "position": "Talent Acquisition Manager - Directora en Generación Talento HR",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Bulacio",
    "url": "https://www.linkedin.com/in/julieta-bulacio-9b919473",
    "company": "Profesional independiente",
    "position": "Recruiter | IT Reruiter | Talent Acquisition Specialist",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Capecce",
    "url": "https://www.linkedin.com/in/julietacapecce",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Carreras",
    "url": "https://www.linkedin.com/in/julieta-carreras",
    "company": "Mercado Libre",
    "position": "Talent Acquisition Manager - IT",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Correa",
    "url": "https://www.linkedin.com/in/ma-julieta-correa-barrera",
    "company": "Profesional Independiente",
    "position": "Tech Recruiter / Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Costa",
    "url": "https://www.linkedin.com/in/julieta-costa-366574127",
    "company": "Staffy",
    "position": "Sr Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Dato",
    "url": "https://www.linkedin.com/in/julieta-dato",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst - Client: Mercado Libre",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "De Grazia",
    "url": "https://www.linkedin.com/in/julietadegrazia",
    "company": "Personal",
    "position": "Líder de Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Franco",
    "url": "https://www.linkedin.com/in/julieta-franco",
    "company": "Veralto",
    "position": "Talent Acquisition Business Partner",
    "keywords": [
      "hrbp/business partner",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Iannelli",
    "url": "https://www.linkedin.com/in/julieta-iannelli-a84476241",
    "company": "Kaver",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "King",
    "url": "https://www.linkedin.com/in/julietaannieking",
    "company": "SMS Sudamérica",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Lourino",
    "url": "https://www.linkedin.com/in/julieta-lourino",
    "company": "Thiga España",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/julieta-l%C3%B3pez-82624b42",
    "company": "DataArt",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Maria",
    "url": "https://www.linkedin.com/in/julieta-maria-141a16213",
    "company": "MPA Consultora",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Martinez",
    "url": "https://www.linkedin.com/in/julieta-martinez-976829206",
    "company": "Allata",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Raineri",
    "url": "https://www.linkedin.com/in/julieta-raineri",
    "company": "Greencode Software",
    "position": "People and Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Rinaldelli",
    "url": "https://www.linkedin.com/in/julieta-rinaldelli",
    "company": "Fanatics",
    "position": "Talent Acquisition Partner (contract through People Path)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Rocchietti",
    "url": "https://www.linkedin.com/in/julietarocchietti",
    "company": "Grupo Abans",
    "position": "Directora de Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Schroder Ferrando",
    "url": "https://www.linkedin.com/in/julietaschroderferrando",
    "company": "ENG",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Turano",
    "url": "https://www.linkedin.com/in/julieta-turano-332587133",
    "company": "EY",
    "position": "Talent Discovery Recruiter Sr Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Valenzuela",
    "url": "https://www.linkedin.com/in/julietavalenzuelahr",
    "company": "Zafirus Technologies",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Julieta",
    "lastName": "Williams",
    "url": "https://www.linkedin.com/in/julietawilliams",
    "company": "DataArt",
    "position": "Talent Acquisition Manager | Global Recruitment Committee",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta Belén",
    "lastName": "Massari",
    "url": "https://www.linkedin.com/in/julietamassari",
    "company": "BRINTA",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Julieta Clara",
    "lastName": "Jasin",
    "url": "https://www.linkedin.com/in/julieta-clara-jasin-26b207296",
    "company": "LinkIT",
    "position": "Sr. Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julieta Mariel",
    "lastName": "Avogadro",
    "url": "https://www.linkedin.com/in/julieta-avogadro",
    "company": "Profesional independiente",
    "position": "HR Consultant & Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julieta R.",
    "lastName": "Kulha",
    "url": "https://www.linkedin.com/in/julieta-r-kulha",
    "company": "Neginet",
    "position": "Senior IT Talent Acquisition Specialist & People Care HR-BP",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Julio",
    "lastName": "Chavez",
    "url": "https://www.linkedin.com/in/julioch%C3%A1vezrodriguez",
    "company": "Dropbox",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julio Angel",
    "lastName": "Astocaza Zárate",
    "url": "https://www.linkedin.com/in/julioastocazaitrecruiter",
    "company": "Adecco",
    "position": "IT Recruiter Analyst",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Julio Cesar",
    "lastName": "Parra Torres",
    "url": "https://www.linkedin.com/in/jc-parra",
    "company": "CodersLink Talent",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "July",
    "lastName": "Cano",
    "url": "https://www.linkedin.com/in/july-cano-a24898263",
    "company": "Profesional independiente",
    "position": "IT recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Justina",
    "lastName": "Gomory",
    "url": "https://www.linkedin.com/in/justinagomory",
    "company": "Self-employed",
    "position": "Senior HR & Talent Acquisition Consultant | People & Talent Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Justina",
    "lastName": "Seeber Padilla",
    "url": "https://www.linkedin.com/in/justina-seeber",
    "company": "Injective Labs",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "K S",
    "lastName": "Gowri",
    "url": "https://www.linkedin.com/in/k-s-gowri-bab785338",
    "company": "OX Consultancy",
    "position": "APAC IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Kaladewi",
    "lastName": "Balasubramanian",
    "url": "https://www.linkedin.com/in/kaladewi-balasubramanian-95616b186",
    "company": "Virtual Calibre - A Japan System Techniques Company",
    "position": "Senior Information Technology / SAP Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Kar Hoe",
    "lastName": "Lee",
    "url": "https://www.linkedin.com/in/karhoelee",
    "company": "Atomic Recruitment SEA",
    "position": "Sr. Recruitment Consultant - IT & Technology",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Karan",
    "lastName": "Paneria",
    "url": "https://www.linkedin.com/in/karan-paneria-64348978",
    "company": "New York Technology India Pvt. Ltd.",
    "position": "Information Technology Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Alzate",
    "url": "https://www.linkedin.com/in/karen-alzate-77b4b1146",
    "company": "Sanofi",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Ayala",
    "url": "https://www.linkedin.com/in/karen-ayala-018088254",
    "company": "Business Development Group, S.A.",
    "position": "Tech recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Bautista",
    "url": "https://www.linkedin.com/in/bautistakaren",
    "company": "ConfiaRH",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Bermúdez",
    "url": "https://www.linkedin.com/in/karemvbf",
    "company": "Rakkau",
    "position": "Human Resources Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Boubet",
    "url": "https://www.linkedin.com/in/karen-denise-boubet",
    "company": "Banco Galicia",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Cilli",
    "url": "https://www.linkedin.com/in/karencilli",
    "company": "Quales Group",
    "position": "People & Culture Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/karen-fernandez-65b82b40",
    "company": "Cloudgenia | Creating Smart Tech Solutions",
    "position": "RH | Recruiter IT | Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "González",
    "url": "https://www.linkedin.com/in/karen-gonz%C3%A1lez-041241b3",
    "company": "TurnKey Tech Staffing",
    "position": "Sr IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Hartmann Arnouts",
    "url": "https://www.linkedin.com/in/karenhaa",
    "company": "Apply Digital",
    "position": "Senior Talent Acquisition Specialist - Latin America",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Osorio",
    "url": "https://www.linkedin.com/in/osoriokaren",
    "company": "Mercado Libre",
    "position": "Specialist Lead- IT Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Palacios",
    "url": "https://www.linkedin.com/in/karen-palacios-36728080",
    "company": "Ford Motor Company",
    "position": "Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Rodríguez",
    "url": "https://www.linkedin.com/in/anarodriguez1604",
    "company": "Volaris",
    "position": "Corporate Recruiter Sr",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Roffe",
    "url": "https://www.linkedin.com/in/karen-roffe",
    "company": "GlobalLogic Latinoamérica",
    "position": "Ssr Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karen",
    "lastName": "Villamil Hernandez",
    "url": "https://www.linkedin.com/in/karen-villamil-hernandez",
    "company": "Bia Energy",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karen Lizbet",
    "lastName": "Flores Montoya",
    "url": "https://www.linkedin.com/in/karen-flores-montoya-",
    "company": "VEMO",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karin M.",
    "lastName": "Lauterbach",
    "url": "https://www.linkedin.com/in/holakarinlauterbachrrhh",
    "company": "ABERCAR SRL - Concesionario Oficial Randon",
    "position": "HRBP | Responsable de RR. HH.",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Karina",
    "lastName": "D´Alessandro",
    "url": "https://www.linkedin.com/in/karinadalessandro",
    "company": "Manpower",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Karina",
    "lastName": "Frossasco",
    "url": "https://www.linkedin.com/in/karina-frossasco",
    "company": "Consultora de Recursos Humanos KFRH",
    "position": "Founder & Talent Acquisition Consultant | KFRH",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karina",
    "lastName": "Garrido",
    "url": "https://www.linkedin.com/in/karina-garrido-3a90bb101",
    "company": "Improving",
    "position": "HR & recruitment lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Karina",
    "lastName": "Li",
    "url": "https://www.linkedin.com/in/karina-li-811407271",
    "company": "Solvd, Inc.",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karina Andrea",
    "lastName": "Berdini",
    "url": "https://www.linkedin.com/in/karinaberdini",
    "company": "Winch Consulting",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karina Estrella",
    "lastName": "Pérez G",
    "url": "https://www.linkedin.com/in/karina-estrella-p%C3%A9rez-g-49593a126",
    "company": "Software Mind",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Karla",
    "lastName": "Arias Salazar",
    "url": "https://www.linkedin.com/in/karla-arias-salazar-5bb84b70",
    "company": "3Pillar",
    "position": "Head of Talent Management LATAM",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Karla",
    "lastName": "Gutiérrez Moreno",
    "url": "https://www.linkedin.com/in/karlagm",
    "company": "TigerConnect",
    "position": "Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Karla",
    "lastName": "M.",
    "url": "https://www.linkedin.com/in/karla-mardueno",
    "company": "Proppel",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Karla",
    "lastName": "Navea",
    "url": "https://www.linkedin.com/in/karla-navea-a9b6471a3",
    "company": "Synapse",
    "position": "Talent Acquisition - Ssr Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karla",
    "lastName": "Riqueziz",
    "url": "https://www.linkedin.com/in/karlariqueziz",
    "company": "Paramo Technologies",
    "position": "Team Leader - Recruitment",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Karla",
    "lastName": "Salguero",
    "url": "https://www.linkedin.com/in/karla-salguero-7766a8204",
    "company": "Kibernum",
    "position": "Senior Talent Acquisition Consultant - (Remote - USA)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karolina",
    "lastName": "Akulenko",
    "url": "https://www.linkedin.com/in/karolina-akulenko-028795150",
    "company": "Vention",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Karoll",
    "lastName": "Gamarra",
    "url": "https://www.linkedin.com/in/karollgamarra",
    "company": "Black & Veatch",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Kartikay",
    "lastName": "Dwivedi",
    "url": "https://www.linkedin.com/in/kartikay-dwivedi-9a4189181",
    "company": "E-Solutions",
    "position": "Senior Technical Recruiter (Canada/Latam)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Karuna",
    "lastName": "Kasturi",
    "url": "https://www.linkedin.com/in/karuna-kasturi",
    "company": "TENTACLE SSO SDN BHD",
    "position": "IT Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Kateryna",
    "lastName": "Smetanska",
    "url": "https://www.linkedin.com/in/kate-smetanska",
    "company": "ARRISE",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Katherin",
    "lastName": "Orjuela Rodriguez",
    "url": "https://www.linkedin.com/in/katherin-orjuela-rodriguez-0b8513b5",
    "company": "Independiente (freelance)",
    "position": "Consultor de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Katherine",
    "lastName": "Beltrán Martínez",
    "url": "https://www.linkedin.com/in/kathebeltran",
    "company": "Novacomp",
    "position": "IT Talent Acquisition Sourcing Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Katherine",
    "lastName": "Henao Meneses",
    "url": "https://www.linkedin.com/in/katherinehenaom08",
    "company": "FPT Latin America",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Katheryn",
    "lastName": "Almentero Rodriguez",
    "url": "https://www.linkedin.com/in/katheryn-almentero-rodriguez-08861013b",
    "company": "Prisma Medios de Pago",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Katia",
    "lastName": "Medina",
    "url": "https://www.linkedin.com/in/katia-medina-7192ba1a2",
    "company": "Stefanini LATAM",
    "position": "IT Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Katia",
    "lastName": "Valadez",
    "url": "https://www.linkedin.com/in/klvza",
    "company": "X-Team",
    "position": "Talent Operations Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Katty",
    "lastName": "Camacho Vasquez",
    "url": "https://www.linkedin.com/in/katty-camacho-vasquez-5b8465112",
    "company": "Freelancer",
    "position": "It recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Katy",
    "lastName": "Rosales",
    "url": "https://www.linkedin.com/in/katy-rosales-",
    "company": "Freelance",
    "position": "Senior Talent Hunter/ Account Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Kausi",
    "lastName": "Harichandran",
    "url": "https://www.linkedin.com/in/kausi-harichandran-1491b4287",
    "company": "DHL IT Services",
    "position": "Recruiter - Graduate trainee",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Keila",
    "lastName": "Núñez",
    "url": "https://www.linkedin.com/in/keila-n%C3%BA%C3%B1ez-402638112",
    "company": "ITPS One",
    "position": "IT Recruiter / Headhunter",
    "keywords": [
      "headhunter",
      "recruiter"
    ]
  },
  {
    "firstName": "Keila Dayana",
    "lastName": "Ortiz",
    "url": "https://www.linkedin.com/in/keila-dayana-ortiz",
    "company": "WES",
    "position": "Specialist | IT Recruitment - Partners Sourcing",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Kelly",
    "lastName": "Reeves",
    "url": "https://www.linkedin.com/in/kelly-reeves-728b9615a",
    "company": "Search Atlas",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Kendo",
    "lastName": "Gil",
    "url": "https://www.linkedin.com/in/kendo-gil-314744209",
    "company": "The Contractor Consultants",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Kenneth",
    "lastName": "Rivas Calvo",
    "url": "https://www.linkedin.com/in/kenneth-rivas-calvo-07b59782",
    "company": "Roche",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Kevin",
    "lastName": "Ortmann",
    "url": "https://www.linkedin.com/in/kevinortmann",
    "company": "First Line Software",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Khushi",
    "lastName": "Sharma",
    "url": "https://www.linkedin.com/in/khushisharma1532",
    "company": "CodeVyasa",
    "position": "Technical HR Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Khushwinder Kaur",
    "lastName": "Chawla",
    "url": "https://www.linkedin.com/in/khushwinder-kaur-chawla-b98b40198",
    "company": "Entellux",
    "position": "IT Recruiter/Talent Aquisition",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Kiara",
    "lastName": "Rondon Ulloa",
    "url": "https://www.linkedin.com/in/kiara-rondon-ulloa-59a174154",
    "company": "Praxis",
    "position": "Analista de Reclutamiento y Selección LATAM",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Kim Marian",
    "lastName": "Maluenga",
    "url": "https://www.linkedin.com/in/marian-maluenga",
    "company": "Lamansys",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Kimberly",
    "lastName": "Peña",
    "url": "https://www.linkedin.com/in/kimberly-pe%C3%B1a-257694202",
    "company": "Orange Tecnología",
    "position": "Technical Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Kimberly",
    "lastName": "Thomas ✨🔎",
    "url": "https://www.linkedin.com/in/kimberlythomasrojas",
    "company": "Axxon Consulting",
    "position": "Talent Acquisition Lead ➨ Argentina, Chile, Uruguay, Paraguay & España🌍🙌",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Kristina",
    "lastName": "Shuflat",
    "url": "https://www.linkedin.com/in/kristina-shuflat-077235217",
    "company": "Svitla Systems, Inc.",
    "position": "IT Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Krystell",
    "lastName": "Tonche",
    "url": "https://www.linkedin.com/in/krystell-tonche-13b112115",
    "company": "Atos",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Krystina",
    "lastName": "Kredel (Carter)",
    "url": "https://www.linkedin.com/in/krystina-kredel-carter-15b69b138",
    "company": "Petfolk",
    "position": "Talent Acquisition Manager, Operations",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ksenia",
    "lastName": "Babenko-Kesyan",
    "url": "https://www.linkedin.com/in/babenkoksenia-it",
    "company": "NDA",
    "position": "Team Lead / Senior recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lalita",
    "lastName": "Upadhyay",
    "url": "https://www.linkedin.com/in/lalita-upadhyay-442a89259",
    "company": "Talentoj",
    "position": "Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lara",
    "lastName": "Bierwerth",
    "url": "https://www.linkedin.com/in/lara-bierwerth",
    "company": "Fudo",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lara",
    "lastName": "De Bernardez",
    "url": "https://www.linkedin.com/in/lara-de-bernardez",
    "company": "Prediktive",
    "position": "Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lara",
    "lastName": "Desse",
    "url": "https://www.linkedin.com/in/larahdesse",
    "company": "Globant",
    "position": "Recruiting Analyst South America",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Lara",
    "lastName": "Sottomano",
    "url": "https://www.linkedin.com/in/larasottomano",
    "company": "Glofy",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lara",
    "lastName": "Vernik",
    "url": "https://www.linkedin.com/in/lara-vernik",
    "company": "Nortal",
    "position": "Senior IT Recruiter 360",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Larissa Regina",
    "lastName": "de Oliveira",
    "url": "https://www.linkedin.com/in/larissareginadeoliveira",
    "company": "Wizdaa",
    "position": "Recruitment Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Larisse",
    "lastName": "Olmedo",
    "url": "https://www.linkedin.com/in/larisse-olmedo",
    "company": "Xepelin",
    "position": "Senior Tech Recruiter & People Business Partner",
    "keywords": [
      "recruiter",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Arango Londoño",
    "url": "https://www.linkedin.com/in/lauraarangol",
    "company": "Blankfactor",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Aristizábal",
    "url": "https://www.linkedin.com/in/laura-aristizabal",
    "company": "Gorilla Logic",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Balboa",
    "url": "https://www.linkedin.com/in/recruiterittecsolgroup",
    "company": "Tecsol Group S.A.",
    "position": "IT Recruiter | Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Barreira",
    "url": "https://www.linkedin.com/in/laurajbarreira85",
    "company": "Urbetrack",
    "position": "Head of Talent",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Benitez",
    "url": "https://www.linkedin.com/in/laura-benitez-magne",
    "company": "IT4W",
    "position": "Talent & Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Biederman",
    "url": "https://www.linkedin.com/in/laura-biederman-44861b46",
    "company": "Concentrix",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Camacho",
    "url": "https://www.linkedin.com/in/lauracamachol",
    "company": "Lean Solutions Group",
    "position": "HR Transformation Tech Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Costero",
    "url": "https://www.linkedin.com/in/lauracostero",
    "company": "BEON.tech",
    "position": "Talent Acquisition Supervisor",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Curia",
    "url": "https://www.linkedin.com/in/laura-curia-61a4a4b4",
    "company": "Cielo Talent",
    "position": "Senior Recruiter Trilingual",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Gutiérrez Franco",
    "url": "https://www.linkedin.com/in/laura-gutierrez-franco",
    "company": "Profesional Independiente",
    "position": "Freelance Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "López Añez",
    "url": "https://www.linkedin.com/in/lauralopezanez",
    "company": "Palladium Hotel Group",
    "position": "Corporate Talent Acquisition & Recruitment Sr. Manager",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Moreira",
    "url": "https://www.linkedin.com/in/laura-moreira-01a3ab211",
    "company": "CodigoDelSur",
    "position": "HR-recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Navarrete Sánchez",
    "url": "https://www.linkedin.com/in/laura-navarrete-s%C3%A1nchez-10890a246",
    "company": "Amaris Consulting",
    "position": "Consulting Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Pulgarin Valencia",
    "url": "https://www.linkedin.com/in/laura-pulgarin-valencia-14712a15a",
    "company": "Better Way Dev",
    "position": "Tech Candidate & Recruit Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Quiroga",
    "url": "https://www.linkedin.com/in/laura-g-quiroga",
    "company": "VMA Growing Partners",
    "position": "Head of Recruiting",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Ramirez Rujinsky",
    "url": "https://www.linkedin.com/in/laurarujnsky",
    "company": "BITLOGIC.io",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Ramos",
    "url": "https://www.linkedin.com/in/laura-ramos-794198239",
    "company": "Oktana Corporation",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Regidor",
    "url": "https://www.linkedin.com/in/laura-it-recruiting",
    "company": "AgileEngine",
    "position": "IT Recruiting Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Rey Lago",
    "url": "https://www.linkedin.com/in/laura-rey-lago-136840134",
    "company": "Cuatro Digital",
    "position": "Talent Manager & Senior Tech Recruiter",
    "keywords": [
      "recruiter",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/laurajsanchez",
    "company": "Chasm Partners",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Schmitman",
    "url": "https://www.linkedin.com/in/laura-schmitman",
    "company": "Bondy",
    "position": "Technical Recruiter",
    "keywords": [
      "hiring",
      "recruiter"
    ]
  },
  {
    "firstName": "Laura",
    "lastName": "Taricco",
    "url": "https://www.linkedin.com/in/laura-taricco",
    "company": "Distillery",
    "position": "Talent Acquisition Lead – LATAM",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Laura Catalina",
    "lastName": "Medina",
    "url": "https://www.linkedin.com/in/laura-catalina-medina-032825208",
    "company": "GFT Technologies",
    "position": "Senior Talent Acquisition Specialist International Delivery Unit",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Laura Fernanda",
    "lastName": "Ramos Ramirez",
    "url": "https://www.linkedin.com/in/lauraramosramirez",
    "company": "Oktana",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Laura Renata",
    "lastName": "Naibaho",
    "url": "https://www.linkedin.com/in/laurarenatasn",
    "company": "Syngenta",
    "position": "Talent Acquisition Partner Indonesia & Malaysia",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lauryn",
    "lastName": "Kingma",
    "url": "https://www.linkedin.com/in/lauryn-kingma-038949b8",
    "company": "StevenDouglas",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lautaro",
    "lastName": "Melendez",
    "url": "https://www.linkedin.com/in/lautaro-melendez",
    "company": "Acciona IT",
    "position": "Technical Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lautaro",
    "lastName": "V Martinez",
    "url": "https://www.linkedin.com/in/lautarovm1",
    "company": "Baufest",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Layla",
    "lastName": "Azlan",
    "url": "https://www.linkedin.com/in/layla-azlan",
    "company": "DHL IT Services",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Laís",
    "lastName": "Pinheiro",
    "url": "https://www.linkedin.com/in/la%C3%ADs-nataly",
    "company": "GoFasti",
    "position": "Mid-level Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Leady",
    "lastName": "Llamoctanta Berrios",
    "url": "https://www.linkedin.com/in/leadyllamoctanta",
    "company": "Corporativo Overall",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Leandra",
    "lastName": "Valencia",
    "url": "https://www.linkedin.com/in/leandravalencia",
    "company": "Heinsohn",
    "position": "Senior Talent Acquisition Specialist & Team Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Leandro",
    "lastName": "Martin",
    "url": "https://www.linkedin.com/in/lmilione",
    "company": "Software Mind",
    "position": "People Care & Recruitment",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Leandro Eduardo",
    "lastName": "Camaño",
    "url": "https://www.linkedin.com/in/leandro-eduardo-cama%C3%B1o-19235610",
    "company": "KNEZEVIC & ASOCIADOS",
    "position": "IT Recruiter in Knezevic & Asociados",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Leandro Milione 🙂",
    "lastName": "IT Recruiting and People Care",
    "url": "https://www.linkedin.com/in/leandromilione",
    "company": "Profesional independiente",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Leda",
    "lastName": "R",
    "url": "https://www.linkedin.com/in/ledota",
    "company": "ChainGPT",
    "position": "People & Talent Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Leidy Lorena",
    "lastName": "Correa González",
    "url": "https://www.linkedin.com/in/leidy-lorena-correa-gonz%C3%A1lez-540577184",
    "company": "Bluetab, an IBM Company",
    "position": "Culture & Happiness Leader / IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Leidymar",
    "lastName": "Vilchez",
    "url": "https://www.linkedin.com/in/leidymar",
    "company": "ADN - Recursos Humanos",
    "position": "IT Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Leila",
    "lastName": "Iglesias",
    "url": "https://www.linkedin.com/in/leilaiglesias",
    "company": "CFOTech",
    "position": "Recruiting Manager",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Lenizareth",
    "lastName": "Silva Flores (She/Her)",
    "url": "https://www.linkedin.com/in/lenizarethsilvarecruiter",
    "company": "2Brains",
    "position": "IT & Experience Talent Acquisition Partner Sr para LATAM Airlines",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Leonel",
    "lastName": "Bustamante",
    "url": "https://www.linkedin.com/in/leonel-bustamante7",
    "company": "Adecco",
    "position": "Master Talent Acquisition Consultant - BCP & Credicorp",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Leonel",
    "lastName": "Cafaro",
    "url": "https://www.linkedin.com/in/leonel-cafaro",
    "company": "Concentrix",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Leslie",
    "lastName": "Hernandez Rodriguez",
    "url": "https://www.linkedin.com/in/leslie-csr-baq",
    "company": "UnifyCX",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Leslie",
    "lastName": "Lambrecht",
    "url": "https://www.linkedin.com/in/leslie-lambrecht-264505129",
    "company": "Despegar",
    "position": "Sr Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lessly",
    "lastName": "Valdivia",
    "url": "https://www.linkedin.com/in/lessly-valdivia",
    "company": "Capgemini",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Leticia",
    "lastName": "Caroline",
    "url": "https://www.linkedin.com/in/leticia-caroline",
    "company": "ICON Solutions do Brasil",
    "position": "Tech Recruiter Sênior",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Leticia",
    "lastName": "Herschlik",
    "url": "https://www.linkedin.com/in/leticia-herschlik",
    "company": "Blue Alba",
    "position": "Human Resources Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Leticia",
    "lastName": "Mastroberti",
    "url": "https://www.linkedin.com/in/leticiamastroberti",
    "company": "The Flock",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lia Victoria",
    "lastName": "De Piero",
    "url": "https://www.linkedin.com/in/lia-victoria-de-piero-28b1351a5",
    "company": "Top-Call",
    "position": "Team Lead Recruiter - International Recruitment Team",
    "keywords": [
      "recruiter",
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lic. Abigail",
    "lastName": "Grimberg",
    "url": "https://www.linkedin.com/in/lic-abigail-grimberg-389161151",
    "company": "Stefanini LATAM",
    "position": "Talent Acquisition | 🇦🇷 - 🇨🇴 - 🇨🇱 - 🇵🇪 - 🇪🇸",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lic. Cecilia",
    "lastName": "Lindner",
    "url": "https://www.linkedin.com/in/celindner",
    "company": "deRecruiters",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lic. Eliana",
    "lastName": "Sanabria",
    "url": "https://www.linkedin.com/in/lisanabria",
    "company": "BVS",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lic. Florencia",
    "lastName": "Arancibia Poblete",
    "url": "https://www.linkedin.com/in/fparanpob97",
    "company": "Process Technologies",
    "position": "Analista de selección y cultura",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Lic. Karina",
    "lastName": "Frossasco",
    "url": "https://www.linkedin.com/in/consultorakfrh",
    "company": "Consultora de Recursos Humanos KFRH",
    "position": "Founder & Talent Acquisition Consultant | KFRH",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lic. Lorena",
    "lastName": "Dos Santos Moraes ✨",
    "url": "https://www.linkedin.com/in/lorenabdossantosmoraes",
    "company": "aliantec",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lic. Mariana",
    "lastName": "Echeverría",
    "url": "https://www.linkedin.com/in/marianaecheverria",
    "company": "Faraday",
    "position": "People & Culture Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lic. Mariana",
    "lastName": "Minotti",
    "url": "https://www.linkedin.com/in/lic-mariana-minotti-54a92a192",
    "company": "Mkt. Business Consulting Group",
    "position": "Recruiter IT Manager Sr. | HRBP - IT & Generalist | LATAM + EUROPA + USA",
    "keywords": [
      "recruiter",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Lic. Tatiana",
    "lastName": "Turco",
    "url": "https://www.linkedin.com/in/lic-tatiana-turco-631161a8",
    "company": "StaffRock IT",
    "position": "Lead Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lic.Daniela",
    "lastName": "Grillo",
    "url": "https://www.linkedin.com/in/danielagrillo",
    "company": "Werben HR LLC",
    "position": "Tech Recruiting Manager (Arg- Miami, USA)",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Lighuen",
    "lastName": "Vazquez Munarriz",
    "url": "https://www.linkedin.com/in/lighuenvm",
    "company": "Bunge",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Liliana",
    "lastName": "Barritta",
    "url": "https://www.linkedin.com/in/liliana-barritta",
    "company": "NTT DATA Europe & LATAM",
    "position": "Head of Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Liliana",
    "lastName": "Franceschini",
    "url": "https://www.linkedin.com/in/liliana-franceschini-8438b941",
    "company": "COTY ARGENTINA S.A",
    "position": "HR Manager Argentina",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Liliana",
    "lastName": "Ramos",
    "url": "https://www.linkedin.com/in/liliana-ramos-7b7133230",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lillian",
    "lastName": "Glickman",
    "url": "https://www.linkedin.com/in/lillian-glickman-9693461b",
    "company": "Lyra Health",
    "position": "Provider Network Development Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lilén",
    "lastName": "D. Di Leo",
    "url": "https://www.linkedin.com/in/lilen-d-dileo",
    "company": "Shifta",
    "position": "Technical Recruiter Ssr",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lina Fernanda",
    "lastName": "Albis Galindo",
    "url": "https://www.linkedin.com/in/lina-fernanda-albis-galindo-b5a585215",
    "company": "Softtek",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Linda",
    "lastName": "Haynes",
    "url": "https://www.linkedin.com/in/linda-haynes-a97846184",
    "company": "Concept Software & Services Inc",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Linda",
    "lastName": "Mejia",
    "url": "https://www.linkedin.com/in/linda-mejia-48545221a",
    "company": "Acklen Avenue",
    "position": "Sr. Talent Acquisition Specialist | Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lisa",
    "lastName": "Osman",
    "url": "https://www.linkedin.com/in/lisa-osman-1944b4b6",
    "company": "ManpowerGroup",
    "position": "Senior Information Technology Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Lisette",
    "lastName": "Dassie",
    "url": "https://www.linkedin.com/in/lisdassie",
    "company": "Matchly Your Talent Partner",
    "position": "HR Consultant & IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lissette",
    "lastName": "Cárdenas G.",
    "url": "https://www.linkedin.com/in/lissette-cardenas",
    "company": "Nuaav",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lisz",
    "lastName": "Moya",
    "url": "https://www.linkedin.com/in/lisz-moya-47126b172",
    "company": "Freelance",
    "position": "Talent Acquisition | IT Recruiter | HR",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Liza",
    "lastName": "Garzino",
    "url": "https://www.linkedin.com/in/lizagarzino",
    "company": "intive",
    "position": "Senior Recruiting Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Lizaveta",
    "lastName": "Karaliuk",
    "url": "https://www.linkedin.com/in/kkelizaveta",
    "company": "Symfa",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lizeth Tatiana",
    "lastName": "Fonseca R.",
    "url": "https://www.linkedin.com/in/lizethfonseca",
    "company": "WPP Media",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lola",
    "lastName": "de Monasterio",
    "url": "https://www.linkedin.com/in/loladm",
    "company": "Lodgify",
    "position": "Senior Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lore",
    "lastName": "Silvera",
    "url": "https://www.linkedin.com/in/lore-silvera",
    "company": "Here We Go - Talent Consultants",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lorena",
    "lastName": "Benitez",
    "url": "https://www.linkedin.com/in/lorena-benitez-128a3345",
    "company": "Source",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lorena",
    "lastName": "Delfante",
    "url": "https://www.linkedin.com/in/lorena-delfante-aa85ab20",
    "company": "Globant",
    "position": "Director of Recruiting",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lorena",
    "lastName": "Marín Agudelo",
    "url": "https://www.linkedin.com/in/lorena-mar%C3%ADn-agudelo-43b880140",
    "company": "TEAM International",
    "position": "Strategic Talent Management LATAM Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lorena",
    "lastName": "Millet",
    "url": "https://www.linkedin.com/in/lorenamillet",
    "company": "SMS Sudamérica",
    "position": "HR Business Partner Manager",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lorena",
    "lastName": "Mrcaich Pejovich",
    "url": "https://www.linkedin.com/in/lorenamrcaich",
    "company": "De Supernova",
    "position": "Technical Recruiter / Atracción de Talento",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lorena",
    "lastName": "Sanucci",
    "url": "https://www.linkedin.com/in/lorena-sanucci-18044a47",
    "company": "Accuratio",
    "position": "Talent Acquisition & Sr.Sales✅🚀",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lorena",
    "lastName": "Souto",
    "url": "https://www.linkedin.com/in/lorena-souto-b17527226",
    "company": "ZirconTech",
    "position": "Recruiter IT/Talent Acquisition Specialist/ Human Resources",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Loshshinee",
    "lastName": "Raj",
    "url": "https://www.linkedin.com/in/loshshinee-raj-316a19295",
    "company": "INSCALE",
    "position": "Junior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lourdes",
    "lastName": "Bringas Fernández",
    "url": "https://www.linkedin.com/in/lourdes-bringas-fern%C3%A1ndez-3313a8127",
    "company": "Apuesta Total",
    "position": "Analista de selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Lourdes",
    "lastName": "Moreno",
    "url": "https://www.linkedin.com/in/lourdes-moreno",
    "company": "Arkano Software",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "LTP Asociados",
    "lastName": "BeeWorks",
    "url": "https://www.linkedin.com/in/ltp-asociados-beeworks-465b4457",
    "company": "BeeWorks Remote IT Teams",
    "position": "Consultoría de IT, Recruiting y la Staffing de Talentos para procesos de negocios",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Luana",
    "lastName": "Coutinho",
    "url": "https://www.linkedin.com/in/luana-coutinho-recruiter",
    "company": "Valtech",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luana",
    "lastName": "Mavila",
    "url": "https://www.linkedin.com/in/luanamavila",
    "company": "Mavila Consulting",
    "position": "Global Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Luca",
    "lastName": "Butti",
    "url": "https://www.linkedin.com/in/luca-butti-8977a0207",
    "company": "HR Oasis Consultora RRHH",
    "position": "Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Lucas",
    "lastName": "Barrau (he/him)",
    "url": "https://www.linkedin.com/in/lucasbarrau",
    "company": "Hapi",
    "position": "People Manager LatAm",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lucas",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/lucas-sanchez-63a16524b",
    "company": "High Level IT Recruitment",
    "position": "IT Recruiter │ Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucas",
    "lastName": "Scagliusi",
    "url": "https://www.linkedin.com/in/britolucas",
    "company": "ARRISE",
    "position": "Senior Manager Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lucas",
    "lastName": "Silva Aspitia",
    "url": "https://www.linkedin.com/in/lucas-silva-aspitia",
    "company": "Valid",
    "position": "Sr Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucas Nicolás",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/lucas-nicol%C3%A1s-rodriguez-0013b2119",
    "company": "Fusap",
    "position": "HR Generalist & IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucero",
    "lastName": "Carruitero",
    "url": "https://www.linkedin.com/in/recruiter-empleabilidad",
    "company": "TechStart Perú",
    "position": "Coordinadora de selección & marketing",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Bressano",
    "url": "https://www.linkedin.com/in/lucia-bressano-45b46750",
    "company": "ConecSI RH",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Chantada",
    "url": "https://www.linkedin.com/in/lucia-chantada-94a135189",
    "company": "Nimble Gravity",
    "position": "Senior Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Danser",
    "url": "https://www.linkedin.com/in/lucia-danser",
    "company": "Nimble Giant Entertainment",
    "position": "Talent Acquisition / People Partner",
    "keywords": [
      "hrbp/business partner",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Daverede",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-lucia-daverede",
    "company": "Accenture Argentina",
    "position": "Recruiting Associate Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Evangelista",
    "url": "https://www.linkedin.com/in/lucia-evangelista-7b5012a6",
    "company": "MIG Consultores Srl.",
    "position": "IT Recruiter / RRHH / Selectora IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/lucia-gonzalez-1317ba154",
    "company": "Acsys",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Lozano",
    "url": "https://www.linkedin.com/in/lucia-lozano-recruiter",
    "company": "EY",
    "position": "Supervising Associate Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Ongaro",
    "url": "https://www.linkedin.com/in/luciabongaror",
    "company": "ZEROGATE",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Suasquita",
    "url": "https://www.linkedin.com/in/lucia-suasquita-06b34493",
    "company": "Santex",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucia",
    "lastName": "Zenobi",
    "url": "https://www.linkedin.com/in/lucia-zenobi",
    "company": "AR Consultores",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucia Belén",
    "lastName": "Longo",
    "url": "https://www.linkedin.com/in/luciabelenlongo",
    "company": "FK TECH Solutions Factory",
    "position": "Talent Acquisition Ssr",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucia Candelaria",
    "lastName": "Barrera Nicholson",
    "url": "https://www.linkedin.com/in/luciabn",
    "company": "Cona Consultores",
    "position": "HRBP - HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Lucia Eleonora",
    "lastName": "Pantano",
    "url": "https://www.linkedin.com/in/luciaeleonorapantano",
    "company": "Walgreens",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucia Micaela",
    "lastName": "Bonomo",
    "url": "https://www.linkedin.com/in/lucia-micaela-bonomo-8a3018170",
    "company": "MDW",
    "position": "HR & IT Talent Acquisition | Spain & Switzerland",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Caminos",
    "url": "https://www.linkedin.com/in/luciana-caminos",
    "company": "MODO",
    "position": "Talent Acquisition Sr Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Clerici",
    "url": "https://www.linkedin.com/in/luciana-clerici-05401268",
    "company": "HUENEI IT SERVICES",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Gallera",
    "url": "https://www.linkedin.com/in/lucianagallera",
    "company": "Wirall",
    "position": "Head of Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Glikman",
    "url": "https://www.linkedin.com/in/luciana-glikman-678a8455",
    "company": "Talent on Demand",
    "position": "Co Founder/ People and Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/luciana-gonzalez-ba5650130",
    "company": "Profesional independiente",
    "position": "Consultoría en Selección - Especialista IT & Retail",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Grinner",
    "url": "https://www.linkedin.com/in/luciana-grinner-22233211",
    "company": "Fabricaciones Militares Sociedad del Estado",
    "position": "Selección, Capacitación y Desarrollo de RRHH",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Magnone",
    "url": "https://www.linkedin.com/in/luciana-magnone",
    "company": "Capgemini Engineering",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Prat",
    "url": "https://www.linkedin.com/in/lucianaprat",
    "company": "Humanitas IT",
    "position": "IT Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Rodriguez Cuevas",
    "url": "https://www.linkedin.com/in/luciana-rodriguez-cuevas",
    "company": "Syneos Health Commercial Solutions",
    "position": "Recruiting Researcher",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Secondo",
    "url": "https://www.linkedin.com/in/lucianasecondo",
    "company": "TrustScale",
    "position": "Talent Acquisition Specialist (AI and Localization)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Silva",
    "url": "https://www.linkedin.com/in/luciana-silva-499629164",
    "company": "EY",
    "position": "Talent Attraction Recruiter | EY US Talent Attraction and Acquisition (TA2)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Trujillo",
    "url": "https://www.linkedin.com/in/luciana-trujillo-a6015325",
    "company": "LaTeam Partners",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Luciana",
    "lastName": "Venditti",
    "url": "https://www.linkedin.com/in/lucianavenditti",
    "company": "Accenture",
    "position": "Field HR SR Analyst (People Lead)",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Luciana Cecilia",
    "lastName": "Ferrara",
    "url": "https://www.linkedin.com/in/luciana-cecilia-ferrara-7aa27153",
    "company": "Atos",
    "position": "IT Recruiter & Talent Acquisition SR",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luciano",
    "lastName": "Nicolino",
    "url": "https://www.linkedin.com/in/luciano-nicolino-42aa4518b",
    "company": "Accusys Technology",
    "position": "Analista de Búsqueda y Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Luciano",
    "lastName": "Palacios",
    "url": "https://www.linkedin.com/in/lucianopalaciosr4",
    "company": "Evoltis",
    "position": "Talent Acquisition IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luciano",
    "lastName": "Varisco",
    "url": "https://www.linkedin.com/in/lucianovarisco",
    "company": "StaffLatam",
    "position": "Head of Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Luciano Daniel",
    "lastName": "Lago",
    "url": "https://www.linkedin.com/in/luciano-lago",
    "company": "Vitaver and Associates, Inc. (dba Vitaver Staffing)",
    "position": "Information Technology Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Basso",
    "url": "https://www.linkedin.com/in/lucila-basso-2511a2124",
    "company": "HUENEI IT SERVICES",
    "position": "Talent Acquisition Head",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Carassai",
    "url": "https://www.linkedin.com/in/lucilacarassai",
    "company": "ZS",
    "position": "Human Resources Associate - Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Conterno",
    "url": "https://www.linkedin.com/in/lucilaconterno",
    "company": "Avenga",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Crucella Ricignuolo",
    "url": "https://www.linkedin.com/in/lucila-crucella-ricignuolo-768621163",
    "company": "Holafly",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Etcheverria (ella/ela/she)",
    "url": "https://www.linkedin.com/in/lucila-etcheverria-ella-ela-she-75b740b6",
    "company": "Softtek",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Lagares",
    "url": "https://www.linkedin.com/in/lucilalagares",
    "company": "Talan",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Lopez Nogueira",
    "url": "https://www.linkedin.com/in/lucila-lopez-nogueira-2b6278204",
    "company": "South Offices",
    "position": "People & Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Mondin",
    "url": "https://www.linkedin.com/in/lucilamondin",
    "company": "Howdy.com",
    "position": "People Experience Senior Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Souto",
    "url": "https://www.linkedin.com/in/lucilasouto",
    "company": "CONEXIONHR - Recruiting Company",
    "position": "Recruiter y administrativa",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Tarrico Villafañe",
    "url": "https://www.linkedin.com/in/lucila-tarrico-villafa%C3%B1e-29967435",
    "company": "Monks",
    "position": "Regional Talent Discovery Senior Director | AI advocate",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Urquiza",
    "url": "https://www.linkedin.com/in/lucila-urquiza-942b9713b",
    "company": "Bull Market",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lucila",
    "lastName": "Villordo",
    "url": "https://www.linkedin.com/in/lucila-villordo",
    "company": "Banco Galicia",
    "position": "Sr HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Lucy",
    "lastName": "Silva",
    "url": "https://www.linkedin.com/in/lucy-s-b29043212",
    "company": "Salt",
    "position": "Technology Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Arrosa Mailhos",
    "url": "https://www.linkedin.com/in/luc%C3%ADa-arrosa-mailhos-4497a1208",
    "company": "Howdy.com",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Bartolini Castro",
    "url": "https://www.linkedin.com/in/luc%C3%ADa-bartolini-castro-7a4a1412b",
    "company": "intive",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "De Feliche",
    "url": "https://www.linkedin.com/in/luc%C3%ADa-de-feliche-bb3142259",
    "company": "Cona Consultores",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Giusti",
    "url": "https://www.linkedin.com/in/luc%C3%ADa-giusti-109bb638",
    "company": "Rootstrap",
    "position": "VP of Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Gómez Massarini",
    "url": "https://www.linkedin.com/in/luciagomezmassarini",
    "company": "Boost",
    "position": "Head of Talent",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Ibáñez",
    "url": "https://www.linkedin.com/in/luciaiba%C3%B1ez",
    "company": "Qubika",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Moreno",
    "url": "https://www.linkedin.com/in/luciaamoreno",
    "company": "Crombie",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Presas",
    "url": "https://www.linkedin.com/in/luciapresas",
    "company": "G&L Group",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Sagardoy Arce",
    "url": "https://www.linkedin.com/in/sagardoylucia",
    "company": "Encora Inc.",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Solveyra",
    "url": "https://www.linkedin.com/in/luciasolveyra",
    "company": "PwC Argentina",
    "position": "Senior Associate | Talent Consultant - HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Lucía",
    "lastName": "Torena",
    "url": "https://www.linkedin.com/in/lucia-torena",
    "company": "EY",
    "position": "Recruiting Coordinator | Early Careers Talent Acquisition | Global Recruiting Operations",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lucía Mariel",
    "lastName": "Miranda",
    "url": "https://www.linkedin.com/in/luc%C3%ADa-mariel-miranda-389b6744",
    "company": "NTT DATA Europe & Latam",
    "position": "Talent Acquisition | IT Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ludmila",
    "lastName": "Leiva",
    "url": "https://www.linkedin.com/in/ludmila-leiva-5bb617102",
    "company": "Accenture Argentina",
    "position": "Recruiter Analyst Tech-Corporate Funtions Operations",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ludmila",
    "lastName": "Palacio",
    "url": "https://www.linkedin.com/in/ludmilapalacio",
    "company": "Profesional independiente",
    "position": "Especialista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Ludmila",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/ludmila-sanchez-b81a4b216",
    "company": "GEMINUS",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ludmila",
    "lastName": "Suarez",
    "url": "https://www.linkedin.com/in/ludmilasuarez",
    "company": "Accenture Argentina",
    "position": "Recruiting Senior Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Luis",
    "lastName": "Caceres",
    "url": "https://www.linkedin.com/in/luis-caceres-a4122a1b2",
    "company": "P'cofit",
    "position": "Community Manager & IT Talent Hunter",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Luis",
    "lastName": "Mandia",
    "url": "https://www.linkedin.com/in/lmandia",
    "company": "Gr4vy, Inc",
    "position": "Head of Talent Acquisition & HR",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Luis",
    "lastName": "Miranda Camacho",
    "url": "https://www.linkedin.com/in/luis-miranda-camacho-92750087",
    "company": "Banco de Crédito BCP",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luis",
    "lastName": "Montaño",
    "url": "https://www.linkedin.com/in/luis-alfonso-monta%C3%B1o-gonz%C3%A1lez",
    "company": "Novartis",
    "position": "Talent Acquisition Sr Business Partner IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luis",
    "lastName": "Ojeda",
    "url": "https://www.linkedin.com/in/luis-ojeda-51584033",
    "company": "Independent Consultant",
    "position": "Independent Strategic LATAM Hiring Partner",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Luisa",
    "lastName": "Parra Arroyo",
    "url": "https://www.linkedin.com/in/luisa-parra-arroyo-25598a238",
    "company": "Yumatech",
    "position": "Senior Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Luisa",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/luisafromeroa",
    "company": "Jobsity",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luisa Angélica",
    "lastName": "Cerda Magaña",
    "url": "https://www.linkedin.com/in/luisa-ang%C3%A9lica-cerda-maga%C3%B1a-937181142",
    "company": "Spot²",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Luisa Fernanda",
    "lastName": "Bonilla",
    "url": "https://www.linkedin.com/in/luisa-fernanda-bonilla-0b8983262",
    "company": "PersonalSoft",
    "position": "Junior Recruiter Analyst",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Luisana",
    "lastName": "Moncada",
    "url": "https://www.linkedin.com/in/luisana-moncada",
    "company": "AI Fund",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Luisina",
    "lastName": "Dalto",
    "url": "https://www.linkedin.com/in/luisinadalto",
    "company": "Streambe",
    "position": "Selección de personal / Capital Humano Ssr",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Luisina",
    "lastName": "Morena",
    "url": "https://www.linkedin.com/in/luisina-morena-88a758157",
    "company": "InAllMedia",
    "position": "Sourcer Talent Acquisition | Talent Hunter",
    "keywords": [
      "talent acquisition",
      "sourcer"
    ]
  },
  {
    "firstName": "Luisina",
    "lastName": "Perassi",
    "url": "https://www.linkedin.com/in/luisina-perassi",
    "company": "Braintly",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Luisina",
    "lastName": "Silio",
    "url": "https://www.linkedin.com/in/luisina-silio-",
    "company": "Staffy",
    "position": "Recruiter IT - Mentora",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luisina",
    "lastName": "Susbielles",
    "url": "https://www.linkedin.com/in/luisina-susbielles",
    "company": "Innovid",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Lujan",
    "lastName": "Gambina",
    "url": "https://www.linkedin.com/in/lujan-gambina",
    "company": "TELUS Digital",
    "position": "Talent Acquisition Manager - Argentina",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Luna",
    "lastName": "Casari",
    "url": "https://www.linkedin.com/in/luna-casari",
    "company": "WeMoter HR",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luz",
    "lastName": "Ayus",
    "url": "https://www.linkedin.com/in/luz-ayus-b84720124",
    "company": "peoplepath",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Luz",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/luzgarcia",
    "company": "NewCombin",
    "position": "Recruiting Lead",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Luz",
    "lastName": "Lopez",
    "url": "https://www.linkedin.com/in/luz-lopez-4b46921a5",
    "company": "Freelance, self-employed",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Luz",
    "lastName": "Ribas",
    "url": "https://www.linkedin.com/in/luz-ribas-",
    "company": "Flock IT",
    "position": "People Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Luz",
    "lastName": "Vistraín Cuenca",
    "url": "https://www.linkedin.com/in/luz-vistra%C3%ADn-cuenca-29454525",
    "company": "ScreenIT",
    "position": "IT Talent Acquisition & Sales Support Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Luzkeila",
    "lastName": "Ferrer",
    "url": "https://www.linkedin.com/in/luzkeila-ferrer-60046341",
    "company": "MAS Global Consulting",
    "position": "Director of Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "M. Julia",
    "lastName": "Martinez",
    "url": "https://www.linkedin.com/in/juliamartinez",
    "company": "Trick Studios",
    "position": "Senior Game Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "M. Milagros",
    "lastName": "Toledo Straberg",
    "url": "https://www.linkedin.com/in/m-milagros-toledo-straberg-8bb242133",
    "company": "GlobalLogic Latinoamérica",
    "position": "Specialist People Development - Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "M. Paula",
    "lastName": "Beaudroit",
    "url": "https://www.linkedin.com/in/mapaulabeaudroit",
    "company": "Practia Global",
    "position": "Sr. Talent Acquisition | Sr Recruiter IT | Sr Talent Attraction - Practia Global.",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "M. Sol",
    "lastName": "DL",
    "url": "https://www.linkedin.com/in/maria-s-de-luca",
    "company": "Proxify",
    "position": "Recruiter - GIG",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "M. Wilma",
    "lastName": "Lepre (she/her)",
    "url": "https://www.linkedin.com/in/wilmalepre",
    "company": "Marcus Thomas LLC",
    "position": "People team Manager Latam",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ma. Lourdes",
    "lastName": "San Martin",
    "url": "https://www.linkedin.com/in/m-lourdes-san-martin",
    "company": "AccelOne",
    "position": "Especialista Sr It Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mabel",
    "lastName": "Espeche",
    "url": "https://www.linkedin.com/in/mabel-espeche",
    "company": "Altimetrik",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mabel",
    "lastName": "Espeche",
    "url": "https://www.linkedin.com/in/mabespeche",
    "company": "Altimetrik",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Macarena",
    "lastName": "Bustos",
    "url": "https://www.linkedin.com/in/macarena-bustos-81a107132",
    "company": "Beilox",
    "position": "Recruiter IT & Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Macarena",
    "lastName": "Ferraro",
    "url": "https://www.linkedin.com/in/macarena-ferraro",
    "company": "Accenture Argentina",
    "position": "Recruiting Associate Manager - Technology",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Macarena",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/macarena-garc%C3%ADa-19880810",
    "company": "Boehringer Ingelheim",
    "position": "Talent Segment Lead- Group Functions LATAM",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Macarena",
    "lastName": "Hauschildt",
    "url": "https://www.linkedin.com/in/macarena-hauschildt",
    "company": "deRecruiters",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Macarena",
    "lastName": "Margaria",
    "url": "https://www.linkedin.com/in/macarena-margaria",
    "company": "Profesional independiente",
    "position": "IT Recruiter (Freelance) | Talent Acquisition for Tech Teams",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Macarena",
    "lastName": "Ramirez",
    "url": "https://www.linkedin.com/in/macarena-ramirez-94b52b193",
    "company": "ÜMA Salud IA",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Macarena",
    "lastName": "Rios Persegani",
    "url": "https://www.linkedin.com/in/riospersegani-rrhh",
    "company": "Essity",
    "position": "HR Specialist - HRBP Finance, Sales, Marketing, HR Services & Logistic",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Macarena",
    "lastName": "Torres",
    "url": "https://www.linkedin.com/in/macarena-torres-9a951936",
    "company": "scaleHUB",
    "position": "Lead IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Macarena Denise",
    "lastName": "Cristaldo",
    "url": "https://www.linkedin.com/in/macarenadenisecristaldo",
    "company": "Ensitech",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Macarena Lucia",
    "lastName": "Nieto",
    "url": "https://www.linkedin.com/in/macarena-lucia-nieto",
    "company": "Tecnosoftware",
    "position": "Talent Acquisition Recruiter Sr",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Macarena W.",
    "lastName": "Valdéz",
    "url": "https://www.linkedin.com/in/macarena-valdez",
    "company": "Here We Go - Talent Consultants",
    "position": "Technical Recruiting Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Magali",
    "lastName": "Acosta",
    "url": "https://www.linkedin.com/in/magalilauraacosta",
    "company": "Accenture Argentina",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Magali",
    "lastName": "Feintuch",
    "url": "https://www.linkedin.com/in/magali-feintuch-9b0951b",
    "company": "CloudX | Nearshore Software Development",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Magali",
    "lastName": "Recalde",
    "url": "https://www.linkedin.com/in/magali-recalde-rrhh2611",
    "company": "Werben HR LLC",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Magali",
    "lastName": "Rigo",
    "url": "https://www.linkedin.com/in/magali-rigo-9396981a4",
    "company": "Holcim Argentina",
    "position": "People Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Magali Belen",
    "lastName": "Gerbasi",
    "url": "https://www.linkedin.com/in/magali-belen-gerbasi-3a3a089b",
    "company": "MUTT DATA",
    "position": "Talent Acquisition Senior Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Magalí",
    "lastName": "Bussolo",
    "url": "https://www.linkedin.com/in/magal%C3%AD-a-bussolo-",
    "company": "Nación Servicios",
    "position": "Analista de Talento | Selección, Evaluaciones y HRBP.",
    "keywords": [
      "hrbp/business partner",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Magalí",
    "lastName": "Mendoza",
    "url": "https://www.linkedin.com/in/magal%C3%AD-m-56851429",
    "company": "OneInfo Consulting",
    "position": "IT Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Magalí",
    "lastName": "Sella Gigli",
    "url": "https://www.linkedin.com/in/magal%C3%AD-sella-gigli-11622252",
    "company": "Alo Cata @alocataok",
    "position": "HRBP generalista",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Magalí",
    "lastName": "Suter",
    "url": "https://www.linkedin.com/in/magal%C3%AD-suter",
    "company": "Lucciano´s",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Magdalena",
    "lastName": "Máspero Castro",
    "url": "https://www.linkedin.com/in/magdalena-m%C3%A1spero-castro-33a2841ba",
    "company": "Launchpad Technologies Inc.",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Magdalena",
    "lastName": "Pla",
    "url": "https://www.linkedin.com/in/magdalena-pla-b6398b12a",
    "company": "The AES Corporation",
    "position": "US Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Magui",
    "lastName": "Gaona",
    "url": "https://www.linkedin.com/in/magui-gaona",
    "company": "Abstra",
    "position": "Recruitment Lead / Tech-IT Recruiter / Sourcing & Selection",
    "keywords": [
      "recruiter",
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Magui",
    "lastName": "Navarro",
    "url": "https://www.linkedin.com/in/magui-navarro-251599b4",
    "company": "Mitrol",
    "position": "Human Talent Specialist - Responsable de Selección, Desarrollo Profesional y Clima Laboral",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Maia",
    "lastName": "Nimis",
    "url": "https://www.linkedin.com/in/maia-nimis",
    "company": "Talent Global LLC",
    "position": "Recruitment Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maia",
    "lastName": "Reyes Raichman",
    "url": "https://www.linkedin.com/in/lic-maia-reyes-raichman",
    "company": "Mismo",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maida",
    "lastName": "Garcia",
    "url": "https://www.linkedin.com/in/maida-garcia",
    "company": "dLocal",
    "position": "People Business Partner and Talent Acquisition Manager | IT & Product",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mailen",
    "lastName": "Allario",
    "url": "https://www.linkedin.com/in/mailenallario",
    "company": "MPA Consultora",
    "position": "Technical Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mailen",
    "lastName": "Juan",
    "url": "https://www.linkedin.com/in/mailen-juan-6437b7240",
    "company": "Innova Talent",
    "position": "Founder | Recruitment IT",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Maira",
    "lastName": "Cardozo",
    "url": "https://www.linkedin.com/in/maira-cardozo-1584441aa",
    "company": "CodigoDelSur",
    "position": "HR Business Partner - IT Recruiter",
    "keywords": [
      "recruiter",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Maira",
    "lastName": "Carmen",
    "url": "https://www.linkedin.com/in/maira-carmen",
    "company": "Aiotek",
    "position": "Talent Acquisition | People & Culture | Human Resources | IT Recruiter | Talent Development",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maira Lizeth",
    "lastName": "Alarcón Zamora",
    "url": "https://www.linkedin.com/in/maira-alarcon",
    "company": "MSD",
    "position": "Senior Talent Acquisition Specialist LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Malena",
    "lastName": "Bonnet",
    "url": "https://www.linkedin.com/in/malenabonnet",
    "company": "Syneos Health",
    "position": "Talent Acquisition Systems Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Malena",
    "lastName": "Machado",
    "url": "https://www.linkedin.com/in/malena-machado-8b7b495a",
    "company": "Flux IT",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Mamen",
    "lastName": "Martín Tena",
    "url": "https://www.linkedin.com/in/mamenmartintena",
    "company": "PageGroup",
    "position": "Tech Talent Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Man",
    "lastName": "Tuteja",
    "url": "https://www.linkedin.com/in/man-tuteja-378132211",
    "company": "Hi-Tech Talents",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Manon",
    "lastName": "Ferrari",
    "url": "https://www.linkedin.com/in/manon-ferrari-hr-recruteur",
    "company": "Indépendant",
    "position": "Head of Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Manuel",
    "lastName": "Arturo",
    "url": "https://www.linkedin.com/in/manu-arturo",
    "company": "Unilever",
    "position": "Talent Country Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Manuel",
    "lastName": "Coll",
    "url": "https://www.linkedin.com/in/manuel-coll-65aa02204",
    "company": "Freelance, self-employed",
    "position": "Recruiter IT Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Manuel",
    "lastName": "Coll Areco",
    "url": "https://www.linkedin.com/in/manuelcollareco",
    "company": "HR DIGITAL GROWTH",
    "position": "Co-Founder - IT Recruiter - Headhunter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Manuel",
    "lastName": "Rufener",
    "url": "https://www.linkedin.com/in/manuel-rufener",
    "company": "Freelance",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Manuel Jose",
    "lastName": "Arango Plazas",
    "url": "https://www.linkedin.com/in/manueljosearangop",
    "company": "Your Startup Operations",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Manuela",
    "lastName": "Cabanillas",
    "url": "https://www.linkedin.com/in/manuela-cabanillas-052ba5115",
    "company": "Mercado Libre",
    "position": "Talent Acquisition Sr Analyst.",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Manuela",
    "lastName": "Caetano",
    "url": "https://www.linkedin.com/in/manuela-caetano",
    "company": "Rad Hires",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Manuela",
    "lastName": "Cardona Guerra",
    "url": "https://www.linkedin.com/in/manuelacardonaguerra",
    "company": "SoftwareONE Colombia",
    "position": "Talent Sourcing Specialist",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Manuela",
    "lastName": "Gautos",
    "url": "https://www.linkedin.com/in/manuela-gautos-rrhh",
    "company": "Applica Mobile",
    "position": "Analista RRHH- Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Manuela",
    "lastName": "Génova",
    "url": "https://www.linkedin.com/in/manuela-g%C3%A9nova",
    "company": "Digital HR.",
    "position": "Head of Recruiting & Growth | Co-Founder",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Manuela",
    "lastName": "Gómez",
    "url": "https://www.linkedin.com/in/mariamanuelagomez13",
    "company": "PedidosYa",
    "position": "Regional Talent Acquisition Sr Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Manuela",
    "lastName": "Ordoqui",
    "url": "https://www.linkedin.com/in/manuela-ordoqui-b44015224",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Manuela",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/manuelasancz",
    "company": "NVB Innovation Business",
    "position": "Hiring IT Specialist at NVB Innovation Business",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Manuela",
    "lastName": "Vercellino",
    "url": "https://www.linkedin.com/in/manuela-vercellino-1b407712a",
    "company": "OpenGov Inc.",
    "position": "Lead Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mara",
    "lastName": "Palermo",
    "url": "https://www.linkedin.com/in/mara-palermo-7951a41b",
    "company": "SNP Group",
    "position": "Sr Recruiting Analyst l Talent Acquisition Specialist",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mara",
    "lastName": "Schmitman (She / Her)",
    "url": "https://www.linkedin.com/in/maraschmitman",
    "company": "Bondy",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mara",
    "lastName": "Álvarez Pérez",
    "url": "https://www.linkedin.com/in/mara-%C3%A1lvarez-p%C3%A9rez-b50787b5",
    "company": "DXC Technology",
    "position": "Talent acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Abbruzzese",
    "url": "https://www.linkedin.com/in/marcela-abbruzzese-101b218",
    "company": "Mercadolibre.com",
    "position": "Regional LATAM Senior Manager, Talent Acquisition – Executive Search (IT & Product)",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Alvarez",
    "url": "https://www.linkedin.com/in/marcela-alvarez-578b492b",
    "company": "Autónomo",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Bernardo",
    "url": "https://www.linkedin.com/in/marcela-bernardo-27863b62",
    "company": "Open English",
    "position": "Senior Talent Acquisition Latam",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Ferreri",
    "url": "https://www.linkedin.com/in/marcela-ferreri-060585b7",
    "company": "Equifax",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Galeano",
    "url": "https://www.linkedin.com/in/marcela-galeano",
    "company": "Becas IT",
    "position": "Team Lead Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Infante",
    "url": "https://www.linkedin.com/in/marcela-infante-5b085a121",
    "company": "Voolkia Software & Services",
    "position": "Talent Acquisition / Recruiting Team Supervisor",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Mengual Falcon",
    "url": "https://www.linkedin.com/in/marmengual",
    "company": "Robinhood",
    "position": "Recruiter Coordinator Early Talent Engineering — Peoplepath.io",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Miño",
    "url": "https://www.linkedin.com/in/marcela-mi%C3%B1o-a512171a7",
    "company": "Profesional independiente",
    "position": "Recruiter y Talent Acquisitión IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Montero",
    "url": "https://www.linkedin.com/in/marcela-montero",
    "company": "Cognizant",
    "position": "HR Ops - Process Engineer and Analytics Senior Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Pineda",
    "url": "https://www.linkedin.com/in/marcela-pineda-3b1320221",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Rey",
    "url": "https://www.linkedin.com/in/marcela-rey-42b00b22a",
    "company": "Independiente",
    "position": "IT Headhunter & Recruiter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Marcela",
    "lastName": "Vázquez",
    "url": "https://www.linkedin.com/in/marcela-v%C3%A1zquez-611391218",
    "company": "Startups",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marcelo",
    "lastName": "Ortega",
    "url": "https://www.linkedin.com/in/marceloemilianoortega",
    "company": "Perficient",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marcelo",
    "lastName": "Servetto",
    "url": "https://www.linkedin.com/in/marcelo-servetto-61557010",
    "company": "INHAUS",
    "position": "IT Recruiting Manager LATAM & Europe",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marcia",
    "lastName": "Antuña",
    "url": "https://www.linkedin.com/in/marcia-antu%C3%B1a-b475b4225",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marco",
    "lastName": "Bolivar",
    "url": "https://www.linkedin.com/in/marco-bolivar-quesada",
    "company": "Halo Media",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marcos",
    "lastName": "Buiatti",
    "url": "https://www.linkedin.com/in/marcosbuiatti",
    "company": "RightWorks",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marcos",
    "lastName": "Goytia",
    "url": "https://www.linkedin.com/in/marcos-goytia-7a27a3150",
    "company": "Vitaver and Associates, Inc. (dba Vitaver Staffing)",
    "position": "Técnico de selección de personal técnico",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Marcos",
    "lastName": "Quintero",
    "url": "https://www.linkedin.com/in/marcos-quintero-60b772229",
    "company": "Folks.Rocks",
    "position": "Talent Sourcer & Headhunter",
    "keywords": [
      "headhunter",
      "sourcer"
    ]
  },
  {
    "firstName": "Marcos Leandro",
    "lastName": "Froio",
    "url": "https://www.linkedin.com/in/marcosfroio",
    "company": "MindTech",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Margaret",
    "lastName": "Morales Espinoza",
    "url": "https://www.linkedin.com/in/margaret-m-02a0a234",
    "company": "Synopsis S.A.",
    "position": "ANALISTA DE RECLUTAMIENTO Y SELECCIÓN TI",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Margarita",
    "lastName": "Aranguren",
    "url": "https://www.linkedin.com/in/margarita-aranguren-a471bb3a",
    "company": "GeoPagos",
    "position": "Talent Acquisition & HRBP Specialist",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Margarita",
    "lastName": "Varangot",
    "url": "https://www.linkedin.com/in/margarita-varangot-737184126",
    "company": "Welcome Pickups",
    "position": "Driver Acquisition Specialist and Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Margorie",
    "lastName": "Portilla",
    "url": "https://www.linkedin.com/in/margorie-portilla",
    "company": "Suris Code - Software Factory",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mari",
    "lastName": "Angarita",
    "url": "https://www.linkedin.com/in/mariannnn",
    "company": "Freelance (Self employed)",
    "position": "Sr. Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mari",
    "lastName": "Castares",
    "url": "https://www.linkedin.com/in/mari-castares-723893109",
    "company": "Assertia Solutions",
    "position": "Human Resources Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mari",
    "lastName": "Vasquez",
    "url": "https://www.linkedin.com/in/marivasquez6",
    "company": "iBender",
    "position": "Talent Acquisition lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Bastidas",
    "url": "https://www.linkedin.com/in/maria-bastidas-60020123b",
    "company": "Hexacta",
    "position": "Especialista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Doberti",
    "url": "https://www.linkedin.com/in/maria-doberti",
    "company": "thaia®︎",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Gamba",
    "url": "https://www.linkedin.com/in/maria-gamba-055aa6231",
    "company": "MARC-IBER",
    "position": "Freelance IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Juarez",
    "url": "https://www.linkedin.com/in/maria-juarez-ab3357156",
    "company": "INFOTEMA SA",
    "position": "Recruiter Sr",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Pithod",
    "url": "https://www.linkedin.com/in/mariajosepithod",
    "company": "Devengine.ca",
    "position": "Lead of Technical Talent Acquisition Team - Succes Team Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Rivas",
    "url": "https://www.linkedin.com/in/maria-rivas-00476299",
    "company": "Wipro",
    "position": "Associate Director Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Ruiz Ruiz",
    "url": "https://www.linkedin.com/in/maria-ruiz-ruiz",
    "company": "Bastida&Farina",
    "position": "Auxiliar de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Salgado",
    "url": "https://www.linkedin.com/in/maria-salgado-63a38347",
    "company": "Profesional independiente",
    "position": "Talent Acquisition Specialist - HR Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Silva",
    "url": "https://www.linkedin.com/in/maria-silva-b9283b173",
    "company": "Nexer Telescope",
    "position": "Competence Management & IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria",
    "lastName": "Zuccarello",
    "url": "https://www.linkedin.com/in/mariazuccarello",
    "company": "IQVIA",
    "position": "Talent Acquisition Partner, LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Agustina",
    "lastName": "Baldani",
    "url": "https://www.linkedin.com/in/agustinabaldani-hrbp-talentadquisitionit",
    "company": "Delegar",
    "position": "Especialista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Maria Agustina",
    "lastName": "Berardo",
    "url": "https://www.linkedin.com/in/maria-agustina-berardo",
    "company": "Humanitas IT",
    "position": "IT Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Maria Alejandra",
    "lastName": "Vazquez",
    "url": "https://www.linkedin.com/in/mariaalejandravazquez1970",
    "company": "WeITConnect",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Maria Belen",
    "lastName": "Calderon",
    "url": "https://www.linkedin.com/in/maria-belen-calderon",
    "company": "Profesional independiente",
    "position": "Recruiter SR. Especialista en Selección de personal",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Maria Belen",
    "lastName": "Cordoba",
    "url": "https://www.linkedin.com/in/maria-belen-cordoba-b93122113",
    "company": "Who? Consultora Integral",
    "position": "IT Recruiter - Talent Acquisition Specialist - Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Belen",
    "lastName": "Corrales",
    "url": "https://www.linkedin.com/in/maria-belen-corrales-1a45a8182",
    "company": "The Sandbox",
    "position": "Sr Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Belen",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/maria-belen-fernandez-hr",
    "company": "redbee studios",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Maria Belén",
    "lastName": "Ferrero Scordo",
    "url": "https://www.linkedin.com/in/maria-bel%C3%A9n-ferrero-scordo-761bb538",
    "company": "PwC Argentina",
    "position": "Talent Acquisition Sr Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Belén",
    "lastName": "Malpiedi",
    "url": "https://www.linkedin.com/in/maria-belen-malpiedi",
    "company": "deRecruiters",
    "position": "Technical recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Carolina",
    "lastName": "Mauri",
    "url": "https://www.linkedin.com/in/maria-carolina-mauri-6b5b63195",
    "company": "SOOFT Technology",
    "position": "Talent Acquisition - Sr IT Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Carolina",
    "lastName": "P Salazar",
    "url": "https://www.linkedin.com/in/mcarolinap",
    "company": "Nexton",
    "position": "Sr. Technical Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Maria Cecilia",
    "lastName": "Gerardi",
    "url": "https://www.linkedin.com/in/maria-cecilia-gerardi",
    "company": "South Geeks",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Cinthia",
    "lastName": "Chiavon",
    "url": "https://www.linkedin.com/in/mariacinthiachiavon261181",
    "company": "Profesional Independiente",
    "position": "Consultora de RRHH / HRBP – Recruiter IT & Generalista (Freelance)",
    "keywords": [
      "recruiter",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Maria Cristina",
    "lastName": "Gomez Naar",
    "url": "https://www.linkedin.com/in/mariacristinagomeznaar",
    "company": "Self-Employed",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria de la Paz",
    "lastName": "Duran Costa",
    "url": "https://www.linkedin.com/in/mariadelapazdurancosta",
    "company": "Sofre Digital SA",
    "position": "Talent Acquisition Specialist / Analista de Talento y Cultura",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria de la Paz",
    "lastName": "Florez Bazterrechea",
    "url": "https://www.linkedin.com/in/mariadelapazfb",
    "company": "Athyna",
    "position": "Lead Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria De Los Angeles",
    "lastName": "Oliveros Molano",
    "url": "https://www.linkedin.com/in/maria-oliveros-ta-manager",
    "company": "Arroyo is becoming INSPYR Global Solutions",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria de los angeles",
    "lastName": "Suarez Cuesta",
    "url": "https://www.linkedin.com/in/mariadelosangelesuarez",
    "company": "SoftwareOne Colombia",
    "position": "Talent Sourcing Specialist - LATAM",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Maria Del Mar",
    "lastName": "Morales Montero",
    "url": "https://www.linkedin.com/in/maria-del-mar-morales-montero-1b3945196",
    "company": "FPT Latin America",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria del Pilar",
    "lastName": "Silva",
    "url": "https://www.linkedin.com/in/maria-del-pilar-silva-531a951b8",
    "company": "Accenture Argentina",
    "position": "IT Recruiter | Client: Mercado Libre",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Eugenia",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/maria-eugenia-fernandez-027a1715",
    "company": "Scarabelli & Asociados",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Eugenia",
    "lastName": "Maurizi",
    "url": "https://www.linkedin.com/in/meugeniamaurizi",
    "company": "InvGate",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Eugenia",
    "lastName": "Tourn",
    "url": "https://www.linkedin.com/in/euge-tourn2018",
    "company": "Rose Paving LLC (former Atlantic Southern Paving)",
    "position": "Director of Payroll and Human Resources Administration",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Eugenia",
    "lastName": "Villalba",
    "url": "https://www.linkedin.com/in/maria-eugenia-villalba-b0759b9",
    "company": "Epidata",
    "position": "Service delivery lead / Selección y desarrollo de talentos IT , Gestión Comercial",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Maria Fernanda",
    "lastName": "Cordoba",
    "url": "https://www.linkedin.com/in/maria-fernanda-cordoba-",
    "company": "Globant",
    "position": "Recruiting Analyst Senior | South Latam",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Maria Fernanda",
    "lastName": "Finol",
    "url": "https://www.linkedin.com/in/maria-fernanda-finol-",
    "company": "Cielo Talent",
    "position": "Delivery Recruitment Lead RPO on behalf Disney & SC Johnson Danone (Customer Service Manager)",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Florencia",
    "lastName": "Cuello",
    "url": "https://www.linkedin.com/in/maria-florencia-cuello",
    "company": "Outsource Argentina",
    "position": "IT Recruiter - Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Florencia",
    "lastName": "Luna",
    "url": "https://www.linkedin.com/in/maria-florencia-luna-29a9237",
    "company": "People IT",
    "position": "Co-Founder @PeopleIT| HRBP | Talent Acquisition | Talent Specialist | We’re Hiring!🚀🧡",
    "keywords": [
      "hiring",
      "hrbp/business partner",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Florencia",
    "lastName": "Musitani",
    "url": "https://www.linkedin.com/in/mariaflorenciamusitani",
    "company": "Propel",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Florencia",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/maria-florencia-rodriguez",
    "company": "Freelance",
    "position": "IT Recruiter & HR Consultant",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Florencia",
    "lastName": "Velez",
    "url": "https://www.linkedin.com/in/maria-florencia-velez-hr",
    "company": "Clarika Software + Innovation",
    "position": "People & Talent Manager at Clarika Software + Innovation",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Gabriela",
    "lastName": "Arias Contreras",
    "url": "https://www.linkedin.com/in/maria-gabriela-a-039a1144",
    "company": "TeamUp",
    "position": "It recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Gabriela",
    "lastName": "Johanneson",
    "url": "https://www.linkedin.com/in/gabyjohanneson",
    "company": "Epidata",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Gabriela",
    "lastName": "Turco",
    "url": "https://www.linkedin.com/in/maria-gabriela-turco",
    "company": "Charles Taylor InsureTech",
    "position": "Global Recruitment Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Gisele",
    "lastName": "Ledesma",
    "url": "https://www.linkedin.com/in/maria-gisele-ledesma-",
    "company": "Zubale",
    "position": "Tech & Prod. HRBP Manager",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Ignacia",
    "lastName": "Mollejas",
    "url": "https://www.linkedin.com/in/mariamollejas",
    "company": "Profesional independiente",
    "position": "Especialista de Reclutamiento y Seleccion",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Maria Ines",
    "lastName": "Rossi (She/Her/Hers)",
    "url": "https://www.linkedin.com/in/mariainesrossi",
    "company": "Monks",
    "position": "Talent Discovery Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Jose",
    "lastName": "Agostino (She/Her)",
    "url": "https://www.linkedin.com/in/maria-jose-agostino",
    "company": "Ruuts",
    "position": "Head People & Culture",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Jose",
    "lastName": "Bonel",
    "url": "https://www.linkedin.com/in/mariajosebonel",
    "company": "peoplepath",
    "position": "Sr. Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Jose",
    "lastName": "Gonzales Chaves",
    "url": "https://www.linkedin.com/in/maria-jose-gonzales-chaves",
    "company": "Mundi",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Jose",
    "lastName": "Navarrete",
    "url": "https://www.linkedin.com/in/majonavarrete",
    "company": "BrainRocket",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Jose",
    "lastName": "Trejo Conde",
    "url": "https://www.linkedin.com/in/maria-jose-trejo-conde-131b9a13a",
    "company": "Mercado Libre",
    "position": "Regional Talent Acquisition IT Senior Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Jose",
    "lastName": "Urbieta Autelli",
    "url": "https://www.linkedin.com/in/mariajose5",
    "company": "MJ TALENT RESEARCH",
    "position": "Talent people Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Jose",
    "lastName": "Vistalli Caballero",
    "url": "https://www.linkedin.com/in/mariajosevistalli",
    "company": "HCLTech",
    "position": "Country Human Resources Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria José (Majo)",
    "lastName": "Valentinuzzi",
    "url": "https://www.linkedin.com/in/majovalentinuzzi",
    "company": "Accenture Argentina",
    "position": "IT Recruiter Associate (Client: Mercado Libre)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Julieta",
    "lastName": "Litta",
    "url": "https://www.linkedin.com/in/maria-julieta-litta-198b0216a",
    "company": "AstroPay",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Laura",
    "lastName": "Nicolás",
    "url": "https://www.linkedin.com/in/marialauranicol%C3%A1s",
    "company": "Coderio | Software Company",
    "position": "Head of Recruitment",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Maria Laura",
    "lastName": "Rodrigues",
    "url": "https://www.linkedin.com/in/maria-laura-rodrigues-55205341",
    "company": "TalantonCH",
    "position": "Consultora Freelance en Selección y Headhunting | Fundadora TalantonCH",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Maria Laura",
    "lastName": "Santander",
    "url": "https://www.linkedin.com/in/maria-laura-santander",
    "company": "HR Partners",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Laura",
    "lastName": "Tassi",
    "url": "https://www.linkedin.com/in/maria-laura-tassi-1495457",
    "company": "Mercado Libre",
    "position": "Regional Talent Acquisition Senior Manager Executive Search",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Lis",
    "lastName": "Gallo",
    "url": "https://www.linkedin.com/in/marialisgallo",
    "company": "Scoutt",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Livia",
    "lastName": "Boero",
    "url": "https://www.linkedin.com/in/maruboer",
    "company": "CtrlChain",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Lucia",
    "lastName": "Battig",
    "url": "https://www.linkedin.com/in/maria-lucia-battig-061274108",
    "company": "Xseed Solutions",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Lujan",
    "lastName": "Ciommo",
    "url": "https://www.linkedin.com/in/marialujanciommo",
    "company": "Mismo",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Manuela",
    "lastName": "Bugnot",
    "url": "https://www.linkedin.com/in/maria-manuela-bugnot",
    "company": "Avery Dennison Label and Packaging Materials",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Maria Milagros",
    "lastName": "Pintos",
    "url": "https://www.linkedin.com/in/maria-milagros-pintos-657a44140",
    "company": "NetDynamic Consulting Inc.",
    "position": "HR & Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Pia",
    "lastName": "Bustamante",
    "url": "https://www.linkedin.com/in/mariapiabustamante",
    "company": "Behavioral Health Field, Inc",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Pia",
    "lastName": "Hurtado",
    "url": "https://www.linkedin.com/in/mpiahurtado",
    "company": "IBM",
    "position": "Talent Acquisition Partner - BPO",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Rene",
    "lastName": "Gandarillas",
    "url": "https://www.linkedin.com/in/maria-rene-gandarillas-27894b1aa",
    "company": "DevLinkers",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Rosa",
    "lastName": "Rodas",
    "url": "https://www.linkedin.com/in/maria-rosa-rodas-73044b3b",
    "company": "Apuesta Total",
    "position": "IT Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Maria Rosario",
    "lastName": "Tiengo",
    "url": "https://www.linkedin.com/in/maria-rosario-tiengo",
    "company": "Global Think Technology",
    "position": "HR Manager - HRBP",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Silvia",
    "lastName": "Benitez",
    "url": "https://www.linkedin.com/in/mariasilviabenitez",
    "company": "IT MAKER",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Silvia",
    "lastName": "Joulia",
    "url": "https://www.linkedin.com/in/mariasilviajoulia",
    "company": "EngBIM",
    "position": "HR People Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Maria Sofia",
    "lastName": "Pensado Islas",
    "url": "https://www.linkedin.com/in/mariasofiapensadoislas",
    "company": "Koronet",
    "position": "SR IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Sol",
    "lastName": "Gomez",
    "url": "https://www.linkedin.com/in/gomezmariasol",
    "company": "Crox - Connecting Careers",
    "position": "Founder & Lead Talent Partner",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Sol",
    "lastName": "Guerra",
    "url": "https://www.linkedin.com/in/maria-sol-guerra-50b87b7b",
    "company": "Thermo Fisher Scientific",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Sol",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/lopezmariasol",
    "company": "ITSM Consulting S.A",
    "position": "People Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maria Sol",
    "lastName": "Sarmoria",
    "url": "https://www.linkedin.com/in/maria-sol-sarmoria",
    "company": "Here We Go - Talent Consultants",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Soledad",
    "lastName": "Perez",
    "url": "https://www.linkedin.com/in/maria-soledad-perez-00680811",
    "company": "Capitalent - Executive Search & Recruiting",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Valeria",
    "lastName": "Gentile",
    "url": "https://www.linkedin.com/in/maria-valeria-gentile-76b69888",
    "company": "CDA Informática",
    "position": "HRBP - Talento & Cultura",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Maria Virginia",
    "lastName": "Braghini",
    "url": "https://www.linkedin.com/in/maria-virginia-braghini-74247698",
    "company": "aliantec",
    "position": "IT Talent Acquisition ( REMOTO)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maria Virginia",
    "lastName": "Contreras",
    "url": "https://www.linkedin.com/in/maria-virginia-contreras-96b03327",
    "company": "AkuTalent",
    "position": "IT Talent Recruiter LATAM",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maria Ximena",
    "lastName": "Del Priore",
    "url": "https://www.linkedin.com/in/ximedelpriore",
    "company": "PayXpert",
    "position": "HRBP Talent & Development",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Marian",
    "lastName": "Aguirre",
    "url": "https://www.linkedin.com/in/marianelaaguirre",
    "company": "NowVertical Group Inc.",
    "position": "IT Recruiter LATAM -Data & Analytics Recruitment Specialist",
    "keywords": [
      "recruiter",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Marian",
    "lastName": "Betancourt",
    "url": "https://www.linkedin.com/in/marian-betancourt-012475192",
    "company": "Team Connection Consultora",
    "position": "Coordinadora de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Marian",
    "lastName": "Ceccardi",
    "url": "https://www.linkedin.com/in/marian-ceccardi-124bab69",
    "company": "Accenture Argentina",
    "position": "Human Resources Business Partner Lead - North America",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marian",
    "lastName": "Lapcha",
    "url": "https://www.linkedin.com/in/marian-lapcha-8b711421b",
    "company": "DataArt",
    "position": "Contract Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Aganetti",
    "url": "https://www.linkedin.com/in/mariana-aganetti",
    "company": "NewDev",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Bedoya",
    "url": "https://www.linkedin.com/in/mariana-bedoya-41893a17b",
    "company": "HatchWorks AI",
    "position": "People Operations Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Bento",
    "url": "https://www.linkedin.com/in/mariana-bento-rrhh",
    "company": "Rappi",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Brachetti",
    "url": "https://www.linkedin.com/in/marianabrachetti",
    "company": "Newfold Digital",
    "position": "Global IT Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Buteler",
    "url": "https://www.linkedin.com/in/marianabuteler",
    "company": "NEORIS",
    "position": "Talent Attraction Lead – Argentina & Chile",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Cantale",
    "url": "https://www.linkedin.com/in/mariana-cantale-545b6b36",
    "company": "Mira Commerce",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Cortez",
    "url": "https://www.linkedin.com/in/cortezmariana",
    "company": "Tadatic",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Couceiro",
    "url": "https://www.linkedin.com/in/mcouceiro",
    "company": "Nexton",
    "position": "Director of Recruiting",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Curiel",
    "url": "https://www.linkedin.com/in/mariana-curiel-75219b21a",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Donadille",
    "url": "https://www.linkedin.com/in/marianadonadille",
    "company": "HireVolt",
    "position": "Co-Founder in HireVolt- IT Talent Headhunter -",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Garcia (Mar)",
    "url": "https://www.linkedin.com/in/marianagarcia-itrecruiter",
    "company": "Qualifinds",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Godino",
    "url": "https://www.linkedin.com/in/mariana-godino-3377107a",
    "company": "DigitalRoom",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Herrero",
    "url": "https://www.linkedin.com/in/mariana-herrero87118b92",
    "company": "aliantec",
    "position": "IT Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Jauregui",
    "url": "https://www.linkedin.com/in/mariana-jauregui-50045a10b",
    "company": "HyreSnap",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Jones",
    "url": "https://www.linkedin.com/in/mariana-jones-87222928",
    "company": "Keyway",
    "position": "Senior People and Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Licarich",
    "url": "https://www.linkedin.com/in/mariana-licarich-2a109217a",
    "company": "Accenture Argentina",
    "position": "Recruiter Analyst: Client Mercado Libre",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Madrigal",
    "url": "https://www.linkedin.com/in/mariana-madrigal-34a3b817a",
    "company": "Envato",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Malnis Cremades",
    "url": "https://www.linkedin.com/in/marianamalnis-rrhh",
    "company": "Zurich Insurance",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Martinetti",
    "url": "https://www.linkedin.com/in/mariana-martinetti",
    "company": "DEPT®",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Monteiro",
    "url": "https://www.linkedin.com/in/mariana-monteiro-395519b9",
    "company": "Zenith Tech",
    "position": "HR & Ops Manager | IT Recruiter",
    "keywords": [
      "people/talent leadership",
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Montoto",
    "url": "https://www.linkedin.com/in/mariana-montoto",
    "company": "IT Patagonia",
    "position": "HR Business Partner Referent",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Montoya",
    "url": "https://www.linkedin.com/in/mariana-montoya-91a823227",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Núñez Archila",
    "url": "https://www.linkedin.com/in/mariana-nunez-archila",
    "company": "OneInfo Consulting",
    "position": "Talent Acquisition Specialist- IT Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Pintos",
    "url": "https://www.linkedin.com/in/mariannpintos",
    "company": "Perficient Latin America",
    "position": "Lead Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Reyes Cedeño",
    "url": "https://www.linkedin.com/in/ellen-mariana-reyesabb134bb",
    "company": "Acid Labs",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Roldán Ruarte",
    "url": "https://www.linkedin.com/in/mariana-r-b61b6637",
    "company": "Futbol Sites - A part of Better Collective",
    "position": "HR Manager LATAM - Performance & Culture Specialist",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Salvarredi",
    "url": "https://www.linkedin.com/in/marianasalvarredi",
    "company": "NUMAN",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "San Martín",
    "url": "https://www.linkedin.com/in/marianasanmartin",
    "company": "Grid Dynamics",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Souto",
    "url": "https://www.linkedin.com/in/marianabsouto",
    "company": "Progres S.A.",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Völker",
    "url": "https://www.linkedin.com/in/iaiavolker",
    "company": "Mariana Völker - RRHH",
    "position": "HR Consultant - Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariana",
    "lastName": "Zavalla Carbó",
    "url": "https://www.linkedin.com/in/mariana-zavalla-carb%C3%B3-190b7498",
    "company": "Takenos",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana Cecilia",
    "lastName": "Maderal",
    "url": "https://www.linkedin.com/in/mariana-cecilia-maderal",
    "company": "Accenture",
    "position": "Global HR V&A Communications and Change Management A. Manager (VATI)",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariana G.",
    "lastName": "Feliú Torres",
    "url": "https://www.linkedin.com/in/feliumariana",
    "company": "Launchpad Technologies Inc.",
    "position": "Senior Talent Acquisition Specialist | Tech & Professional Services",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariana Nicole",
    "lastName": "Len Reale",
    "url": "https://www.linkedin.com/in/mariana-len-reale",
    "company": "Aquanima Grupo Santander",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Marianela",
    "lastName": "Acevedo",
    "url": "https://www.linkedin.com/in/marianela-acevedo-878361164",
    "company": "Softtek",
    "position": "Talent Acquisition & IT Recruiter SSR",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marianela",
    "lastName": "González",
    "url": "https://www.linkedin.com/in/msgonzalez96",
    "company": "Werben HR LLC",
    "position": "IT Recruiter / Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marianela",
    "lastName": "Marcato",
    "url": "https://www.linkedin.com/in/marianela-marcato-290a151b0",
    "company": "Venon Solutions",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marianela Isabel",
    "lastName": "Garuti",
    "url": "https://www.linkedin.com/in/marianelagaruti",
    "company": "Bait | Recruit & Hire Top Tech Talent",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marianne",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/marianne-gonzalez-600ab1229",
    "company": "You Health",
    "position": "Human Resources Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariano",
    "lastName": "Assaf",
    "url": "https://www.linkedin.com/in/marianoassaf",
    "company": "Mercado Libre",
    "position": "People Business Partner Sr Manager",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariano",
    "lastName": "Casarini",
    "url": "https://www.linkedin.com/in/mariano-casarini-13918340",
    "company": "Grassi SA",
    "position": "HRBP | Administración - Sistemas TI",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Mariano",
    "lastName": "Cordero",
    "url": "https://www.linkedin.com/in/mariano-cordero-6a2832134",
    "company": "Eldar",
    "position": "Talent Acquisition Partner Sr",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariano",
    "lastName": "Hevia",
    "url": "https://www.linkedin.com/in/mariano-hevia-47069817b",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariano",
    "lastName": "León",
    "url": "https://www.linkedin.com/in/mariano-le%C3%B3n-09074ba2",
    "company": "Rockcruit",
    "position": "Senior Global Talent Sourcer",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Mariano",
    "lastName": "Obligado",
    "url": "https://www.linkedin.com/in/marianoobligado",
    "company": "MindTech",
    "position": "Head of HR",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariano",
    "lastName": "Ruidiaz",
    "url": "https://www.linkedin.com/in/marianoruidiaz",
    "company": "IMR Consulting",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maricel",
    "lastName": "Mangia",
    "url": "https://www.linkedin.com/in/marymangia",
    "company": "GlobalLogic",
    "position": "Associate Manager - People Development",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maricel",
    "lastName": "Ocampo",
    "url": "https://www.linkedin.com/in/maricelanaliaocampo",
    "company": "Welocalize",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marie",
    "lastName": "McKone",
    "url": "https://www.linkedin.com/in/mariemckone",
    "company": "ADP",
    "position": "Senior Recruiter Talent Acquisition RPO",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariel",
    "lastName": "Avalos",
    "url": "https://www.linkedin.com/in/mariel-avalos",
    "company": "Stateside",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariel",
    "lastName": "Gómez",
    "url": "https://www.linkedin.com/in/mariel-g%C3%B3mez-2929a5b7",
    "company": "TELUS Digital",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariel",
    "lastName": "Leon",
    "url": "https://www.linkedin.com/in/mariel-leon-50b009112",
    "company": "Avalora Tecnologías de la Información",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariel",
    "lastName": "Martin",
    "url": "https://www.linkedin.com/in/mariel-martin",
    "company": "Paretisa",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariel",
    "lastName": "Rocha",
    "url": "https://www.linkedin.com/in/mariel-rocha-rrhh",
    "company": "Sating Consultora",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Mariela",
    "lastName": "Fassi",
    "url": "https://www.linkedin.com/in/mariela-fassi",
    "company": "Novakorp",
    "position": "People Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Mariela",
    "lastName": "Iglesias",
    "url": "https://www.linkedin.com/in/mariela-iglesias-84b7162b",
    "company": "Givaudan",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariela",
    "lastName": "Livy",
    "url": "https://www.linkedin.com/in/marielalivy",
    "company": "LIVY Gestión de Talentos",
    "position": "Founder & Headhunter | RRHH Estratégico Externo",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Mariela",
    "lastName": "Livy ✔️ Perfil Secundario",
    "url": "https://www.linkedin.com/in/livy-gesti%C3%B3n-del-talento",
    "company": "LIVY Gestión de Talentos",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariela",
    "lastName": "Medina",
    "url": "https://www.linkedin.com/in/mariela-medina-b7b63193",
    "company": "Digital HR.",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariela",
    "lastName": "Mosquera",
    "url": "https://www.linkedin.com/in/mariela-mosquera-ab26b716",
    "company": "In-Haus Recursos Humanos",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Mariela",
    "lastName": "Rebuñal",
    "url": "https://www.linkedin.com/in/marielarebu%C3%B1al",
    "company": "Prosegur",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mariela",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/mariela-rodriguez-01a113246",
    "company": "Nexion Solutions - We are already there",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mariela",
    "lastName": "Sikora",
    "url": "https://www.linkedin.com/in/mariela-sikora-hr-partner",
    "company": "FlyOnData",
    "position": "People & Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marielys",
    "lastName": "Feliz",
    "url": "https://www.linkedin.com/in/marielysfeliz",
    "company": "Aszendit Tech",
    "position": "IT Talent & Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mariia",
    "lastName": "Pulavska 🌻",
    "url": "https://www.linkedin.com/in/mariia-pulavska-%F0%9F%8C%BB-372734219",
    "company": "DevKit",
    "position": "Talent Acquisition Specialist/Talent Sourcer",
    "keywords": [
      "talent acquisition",
      "sourcer"
    ]
  },
  {
    "firstName": "Mariia",
    "lastName": "Ramzaeva",
    "url": "https://www.linkedin.com/in/mariia-ramzaeva",
    "company": "Utopia Design",
    "position": "Recruitment Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Basyuk",
    "url": "https://www.linkedin.com/in/marina-basyuk",
    "company": "Freelance",
    "position": "Freelance Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Heredia",
    "url": "https://www.linkedin.com/in/marina-heredia",
    "company": "Welo Data",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Larrache Olszak",
    "url": "https://www.linkedin.com/in/marinalarracheolszak",
    "company": "Capital Humano",
    "position": "Especialista en Selección y Atracción de Talento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Laurini",
    "url": "https://www.linkedin.com/in/marinalaurini",
    "company": "Bitwise SA",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Lavena",
    "url": "https://www.linkedin.com/in/marinalavena",
    "company": "PwC",
    "position": "Senior Associate Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Lobo Theiler, MBA",
    "url": "https://www.linkedin.com/in/marina-lobo",
    "company": "Koin",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Morales",
    "url": "https://www.linkedin.com/in/marina-morales-584281120",
    "company": "Teladoc Health",
    "position": "Manager, Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Muras",
    "url": "https://www.linkedin.com/in/marinamuras",
    "company": "ANAT Business for Business",
    "position": "People, Recruitment and Training Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Petrovich",
    "url": "https://www.linkedin.com/in/marina-petrovich",
    "company": "GoFasti",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marina",
    "lastName": "Riquelme",
    "url": "https://www.linkedin.com/in/marina-riquelme",
    "company": "Mercado Libre",
    "position": "Talent Acquisition Specialist - Executive Search IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marina Soledad",
    "lastName": "Mangano",
    "url": "https://www.linkedin.com/in/marina-soledad-mangano-23857969",
    "company": "Natural Life - Apasionados por tu mascota",
    "position": "Especialista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Marines",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/marinesdiaz",
    "company": "Randstad Argentina",
    "position": "Talent Acquisition Digital Ssr",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marisa",
    "lastName": "Ruiz Insaurralde",
    "url": "https://www.linkedin.com/in/marisa-ruiz-insaurralde-bb5421202",
    "company": "Webstarted",
    "position": "It Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marisel",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/mariselromero",
    "company": "Dichi Consultores",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marisella",
    "lastName": "Negrón",
    "url": "https://www.linkedin.com/in/marisellanegron",
    "company": "Strong CRM",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marisol",
    "lastName": "Acuña",
    "url": "https://www.linkedin.com/in/marisol-acu%C3%B1a-ok",
    "company": "Velozient",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marisol",
    "lastName": "Castañeda",
    "url": "https://www.linkedin.com/in/marisol-casta%C3%B1eda-b2650b9",
    "company": "Potentiality Group",
    "position": "Co-Founder & HR Director (CHRO)",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Marita",
    "lastName": "Adrianzén",
    "url": "https://www.linkedin.com/in/marita-adrianz%C3%A9n-0860b853",
    "company": "Talent2Win Perú",
    "position": "Talent Acquisition Business Parnter (BP)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maritza Elena",
    "lastName": "Hernandez Aldana",
    "url": "https://www.linkedin.com/in/maritzahernand",
    "company": "TalentIA 360",
    "position": "Talent Acquisition Manager & Recruitment Ops Lead",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mark",
    "lastName": "Garland",
    "url": "https://www.linkedin.com/in/mark-garland-3a0325a8",
    "company": "Mark Garland Tech Recruitment Services",
    "position": "Freelance Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mark",
    "lastName": "Gordoncillo",
    "url": "https://www.linkedin.com/in/mark-gordoncillo-892282241",
    "company": "SYNERGY LOG-IN SYSTEMS SDN. BHD.",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Marta",
    "lastName": "Carbajal",
    "url": "https://www.linkedin.com/in/marta-carbajal",
    "company": "DXC Technology",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marta",
    "lastName": "De La Vega Fernandez",
    "url": "https://www.linkedin.com/in/marta-de-la-vega-fernandez-7376b121",
    "company": "IZERTIS",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Marta",
    "lastName": "Ojeda Berger",
    "url": "https://www.linkedin.com/in/marta-ojeda-berger",
    "company": "CDA Informática",
    "position": "Analista de Gestión de Talento y Cultura - It Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martha",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/martha-l%C3%B3pez-49992223a",
    "company": "Falabella",
    "position": "Talent Acquisition Professional",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martha",
    "lastName": "Ros",
    "url": "https://www.linkedin.com/in/martha-ros-4379202a",
    "company": "DigiTalent IT Executive Search",
    "position": "DigiTalent|IT Recruiter|Technical Recruiter|IT Sourcer|Talent Acquisition|Technology Recruiter |Soci",
    "keywords": [
      "recruiter",
      "talent acquisition",
      "sourcer"
    ]
  },
  {
    "firstName": "Martin",
    "lastName": "Castro",
    "url": "https://www.linkedin.com/in/martinfcastro",
    "company": "Focus IT - LATAM",
    "position": "Recruiting & Sourcing Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Martin",
    "lastName": "Cornaglia",
    "url": "https://www.linkedin.com/in/martin-cornaglia-154627199",
    "company": "KIUVI Software Quality",
    "position": "Business development and IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martin",
    "lastName": "Dammiano",
    "url": "https://www.linkedin.com/in/martin-dammiano-8a8082240",
    "company": "APM Terminals",
    "position": "HR People Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Martin",
    "lastName": "Espejo",
    "url": "https://www.linkedin.com/in/mespejo",
    "company": "Keysight Technologies",
    "position": "Talent Acquisition EMEA",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martin",
    "lastName": "Longo",
    "url": "https://www.linkedin.com/in/martin-longo",
    "company": "BB Media",
    "position": "Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Martin",
    "lastName": "Macallister",
    "url": "https://www.linkedin.com/in/martin-macallister-82106482",
    "company": "Self-Employed",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martin",
    "lastName": "Morales",
    "url": "https://www.linkedin.com/in/martin-morales-",
    "company": "rhumbo",
    "position": "Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martin Dino",
    "lastName": "Panizza",
    "url": "https://www.linkedin.com/in/martin-dino-panizza-889494176",
    "company": "Ualá",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Alvarellos",
    "url": "https://www.linkedin.com/in/martina-alvarellos-4090b6136",
    "company": "Adnami",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Berardi",
    "url": "https://www.linkedin.com/in/martina-berardi-a82244217",
    "company": "Jampp",
    "position": "Global Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Criscuolo",
    "url": "https://www.linkedin.com/in/martinacriscuolo",
    "company": "Entropy",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "De Leo",
    "url": "https://www.linkedin.com/in/martinadeleo",
    "company": "Adecco",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "García Monteverdi",
    "url": "https://www.linkedin.com/in/martina-garc%C3%ADa-monteverdi-092314215",
    "company": "South",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "González Groppo (She/Her)",
    "url": "https://www.linkedin.com/in/martina-gonz%C3%A1lez-groppo-she-her-981a5116b",
    "company": "peoplepath.io",
    "position": "Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Hernández",
    "url": "https://www.linkedin.com/in/martinahernandez97",
    "company": "GlobalTask",
    "position": "IT People Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Herrera",
    "url": "https://www.linkedin.com/in/martina-herrera-064625142",
    "company": "Independiente (freelance)",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Hintuchi",
    "url": "https://www.linkedin.com/in/martina-hintuchi-947155231",
    "company": "TGV Americas",
    "position": "HR Analyst / IT Recruiter/ Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Iocco",
    "url": "https://www.linkedin.com/in/martinaiocco",
    "company": "Randstad Argentina",
    "position": "Recruiter Sr. | RPO Interno",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Madero",
    "url": "https://www.linkedin.com/in/martina-madero-33475b16b",
    "company": "Avature",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Nobile Giusto",
    "url": "https://www.linkedin.com/in/martina-nobile-giusto",
    "company": "Bloom Talent Partners",
    "position": "IT Recruiter - Tech Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Perckis",
    "url": "https://www.linkedin.com/in/mperckis",
    "company": "Motivus",
    "position": "Tech Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Pifarré",
    "url": "https://www.linkedin.com/in/martinapifarre",
    "company": "Globant",
    "position": "Capacity & People Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Quiroga",
    "url": "https://www.linkedin.com/in/martina-quiroga-158635181",
    "company": "Rooftop",
    "position": "Hiring Expert",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Rosales",
    "url": "https://www.linkedin.com/in/martina-rosales",
    "company": "Qubika",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Rothberg Dussaut",
    "url": "https://www.linkedin.com/in/martina-rothberg-dussaut",
    "company": "Prediktive",
    "position": "Talent Recruiting Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Schneider",
    "url": "https://www.linkedin.com/in/martina-schneider23",
    "company": "Staffy",
    "position": "Tech Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Suárez",
    "url": "https://www.linkedin.com/in/martina-su%C3%A1rez",
    "company": "ConfiaRH",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Vai",
    "url": "https://www.linkedin.com/in/martina-vai-4358a8241",
    "company": "Talently",
    "position": "It Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Martina",
    "lastName": "Valdez Duarte",
    "url": "https://www.linkedin.com/in/martinavaldezduarte",
    "company": "DXC Technology",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martina Conti Garriga -",
    "lastName": "IT Specialists",
    "url": "https://www.linkedin.com/in/marti-conti-garriga",
    "company": "5411 Hub - LATAM Talents",
    "position": "Talent and Sourcing Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Martín",
    "lastName": "Aranciva Casalderrey",
    "url": "https://www.linkedin.com/in/mart%C3%ADn-aranciva",
    "company": "Agrolimen",
    "position": "RPO Recruiter @ Grupo Agrolimen (via Talent Search People)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martín",
    "lastName": "Capo",
    "url": "https://www.linkedin.com/in/talentwizard",
    "company": "Intuition Machines",
    "position": "Lead Global Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martín",
    "lastName": "Cañete",
    "url": "https://www.linkedin.com/in/mart%C3%ADn-ca%C3%B1ete-83b442142",
    "company": "Balloon Group",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martín",
    "lastName": "Celle",
    "url": "https://www.linkedin.com/in/martin-celle",
    "company": "RHT",
    "position": "Business Partner & IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Martín",
    "lastName": "Muñoz",
    "url": "https://www.linkedin.com/in/mart%C3%ADnmu%C3%B1oz",
    "company": "Selectium",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Martín",
    "lastName": "Narvaja",
    "url": "https://www.linkedin.com/in/martinnarvaja",
    "company": "Freelance, self-employed",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martín",
    "lastName": "Quadro",
    "url": "https://www.linkedin.com/in/martinquadro",
    "company": "Q2 Talent Acquisition",
    "position": "Founder & Head of IT Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Martín",
    "lastName": "Riveira",
    "url": "https://www.linkedin.com/in/martin-riveira-q2it",
    "company": "Q2 Talent Acquisition",
    "position": "IT Talent Acquisition Lead | Argentina, LATAM, USA & Europe",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Martín",
    "lastName": "Sánchez",
    "url": "https://www.linkedin.com/in/gonsan1986",
    "company": "ACL",
    "position": "IT Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Martín Andrés",
    "lastName": "Coloma Alcántara",
    "url": "https://www.linkedin.com/in/martincoloma",
    "company": "Suma 3 Consultores RRHH",
    "position": "Recruiter / Talent Acquisition Ssr.",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mary",
    "lastName": "Chavez Nuñez",
    "url": "https://www.linkedin.com/in/mary-chavez-nu%C3%B1ez",
    "company": "Prometeo Talent",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mary C.",
    "lastName": "Vasquez B.",
    "url": "https://www.linkedin.com/in/maryvasquez",
    "company": "Fz Sports",
    "position": "People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Maryna",
    "lastName": "Kuzmina",
    "url": "https://www.linkedin.com/in/maryna-kuzmina-853a76205",
    "company": "Adaptiq",
    "position": "Tech Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "María",
    "lastName": "Andrieu",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-andrieu-27636091",
    "company": "Independent",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María",
    "lastName": "Antonini",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-antonini-a58863183",
    "company": "Properix",
    "position": "Sr Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María",
    "lastName": "Harting",
    "url": "https://www.linkedin.com/in/mariaharting",
    "company": "Torc",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María",
    "lastName": "Hernández",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-hern%C3%A1ndez-recruiter",
    "company": "Tecnosoftware",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María",
    "lastName": "Moncaleano",
    "url": "https://www.linkedin.com/in/mariagamarram",
    "company": "Gold Media Tech",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María",
    "lastName": "Rojas",
    "url": "https://www.linkedin.com/in/psicomariarojas",
    "company": "EGCI Escuela de Gerencia",
    "position": "Especialista en Selección | Desarrollo de servicio de reclutamiento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María",
    "lastName": "Sarmiento Vargas",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-sarmiento-vargas-592418111",
    "company": "Accenture",
    "position": "IT Recruiter Analyst SR",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "María",
    "lastName": "Sánchez",
    "url": "https://www.linkedin.com/in/mariadelros",
    "company": "TechGenies",
    "position": "Senior Talent Acquisition and HR Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "María Agustina",
    "lastName": "Asencio",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-agustina-asencio-8a8267144",
    "company": "Veritran",
    "position": "Global Talent Acquisition Specialist & Mexico´s People Experience",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Agustina",
    "lastName": "Glucksmann",
    "url": "https://www.linkedin.com/in/agusglu",
    "company": "AltaTienda",
    "position": "Senior Human Resources Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Agustina",
    "lastName": "Rasmussen",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-agustina-r%C3%A1smussen",
    "company": "Accenture Argentina",
    "position": "Talent Acquisition Senior Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Alexandra",
    "lastName": "Cárdenas",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-alexandra-c%C3%A1rdenas-a4b64029b",
    "company": "excelia",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Belén",
    "lastName": "Bonaiuto",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-bel%C3%A9n-bonaiuto-3a6831199",
    "company": "ADN - Recursos Humanos",
    "position": "Asistente de recursos humanos para selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María Belén",
    "lastName": "Tirante",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-bel%C3%A9n-tirante-06b38975",
    "company": "ITPS ONE",
    "position": "Recruiter SAP SR",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Belén",
    "lastName": "Vieyra",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-bel%C3%A9n-vieyra-70b449220",
    "company": "Qubika",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Betania",
    "lastName": "Petry",
    "url": "https://www.linkedin.com/in/betaniapetry",
    "company": "Profesional independiente",
    "position": "IT & Digital Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Camila",
    "lastName": "Vélez Vélez",
    "url": "https://www.linkedin.com/in/mariacamilavelez2",
    "company": "Truelogic Software",
    "position": "Senior IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Celeste",
    "lastName": "Moldovan",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-celeste-moldovan",
    "company": "Selección IT",
    "position": "Founder Seleccion IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María Daniela",
    "lastName": "Cantoni",
    "url": "https://www.linkedin.com/in/macantoni",
    "company": "Dancan - Gestión del Talento",
    "position": "Tech Recruiter, Talenthunter & HR Consultant",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María de la Paz",
    "lastName": "Perez Ares",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-de-la-paz-perez-ares-992aa6182",
    "company": "Hand Selection",
    "position": "Coordinadora de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María de los Angeles",
    "lastName": "Dalmasso",
    "url": "https://www.linkedin.com/in/marydalmasso",
    "company": "Techunting",
    "position": "Senior IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María del Rosario",
    "lastName": "Ramos",
    "url": "https://www.linkedin.com/in/mdrr1985",
    "company": "LATAM5411 Growing Partners",
    "position": "IT Recruiter - Team Leader - Customer Success - Growing Partner",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Delfina",
    "lastName": "Accorinti Bellorini",
    "url": "https://www.linkedin.com/in/maria-delfina-accorinti-bellorini",
    "company": "Jalasoft",
    "position": "People - Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Emilia",
    "lastName": "Aquilante",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-emilia-aquilante-510340208",
    "company": "Manage Resources - Latam",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Emilia",
    "lastName": "Cantoni",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-emilia-cantoni-a5589812b",
    "company": "DANCAN - Gestión del Talento",
    "position": "Selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María Emilia",
    "lastName": "Lema",
    "url": "https://www.linkedin.com/in/mariaemilialema",
    "company": "IT MAKER",
    "position": "People Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "María Fernanda",
    "lastName": "Figueroa Gentile",
    "url": "https://www.linkedin.com/in/fernandafigueroa",
    "company": "MINEXUS",
    "position": "HRBP | People & Culture Specialist",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "María Fernanda",
    "lastName": "Gómez Sauerborn",
    "url": "https://www.linkedin.com/in/mfgomezsauerborn",
    "company": "Folder IT",
    "position": "Direction Team - Human Resources Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "María Fernanda",
    "lastName": "Penisse",
    "url": "https://www.linkedin.com/in/mariafernandapenisse",
    "company": "Mercado Libre",
    "position": "Regional Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Fernanda",
    "lastName": "Spirito",
    "url": "https://www.linkedin.com/in/spiritomariafernanda",
    "company": "MFS Talento Humano",
    "position": "Senior HR Consulting | Acting Head of People for Clients",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "María Fernanda",
    "lastName": "Ávila",
    "url": "https://www.linkedin.com/in/fernanda-%C3%A1vila-d%C3%ADaz",
    "company": "BAT",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Florencia",
    "lastName": "Fattori",
    "url": "https://www.linkedin.com/in/florenciafattori",
    "company": "hireworks",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Florencia",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/florenciagarcia",
    "company": "Here We Go - Talent Consultants",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Florencia",
    "lastName": "Gattari",
    "url": "https://www.linkedin.com/in/mariaflorenciagattari",
    "company": "Exomindset",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "María Florencia",
    "lastName": "Perizok",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-florencia-perizok-5b20b5161",
    "company": "Cloud(x);",
    "position": "Technical IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Florencia",
    "lastName": "Vietri",
    "url": "https://www.linkedin.com/in/mar%C3%ADaflorenciavietri",
    "company": "Datastar Argentina S.A.",
    "position": "Recruiter IT | HR Generalist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Gracia",
    "lastName": "Sotomayor",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-gracia-sotomayor-982914175",
    "company": "Jelou",
    "position": "Recruitment Assistant & OD",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "María Guadalupe",
    "lastName": "Quinteros",
    "url": "https://www.linkedin.com/in/maria-guadalupe-quinteros",
    "company": "RE/MAX Legado",
    "position": "Responsable de Reclutamiento y Desarrollo de Agentes Inmobiliarios",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María Inés",
    "lastName": "Mazzacaro",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-in%C3%A9s-mazzacaro-178a54119",
    "company": "Independiente (freelance)",
    "position": "Consultor en Recursos Humanos - Especialista en Selección de Personas- Recruiter",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María Joaquina",
    "lastName": "Cieza",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-joaquina-cieza-gonz%C3%A1lez",
    "company": "Cross Border Talents",
    "position": "International Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María José",
    "lastName": "Calle",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-jos%C3%A9-calle",
    "company": "TECLA",
    "position": "Recruiting Partner",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "María José",
    "lastName": "Dean Eguia",
    "url": "https://www.linkedin.com/in/maria-jose-dean-eguia",
    "company": "Accenture Argentina",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María José",
    "lastName": "Figueroa",
    "url": "https://www.linkedin.com/in/majofi",
    "company": "Tecnova Soluciones Informaticas",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María José",
    "lastName": "Gordillo",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-jos%C3%A9-gordillo-9b28b433",
    "company": "Brocsoft",
    "position": "IT Talent Acquisition | LATAM & Europe",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Julia",
    "lastName": "Acuña",
    "url": "https://www.linkedin.com/in/majuliaacu%C3%B1a",
    "company": "Canary Technologies",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Laura",
    "lastName": "Mazzoli",
    "url": "https://www.linkedin.com/in/marialauramazz",
    "company": "Toyota Kansai",
    "position": "Analista de reclutamiento y Desarrollo",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María Lourdes",
    "lastName": "Murúa (She/her)",
    "url": "https://www.linkedin.com/in/lourdesmurua",
    "company": "Almundo - CVC Argentina",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Luján",
    "lastName": "Castro",
    "url": "https://www.linkedin.com/in/marialujancastro",
    "company": "Huenei IT Services",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Manuela",
    "lastName": "Fernández Jaime",
    "url": "https://www.linkedin.com/in/mariamanuelafernandez",
    "company": "Morning Value",
    "position": "Analista de Reclutamiento y Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María Mercedes",
    "lastName": "Rusca",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-mercedes-rusca-44bb75100",
    "company": "Equus Argentina",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "María Noé",
    "lastName": "Pinto",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-no%C3%A9-pinto-712433262",
    "company": "Proxify",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Paula",
    "lastName": "Secondo",
    "url": "https://www.linkedin.com/in/paulasecondo",
    "company": "Trafigura",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Paz",
    "lastName": "Hurtado Salavarría",
    "url": "https://www.linkedin.com/in/maria-paz-hurtados",
    "company": "Nexton",
    "position": "Ssr Technical Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "María Pía",
    "lastName": "Xodo",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-p%C3%ADa-xodo",
    "company": "Datial",
    "position": "Head of People and Culture Datial",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "María Salomé",
    "lastName": "Esquivel",
    "url": "https://www.linkedin.com/in/salomeesquivel",
    "company": "EducacionIT",
    "position": "HR - Tech Recruiter SR | Soporte externo",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Sol",
    "lastName": "Cattáneo",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-sol-catt%C3%A1neo",
    "company": "CFOTech IT Global Services",
    "position": "Talent Acquisition - Senior",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Sol",
    "lastName": "Mallo",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-sol-mallo-",
    "company": "doc24",
    "position": "Capital Humano & IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Soledad",
    "lastName": "Leiva",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-soledad-leiva-629a6817",
    "company": "Leiva & Asociados - Especialistas en Capital Humano -",
    "position": "Líder de Reclutamiento, Selección y Evaluación",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "María Teresa",
    "lastName": "Rojas Aceituno",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-teresa-rojas-aceituno-9b8b16161",
    "company": "CRAFTLabs",
    "position": "HR Assistant/ IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "María Verónica",
    "lastName": "Quadro Riveira",
    "url": "https://www.linkedin.com/in/veronica-quadro",
    "company": "Globant",
    "position": "Recruiting Specialist - People & Capacity .",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "María Victoria",
    "lastName": "Bianchi",
    "url": "https://www.linkedin.com/in/mv-bianchi",
    "company": "KPMG España",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Victoria",
    "lastName": "Butani",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-victoria-butani-77a244140",
    "company": "TMF Group",
    "position": "Talent Acquisition Senior Specialist South LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Victoria",
    "lastName": "Cupo",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-victoria-cupo-76764419a",
    "company": "AES Servicios América",
    "position": "SR Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Victoria",
    "lastName": "Pappalardo",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-victoria-pappalardo-9979a824",
    "company": "Mercado Libre",
    "position": "Regional IT Talent Acquisition Supervisor",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "María Victoria",
    "lastName": "Rivera",
    "url": "https://www.linkedin.com/in/victoriarivera",
    "company": "Compass",
    "position": "Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mateja",
    "lastName": "Jokovich",
    "url": "https://www.linkedin.com/in/mateja-j-9a0ba521a",
    "company": "BlueCloud",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mateo",
    "lastName": "Franco Franco",
    "url": "https://www.linkedin.com/in/mateo-franco1",
    "company": "Talent Software",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Mathias",
    "lastName": "Costanzo",
    "url": "https://www.linkedin.com/in/mathias-costanzo-8055b3198",
    "company": "Accenture",
    "position": "Recruiting Senior Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Matias",
    "lastName": "Godoy",
    "url": "https://www.linkedin.com/in/matias-godoy-99528217a",
    "company": "KUNAN S.A.",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Matias",
    "lastName": "Godoy",
    "url": "https://www.linkedin.com/in/matiasgodoyy",
    "company": "KUNAN S.A.",
    "position": "Technical IT Recruiter at KUNAN S.A.",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Matias",
    "lastName": "Gutierrez",
    "url": "https://www.linkedin.com/in/matias-g-a83836228",
    "company": "Pearster Global",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Matias",
    "lastName": "Huvelle",
    "url": "https://www.linkedin.com/in/matiashuvelle",
    "company": "Glovo",
    "position": "People & Global Rewards Sr Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Matias",
    "lastName": "Lozano Gimenez",
    "url": "https://www.linkedin.com/in/matias-lozano-gimenez",
    "company": "MURATA S.A.",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Matias",
    "lastName": "Macri",
    "url": "https://www.linkedin.com/in/matias-macri-99333a158",
    "company": "Valtech",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Matias",
    "lastName": "Richards",
    "url": "https://www.linkedin.com/in/matiasrichards",
    "company": "Mindalter",
    "position": "Head of Talent",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Matias Damian",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/matias-damian-rodriguez",
    "company": "Criterium",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Matias Sebastian",
    "lastName": "Cuesta",
    "url": "https://www.linkedin.com/in/matias-sebastian-cuesta-66599b2b",
    "company": "Impera & Co.",
    "position": "Headhunting & Recruitment Energy & Royal Estate Division Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Matilde",
    "lastName": "Arbiza",
    "url": "https://www.linkedin.com/in/matilde-arbiza-9aa7a8222",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Matías",
    "lastName": "Masliah",
    "url": "https://www.linkedin.com/in/matias-masliah",
    "company": "Ardua",
    "position": "Head of HR",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Matías",
    "lastName": "Pedulla",
    "url": "https://www.linkedin.com/in/mpedulla",
    "company": "AccelOne",
    "position": "Head of HR",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Matías",
    "lastName": "Ramirez",
    "url": "https://www.linkedin.com/in/rhmatiasramirez",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Matías",
    "lastName": "Salvo",
    "url": "https://www.linkedin.com/in/matiasalvo",
    "company": "Dtalentosarg",
    "position": "Reclutamiento y Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Matías",
    "lastName": "Trost",
    "url": "https://www.linkedin.com/in/matiastrost",
    "company": "Moovx",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Matías",
    "lastName": "Villalba",
    "url": "https://www.linkedin.com/in/mat%C3%ADas-villalba",
    "company": "WeDevelop",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Matías Alberto",
    "lastName": "Liberona Díaz",
    "url": "https://www.linkedin.com/in/matias-liberona-diaz",
    "company": "Stefanini Group",
    "position": "Talent acquisition IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Matías Alberto",
    "lastName": "López Muñoz",
    "url": "https://www.linkedin.com/in/mat%C3%ADas-alberto-l%C3%B3pez-mu%C3%B1oz",
    "company": "Imagemaker",
    "position": "IT Senior Executive Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Matías Ariel",
    "lastName": "Nadborny",
    "url": "https://www.linkedin.com/in/mat%C3%ADas-ariel-nadborny-86329120",
    "company": "Freelance recruiter - US & International clients",
    "position": "Human Resources Recruiter IT & Executive",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mauricio",
    "lastName": "Krausse",
    "url": "https://www.linkedin.com/in/mauricio-krausse-86bb85183",
    "company": "NTT DATA Europe & Latam",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mauro",
    "lastName": "Dalla Vía",
    "url": "https://www.linkedin.com/in/mauro-dalla-v%C3%ADa-b2b6b056",
    "company": "Parser",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mauro",
    "lastName": "Grilli",
    "url": "https://www.linkedin.com/in/mauro-grilli-6a905a51",
    "company": "Bonhomia RRHH",
    "position": "Global Talent Acquisition - Recruiting IT and Headhunting",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mauro",
    "lastName": "Kermadec",
    "url": "https://www.linkedin.com/in/mauro-kermadec-b34746b9",
    "company": "CERUTTI GLOBAL RH",
    "position": "Talent Acquisition Manager LATAM y Caribe",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mauro",
    "lastName": "Lacrouts",
    "url": "https://www.linkedin.com/in/mauro-lacrouts",
    "company": "Recurso CapITal",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mauro Rodrigo",
    "lastName": "Vazquez",
    "url": "https://www.linkedin.com/in/psimaurovazquez",
    "company": "Revelo Network",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Maxime",
    "lastName": "Szczerba",
    "url": "https://www.linkedin.com/in/maximeszczerba",
    "company": "Ansys",
    "position": "Talent Acquisition Specialist EMEA",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Maximiliano",
    "lastName": "Eggers",
    "url": "https://www.linkedin.com/in/maximiliano-eggers",
    "company": "Softtek",
    "position": "People Analytics Global Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Maximiliano",
    "lastName": "Sayago",
    "url": "https://www.linkedin.com/in/maximiliano-sayago-226799140",
    "company": "Free Lance",
    "position": "Consultor externo en Reclutamiento IT/perfiles generales",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Mayra",
    "lastName": "Berto Massuda",
    "url": "https://www.linkedin.com/in/mayramassuda",
    "company": "Sema",
    "position": "Human Resources Operations Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mayra",
    "lastName": "Cihal",
    "url": "https://www.linkedin.com/in/mayracihal",
    "company": "DG Consultores en Recursos Humanos",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Mayra",
    "lastName": "Finkel (She/Her)",
    "url": "https://www.linkedin.com/in/mayrafinkel",
    "company": "Arionkoder",
    "position": "Head of Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mayra",
    "lastName": "Giménez",
    "url": "https://www.linkedin.com/in/mayragimenezrrhh",
    "company": "WES",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mayra",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/mayra-l%C3%B3pez-7b3385164",
    "company": "ITR",
    "position": "IT Recruiter SR | Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mayra",
    "lastName": "Pompas",
    "url": "https://www.linkedin.com/in/mayra-pompas",
    "company": "Monks",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mayra",
    "lastName": "Puentes Salim",
    "url": "https://www.linkedin.com/in/mayra-puentes-salim-947025117",
    "company": "Rather Labs, Inc",
    "position": "Web3 Recruitment & Partnerships",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Mayra",
    "lastName": "Vicente",
    "url": "https://www.linkedin.com/in/mayravic",
    "company": "Alcor",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mayra Alejandra",
    "lastName": "Herrera Manga",
    "url": "https://www.linkedin.com/in/mayra-alejandra-herrera-manga-012a16126",
    "company": "DevSavant",
    "position": "Sr. IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mel",
    "lastName": "Perez",
    "url": "https://www.linkedin.com/in/melinaperezdiversitytalentadvocate",
    "company": "Cazandra",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Melania",
    "lastName": "Halabi Flores",
    "url": "https://www.linkedin.com/in/melania-halabi-flores-765334166",
    "company": "Growth Acceleration Partners",
    "position": "Advanced IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melania",
    "lastName": "Salas",
    "url": "https://www.linkedin.com/in/itrecruiter-melaniasalas",
    "company": "RYZ Labs",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melanie",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/melanie-diaz-6735b019b",
    "company": "CFOTech",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Melanie",
    "lastName": "Feito",
    "url": "https://www.linkedin.com/in/melanie-feito-44756783",
    "company": "Wazuh, Inc.",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melanie",
    "lastName": "Quaglia",
    "url": "https://www.linkedin.com/in/melanie-quaglia-",
    "company": "Mendel",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Melanie",
    "lastName": "Quilez",
    "url": "https://www.linkedin.com/in/melaniequilez",
    "company": "Nubiral",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Melanie",
    "lastName": "Ramirez",
    "url": "https://www.linkedin.com/in/melanieframirezz",
    "company": "Grupo Mercel S.A.",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melanie",
    "lastName": "Sifria",
    "url": "https://www.linkedin.com/in/melanie-sifria",
    "company": "Glofy",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melanie",
    "lastName": "Szabo",
    "url": "https://www.linkedin.com/in/melanie-szabo-b92102100",
    "company": "Prex",
    "position": "Sr IT Talent Acquisition & People Partner",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Melanie Belén",
    "lastName": "Zaia",
    "url": "https://www.linkedin.com/in/melanie-zaia",
    "company": "Acciona IT",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Melany",
    "lastName": "Larovere",
    "url": "https://www.linkedin.com/in/melany-larovere-66b540185",
    "company": "Pearster",
    "position": "Head of People Experience & SR Recruiter",
    "keywords": [
      "recruiter",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Melany",
    "lastName": "Marques",
    "url": "https://www.linkedin.com/in/melany-marques",
    "company": "TeamUp",
    "position": "Hiring Manager",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Melby",
    "lastName": "Carrión",
    "url": "https://www.linkedin.com/in/melby-carrion",
    "company": "WillDom",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Bazarian",
    "url": "https://www.linkedin.com/in/melina-bazarian",
    "company": "On",
    "position": "Senior Specialist - Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Buffarini",
    "url": "https://www.linkedin.com/in/melina-buffarini-bb912a28",
    "company": "SBI Technology",
    "position": "IT Sr Recruiter, Responsable de Selección de Personal",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Ceriana",
    "url": "https://www.linkedin.com/in/melina-ceriana",
    "company": "exomindset",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Libsfraint",
    "url": "https://www.linkedin.com/in/melina-libsfraint-59b1b527",
    "company": "Solu.",
    "position": "IT, People & Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Loizzo",
    "url": "https://www.linkedin.com/in/melinaloizzo",
    "company": "Manage Resources - Latam",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Mamani",
    "url": "https://www.linkedin.com/in/melina-mamani",
    "company": "Aliancers",
    "position": "IT Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Peirano",
    "url": "https://www.linkedin.com/in/melina-peirano-554179201",
    "company": "Yumatech",
    "position": "Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Puertas",
    "url": "https://www.linkedin.com/in/melina-puertas",
    "company": "Givaudan",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Rodriguez Vul",
    "url": "https://www.linkedin.com/in/melina-rodr%C3%ADguez-vul-",
    "company": "Sellerate",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Rubio",
    "url": "https://www.linkedin.com/in/melinarubio",
    "company": "aliantec",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Ruggeri",
    "url": "https://www.linkedin.com/in/melina-ruggeri",
    "company": "Salesforce",
    "position": "LATAM Recruiting Senior Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Tomasello",
    "url": "https://www.linkedin.com/in/melinatomasello",
    "company": "Korn Ferry",
    "position": "Senior Regional Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melina",
    "lastName": "Vecchio",
    "url": "https://www.linkedin.com/in/melina-vecchio",
    "company": "Mavila Consulting",
    "position": "Global Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melina Belen",
    "lastName": "Di Lorenzo",
    "url": "https://www.linkedin.com/in/melinadilorenzo",
    "company": "Software Mind Americas",
    "position": "Senior Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Melina R.",
    "lastName": "Mansilla",
    "url": "https://www.linkedin.com/in/melinamansilla",
    "company": "GlobalTask",
    "position": "IT Recruiter & Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Melisa",
    "lastName": "Comparini",
    "url": "https://www.linkedin.com/in/melicomparini",
    "company": "Evolution Cloud Services (EVOCS)",
    "position": "Director of People & Culture",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Melisa",
    "lastName": "Cristofari",
    "url": "https://www.linkedin.com/in/melisacristofari",
    "company": "Accenture",
    "position": "Recruiting Analyst (Cliente Mercado Libre 💛)",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Melisa",
    "lastName": "Ponce",
    "url": "https://www.linkedin.com/in/melisalponce",
    "company": "TrustScale",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Melissa",
    "lastName": "Barrios",
    "url": "https://www.linkedin.com/in/melissa-barrios-53254ba0",
    "company": "Babel",
    "position": "Sr IT Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Melissa",
    "lastName": "Múnera",
    "url": "https://www.linkedin.com/in/melissamuneraa",
    "company": "inVerita",
    "position": "Technical Recruiter | HR Operations",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Melissa",
    "lastName": "Ribeyro V.",
    "url": "https://www.linkedin.com/in/melissa-ribeyro",
    "company": "ISPROX",
    "position": "Associate Recruitment Partner en ISPROX",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Melody",
    "lastName": "Portnoy",
    "url": "https://www.linkedin.com/in/melody-portnoy",
    "company": "Globant",
    "position": "Tech Talent Acquisition LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Ase",
    "url": "https://www.linkedin.com/in/mercedes-ase",
    "company": "TierOne",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Barriga Huamán",
    "url": "https://www.linkedin.com/in/mercedes-barriga-huam%C3%A1n-655076185",
    "company": "Avantica",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Beltrán",
    "url": "https://www.linkedin.com/in/mercedes-beltr%C3%A1n-504337142",
    "company": "GlobalLogic",
    "position": "Talent Acquisition Semi Senior",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Burges",
    "url": "https://www.linkedin.com/in/mercedes-burges-a662894a",
    "company": "Autónomo",
    "position": "Global IT & Blockchain Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Buteler",
    "url": "https://www.linkedin.com/in/mercedes-buteler",
    "company": "TurnKey Tech Staffing",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Coltelli",
    "url": "https://www.linkedin.com/in/mercedes-coltelli-a2ba0621b",
    "company": "Cecilia Presenza y Equipo",
    "position": "Freelance Talent Recruiter - Latam, US & UE",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Espinosa",
    "url": "https://www.linkedin.com/in/mercedes-espinosa-52a93b67",
    "company": "Resilient Co.",
    "position": "Global Talent Acquisition Partner| LATAM, US & EMEA",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Foster",
    "url": "https://www.linkedin.com/in/mercedes-foster-455a3b159",
    "company": "Tiendamia",
    "position": "People Partner IT & Talent Specialist",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Martin",
    "url": "https://www.linkedin.com/in/mercedesmartins",
    "company": "Neo Group",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Nogueira",
    "url": "https://www.linkedin.com/in/mercedesnogueira",
    "company": "Akkodis",
    "position": "Tech Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mercedes",
    "lastName": "Rinaldi",
    "url": "https://www.linkedin.com/in/maria-mercedes-rinaldi",
    "company": "Capitole",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mercy Antonela",
    "lastName": "Llontop Donato",
    "url": "https://www.linkedin.com/in/mercy-antonela-llontop-donato-00b269172",
    "company": "EVOL (TSnet)",
    "position": "Gerente de Reclutamiento y Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Mery",
    "lastName": "Iriarte",
    "url": "https://www.linkedin.com/in/mery-iriarte",
    "company": "ITX Corp.",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mia",
    "lastName": "Corona",
    "url": "https://www.linkedin.com/in/mia-corona-669956264",
    "company": "Taller",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Amadeo",
    "url": "https://www.linkedin.com/in/micaela-amadeo-568b831",
    "company": "Argeniss Software",
    "position": "Manager Talent Management",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Barreiro",
    "url": "https://www.linkedin.com/in/micaelabarreiro",
    "company": "MicroStrategy",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Barriga",
    "url": "https://www.linkedin.com/in/micaela-barriga-533678218",
    "company": "Cleopatra Recruiting",
    "position": "IT Business Developer | Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Campos",
    "url": "https://www.linkedin.com/in/camposmicaela",
    "company": "JPMorganChase",
    "position": "Tech Talent Acquisition Associate",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Casas",
    "url": "https://www.linkedin.com/in/micaela-casas32",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Chaves",
    "url": "https://www.linkedin.com/in/micaelachaves",
    "company": "Autónomo",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Cina",
    "url": "https://www.linkedin.com/in/micaela-cina-1bb82917b",
    "company": "EY",
    "position": "Supervising Associate Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "D'Agostino",
    "url": "https://www.linkedin.com/in/micaeladagostino",
    "company": "Accenture Argentina",
    "position": "HR Team Lead (Client: Mercado Libre)",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Didia",
    "url": "https://www.linkedin.com/in/micaela-didia-3814b141",
    "company": "Mundi",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Gaitan Cassino",
    "url": "https://www.linkedin.com/in/micaelagaitancassino",
    "company": "MinData",
    "position": "Recruiter IT | Europa & LATAM | Proceso de Selección E2E",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Garcia",
    "url": "https://www.linkedin.com/in/micaela-garcia-123410217",
    "company": "GlobalTask",
    "position": "IT Recruiter & Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Giampaoletti",
    "url": "https://www.linkedin.com/in/micaela-giampaoletti-1b0a9119",
    "company": "peoplepath",
    "position": "Technical Recruiter / Sourcer",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Golceker",
    "url": "https://www.linkedin.com/in/micaela-golceker",
    "company": "Pomelo",
    "position": "Regional Sr Talent Acquisition (LATAM)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Larroca",
    "url": "https://www.linkedin.com/in/micaela-larroca-060b51142",
    "company": "",
    "position": "Consultor de selección de personal de RR. HH.",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Latorraca",
    "url": "https://www.linkedin.com/in/micalatorraca",
    "company": "Freelance (Self employed)",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Maneiro",
    "url": "https://www.linkedin.com/in/micaelamaneiro",
    "company": "Plan-IT",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Mendez",
    "url": "https://www.linkedin.com/in/micaela-mendez-165307219",
    "company": "Acciona IT",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Mercado Medal",
    "url": "https://www.linkedin.com/in/micaela-mercado-medal-92b681107",
    "company": "Independiente",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Mercorelli",
    "url": "https://www.linkedin.com/in/micaela-mercorelli",
    "company": "Sybox",
    "position": "Talent Acquisition Analyst IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Miranda",
    "url": "https://www.linkedin.com/in/micaela-miranda-45425ab0",
    "company": "CDA Informática",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Mirás",
    "url": "https://www.linkedin.com/in/micaelamiras",
    "company": "Prediktive",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Piron",
    "url": "https://www.linkedin.com/in/micaela-piron",
    "company": "Boreal IT Solutions",
    "position": "Staffing HRBP & Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Ramanzin",
    "url": "https://www.linkedin.com/in/micaela-ramanzin",
    "company": "Accenture Argentina",
    "position": "Talent Acquisition Sr Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Roo",
    "url": "https://www.linkedin.com/in/micaelaroo",
    "company": "NTT DATA",
    "position": "Sr Talent Acquisition Advisor",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Sosa",
    "url": "https://www.linkedin.com/in/-micaela-sosa",
    "company": "Working HR",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Micaela",
    "lastName": "Tabia",
    "url": "https://www.linkedin.com/in/tabia-micaela",
    "company": "ConfiaRH",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Michell",
    "lastName": "Rivera",
    "url": "https://www.linkedin.com/in/michell-rivera-4168a6117",
    "company": "Ensitech",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Michelle",
    "lastName": "Alborés",
    "url": "https://www.linkedin.com/in/michellealbores",
    "company": "ERON International",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Michelle",
    "lastName": "Espinosa",
    "url": "https://www.linkedin.com/in/michelleespinosarecruiter",
    "company": "Wizeline",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Michelle",
    "lastName": "Gallegos",
    "url": "https://www.linkedin.com/in/michellegallegos",
    "company": "Syniti",
    "position": "Talent Acquisition Administrator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Michelle",
    "lastName": "Starkey",
    "url": "https://www.linkedin.com/in/michellekostarkey",
    "company": "2K",
    "position": "Senior Talent Acquisition Manager, Studios",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Miguel",
    "lastName": "Albornett, MBA",
    "url": "https://www.linkedin.com/in/miguel-albornett-mba-8123a674",
    "company": "Gold Media Tech",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Miguel",
    "lastName": "Nally",
    "url": "https://www.linkedin.com/in/miguel-nally-749236203",
    "company": "GeeK Consulting",
    "position": "Technical Recruiter and Talent Acquisition Advisor - Headhunting",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Miguel",
    "lastName": "Suarez",
    "url": "https://www.linkedin.com/in/miguel-suarez-295a61190",
    "company": "Miguel Suarez",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Miguel",
    "lastName": "Toledo Nuñez",
    "url": "https://www.linkedin.com/in/miguel-toledo-nu%C3%B1ez-2a43341a",
    "company": "MT Consulting LATAM",
    "position": "Consultor Experto RR.HH I Headhunter I Coach Ejecutivo I CEO MT Consulting LATAM",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Miguel",
    "lastName": "Wüst",
    "url": "https://www.linkedin.com/in/miguelwust",
    "company": "Accenture Argentina",
    "position": "Talent Acquisition Sr. Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Miguel Angel",
    "lastName": "Rantes",
    "url": "https://www.linkedin.com/in/rantesitrecruiter",
    "company": "Mindora",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Aguirre",
    "url": "https://www.linkedin.com/in/milagros-ca-aguirre",
    "company": "Kopius | Careers",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Anaya",
    "url": "https://www.linkedin.com/in/milagros-anaya-365b0382",
    "company": "Clear Tech",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Capizzano",
    "url": "https://www.linkedin.com/in/milagros-capizzano",
    "company": "ScrumLaunch",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Caucas",
    "url": "https://www.linkedin.com/in/milagros-caucas",
    "company": "Freelance | Self-Employed",
    "position": "Senior IT Recruiter & Talent Acquisition Specialist",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Fonollat",
    "url": "https://www.linkedin.com/in/milagrosfonollat",
    "company": "Develative",
    "position": "Head of People & Operations",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Miranda",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-milagros-miranda",
    "company": "GlobalTask",
    "position": "IT Recruiting Team Lead & Talent Acquisition Partner",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Pérez",
    "url": "https://www.linkedin.com/in/milagros-empleo",
    "company": "Freelance",
    "position": "Recruiter IT freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Ramirez",
    "url": "https://www.linkedin.com/in/mili-ramirez",
    "company": "Tether.io",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Rapalo",
    "url": "https://www.linkedin.com/in/milagros-rapalo-gordillo",
    "company": "Darwoft",
    "position": "Ssr. IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Shaw",
    "url": "https://www.linkedin.com/in/milagrosshaw",
    "company": "PwC Argentina",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Urlezaga",
    "url": "https://www.linkedin.com/in/milagros-urlezaga-70bb66b4",
    "company": "Mercado Libre",
    "position": "People Business Parter Manager - IT & Product",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Valdés",
    "url": "https://www.linkedin.com/in/maria-milagros-valdes",
    "company": "Taller",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Vidal",
    "url": "https://www.linkedin.com/in/milagros-noevidal",
    "company": "Cabify",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Vignolo",
    "url": "https://www.linkedin.com/in/milagros-vignolo-089510241",
    "company": "Accenture",
    "position": "Recruiting Associate",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Villaran Larrañaga",
    "url": "https://www.linkedin.com/in/milagrosvillaran",
    "company": "Codeable Labs",
    "position": "Talent Acquisition & Development Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Milagros",
    "lastName": "Youssefian",
    "url": "https://www.linkedin.com/in/miliyoussefian",
    "company": "Freelance (Self employed)",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Milagros Lucía",
    "lastName": "Paradela",
    "url": "https://www.linkedin.com/in/milagros-luc%C3%ADa-paradela",
    "company": "ExxonMobil",
    "position": "WFE Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Milena",
    "lastName": "Capuzzi",
    "url": "https://www.linkedin.com/in/milena-capuzzi-961217116",
    "company": "JPMorgan Chase & Co.",
    "position": "Senior Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Milena",
    "lastName": "Quinteros",
    "url": "https://www.linkedin.com/in/milena-quinteros-b06a01a2",
    "company": "Pitcheers",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Milena",
    "lastName": "Stelli",
    "url": "https://www.linkedin.com/in/milena-stelli",
    "company": "EY",
    "position": "Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Milena",
    "lastName": "Vazquez Soave",
    "url": "https://www.linkedin.com/in/milenavazquezsoave",
    "company": "Yumatech",
    "position": "IT Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Minerva",
    "lastName": "Mendoza Cázares",
    "url": "https://www.linkedin.com/in/minerva-mendoza-c%C3%A1zares-76797012",
    "company": "FPT Latin America",
    "position": "SAP Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Miranda",
    "lastName": "Doberti",
    "url": "https://www.linkedin.com/in/mirudoberti",
    "company": "thaia®︎",
    "position": "Co-Founder & Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Miriam",
    "lastName": "Marín",
    "url": "https://www.linkedin.com/in/miriam-mar%C3%ADn-b8bab820",
    "company": "Lenovo",
    "position": "Regional Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Miriam",
    "lastName": "Paula González",
    "url": "https://www.linkedin.com/in/miriampaulahr",
    "company": "Otovo",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mirna",
    "lastName": "Yelicich",
    "url": "https://www.linkedin.com/in/mirnayelicich",
    "company": "Hutrit",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Mohan Kumar",
    "lastName": "Chebrolu",
    "url": "https://www.linkedin.com/in/mohan-kumar-chebrolu-31a8a61a3",
    "company": "iCube Solutions LLC",
    "position": "Senior US IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mohd Abdul",
    "lastName": "Afroz Baba",
    "url": "https://www.linkedin.com/in/mohd-abdul-afroz-baba-55610b171",
    "company": "Denken Solutions, Inc.",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mohit",
    "lastName": "kr.",
    "url": "https://www.linkedin.com/in/mohit-kr-897b7a21b",
    "company": "Quantum World Technologies Inc.",
    "position": "Senior Technical Recruiter / ATL (Latam/Mexico/ US)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Monika",
    "lastName": "Saleta, Dr. BA",
    "url": "https://www.linkedin.com/in/monikasaleta",
    "company": "Monika Saleta",
    "position": "Expert IT & Technology Talent Sourcer (On Demand) - USA & Europe",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Monisha Joel",
    "lastName": "Mahesvaran",
    "url": "https://www.linkedin.com/in/monisha-joel-mahesvaran-958620214",
    "company": "SYNERGY LOG-IN SYSTEMS SDN. BHD.",
    "position": "HR & Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "MONKLAR",
    "lastName": "<>",
    "url": "https://www.linkedin.com/in/monklar",
    "company": "Monklar",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Montserrat",
    "lastName": "Garduño",
    "url": "https://www.linkedin.com/in/montserrat-gardu%C3%B1o-5bb686221",
    "company": "Codifin",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Monu kumar",
    "lastName": "Srivastava",
    "url": "https://www.linkedin.com/in/monu-kumar-srivastava-231855139",
    "company": "Self-employed",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Mora",
    "lastName": "Ugarte Perez del Cerro",
    "url": "https://www.linkedin.com/in/mora-ugarte-perez-del-cerro-1795341b8",
    "company": "Hexacta",
    "position": "Ssr IT Recruiting",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Morina",
    "lastName": "Dichi",
    "url": "https://www.linkedin.com/in/morina-dichi-20b042135",
    "company": "Dichi Consultores",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Muhammad Abdul Halim",
    "lastName": "Jafar",
    "url": "https://www.linkedin.com/in/abdhalimjafar",
    "company": "Roche",
    "position": "Talent Acquisition Partner (APAC)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "MunHong",
    "lastName": "Chin",
    "url": "https://www.linkedin.com/in/munhong-1224",
    "company": "JOB EXPERT GROUP",
    "position": "Recruitment Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Muzira",
    "lastName": "Ngah",
    "url": "https://www.linkedin.com/in/muzira-ngah-734475118",
    "company": "AaroRn Technologies Malaysia Sdn Bhd",
    "position": "IT Recruiter and Business Development",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Myroslava",
    "lastName": "Masalykina",
    "url": "https://www.linkedin.com/in/myroslava-masalykina-a08898204",
    "company": "Moravio",
    "position": "HR-recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mónica",
    "lastName": "de León",
    "url": "https://www.linkedin.com/in/mydeleon",
    "company": "SQT Argentina - HS Brands Latinoamerica y Caribe",
    "position": "Head hunter - Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Mónica",
    "lastName": "Ortíz",
    "url": "https://www.linkedin.com/in/m%C3%B3nica-ort%C3%ADz-878100218",
    "company": "Startups",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Naara",
    "lastName": "Fernandes",
    "url": "https://www.linkedin.com/in/naara-fernandes-ab1088108",
    "company": "Rock Encantech",
    "position": "Talent Acquisition & Tech Hiring Partner",
    "keywords": [
      "talent acquisition",
      "hiring"
    ]
  },
  {
    "firstName": "Nacho",
    "lastName": "Franco",
    "url": "https://www.linkedin.com/in/nachofranco-hr",
    "company": "Softensity Inc",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nadia",
    "lastName": "Aguilera",
    "url": "https://www.linkedin.com/in/naaguilera",
    "company": "CartaSur",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Nadia",
    "lastName": "Cossettini",
    "url": "https://www.linkedin.com/in/nadia-cossettini",
    "company": "BBK Group",
    "position": "Head of People & Culture",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nadia",
    "lastName": "Domínguez",
    "url": "https://www.linkedin.com/in/nadia-dom%C3%ADnguez-8a1153122",
    "company": "NTT DATA Europe & Latam",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nadia",
    "lastName": "Jurevicius Rodriguez",
    "url": "https://www.linkedin.com/in/nadia-jurevicius-rodriguez-10a8b121a",
    "company": "Who? Consultora Integral",
    "position": "IT Recruiter | Talent Acquisition Partner",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nadia",
    "lastName": "Vera",
    "url": "https://www.linkedin.com/in/nadia-vera",
    "company": "Pitcheers",
    "position": "IT Recruiter Analyst",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nadia Belen",
    "lastName": "Bustos",
    "url": "https://www.linkedin.com/in/nadia-belen-bustos-446277b5",
    "company": "Emergencias",
    "position": "Analista de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Nadin Ailen",
    "lastName": "Lerch",
    "url": "https://www.linkedin.com/in/nadin-ailen-lerch",
    "company": "Profesional independiente",
    "position": "Consultora Independiente en Atracción y Selección de Talento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Nahir",
    "lastName": "Iberra",
    "url": "https://www.linkedin.com/in/niberra",
    "company": "Pepper Advantage",
    "position": "Talent Acquisition Partner (Product & Engineering)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nahuel",
    "lastName": "Aimetta",
    "url": "https://www.linkedin.com/in/nahuel-aimetta",
    "company": "Accenture Argentina",
    "position": "Consultor de atracción y selección de talento (Client: YPF)",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Nahuel",
    "lastName": "Seguí",
    "url": "https://www.linkedin.com/in/nahuelsegui",
    "company": "Squad",
    "position": "Recruiter Partner (Contract)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Naim",
    "lastName": "Nasir",
    "url": "https://www.linkedin.com/in/naim-nasir",
    "company": "Kloudynet",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nalan",
    "lastName": "Viswa",
    "url": "https://www.linkedin.com/in/nalan-viswa-85a6a924a",
    "company": "Culminant",
    "position": "Human Resources Executive Recruitment",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Nancy",
    "lastName": "Bravo",
    "url": "https://www.linkedin.com/in/nancy-bravo",
    "company": "Corporación Crea 21",
    "position": "Recruitment and Organizational Development",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "NANCY",
    "lastName": "ESPINOZA",
    "url": "https://www.linkedin.com/in/nancyespinoza-ta-humanresources-it",
    "company": "Crossbridge Global Partners",
    "position": "Director Talent Acquisition",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nancy",
    "lastName": "Mercado",
    "url": "https://www.linkedin.com/in/nancymg",
    "company": "Novo",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Nancy",
    "lastName": "Reséndiz Reséndiz",
    "url": "https://www.linkedin.com/in/nancyresendizit",
    "company": "Weldmation de México",
    "position": "Coordinadora de Reclutamiento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Naomi",
    "lastName": "Elizondo",
    "url": "https://www.linkedin.com/in/itrecruiter-naomi-elizondo",
    "company": "RecruitingSKULL",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nara",
    "lastName": "Aguirre",
    "url": "https://www.linkedin.com/in/nara-aguirre-155464204",
    "company": "Staffy",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nargiz",
    "lastName": "Sukaeva",
    "url": "https://www.linkedin.com/in/soukaeva",
    "company": "Emerging Travel Group",
    "position": "IT & Digital Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Narine",
    "lastName": "Vardanyan",
    "url": "https://www.linkedin.com/in/narine-vardanyan-52279783",
    "company": "Deverno Inc.",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nat",
    "lastName": "Quintero",
    "url": "https://www.linkedin.com/in/nat-quintero",
    "company": "CONEXIONHR - Recruiting Company",
    "position": "Technical Recruiter - Lead / Sourcer",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Natacha",
    "lastName": "Rigoli",
    "url": "https://www.linkedin.com/in/natacha-rigoli-b38a58157",
    "company": "ArcelorMittal Acindar",
    "position": "HR Business Partner Sr",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Natacha M.",
    "lastName": "González",
    "url": "https://www.linkedin.com/in/natachagonz%C3%A1lez",
    "company": "VyA",
    "position": "Asistente. IT Recruiter en Visión y Acción",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Chiappuzzo",
    "url": "https://www.linkedin.com/in/natalia-chiappuzzo-246a40176",
    "company": "Manage Resources Recursos Humanos",
    "position": "Seleccion de personal IT y generalista",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Diotti",
    "url": "https://www.linkedin.com/in/nataliadiotti",
    "company": "Institorian",
    "position": "Recruitment Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Fedorinenko",
    "url": "https://www.linkedin.com/in/natalia-fedorinenko-239205226",
    "company": "EPAM Anywhere",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Fuks",
    "url": "https://www.linkedin.com/in/nataliafuks",
    "company": "Actividad Independiente",
    "position": "Evaluaciones Psicotécnicas. Selección de personal. Orientación vocacional y laboral. Free Lance.",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Giordano",
    "url": "https://www.linkedin.com/in/nataliagiordano",
    "company": "Profesional independiente",
    "position": "Headhunter - Executive Search - Business Psychologist",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Girolimini",
    "url": "https://www.linkedin.com/in/natalia-girolimini",
    "company": "Cocos Capital",
    "position": "HRBP & Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Graña",
    "url": "https://www.linkedin.com/in/natalia-gra%C3%B1a",
    "company": "CFOTech",
    "position": "Talent Acquisition Sr",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Gómez",
    "url": "https://www.linkedin.com/in/natalia-g%C3%B3mez-hk",
    "company": "Human Key - Consultora de RR.HH.",
    "position": "IT Recruiter & Sourcer | Talent Adquisition Freelance |",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Hilbert",
    "url": "https://www.linkedin.com/in/natalia-hilbert-",
    "company": "EY",
    "position": "Talent Attraction Recruiter - Supervising Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Lupano",
    "url": "https://www.linkedin.com/in/natalia-lupano-292372217",
    "company": "Tramas RRHH",
    "position": "Consultor de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Machuca Zárate",
    "url": "https://www.linkedin.com/in/nataliamz",
    "company": "Baufest",
    "position": "IT Global Talent Acquisition Sr| HR On-boarding & People Experience Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Martinez Murias",
    "url": "https://www.linkedin.com/in/nataliamurias",
    "company": "Mercap",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Mendez",
    "url": "https://www.linkedin.com/in/natalia-mendez-69103529",
    "company": "VyA",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Myhaliuk",
    "url": "https://www.linkedin.com/in/natalia-myhaliuk",
    "company": "Elevate Core",
    "position": "Recruiter / Talent Partner",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Nogueroles",
    "url": "https://www.linkedin.com/in/itandengrecruitment",
    "company": "Free Lance",
    "position": "Selectora/ Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Okroglic",
    "url": "https://www.linkedin.com/in/natalia-okroglic-7bb68471",
    "company": "Jetpacks!",
    "position": "Talent & People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Perez",
    "url": "https://www.linkedin.com/in/natalia-perez-06248b75",
    "company": "Miratech",
    "position": "Senior Talent Acquisition Specialist / International Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Piletska",
    "url": "https://www.linkedin.com/in/natalia-piletska-600508a0",
    "company": "Avenga",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Reinoso",
    "url": "https://www.linkedin.com/in/nreinoso",
    "company": "UNIGIS",
    "position": "Analista de Recursos Humanos y Reclutamiento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Rossi",
    "url": "https://www.linkedin.com/in/natalia-rossi-a65354156",
    "company": "KAVER-Consulting S.A.",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Skikas",
    "url": "https://www.linkedin.com/in/natalia-skikas-83428a20",
    "company": "Free-lance",
    "position": "Psicologa, Consultora en Seleccion y Empleos.",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Varela",
    "url": "https://www.linkedin.com/in/natalia-varela-a6642182",
    "company": "POSSUMUS",
    "position": "Talent Acquisition & Outsourcing Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Natalia",
    "lastName": "Vásquez",
    "url": "https://www.linkedin.com/in/nataliav%C3%A1squez",
    "company": "Truelogic Software",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Natalia Belén",
    "lastName": "Naveiro",
    "url": "https://www.linkedin.com/in/natalia-belen-naveiro",
    "company": "QuadMinds",
    "position": "People Analyst - Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Natalia Florencia",
    "lastName": "Vitali",
    "url": "https://www.linkedin.com/in/natalia-florencia-vitali-2713932a",
    "company": "Avature",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Natalia Mariel",
    "lastName": "Gonzalez Solis 🔸",
    "url": "https://www.linkedin.com/in/nataliamarielgonzalezsolis",
    "company": "Proguide",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Natalie",
    "lastName": "Yaffé Erlich",
    "url": "https://www.linkedin.com/in/natalie-yaff%C3%A9-erlich",
    "company": "mibucle",
    "position": "Recruiting Lead- Executive hunter- Ayudo a conectar el talento IT con las mejores empresas!",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nataliia",
    "lastName": "Chekh",
    "url": "https://www.linkedin.com/in/nataliia-chekh",
    "company": "toogeza",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nataliia",
    "lastName": "Derkach",
    "url": "https://www.linkedin.com/in/nataliia-derkach-610090150",
    "company": "Honeycomb Software",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nataly",
    "lastName": "Marin",
    "url": "https://www.linkedin.com/in/nataly-marin",
    "company": "RHT",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nataly",
    "lastName": "Z.",
    "url": "https://www.linkedin.com/in/nataly-z-b970806b",
    "company": "SoftServe",
    "position": "Talent Success Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Natanael",
    "lastName": "Carvalho",
    "url": "https://www.linkedin.com/in/natanaeltcarvalho",
    "company": "Ubiminds: You, International.",
    "position": "Tech Recruiter LATAM",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Natasha",
    "lastName": "kuhn",
    "url": "https://www.linkedin.com/in/natasha-kuhn-b2b1a430",
    "company": "CFOTech",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Natasha",
    "lastName": "Tarapow",
    "url": "https://www.linkedin.com/in/natashatarapow",
    "company": "Hire With Near",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Nathalie",
    "lastName": "Martel",
    "url": "https://www.linkedin.com/in/nathalie-martel-010b00212",
    "company": "EVOL (TSnet)",
    "position": "Analista Senior de Reclutamiento y Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Navin",
    "lastName": "Pandey",
    "url": "https://www.linkedin.com/in/navin-pandey-12a39611a",
    "company": "US Tech Solutions",
    "position": "Team Lead - Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nazareno",
    "lastName": "Machuca",
    "url": "https://www.linkedin.com/in/nazarenomachuca",
    "company": "BA TECHNOLOGIES- IT solutions/Staff Augmentation",
    "position": "Técnico de selección de personal técnico",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Neha",
    "lastName": "Ghosh",
    "url": "https://www.linkedin.com/in/neha-ghosh-7651b2191",
    "company": "Flexiple",
    "position": "Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nehemarys",
    "lastName": "E.",
    "url": "https://www.linkedin.com/in/nehemarysescalonar",
    "company": "InvaRH Consultores",
    "position": "Técnico de selección de personal informático y generalista",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Nela",
    "lastName": "Salvañá",
    "url": "https://www.linkedin.com/in/nelasalvana",
    "company": "Aditi Consulting",
    "position": "Client Services Manager & Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nerina",
    "lastName": "Castro",
    "url": "https://www.linkedin.com/in/nerina-castro-9259a0224",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nerina",
    "lastName": "La Torre",
    "url": "https://www.linkedin.com/in/nerina-la-torre",
    "company": "So Shall We",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Neylin",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/neylin-gonzalez-95ab70102",
    "company": "Epidata",
    "position": "Recruiter IT /Sourcer Specialist Senior",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Nico",
    "lastName": "Franchini",
    "url": "https://www.linkedin.com/in/nicofranchini",
    "company": "Lithium Software",
    "position": "Head of Talent",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nicol",
    "lastName": "Minaya Alberca",
    "url": "https://www.linkedin.com/in/nicol-m-186a48228",
    "company": "Softtek",
    "position": "IT Talent Acquisition Assistant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Arcusin",
    "url": "https://www.linkedin.com/in/nicolasarcusin",
    "company": "Graphite",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Barrirero",
    "url": "https://www.linkedin.com/in/nicolas-barrirero-0347a1227",
    "company": "Pearster Global",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Cabases",
    "url": "https://www.linkedin.com/in/nicolascabases",
    "company": "CFOTech IT Global Services",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Durrieu",
    "url": "https://www.linkedin.com/in/itrecruiter-nicolas-durrieu",
    "company": "Pitcheers",
    "position": "Connector en Pitcheers - IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Grinberg",
    "url": "https://www.linkedin.com/in/nicolas-grinberg-cofounder-headhunter-ipsumhr",
    "company": "IpsumHR",
    "position": "Co Founder & Global Headhunter Expert",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Hill",
    "url": "https://www.linkedin.com/in/psynicolashill",
    "company": "axity",
    "position": "Senior Talent Acquisition Specialist / HR Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Maekawa",
    "url": "https://www.linkedin.com/in/nicolas-maekawa-47a4a1b5",
    "company": "Dicsys",
    "position": "Technical Recruiter - IT Recruiter - Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Mosto",
    "url": "https://www.linkedin.com/in/nicolas-mosto",
    "company": "Netrix Global",
    "position": "Ssr. Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Peyret",
    "url": "https://www.linkedin.com/in/nicolas-peyret",
    "company": "Newfire Global Partners",
    "position": "Recruitment Manager for Latam & US",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nicolas",
    "lastName": "Villalba",
    "url": "https://www.linkedin.com/in/nicolas-villalba-958a5b46",
    "company": "CUBI Human Resource \"Capacidad de Conectar\"",
    "position": "Back Office- Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicole",
    "lastName": "Naz",
    "url": "https://www.linkedin.com/in/nicole-naz-28067010b",
    "company": "Strata Analytics Group",
    "position": "HRBP & Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nicole",
    "lastName": "Sonsino",
    "url": "https://www.linkedin.com/in/nicolesonsino",
    "company": "Fulcrum Digital Inc",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nicoleta",
    "lastName": "Ivanova",
    "url": "https://www.linkedin.com/in/nicoleta-ivanova",
    "company": "Atos",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicoll",
    "lastName": "Oviedo",
    "url": "https://www.linkedin.com/in/nicoll-oviedo",
    "company": "Capgemini Engineering",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolle",
    "lastName": "García Fleury",
    "url": "https://www.linkedin.com/in/nicolle-garc%C3%ADa-fleury-bb8001219",
    "company": "Arroyo is becoming INSPYR Global Solutions",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "Coutinho",
    "url": "https://www.linkedin.com/in/ncoutinho2",
    "company": "Prediktive",
    "position": "IT Recruiter | Talent Sourcing Analyst",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "D'angelo",
    "url": "https://www.linkedin.com/in/nicol%C3%A1s-d-angelo-baa808201",
    "company": "PhishFort",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "Díaz",
    "url": "https://www.linkedin.com/in/nicolasdiazhr",
    "company": "Cervecería y Maltería Quilmes",
    "position": "HRBP Leader",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/nicol%C3%A1s-gonzalez-3b581210b",
    "company": "Renaiss",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "Lell",
    "url": "https://www.linkedin.com/in/nicolas-lell-psi",
    "company": "Accenture Argentina",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "Rosso",
    "url": "https://www.linkedin.com/in/nicolasrosso-",
    "company": "Link&IT Consulting Services",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "Salinas",
    "url": "https://www.linkedin.com/in/nicolas-salinas-",
    "company": "CDA Informática",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "Salinas",
    "url": "https://www.linkedin.com/in/nicolassalinascda",
    "company": "CDA Informática",
    "position": "Sr Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "Sotelo",
    "url": "https://www.linkedin.com/in/nicol%C3%A1s-sotelo-human-resources",
    "company": "Keystone Fire Safety LTD",
    "position": "HR & Project Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nicolás",
    "lastName": "Szewkies",
    "url": "https://www.linkedin.com/in/nicol%C3%A1s-szewkies-8b822493",
    "company": "Properix",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nicolás Alejandro",
    "lastName": "Wayar",
    "url": "https://www.linkedin.com/in/nicol%C3%A1s-alejandro-wayar-9650001b8",
    "company": "Carla Paola Vera Albornoz",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nina",
    "lastName": "Geißler",
    "url": "https://www.linkedin.com/in/nina-gei%C3%9Fler-065b14103",
    "company": "Ralph",
    "position": "Lead Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nisa",
    "lastName": "Samudin",
    "url": "https://www.linkedin.com/in/nisa-samudin-9300381b3",
    "company": "Sutherland",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Noe",
    "lastName": "Guercetti",
    "url": "https://www.linkedin.com/in/noeliaguercetti",
    "company": "Rooftop",
    "position": "HIring Expert",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Noel",
    "lastName": "Navaridas",
    "url": "https://www.linkedin.com/in/noel-navaridas-638954b0",
    "company": "RedCloud",
    "position": "Regional People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Noeli",
    "lastName": "Gomez",
    "url": "https://www.linkedin.com/in/noeli-gomez-6281b0154",
    "company": "GlobalLogic Latinoamérica",
    "position": "Senior Tech Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Balzardi",
    "url": "https://www.linkedin.com/in/noeliabalzardi",
    "company": "ConfiaRH",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Barrera González",
    "url": "https://www.linkedin.com/in/noeliabarreragonz%C3%A1lez",
    "company": "Kibernum",
    "position": "Senior Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Burgos",
    "url": "https://www.linkedin.com/in/noeliaburgos",
    "company": "MetLife Argentina",
    "position": "Sr Regional Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Landeira",
    "url": "https://www.linkedin.com/in/noelia-landeira-03a6b1bb",
    "company": "Consultora ConfiaRH",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Mendoza",
    "url": "https://www.linkedin.com/in/noelia-mendoza-a0646059",
    "company": "VMN+",
    "position": "Jr Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Osorio",
    "url": "https://www.linkedin.com/in/osorionoelia",
    "company": "Yumatech",
    "position": "IT Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Perez Reyzabal",
    "url": "https://www.linkedin.com/in/noelia-perez-reyzabal-39bb91245",
    "company": "MinData",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Peréz",
    "url": "https://www.linkedin.com/in/noelia-per%C3%A9z-73957ab6",
    "company": "Selectium",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Roura",
    "url": "https://www.linkedin.com/in/rouranoelia",
    "company": "deRecruiters.com",
    "position": "Sr. Tech Recruiter | HRBP",
    "keywords": [
      "hrbp/business partner",
      "recruiter"
    ]
  },
  {
    "firstName": "Noelia",
    "lastName": "Vidaurre",
    "url": "https://www.linkedin.com/in/noelia-vidaurre-9a4799a9",
    "company": "NTT DATA Europe & LATAM",
    "position": "IT Recruiting Analyst | IT Talent Acquisition Specialist",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Noelia G.",
    "lastName": "DiLeo",
    "url": "https://www.linkedin.com/in/noelia-g-dileo-910546194",
    "company": "CONEXIONHR",
    "position": "IT Recruiter Ssr.",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nohemi",
    "lastName": "Pérez Flores",
    "url": "https://www.linkedin.com/in/nohemiperez88",
    "company": "XBP Global",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Noily",
    "lastName": "Madriz A.",
    "url": "https://www.linkedin.com/in/noily-madriz-a-450158a5",
    "company": "Quid Solutions",
    "position": "Talent Adquisition Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Nora",
    "lastName": "Mendaña",
    "url": "https://www.linkedin.com/in/noram1",
    "company": "Progres S.A.",
    "position": "Coordinadora Area de seleccion IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Noran",
    "lastName": "Ashraf",
    "url": "https://www.linkedin.com/in/noran-ashraf-326ab8166",
    "company": "AZM Squad",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Norasyrani",
    "lastName": "Shami",
    "url": "https://www.linkedin.com/in/norasyrani-shami-959464230",
    "company": "AMK Group",
    "position": "Talent Acquisition Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Norida",
    "lastName": "Dimate Roa",
    "url": "https://www.linkedin.com/in/norida-dimate-roa-345196249",
    "company": "Think Us - It Staff Augmentation",
    "position": "Analista de selección de personal IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Norma",
    "lastName": "Diaz Alvarez",
    "url": "https://www.linkedin.com/in/normadiazalvarez",
    "company": "Reswoy",
    "position": "Senior Tech & HR Recruiter | Consultor/a de Gestión de Talento",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Norul Fazilah",
    "lastName": "Zainal",
    "url": "https://www.linkedin.com/in/norul-fazilah-zainal-630a89243",
    "company": "Posable.ai",
    "position": "Talent Acquisition Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Noé",
    "lastName": "Álvarez M",
    "url": "https://www.linkedin.com/in/no%C3%A9-%C3%A1lvarez-m-1513731a3",
    "company": "Alvea Soluciones Tecnológicas",
    "position": "IT Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Nur",
    "lastName": "Arissa",
    "url": "https://www.linkedin.com/in/arissa-azhar",
    "company": "Ethereal Digital",
    "position": "Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nur Hazwani",
    "lastName": "Harun",
    "url": "https://www.linkedin.com/in/nurhazwaniharun",
    "company": "cbs Corporate Business Solutions",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Nurfarhana",
    "lastName": "Abdul Ghani",
    "url": "https://www.linkedin.com/in/nurfarhana-a-4ba0ba171",
    "company": "TechTiera Corporation",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Nuryib Cecilia",
    "lastName": "Gómez",
    "url": "https://www.linkedin.com/in/nuryibgomez",
    "company": "Stellantis South America",
    "position": "Senior Regional Talent Acquisition South América",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Octavio",
    "lastName": "D Real",
    "url": "https://www.linkedin.com/in/octavio-d-98948069",
    "company": "Eden Capital Careers",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Oktavia",
    "lastName": "Merazga",
    "url": "https://www.linkedin.com/in/oktaviamerazga",
    "company": "Skydropx",
    "position": "Head of Talent",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Olga",
    "lastName": "Babaeva",
    "url": "https://www.linkedin.com/in/olga-babaeva",
    "company": "dLocal",
    "position": "Senior IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Olga",
    "lastName": "Misincsuk",
    "url": "https://www.linkedin.com/in/olga-misincsuk-4b4766b0",
    "company": "ZangaBee",
    "position": "Technical Recruiter and Financial Administrator",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Olga",
    "lastName": "Titova",
    "url": "https://www.linkedin.com/in/olga-titova-26a672a7",
    "company": "NCube Ltd - software development outsourcing and outstaffing services",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Olha",
    "lastName": "Moroz",
    "url": "https://www.linkedin.com/in/oolha-moroz",
    "company": "GlobalLogic",
    "position": "Middle Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Olha",
    "lastName": "Usatiuk",
    "url": "https://www.linkedin.com/in/olha-usatiuk-5467a724a",
    "company": "TurnKey Tech Staffing",
    "position": "Technical Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Olha",
    "lastName": "Vladyslavivna",
    "url": "https://www.linkedin.com/in/olha-rec7",
    "company": "Svitla Systems, Inc.",
    "position": "Recruiting Sourcer",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Olivia",
    "lastName": "Nieto",
    "url": "https://www.linkedin.com/in/olivianieto",
    "company": "deRecruiters",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Om",
    "lastName": "Prakash •",
    "url": "https://www.linkedin.com/in/omprakash23892",
    "company": "Acnovate Corporation",
    "position": "Senior IT Recruiter - US, Canada , LATAM & India.",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Omaira",
    "lastName": "Barraez",
    "url": "https://www.linkedin.com/in/omairabarraez",
    "company": "HuntingIT",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Omar",
    "lastName": "Ochoa",
    "url": "https://www.linkedin.com/in/omar-ochoa-028094162",
    "company": "ITPS One",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Oreana",
    "lastName": "Febres Leyva",
    "url": "https://www.linkedin.com/in/oreanafebres",
    "company": "Staffy",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Oriana",
    "lastName": "Faijos",
    "url": "https://www.linkedin.com/in/orianafaijosrecruiter",
    "company": "Techunting",
    "position": "Technical Sourcer | IT Talent Acquisition",
    "keywords": [
      "sourcer",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Oriana",
    "lastName": "Garziera",
    "url": "https://www.linkedin.com/in/oriana-garziera-87531026a",
    "company": "Kenility",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Oriana",
    "lastName": "Ortega",
    "url": "https://www.linkedin.com/in/orianaortegavilla",
    "company": "Félix",
    "position": "Technical Recruitment Associate",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Oriana",
    "lastName": "Puente",
    "url": "https://www.linkedin.com/in/oriana-puente-3a3029107",
    "company": "Nexton",
    "position": "Principal Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Oriana",
    "lastName": "Rodríguez",
    "url": "https://www.linkedin.com/in/oriana-rodriguez-tas",
    "company": "ZEROGATE",
    "position": "Technical Recruiter (Talent Acquisition Specialist)",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Orlando",
    "lastName": "González",
    "url": "https://www.linkedin.com/in/orlando-gonz%C3%A1lez-582050125",
    "company": "Care Lumen",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Orly",
    "lastName": "Zaidenknop",
    "url": "https://www.linkedin.com/in/orly-zaidenknop",
    "company": "Veritran",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ornela",
    "lastName": "De Maio",
    "url": "https://www.linkedin.com/in/ornelademaio",
    "company": "We Global Talent",
    "position": "Sr. Talent Acquisition | Recruiter IT",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ornella",
    "lastName": "Di Siervo",
    "url": "https://www.linkedin.com/in/ornellads",
    "company": "Human Match",
    "position": "Co-founder & Fractional Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ornella",
    "lastName": "Toledo",
    "url": "https://www.linkedin.com/in/ornella-toledo-",
    "company": "Devlights - Argentina",
    "position": "Tech Recruiter - Human Resources Assistant",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Oscar",
    "lastName": "Fuentes Romero",
    "url": "https://www.linkedin.com/in/oscarfuentesromero",
    "company": "Option",
    "position": "Senior IT Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Oscar",
    "lastName": "Trujillo",
    "url": "https://www.linkedin.com/in/oscar-trujillo-42174816",
    "company": "Freelancer- Self employed",
    "position": "Freelance Recruiter (on-demand)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Oscar D",
    "lastName": "Hinestroza",
    "url": "https://www.linkedin.com/in/oscar-d-hinestroza-163532222",
    "company": "Tech First",
    "position": "Delivery Lead | LATAM Talent Delivery & Recruiting Management",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Oscar Damian",
    "lastName": "Bernal Sanchez",
    "url": "https://www.linkedin.com/in/oscar-damian-bernal-sanchez-04a17961",
    "company": "Stefanini LATAM",
    "position": "Talent Acquisition Manager LATAM",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Bellini",
    "url": "https://www.linkedin.com/in/pablo-bellini-07278a222",
    "company": "Appzlogic",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Bellini",
    "url": "https://www.linkedin.com/in/pablo-bellini-047143112",
    "company": "Paired",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Benulich",
    "url": "https://www.linkedin.com/in/pablobenulich",
    "company": "Hunteando",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Galván Leyes",
    "url": "https://www.linkedin.com/in/pablo-galv%C3%A1n-leyes-1a8464192",
    "company": "HR Oasis Consultora RRHH",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Llama",
    "url": "https://www.linkedin.com/in/pablo-llama-7bb6ba19b",
    "company": "Agnostic | a cognitive company",
    "position": "IT Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Lopez",
    "url": "https://www.linkedin.com/in/pablolopezrh",
    "company": "Ulead",
    "position": "Consultor de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Palma",
    "url": "https://www.linkedin.com/in/pablo-palma-rh",
    "company": "Digbang",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Queipo",
    "url": "https://www.linkedin.com/in/pabloqueipo",
    "company": "GeeK Consulting",
    "position": "Senior Technical Recruiter - Headhunting",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Resek",
    "url": "https://www.linkedin.com/in/pablo-resek-1712b9118",
    "company": "ExxonMobil",
    "position": "Regional Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Rodriguez Sayas",
    "url": "https://www.linkedin.com/in/pablo-rodriguez-sayas-",
    "company": "Accenture",
    "position": "Recruiter (Client MercadoLibre) Shipping",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Vedoy",
    "url": "https://www.linkedin.com/in/pablo-vedoy-b03a8093",
    "company": "SOMOS Recursos Humanos",
    "position": "Head of Human Resources",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Pablo",
    "lastName": "Yelpo",
    "url": "https://www.linkedin.com/in/pablo-yelpo",
    "company": "Mission Resourcing LLC",
    "position": "Technical Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Pablo E.",
    "lastName": "Rovito - MBA",
    "url": "https://www.linkedin.com/in/pablorovito",
    "company": "iTechCareer-RD Latam Search & Selection",
    "position": "Sr Talent Director - INNOVATIVE IT & OT RECRUITING in https://rd.itechcareer.com/",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Pal",
    "lastName": "Toth",
    "url": "https://www.linkedin.com/in/paltoth",
    "company": "Wise",
    "position": "Senior Tecnical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paloma",
    "lastName": "Bidonde Viglione",
    "url": "https://www.linkedin.com/in/palomabidondeviglione",
    "company": "DinoCloud Latam",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paloma",
    "lastName": "Soto",
    "url": "https://www.linkedin.com/in/palomasotoregalado",
    "company": "NTT DATA Europe & LATAM",
    "position": "IT Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pamela",
    "lastName": "Ballarati",
    "url": "https://www.linkedin.com/in/pamela-ballarati-911aa549",
    "company": "CRAFTLabs",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pamela",
    "lastName": "Chécolis",
    "url": "https://www.linkedin.com/in/pamela-ch%C3%A9colis",
    "company": "Brazoderecho",
    "position": "Talent Acquisition | Proyecto Temporal",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pamela",
    "lastName": "Navarro",
    "url": "https://www.linkedin.com/in/navarropamela",
    "company": "PS Consultora de Recursos Humanos",
    "position": "Human Resources Consultant - Freelancer Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pamela",
    "lastName": "Roberts",
    "url": "https://www.linkedin.com/in/pamela-roberts-4696ab231",
    "company": "Recruiter Partner",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pamela",
    "lastName": "Yabra",
    "url": "https://www.linkedin.com/in/pamela-yabra",
    "company": "CTL Information Technology",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pamela Soledad",
    "lastName": "Ruschioni",
    "url": "https://www.linkedin.com/in/pamela-soledad-ruschioni-33047539",
    "company": "Staffy",
    "position": "Sr IT Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paola",
    "lastName": "Bustos Garcia",
    "url": "https://www.linkedin.com/in/paola-bustos-garcia-839807b6",
    "company": "Unosquare",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Paola",
    "lastName": "Cóndor Andrade",
    "url": "https://www.linkedin.com/in/paola-condor",
    "company": "Jobsity",
    "position": "Recruitment Manager & Senior Talent Acquisition Specialist",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paola",
    "lastName": "Flores Alves (she/her)",
    "url": "https://www.linkedin.com/in/paola-flores-alves",
    "company": "Wärtsilä",
    "position": "Talent Acquisition Partner - North America",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Paola",
    "lastName": "Gesé",
    "url": "https://www.linkedin.com/in/paola-ges%C3%A9-6861a265",
    "company": "Nimble.LA Group",
    "position": "Talent Acquisition Team Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paola",
    "lastName": "Martinez Sevilla",
    "url": "https://www.linkedin.com/in/paolamtzsevilla",
    "company": "K2 Partnering Solutions",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paola",
    "lastName": "Velazquez",
    "url": "https://www.linkedin.com/in/pavela94",
    "company": "Infotree Global Solutions",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paola Andrea",
    "lastName": "T",
    "url": "https://www.linkedin.com/in/10777371052386108215265411279",
    "company": "PhiDimensions, Inc",
    "position": "Talent Acquisition Lead & HR Specialist",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paola Jimena",
    "lastName": "Losada",
    "url": "https://www.linkedin.com/in/paola-jimena-losada-7ba3521b",
    "company": "NIZTECH",
    "position": "Head of Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Patricia",
    "lastName": "Bugallo",
    "url": "https://www.linkedin.com/in/patricia-bugallo-04917412",
    "company": "Salution HR",
    "position": "Regional Talent Acquisition Expert IT | Consultora HR",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Patricia",
    "lastName": "Farias",
    "url": "https://www.linkedin.com/in/patricia-farias-hercules",
    "company": "AgileEngine",
    "position": "VP of Recruiting",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Patricia",
    "lastName": "Frías",
    "url": "https://www.linkedin.com/in/patriciafriasit",
    "company": "ECOSISTEMAS",
    "position": "Senior Talent Acquisition Specialist IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Patricia",
    "lastName": "Guerrero",
    "url": "https://www.linkedin.com/in/patricia-guerrero-8ab491223",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Patricia",
    "lastName": "Lantin",
    "url": "https://www.linkedin.com/in/patricia-lantin-347bbb1b6",
    "company": "Trafilea Group",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Patricia",
    "lastName": "Tineo",
    "url": "https://www.linkedin.com/in/patriciatineo",
    "company": "TIVIT LATAM",
    "position": "IT Talent Acquisition Specialist LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Patricia",
    "lastName": "Ventura Vázquez",
    "url": "https://www.linkedin.com/in/patricia-ventura-v%C3%A1zquez-90920b45",
    "company": "Profesional independiente",
    "position": "Especialista en reclutamiento y selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Patricia",
    "lastName": "Vitale",
    "url": "https://www.linkedin.com/in/patricia-vitale-04726714",
    "company": "Owner en PV HR Consultant",
    "position": "Headhunter- IT Recruiter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Patricio",
    "lastName": "Severio",
    "url": "https://www.linkedin.com/in/patricio-severio",
    "company": "Mission.dev",
    "position": "Sr. Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Patrícia",
    "lastName": "Barbosa",
    "url": "https://www.linkedin.com/in/patriciasilvabarbosa",
    "company": "Strider",
    "position": "LATAM IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Patrícia",
    "lastName": "Gonçalves",
    "url": "https://www.linkedin.com/in/patr%C3%ADcia-gon%C3%A7alves-529a1583",
    "company": "SendSpeed",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Patsy",
    "lastName": "Flores",
    "url": "https://www.linkedin.com/in/patsyflores",
    "company": "WisdomTree",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Patty",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/patty-fernandez-5298b7101",
    "company": "myTOD",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Paty",
    "lastName": "López",
    "url": "https://www.linkedin.com/in/patyloal",
    "company": "GVW Group",
    "position": "Executive Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paul",
    "lastName": "Wildfeir",
    "url": "https://www.linkedin.com/in/paulwildfeir-techandsalesecruiter",
    "company": "CBRE",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Altamirano",
    "url": "https://www.linkedin.com/in/paula-altamirano-532233158",
    "company": "Tarmac.IO",
    "position": "Senior IT Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Anselmo",
    "url": "https://www.linkedin.com/in/paula-a-8509b935",
    "company": "iCIMS",
    "position": "Sr. Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Barrionuevo Tomedi",
    "url": "https://www.linkedin.com/in/ptomedi",
    "company": "Builders",
    "position": "Head of Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Beltran",
    "url": "https://www.linkedin.com/in/paulabeltranc",
    "company": "K2 Partnering Solutions",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Bertinatto",
    "url": "https://www.linkedin.com/in/paulabertinatto",
    "company": "DataArt",
    "position": "Sr IT Recruiter & HR",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Bosio",
    "url": "https://www.linkedin.com/in/paulabosio",
    "company": "Salesforce",
    "position": "Sr. Sales Recruiter - South EMEA",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "C.",
    "url": "https://www.linkedin.com/in/paula-c-31441a54",
    "company": "2Brains",
    "position": "People Acquisition Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Cefarelli",
    "url": "https://www.linkedin.com/in/paula-cefarelli-6b958a48",
    "company": "Sumarte IT",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Chuk",
    "url": "https://www.linkedin.com/in/paulachuk",
    "company": "Accenture",
    "position": "North America Recruiting Senior Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Corvino",
    "url": "https://www.linkedin.com/in/paulacorvino",
    "company": "We Global Talent",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Dainese",
    "url": "https://www.linkedin.com/in/paula-dainese-26277334",
    "company": "Asoko Professional",
    "position": "Consultora de Reclutamiento Generalista & IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Damill",
    "url": "https://www.linkedin.com/in/pauladamillrecruitment",
    "company": "KellyOCG",
    "position": "Sr Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Devincenzi",
    "url": "https://www.linkedin.com/in/paula-devincenzi-38a9a78b",
    "company": "Suris Code - Software Factory",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/paula-diaz-995239222",
    "company": "Freelance",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Dábalos",
    "url": "https://www.linkedin.com/in/licpaudabalos",
    "company": "Hiring",
    "position": "Recruiter/ Headhunter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Garcia",
    "url": "https://www.linkedin.com/in/garciapaula1",
    "company": "Grupo Gestión",
    "position": "Analista de Selección y Capacitación en Carrefour",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Giose",
    "url": "https://www.linkedin.com/in/paula-giose",
    "company": "DataArt",
    "position": "Recruitment Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Giovan",
    "url": "https://www.linkedin.com/in/paula-giovan-2864b1173",
    "company": "Glofy",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/paula-gonzalez-51b85a1b2",
    "company": "FRICE Consulting",
    "position": "Reclutamiento IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Guiñazú",
    "url": "https://www.linkedin.com/in/paula-gui%C3%B1az%C3%BA-3887b0b9",
    "company": "ScaleIT Consulting",
    "position": "Co-Founder | Tech Recruitment & Talent Strategy",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Marques",
    "url": "https://www.linkedin.com/in/paulamarquesloureiro",
    "company": "Accenture",
    "position": "Recruiting Team Lead - Latam",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Moniz",
    "url": "https://www.linkedin.com/in/paula-moniz-talent-acquisition",
    "company": "Satellite Talent",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Monsegur",
    "url": "https://www.linkedin.com/in/paulamonsegur",
    "company": "Belong",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Pallo",
    "url": "https://www.linkedin.com/in/paulapallo",
    "company": "Perception Group - Aleph - Horecacity",
    "position": "Consultor en Seleccion de Profesionales IT - RRHH - Talento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Passarelli",
    "url": "https://www.linkedin.com/in/paula-passarelli",
    "company": "Gi Group",
    "position": "Recruiter Ssr",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Perez Chirife",
    "url": "https://www.linkedin.com/in/paulaperezchirife",
    "company": "Latcom | WorldcomOOH",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Perticone",
    "url": "https://www.linkedin.com/in/paula-perticone",
    "company": "BECHSUD ARG - Tecnología de lubricación",
    "position": "HR Manager - Bechsud Argentina - Bechsud do Brasil",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Richard",
    "url": "https://www.linkedin.com/in/paula-richard",
    "company": "Len & Nyle",
    "position": "Human Resources Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/paula-rodriguez-organizational-consulting",
    "company": "Paula Rodriguez",
    "position": "Consultora de RRHH | Talent Acquisition & People Ops (Remoto)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Paula",
    "lastName": "Álvarez",
    "url": "https://www.linkedin.com/in/paula-%C3%A1lvarez-2001831ba",
    "company": "Tadatic",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paula Soledad",
    "lastName": "Stany",
    "url": "https://www.linkedin.com/in/paulasoledadstany",
    "company": "PwC Acceleration Centers",
    "position": "Recruitment Services & Onboarding - Specialist 5",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Paula Yanil",
    "lastName": "Correa",
    "url": "https://www.linkedin.com/in/paula-yanil-correa-93a805116",
    "company": "Proxify",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pauli",
    "lastName": "P.",
    "url": "https://www.linkedin.com/in/paulipe",
    "company": "Now it talent",
    "position": "Senior Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Paulina",
    "lastName": "Leiva Quezada",
    "url": "https://www.linkedin.com/in/paulina-leiva-quezada-845640145",
    "company": "ACL Tecnología",
    "position": "Gestora de Canales de Reclutamiento y Selección TI",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Paulina",
    "lastName": "Mendoza",
    "url": "https://www.linkedin.com/in/paulinamendoza8",
    "company": "Stefanini Group",
    "position": "HeadHunter | Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "headhunter"
    ]
  },
  {
    "firstName": "Paulo",
    "lastName": "Muniz",
    "url": "https://www.linkedin.com/in/paulormuniz",
    "company": "Kake",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Paulo",
    "lastName": "Pelegrini",
    "url": "https://www.linkedin.com/in/itrecruiter-paulo-pelegrini",
    "company": "RecruitingSKULL",
    "position": "Tech Recruiter | Talent Manager",
    "keywords": [
      "people/talent leadership",
      "recruiter"
    ]
  },
  {
    "firstName": "Pauly",
    "lastName": "Garita",
    "url": "https://www.linkedin.com/in/pauly-garita-11706059",
    "company": "Mission.dev",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pavan",
    "lastName": "Kumar",
    "url": "https://www.linkedin.com/in/pavan-kumar-104522223",
    "company": "Avows IT Solutions Pvt Ltd(Avows Technologies Sdn Bhd, Malaysia)",
    "position": "Senior Executive Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pavel",
    "lastName": "Melnicov",
    "url": "https://www.linkedin.com/in/pavel-melnicov-41146b145",
    "company": "Index",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pedro",
    "lastName": "Belardo",
    "url": "https://www.linkedin.com/in/pedro-belardo-b2a25a226",
    "company": "Resorsi",
    "position": "Lead Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pedro",
    "lastName": "Zuvic",
    "url": "https://www.linkedin.com/in/petezuvicv",
    "company": "testRigor",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Penélope",
    "lastName": "Mauro",
    "url": "https://www.linkedin.com/in/penelopemauro",
    "company": "Finvivir",
    "position": "Digital Operations Manager - HRBP Station (Tecnología, Producto y Analítica) @Finvivir LatAm",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "PILAR",
    "lastName": "BALAGUER BUSTOS",
    "url": "https://www.linkedin.com/in/pilar-balaguer-bustos",
    "company": "Capgemini",
    "position": "Human Resources Lead & HRBP",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Pilar",
    "lastName": "Becerra",
    "url": "https://www.linkedin.com/in/mar%C3%ADapilarbecerraferrer",
    "company": "Hendercross",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pilar",
    "lastName": "Camacho",
    "url": "https://www.linkedin.com/in/pilar-camacho",
    "company": "Wildlife Studios",
    "position": "Talent Management Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Pilar",
    "lastName": "Domínguez",
    "url": "https://www.linkedin.com/in/dominguezpilar",
    "company": "Freelance",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pilar",
    "lastName": "Lozano",
    "url": "https://www.linkedin.com/in/pilar-lozano-77520a226",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pilar",
    "lastName": "Martín López",
    "url": "https://www.linkedin.com/in/pilar-mart%C3%ADn-l%C3%B3pez-610225129",
    "company": "NTT DATA Europe & LATAM",
    "position": "Talent Acquisition Senior Analyst/IT Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pilar",
    "lastName": "Molina",
    "url": "https://www.linkedin.com/in/pilar-molina",
    "company": "Avenga",
    "position": "People Business Partner & Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Pilar",
    "lastName": "Muñoz Cordero",
    "url": "https://www.linkedin.com/in/pilar-mu%C3%B1oz-cordero-188617233",
    "company": "Iwantsales",
    "position": "Executive Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pilar",
    "lastName": "Vega Cigoj",
    "url": "https://www.linkedin.com/in/pilar-vega-cigoj-b8b34a138",
    "company": "Aditi Consulting",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Pintu",
    "lastName": "Mayengbam",
    "url": "https://www.linkedin.com/in/pintumayengbam",
    "company": "Netcracker Technology",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Polina",
    "lastName": "Filimonova",
    "url": "https://www.linkedin.com/in/polinafilimonova",
    "company": "OrganicApps",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Pooja",
    "lastName": "Ahi",
    "url": "https://www.linkedin.com/in/pooja-ahi-48b36935",
    "company": "Hilti Asia IT Services",
    "position": "Talent Acquisition Business Partner",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Pradeep",
    "lastName": "Srinivasan",
    "url": "https://www.linkedin.com/in/pradeep-srinivasan-a8a79936",
    "company": "HTC GLOBAL SERVICES PRIVAT LIMITED",
    "position": "Sr APAC Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Prasath",
    "lastName": "Mohan",
    "url": "https://www.linkedin.com/in/prasath-mohan-393015b6",
    "company": "Troogue.ai",
    "position": "Sr Talent Acquisition Specialist/Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Prashant",
    "lastName": "Airan",
    "url": "https://www.linkedin.com/in/prashant-airan-955bb7101",
    "company": "Techgene Solutions",
    "position": "Sr. US IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Pratiksha",
    "lastName": "Hatkar",
    "url": "https://www.linkedin.com/in/pratiksha-hatkar-8aa70361",
    "company": "New York Technology Partners",
    "position": "US IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Preeti",
    "lastName": "Anand",
    "url": "https://www.linkedin.com/in/preeti-anand-1000000000",
    "company": "Tech Mahindra",
    "position": "Senior Executive Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Prema",
    "lastName": "Viera Rodriguez",
    "url": "https://www.linkedin.com/in/prema-viera-rodriguez-6280205b",
    "company": "Chevron",
    "position": "Team Lead - People Solutions",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Prince",
    "lastName": "Nkutha",
    "url": "https://www.linkedin.com/in/prince-nkutha-b87647251",
    "company": "Hutech International Group",
    "position": "Technical Talent Acquisition Specialist/Account Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Priscila",
    "lastName": "Costa",
    "url": "https://www.linkedin.com/in/priscila-costa-b8964b62",
    "company": "Gigster",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Priscila",
    "lastName": "Morán",
    "url": "https://www.linkedin.com/in/priscila-mor%C3%A1n-781929238",
    "company": "AR Consultores",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "priya",
    "lastName": "bhargava",
    "url": "https://www.linkedin.com/in/priya-bhargava-0b60ab73",
    "company": "CosMicIT",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ps. Gabriela",
    "lastName": "Genz",
    "url": "https://www.linkedin.com/in/gabrielagenz",
    "company": "Gabriela Genz Consultora",
    "position": "Talent Acquisition Specialist - IT Recruiter - Especialista en búsqueda y selección de perfiles",
    "keywords": [
      "recruiter",
      "talent acquisition",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Purnima",
    "lastName": "Varshney",
    "url": "https://www.linkedin.com/in/purnima-varshney-76a70937",
    "company": "Mango Global Technologies Co.",
    "position": "Talent Acquistion Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Quick Talent",
    "lastName": "IT",
    "url": "https://www.linkedin.com/in/quick-talent-it-77a7b4233",
    "company": "Quick Talent",
    "position": "Profesionales en Selección de Personal IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Rachel",
    "lastName": "Güemez",
    "url": "https://www.linkedin.com/in/rachelgh",
    "company": "VAREMG",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rafael",
    "lastName": "Greinert",
    "url": "https://www.linkedin.com/in/rafaelcgreinert",
    "company": "GoGloby",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rafael",
    "lastName": "Hércules",
    "url": "https://www.linkedin.com/in/rafahercules",
    "company": "Mathison Projects Inc",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rafael",
    "lastName": "Morfes",
    "url": "https://www.linkedin.com/in/rafael-morfes",
    "company": "Silver.dev",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rahul",
    "lastName": "Valmiki",
    "url": "https://www.linkedin.com/in/rahulvalmiki",
    "company": "Norgate Technology",
    "position": "Senior Recruitment Team Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Raj",
    "lastName": "mishra",
    "url": "https://www.linkedin.com/in/raj-mishra-17b05920a",
    "company": "Confidential",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Raj",
    "lastName": "Mishra",
    "url": "https://www.linkedin.com/in/rajatmishra27",
    "company": "New York Global Consultants Inc. (NYGCI)",
    "position": "Talent Acquisition Account Executive",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rajnee",
    "lastName": "Verma",
    "url": "https://www.linkedin.com/in/rajnee-verma-8a29aa145",
    "company": "Tekshapers",
    "position": "Senior Executive Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rakesh",
    "lastName": "Puvvada",
    "url": "https://www.linkedin.com/in/rakeshpchowdary",
    "company": "QualiZeal",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ramiro",
    "lastName": "Mellado",
    "url": "https://www.linkedin.com/in/rmellado02",
    "company": "Time Doctor",
    "position": "Global HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Ramon Jose",
    "lastName": "Colmenarez Mendoza",
    "url": "https://www.linkedin.com/in/ramonjcolmenarez",
    "company": "Manpower Argentina",
    "position": "Recruiting Sourcer",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Rashmi",
    "lastName": "Mishra",
    "url": "https://www.linkedin.com/in/rashmi-mishra-809106193",
    "company": "eTeam India",
    "position": "Senior Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Raul Marcelo",
    "lastName": "Bustos",
    "url": "https://www.linkedin.com/in/raul-marcelo-bustos-635a9032",
    "company": "Softensity Inc",
    "position": "Global IT Recruitment Lead / Sr. Technical Recruiter",
    "keywords": [
      "recruiter",
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ray",
    "lastName": "Peraza🚀 ✅",
    "url": "https://www.linkedin.com/in/rayperaza",
    "company": "prosourceIT",
    "position": "Senior Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Raziel Elizabeth",
    "lastName": "Ledezma L.",
    "url": "https://www.linkedin.com/in/razielledezma",
    "company": "Garage Labs",
    "position": "Head of Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Raí",
    "lastName": "Pérez López",
    "url": "https://www.linkedin.com/in/rai0001",
    "company": "CBQA Solutions Inc.",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Raúl",
    "lastName": "Recio Guerrero",
    "url": "https://www.linkedin.com/in/ra%C3%BAl-recio-guerrero-2b825b137",
    "company": "UST",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rebeca",
    "lastName": "Correa",
    "url": "https://www.linkedin.com/in/rebecacorrea7",
    "company": "Randstad Argentina",
    "position": "IT Talent acquisition & People Team Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rebeca",
    "lastName": "Gosp",
    "url": "https://www.linkedin.com/in/rebeca-gosp",
    "company": "CONEXIONHR - Recruiting Company",
    "position": "Talent Acquisition Specialist | Tech Recruiter para PERSONAL",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rebeca",
    "lastName": "Salinas",
    "url": "https://www.linkedin.com/in/rebecasalinasgoytia",
    "company": "iDelsoft",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Reclutamiento",
    "lastName": "Kickoff",
    "url": "https://www.linkedin.com/in/reclutamiento-kickoff-aa9742250",
    "company": "Kickoff",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Recruiter",
    "lastName": "PY",
    "url": "https://www.linkedin.com/in/recruiter-py-445235259",
    "company": "PyRecruiter",
    "position": "Recruiter TI",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Reed",
    "lastName": "Kellick",
    "url": "https://www.linkedin.com/in/reedkellick",
    "company": "Jobot",
    "position": "Senior Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Regina",
    "lastName": "Benitez",
    "url": "https://www.linkedin.com/in/regina-benitez-rrhhitrecruiter-peoplecare",
    "company": "Churrasco.cc",
    "position": "IT Recruiter & People Care",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Regina",
    "lastName": "Ochoa",
    "url": "https://www.linkedin.com/in/regina-ochoa-67a54116a",
    "company": "INJC",
    "position": "Head of People & Culture",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Renzo",
    "lastName": "Bordon",
    "url": "https://www.linkedin.com/in/renzo-bordon",
    "company": "EY",
    "position": "Talent Attraction Recruiter - CBS US",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Reyna",
    "lastName": "Hurtado",
    "url": "https://www.linkedin.com/in/reyna-hurtado-ab2396138",
    "company": "MinData",
    "position": "Team Leader - IT & Digital Sr. Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ricardo",
    "lastName": "Gaite",
    "url": "https://www.linkedin.com/in/ricardo-gaite",
    "company": "EPAM Systems",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ricardo",
    "lastName": "Hanoeman हनुमान",
    "url": "https://www.linkedin.com/in/rhanoeman03",
    "company": "Detacheerder",
    "position": "Senior recruiter informatietechnologie",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Richa",
    "lastName": "Trivedi",
    "url": "https://www.linkedin.com/in/richa-trivedi-3933a755",
    "company": "Attribute Group",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ricky",
    "lastName": "Ragab",
    "url": "https://www.linkedin.com/in/ricky-ragab-b917895a",
    "company": "The Judge Group",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Riri, Noril",
    "lastName": "Zaidi",
    "url": "https://www.linkedin.com/in/riri-noril-zaidi-6b3384196",
    "company": "Laurelsoft (M) Sdn Bhd",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Rita",
    "lastName": "Mansilla",
    "url": "https://www.linkedin.com/in/rita-mansilla-066aa5225",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rita",
    "lastName": "Moreno Muñoz",
    "url": "https://www.linkedin.com/in/ritamoreno28",
    "company": "Métrica Perú",
    "position": "Human Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Riya",
    "lastName": "Arora",
    "url": "https://www.linkedin.com/in/hr-riya-arora",
    "company": "N2S.Global",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Roberto Carlo",
    "lastName": "Peña Cadillo",
    "url": "https://www.linkedin.com/in/robertope%C3%B1a",
    "company": "Encora Inc.",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Roberto Carlos",
    "lastName": "Monterroza Diaz",
    "url": "https://www.linkedin.com/in/roberto-carlos-monterroza-diaz-b43899160",
    "company": "Paired",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Cecchetto",
    "url": "https://www.linkedin.com/in/rocio-cecchetto",
    "company": "Fligoo",
    "position": "People & Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/rociod-",
    "company": "Welo Data",
    "position": "Talent Community Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Godoy",
    "url": "https://www.linkedin.com/in/rociog-godoy",
    "company": "VORTEX-IT",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Heredia",
    "url": "https://www.linkedin.com/in/rocio-heredia",
    "company": "Capital Humano",
    "position": "Operations & Recruiting Leader",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Hidalgo",
    "url": "https://www.linkedin.com/in/rociohidalgo",
    "company": "Talento Cumbre",
    "position": "Directora & Fundadora en Talento Cumbre | Head Hunter | HR Consultant",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Leguizamon",
    "url": "https://www.linkedin.com/in/rocio-leguizamon-b261b116b",
    "company": "TeamUp",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Rivera",
    "url": "https://www.linkedin.com/in/rocionahirrivera",
    "company": "Nexton",
    "position": "Senior Technical Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/rocio-f-sanchez",
    "company": "Brubank",
    "position": "Head of Talent Acquisition & People Experience",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Santesteban",
    "url": "https://www.linkedin.com/in/rocio-santesteban-665845285",
    "company": "Plant",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rocio",
    "lastName": "Uranga",
    "url": "https://www.linkedin.com/in/rocio-urangarrhh",
    "company": "BullMetrix",
    "position": "People Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rocio Soledad",
    "lastName": "Colman",
    "url": "https://www.linkedin.com/in/rocio0recruiter0asesoralaboral",
    "company": "Dev.Pro",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rocío",
    "lastName": "Albelo",
    "url": "https://www.linkedin.com/in/roc%C3%ADo-albelo",
    "company": "aliantec",
    "position": "IT Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rocío",
    "lastName": "Cabezón Panadero",
    "url": "https://www.linkedin.com/in/roc%C3%ADo-cabez%C3%B3n-panadero-26b795b9",
    "company": "Inetum",
    "position": "IT Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rocío",
    "lastName": "Catalano",
    "url": "https://www.linkedin.com/in/rociocatalano",
    "company": "Engineer Access",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rocío",
    "lastName": "Céspedes",
    "url": "https://www.linkedin.com/in/roc%C3%ADo-c-2498283a",
    "company": "SNP Group",
    "position": "LATAM Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rocío",
    "lastName": "Fernández",
    "url": "https://www.linkedin.com/in/roc%C3%ADo-fern%C3%A1ndez-40ab68228",
    "company": "GlobalTask",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rocío",
    "lastName": "Miguenz",
    "url": "https://www.linkedin.com/in/rociomiguenz",
    "company": "Leafnoise",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rocío",
    "lastName": "Rivas",
    "url": "https://www.linkedin.com/in/rocio-rivas",
    "company": "LaPieza",
    "position": "Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Rocío",
    "lastName": "Ruiz",
    "url": "https://www.linkedin.com/in/ruiz-rocio-",
    "company": "Lupa Hire",
    "position": "Senior Recruiting Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Rocío Belén",
    "lastName": "Cabrera",
    "url": "https://www.linkedin.com/in/roc%C3%ADo-bel%C3%A9n-cabrera-9a66a1122",
    "company": "Mercado Libre",
    "position": "Regional IT Talent Acquisition Supervisor",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rocío Belén",
    "lastName": "Fernández",
    "url": "https://www.linkedin.com/in/rociobelenfernandez",
    "company": "Accenture",
    "position": "Regional Talent Acquisition l Cliente: Mercado Libre",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rodrigo",
    "lastName": "Paravizzo",
    "url": "https://www.linkedin.com/in/rodrigo-paravizzo-a28b9a150",
    "company": "Aditi Consulting",
    "position": "HR Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rodrigo",
    "lastName": "Pinillos",
    "url": "https://www.linkedin.com/in/rodrigopinillos",
    "company": "Recru-IT",
    "position": "Co-Founder, Sr Compensations and Benefits, HR Consultant, Headhunter, IT Recruiter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Rodrigo",
    "lastName": "Ponce",
    "url": "https://www.linkedin.com/in/rodrigoponcem",
    "company": "Confidential Client (NDA)",
    "position": "Senior Recruitment Operations Associate",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Roge",
    "lastName": "Metz",
    "url": "https://www.linkedin.com/in/rogemetz",
    "company": "Strider",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Roger",
    "lastName": "Davila",
    "url": "https://www.linkedin.com/in/roger-it-recruiter",
    "company": "FullStack Labs",
    "position": "IT Sourcer Specialist",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Roger",
    "lastName": "Limonche",
    "url": "https://www.linkedin.com/in/rogerlimonchekukec",
    "company": "MMC Search Partners",
    "position": "Founding Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rohini",
    "lastName": "Rupnoor",
    "url": "https://www.linkedin.com/in/rohini-rupnoor-7b263b159",
    "company": "Perfict",
    "position": "Sr Technical Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Rohit",
    "lastName": "kumar",
    "url": "https://www.linkedin.com/in/rohit-kumar-20aa81b5",
    "company": "Evolve Squads",
    "position": "Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Rolando",
    "lastName": "Toyo",
    "url": "https://www.linkedin.com/in/rolando-toyo-4a2710233",
    "company": "Jobsity",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rolimar",
    "lastName": "Domero",
    "url": "https://www.linkedin.com/in/rolimardomero",
    "company": "Blackfin Corp",
    "position": "Coordinador de Personas y Organización y Reclutamiento IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Barone",
    "url": "https://www.linkedin.com/in/romina-barone-41a98820b",
    "company": "Accenture",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Civile",
    "url": "https://www.linkedin.com/in/rocivile",
    "company": "scaleHUB",
    "position": "Human Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Echazú",
    "url": "https://www.linkedin.com/in/rominaechazu",
    "company": "Accenture",
    "position": "Recruiting Senior Analyst at Accenture Argentina - Cliente YPF",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Imoberdorf",
    "url": "https://www.linkedin.com/in/rominaimoberdorf",
    "company": "IMPULSA HR",
    "position": "Consultora en Capital Humano y Desarrollo Profesional | IT Recruiter Freelance | Formadora 💫",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Mottola",
    "url": "https://www.linkedin.com/in/rominamottola",
    "company": "Atos",
    "position": "Talent Acquisition Manager Austral Andean Region + HRBP Argentina",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Moyano",
    "url": "https://www.linkedin.com/in/rominamoyano",
    "company": "atomic* HR",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Parente",
    "url": "https://www.linkedin.com/in/romina-parente",
    "company": "TeamUp",
    "position": "IT Recruiter / Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Raffo De León",
    "url": "https://www.linkedin.com/in/romina-raffo-de-le%C3%B3n-10ab4273",
    "company": "VAIRIX",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Ricar",
    "url": "https://www.linkedin.com/in/rominaricar",
    "company": "Modo Plural - Consultora en gestión y selección de personas",
    "position": "Líder en Atracción y Selección de Talento – Modo Plural",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Rizzo",
    "url": "https://www.linkedin.com/in/romina-rizzo",
    "company": "Ready Set",
    "position": "People Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Sabino",
    "url": "https://www.linkedin.com/in/romina-sabino-856a8622",
    "company": "KAVER-Consulting S.A.",
    "position": "Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Romina",
    "lastName": "Tymoszuk",
    "url": "https://www.linkedin.com/in/romina-tymoszuk-b9337277",
    "company": "Assertia Solutions",
    "position": "IT Recruiter in Assertia Solutions",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Romina (Romi)",
    "lastName": "Fernández (She/Her/Ella)",
    "url": "https://www.linkedin.com/in/rominafernandez",
    "company": "BEMA Talent",
    "position": "Talent Adquisition Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Romina Fiorella",
    "lastName": "Mezzabolta-",
    "url": "https://www.linkedin.com/in/romina-fiorella-mezzabolta-",
    "company": "FullStackRemote",
    "position": "Head of Global Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Romina Gisela",
    "lastName": "Tuccio",
    "url": "https://www.linkedin.com/in/romina-gisela-tuccio-996a4977",
    "company": "Scanntech Argentina",
    "position": "HRBP/ GESTION HUMANA/ SCANNTECH S.A",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Romina Paola",
    "lastName": "Forti",
    "url": "https://www.linkedin.com/in/romina-paola-f-8367791b9",
    "company": "Who? Consultora Integral",
    "position": "Talent acquisition IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ronald",
    "lastName": "Huari",
    "url": "https://www.linkedin.com/in/ronaldhuari",
    "company": "Encora Inc.",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rosa",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/rosa-rodriguez-b1800444",
    "company": "Diebold Nixdorf",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rosa Yesica Tamara",
    "lastName": "Martinez",
    "url": "https://www.linkedin.com/in/rosa-yesica-tamara-martinez-6b454818b",
    "company": "ORIGIN Software",
    "position": "Talent Recruiter Analyst - People Experience",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rosalía",
    "lastName": "Rebolero",
    "url": "https://www.linkedin.com/in/rosaliarebolero",
    "company": "Pampa BI",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rosana",
    "lastName": "Bonini",
    "url": "https://www.linkedin.com/in/rosanabonini",
    "company": "Licencias OnLine",
    "position": "Talent Management Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rosana",
    "lastName": "Di Carlantonio",
    "url": "https://www.linkedin.com/in/rosana-di-carlantonio-68a488113",
    "company": "Autonomo-Freelance",
    "position": "Recruiter IT / Technical Soucer IT Freelancer",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rosana",
    "lastName": "Di Rosa",
    "url": "https://www.linkedin.com/in/rosana-di-rosa-0b197b112",
    "company": "Botmaker",
    "position": "Senior Talent Acquisition Specialist - HR - People LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rosario",
    "lastName": "Abrigo",
    "url": "https://www.linkedin.com/in/rosarioabrigo",
    "company": "Santex",
    "position": "Junior Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Rosario",
    "lastName": "André",
    "url": "https://www.linkedin.com/in/rosario-andr%C3%A9-a12371248",
    "company": "iTalent Connection",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rosario",
    "lastName": "Blanc",
    "url": "https://www.linkedin.com/in/rosario-blanc",
    "company": "CRAFTLabs",
    "position": "IT recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rosario",
    "lastName": "Corti",
    "url": "https://www.linkedin.com/in/rosario-corti-8b469451",
    "company": "Docplanner",
    "position": "Global Head of Talent Acquisition - Go To Market",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Rosario",
    "lastName": "Noceti Achával",
    "url": "https://www.linkedin.com/in/itrecruiter-rosario-noceti-ach%C3%A1val-97857a180",
    "company": "Hublance",
    "position": "International Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rosario",
    "lastName": "Valdés",
    "url": "https://www.linkedin.com/in/mariarosariovaldes",
    "company": "Taller",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rosmelin",
    "lastName": "Padrón Corona",
    "url": "https://www.linkedin.com/in/rosmelin-padr%C3%B3n-corona",
    "company": "The Clorox Company",
    "position": "International Talent Acquisition Partner (Canada + LATAM)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rossana",
    "lastName": "Mercado",
    "url": "https://www.linkedin.com/in/rossana-mercado",
    "company": "Hire With Near",
    "position": "Full-Cycle Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rossana",
    "lastName": "Obando Casas",
    "url": "https://www.linkedin.com/in/rossanaobandocasas",
    "company": "Canvia",
    "position": "Analista de Reclutamiento y Selección Senior",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Roxana",
    "lastName": "Hernandez Guerrero (She/Her)",
    "url": "https://www.linkedin.com/in/roxana-hernandez-guerrero-she-her-1a9289128",
    "company": "itti",
    "position": "Sr Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Roxana",
    "lastName": "Ledesma",
    "url": "https://www.linkedin.com/in/roxana-ledesma",
    "company": "Freelance",
    "position": "Tech Recruiting",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Roxana",
    "lastName": "Morelli",
    "url": "https://www.linkedin.com/in/roxana-morelli-308ba5229",
    "company": "Ah! Consultora en Selección IT",
    "position": "IT Recruiter Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Rozeimer Gamboa",
    "lastName": "Recruiter",
    "url": "https://www.linkedin.com/in/rozeimer-gamboa-recruiter-a0b64436",
    "company": "Gi Group Holding",
    "position": "Sourcer IT- Recruiter",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "RRHH",
    "lastName": "Hiring",
    "url": "https://www.linkedin.com/in/rrhh-hiring-68aa46218",
    "company": "CodigoDelSur",
    "position": "HR Business Partner / IT Recruiter",
    "keywords": [
      "recruiter",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Ruben",
    "lastName": "Ramachandran",
    "url": "https://www.linkedin.com/in/rubenramachandran",
    "company": "The Access Group",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Rushi",
    "lastName": "Vyas",
    "url": "https://www.linkedin.com/in/rushi-vyas-baa73218a",
    "company": "Hyqoo",
    "position": "Lead Talent Evangelist",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ruth",
    "lastName": "Leytes",
    "url": "https://www.linkedin.com/in/itrecruiter-ruth-leytes",
    "company": "Strider",
    "position": "It Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Ardiles",
    "url": "https://www.linkedin.com/in/sabrina-ardiles",
    "company": "Baires Talent",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Benitez",
    "url": "https://www.linkedin.com/in/sabrinabenitez",
    "company": "Qualitest",
    "position": "Senior Associate - Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Cardona",
    "url": "https://www.linkedin.com/in/sabrina-cardona-recruiter",
    "company": "The Agency IT",
    "position": "IT Talent Sourcer Freelance",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Casaux",
    "url": "https://www.linkedin.com/in/sabrina-casaux-7884b236",
    "company": "Vanguard X",
    "position": "Senior Talent Acquisition and HR",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Celona",
    "url": "https://www.linkedin.com/in/celonasabrina",
    "company": "Impacto Talent",
    "position": "Technical Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Cerviño",
    "url": "https://www.linkedin.com/in/sabricervi",
    "company": "The Mobile-First Company",
    "position": "Founding People & Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "F.",
    "url": "https://www.linkedin.com/in/sfieramosca",
    "company": "Mercado Libre",
    "position": "IT Regional Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Fruto",
    "url": "https://www.linkedin.com/in/sabrinafruto",
    "company": "ITSM Consulting S.A",
    "position": "Talent Acquisition Analyst/ Recruiter IT",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Perez Scibona",
    "url": "https://www.linkedin.com/in/sabrina-perez-scibona",
    "company": "SUPLE",
    "position": "Talent Acquisition | Recruiting Specialist Sr",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Raffaini",
    "url": "https://www.linkedin.com/in/sabrina-raffaini-113119b7",
    "company": "LatinAd",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Than",
    "url": "https://www.linkedin.com/in/sabrina-than",
    "company": "Accenture",
    "position": "Recruiting Senior Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Sabrina",
    "lastName": "Zoellner",
    "url": "https://www.linkedin.com/in/sabrinazoellner",
    "company": "Ambush",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Saiful",
    "lastName": "SSR",
    "url": "https://www.linkedin.com/in/saiful-ssr-b6b20411b",
    "company": "Tata Consultancy Services",
    "position": "Lead Recruiter - ERU (Hiring IT Talents)",
    "keywords": [
      "recruiter",
      "hiring"
    ]
  },
  {
    "firstName": "Saiteja",
    "lastName": "Aluri",
    "url": "https://www.linkedin.com/in/saiteja-aluri-992138250",
    "company": "Snap Code Inc",
    "position": "US IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sally",
    "lastName": "Ng",
    "url": "https://www.linkedin.com/in/sally-ng-24295416b",
    "company": "Intel Corporation",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Salman",
    "lastName": "Mahammad",
    "url": "https://www.linkedin.com/in/salman-mahammad-886ba4253",
    "company": "Cross Border Talents",
    "position": "International Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Salomé",
    "lastName": "Alvarez",
    "url": "https://www.linkedin.com/in/salom%C3%A9-alvarez",
    "company": "Making Sense LLC",
    "position": "Talent Attraction Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Samanta",
    "lastName": "Fioretti",
    "url": "https://www.linkedin.com/in/samanta-fioretti-043a1238",
    "company": "Admios",
    "position": "Head of Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Samanta",
    "lastName": "Taddei",
    "url": "https://www.linkedin.com/in/samanta-taddei-3a777a1aa",
    "company": "Revelo",
    "position": "IT Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Samantha",
    "lastName": "Moore",
    "url": "https://www.linkedin.com/in/samanthamexperis",
    "company": "Experis",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sameer",
    "lastName": "Chandravanshi",
    "url": "https://www.linkedin.com/in/sameer-chandravanshi-9266a6123",
    "company": "Accion Labs",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Samir",
    "lastName": "Saavedra Cisternas",
    "url": "https://www.linkedin.com/in/samir-saavedra-cisternas-269141188",
    "company": "Hunteed",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Sandra",
    "lastName": "Arola",
    "url": "https://www.linkedin.com/in/sandra-arola-447537235",
    "company": "Autónomo",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sandra",
    "lastName": "Betanzo",
    "url": "https://www.linkedin.com/in/sandra-betanzo-",
    "company": "Reclutamiento It",
    "position": "IT Talent Operations Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sandra",
    "lastName": "Hernández",
    "url": "https://www.linkedin.com/in/sanhdezf",
    "company": "Adecco",
    "position": "Consultora de selección IT",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Sandra",
    "lastName": "Mino",
    "url": "https://www.linkedin.com/in/sandra-mino-03372121b",
    "company": "recruitmentagency",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sandra Araceli",
    "lastName": "Hernández Pérez",
    "url": "https://www.linkedin.com/in/aracelihpz",
    "company": "Banamex",
    "position": "IT Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sanjay",
    "lastName": "Prince Thaliyaparambil",
    "url": "https://www.linkedin.com/in/sanjay-prince-thaliyaparambil-b87223195",
    "company": "Hi-Tech Talents",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Barraza",
    "url": "https://www.linkedin.com/in/santiagobarraza",
    "company": "Silver.dev",
    "position": "Founding Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Barud",
    "url": "https://www.linkedin.com/in/santiago-barud-33106428",
    "company": "AccelOne",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Camacho",
    "url": "https://www.linkedin.com/in/santiago-camacho-9b7799170",
    "company": "10Pearls",
    "position": "People & Talent Development Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Castro",
    "url": "https://www.linkedin.com/in/santiago-castro-113735b4",
    "company": "HR DIGITAL GROWTH",
    "position": "Recruiter IT Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Fernández",
    "url": "https://www.linkedin.com/in/santiago-fernandeza",
    "company": "DXC Technology",
    "position": "Recruiting Team Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Garcia Mantel",
    "url": "https://www.linkedin.com/in/santiago-gmantel",
    "company": "EY",
    "position": "Tax Technology Talent Attraction Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Guiñazu",
    "url": "https://www.linkedin.com/in/santiago-gui%C3%B1azu-94765a174",
    "company": "Launch Consulting Group",
    "position": "Sr IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Lonardi",
    "url": "https://www.linkedin.com/in/santiago-lonardi",
    "company": "HR Oasis",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Mazzoni",
    "url": "https://www.linkedin.com/in/mazzonisantiago",
    "company": "Bizit Global",
    "position": "Talent Experience - People Care - IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Mues",
    "url": "https://www.linkedin.com/in/santiago-mues-14745b25",
    "company": "Santiago Mues",
    "position": "Coordinador de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Oliverio",
    "url": "https://www.linkedin.com/in/santiago-oliverio",
    "company": "Applica corp.",
    "position": "Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Rocca",
    "url": "https://www.linkedin.com/in/santiago-rocca",
    "company": "PwC Argentina",
    "position": "HRBP - Talent Consultant | Senior Associate 2",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Sosa",
    "url": "https://www.linkedin.com/in/santiago-sosa31ab281",
    "company": "Poincenot tech.studio",
    "position": "Técnico de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Santiago",
    "lastName": "Walker",
    "url": "https://www.linkedin.com/in/santiago-walker-318b4b1aa",
    "company": "Freelance, self-employed",
    "position": "Associate Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Santiago Nicolás",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/snrodriguez96",
    "company": "Air Liquide",
    "position": "HR OPS Talent Acquisition SSr Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Santiago Rafael",
    "lastName": "Cárdenas Escobar",
    "url": "https://www.linkedin.com/in/srce",
    "company": "Talently",
    "position": "Tech Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Sara",
    "lastName": "Buccino",
    "url": "https://www.linkedin.com/in/sara-buccino-528bb8206",
    "company": "Datamind Italia S.r.l.",
    "position": "Recruiter IT | Software Developer",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "SARA",
    "lastName": "ENCISO",
    "url": "https://www.linkedin.com/in/sara-enciso-7b665470",
    "company": "SELECTORA INDEPENDIENTE FREE LANCE IT/TECNICOS",
    "position": "Selectora de Personal Tecnico/Selectora de Personal IT/IT RECRUITER",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sara",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/sararomero1990",
    "company": "Cognizant",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sara",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/sara-romerop",
    "company": "Encora Inc.",
    "position": "IT Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sara",
    "lastName": "Saldarriaga Arredondo",
    "url": "https://www.linkedin.com/in/sarasaldarriagaarredondo",
    "company": "Evertec",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sarthak",
    "lastName": "Singhal",
    "url": "https://www.linkedin.com/in/sarthak-singhal-healthcare",
    "company": "QX Global Group",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Sasha",
    "lastName": "Denchuk",
    "url": "https://www.linkedin.com/in/sasha-denchuk-63506522a",
    "company": "Evolve Squads",
    "position": "Mid IT Recruiter | Talent Sourcer",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Sasha",
    "lastName": "Piñero Marengo",
    "url": "https://www.linkedin.com/in/marengosasha",
    "company": "SAIA (Sociedad Argentina de Inteligencia Artificial)",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Satinder",
    "lastName": "Sharma",
    "url": "https://www.linkedin.com/in/satinder-sharma-667977113",
    "company": "Bebo Technologies Pvt Ltd",
    "position": "Sr. Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Saya",
    "lastName": "Porta",
    "url": "https://www.linkedin.com/in/sayportacapararo",
    "company": "Softtek",
    "position": "Sr. Talent Acquisition Analyst IT",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sebastian",
    "lastName": "Borghello",
    "url": "https://www.linkedin.com/in/sebastian-borghello",
    "company": "OctoHire",
    "position": "Co-Founder at Octohire | Talent Partner | Recruitment & Hunting Technology Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Sebastian",
    "lastName": "Kady",
    "url": "https://www.linkedin.com/in/sebastian-k-7391b5125",
    "company": "ConsultR",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sebastian",
    "lastName": "Pugliese",
    "url": "https://www.linkedin.com/in/sebastianpugliese",
    "company": "BioScience GmbH",
    "position": "Senior Human Resources and Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sebastián",
    "lastName": "Lovero",
    "url": "https://www.linkedin.com/in/sebastian-lovero",
    "company": "Accenture Argentina",
    "position": "Recruiting Senior Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Sebastián",
    "lastName": "Pérez Peñalver",
    "url": "https://www.linkedin.com/in/sebasti%C3%A1n-p%C3%A9rez-pe%C3%B1alver-a6499698",
    "company": "Nearshore Business Solutions",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sebastián",
    "lastName": "Santoro",
    "url": "https://www.linkedin.com/in/sebastian-santoro-it",
    "company": "PHI - Business Consulting & Accounting",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sebastián",
    "lastName": "Vilas",
    "url": "https://www.linkedin.com/in/sebastianvilas",
    "company": "Tecsol Group S.A.",
    "position": "IT Recruiter Senior | Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Seema",
    "lastName": "Meeshaa",
    "url": "https://www.linkedin.com/in/seema-meeshaa-7a5581231",
    "company": "Skitech Solutions",
    "position": "Senior Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Seled",
    "lastName": "Cárdenas",
    "url": "https://www.linkedin.com/in/seled-c%C3%A1rdenas-20701b18b",
    "company": "Skala",
    "position": "Recruiter Partner",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Selena",
    "lastName": "Lungo",
    "url": "https://www.linkedin.com/in/selenalungo",
    "company": "Hire Clinch",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sergio",
    "lastName": "Carrizales",
    "url": "https://www.linkedin.com/in/sergio-carrizales-aab865286",
    "company": "HireIn Cloud",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sergio",
    "lastName": "Di Dio",
    "url": "https://www.linkedin.com/in/sergio-di-dio-622770226",
    "company": "Sandvik",
    "position": "Consultor de selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Sergio",
    "lastName": "Giménez",
    "url": "https://www.linkedin.com/in/q2itgimenez",
    "company": "Q2 Talent Acquisition",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Shams",
    "lastName": "Mistry",
    "url": "https://www.linkedin.com/in/shams-mistry-5824b49",
    "company": "WTN",
    "position": "Co-Founder & Global Head Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sharon",
    "lastName": "Perelmuter",
    "url": "https://www.linkedin.com/in/sharon-perelmuter-b1319b66",
    "company": "Mercado Libre",
    "position": "SR IT Regional Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Shayna",
    "lastName": "Iskandarani",
    "url": "https://www.linkedin.com/in/shayna-iskandarani",
    "company": "LinkIT",
    "position": "Sr IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sheila",
    "lastName": "Gaitan",
    "url": "https://www.linkedin.com/in/sheila-gaitan",
    "company": "DataArt",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sheila",
    "lastName": "Macarrone",
    "url": "https://www.linkedin.com/in/sheilamacarronehumanresources",
    "company": "Rieka Talent ETT",
    "position": "Talent Acquisition Specialist ~ Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Shruti",
    "lastName": "B",
    "url": "https://www.linkedin.com/in/shruti-b-a262b054",
    "company": "U3 Infotech",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Silvana",
    "lastName": "Gomensoro",
    "url": "https://www.linkedin.com/in/silvana-gomensoro-b76552218",
    "company": "Freelance",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Silvana",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/silvana-gonzalez-253130195",
    "company": "Applicant - IT Talent Management",
    "position": "Remote IT Recruitment",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Silvana",
    "lastName": "Oviedo",
    "url": "https://www.linkedin.com/in/recruitersilvana",
    "company": "Techunting.net",
    "position": "Talent Acquisition and Client Success Manager - LATAM",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Silvia",
    "lastName": "Andrade",
    "url": "https://www.linkedin.com/in/itrecruitersilvia-andrade",
    "company": "Velozient",
    "position": "Senior Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Silvia",
    "lastName": "Matiello",
    "url": "https://www.linkedin.com/in/silvia-fernanda-matiello",
    "company": "Arkano Software",
    "position": "Senior Talent Acquisition Specialist - IT Technical Recruiter.",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Silvia",
    "lastName": "Ocón Ahumada ✔",
    "url": "https://www.linkedin.com/in/silviaoconahumada",
    "company": "Gates Consulting",
    "position": "IT Recruiter Ssr",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Silvia",
    "lastName": "Palacios",
    "url": "https://www.linkedin.com/in/silvia-palacios-71a58313",
    "company": "Perdif - Perfiles Dificiles",
    "position": "Partner - Búsqueda y Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Silvia",
    "lastName": "Peñaloza",
    "url": "https://www.linkedin.com/in/silvia-pe%C3%B1aloza",
    "company": "Empirical LLC",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Silvia",
    "lastName": "Rage",
    "url": "https://www.linkedin.com/in/silvia-rage-821599230",
    "company": "freelance",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Silvina",
    "lastName": "Davi",
    "url": "https://www.linkedin.com/in/silvina-davi",
    "company": "Wakapi",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Silvina",
    "lastName": "Mirabelli",
    "url": "https://www.linkedin.com/in/silvina-mirabelli-6348976",
    "company": "IT Patagonia",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Silvina",
    "lastName": "Peroni",
    "url": "https://www.linkedin.com/in/silvina-peroni-65801215a",
    "company": "CorpLATAM5411 - Specialized Recruitment",
    "position": "IT Recruiter &Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Silvina Laura",
    "lastName": "Mariconda",
    "url": "https://www.linkedin.com/in/smariconda",
    "company": "Impacto Talent",
    "position": "Technical Recruiter | IT Talent Acquisition Partner",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sima",
    "lastName": "Bizreh",
    "url": "https://www.linkedin.com/in/sima-bizreh",
    "company": "DistantJob",
    "position": "Senior IT Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Sirikul",
    "lastName": "Teetanyaphat",
    "url": "https://www.linkedin.com/in/sirikul-t-113b269a",
    "company": "TransPerfect",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "SMP",
    "lastName": "Consultores",
    "url": "https://www.linkedin.com/in/smpconsultores",
    "company": "SMP CONSULTORES",
    "position": "International Headhunter/ IT Recruiter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Achaval",
    "url": "https://www.linkedin.com/in/sofiaachaval",
    "company": "Bloom Talent Partners",
    "position": "IT Recruiter - Tech Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Balbo",
    "url": "https://www.linkedin.com/in/sofia-balbo-b3442b262",
    "company": "BEON.tech",
    "position": "Talent Sourcing Automation Analyst",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Becker Leon",
    "url": "https://www.linkedin.com/in/sofiabeckerleon",
    "company": "Avature",
    "position": "Talent Acquisition - Sourcing Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Benitez Barnada",
    "url": "https://www.linkedin.com/in/sofia-benitezbarnada",
    "company": "Globant",
    "position": "SR Recruiter & Technical Team Lead",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Dayan",
    "url": "https://www.linkedin.com/in/sofia-dayan",
    "company": "Cocos Capital",
    "position": "People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Echavarria",
    "url": "https://www.linkedin.com/in/sofia-echavarria",
    "company": "BetWarrior",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/itrecruitersofiag",
    "company": "Strategic Staffing Solutions",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Jimenez",
    "url": "https://www.linkedin.com/in/sofia-e-jimenez",
    "company": "SOTEC CONSULTING",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Ledesma",
    "url": "https://www.linkedin.com/in/sofia-ledesma",
    "company": "Boreal IT Solutions",
    "position": "Recruiter IT/ Business Partner",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Liendo",
    "url": "https://www.linkedin.com/in/sofialiendo",
    "company": "Globant",
    "position": "Global Capacity & People Sr Manager - Enterprise & GEAI",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Muslera",
    "url": "https://www.linkedin.com/in/sofiamuslera",
    "company": "Trafilea Tech E-commerce Group",
    "position": "Sr Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Paredes",
    "url": "https://www.linkedin.com/in/sofia-paredes-36b0523b",
    "company": "Minutentag",
    "position": "Sr. IT Talent Acquisition Specialist / HRBP",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Pavone",
    "url": "https://www.linkedin.com/in/sofiapavone",
    "company": "DataArt",
    "position": "Recruiter & People Analytics",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Primo",
    "url": "https://www.linkedin.com/in/sofia-primo-",
    "company": "Rooftop",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Quintana",
    "url": "https://www.linkedin.com/in/sofia-quintana",
    "company": "Amalgama",
    "position": "People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Rossi",
    "url": "https://www.linkedin.com/in/sofia-rossi-a8602a247",
    "company": "Rad Hires",
    "position": "Senior Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/sofia-sanchez-9a2895b8",
    "company": "ITLG",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Schoppe",
    "url": "https://www.linkedin.com/in/sofiaschoppe",
    "company": "iHuman Agency",
    "position": "Fractional Talent Consultant | Recruitment Partner @ iHuman (GTM & Engineering Teams)",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Simón",
    "url": "https://www.linkedin.com/in/sofia-sim%C3%B3n-430325141",
    "company": "Flux IT",
    "position": "IT Recruiter Ssr.",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Speroni",
    "url": "https://www.linkedin.com/in/sofia-speroni-2abb8244",
    "company": "Personal",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Villalobos Córdoba",
    "url": "https://www.linkedin.com/in/sofiavillalobos97",
    "company": "Strategic Staffing Solutions",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofia",
    "lastName": "Zanoni",
    "url": "https://www.linkedin.com/in/sofia-zanoni-209bb1115",
    "company": "10EQS",
    "position": "Manager - Client Delivery Operations & Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sofia Ayelen",
    "lastName": "Dallavia",
    "url": "https://www.linkedin.com/in/sofia-ayelen-dallavia",
    "company": "Automóviles San Jorge",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sofia Maria",
    "lastName": "Ferrari",
    "url": "https://www.linkedin.com/in/sofia-maria-ferrari",
    "company": "Caylent",
    "position": "Manager of Talent Acquisition Operations",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Bonadeo",
    "url": "https://www.linkedin.com/in/sbonadeo",
    "company": "TeraCode",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Brelis",
    "url": "https://www.linkedin.com/in/sofiabrelishr",
    "company": "Mindbits",
    "position": "HR Consultant & Talent Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Castaños",
    "url": "https://www.linkedin.com/in/sofiacastanos",
    "company": "blinker HR",
    "position": "Senior Recruiter / Talent Partner",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Caymaris",
    "url": "https://www.linkedin.com/in/sof%C3%ADa-caymaris",
    "company": "Blend",
    "position": "Senior Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Contreras Hagelstrom",
    "url": "https://www.linkedin.com/in/soficontrerash",
    "company": "Profesional independiente",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Hernández Otaño",
    "url": "https://www.linkedin.com/in/sofiahernandezotano",
    "company": "Accenture Argentina",
    "position": "Talent Acquisition A.Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Rodríguez de la Torre",
    "url": "https://www.linkedin.com/in/sof%C3%ADarodriguezdelatorre1996",
    "company": "Accenture Argentina",
    "position": "Recruiting Associate (Client: BBVA Argentina)",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Ruíz",
    "url": "https://www.linkedin.com/in/sofiaruiznino-recursoshumanos",
    "company": "SOAINT",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Scaglione",
    "url": "https://www.linkedin.com/in/sofia-scaglione",
    "company": "Bydrec, Inc.",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sofía",
    "lastName": "Suarez 👩🏼‍💻",
    "url": "https://www.linkedin.com/in/sofia-suarez-1605",
    "company": "Cometa",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Soirivel",
    "lastName": "León Fernández",
    "url": "https://www.linkedin.com/in/soirivel-le%C3%B3n-fern%C3%A1ndez-10b71ab0",
    "company": "CodersLab",
    "position": "Team Leader & Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sol",
    "lastName": "Chelini",
    "url": "https://www.linkedin.com/in/sol-chelini",
    "company": "ALTEN Spain",
    "position": "Talent Acquisition Partner | IT Specialist at ALTEN SPAIN",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sol",
    "lastName": "Consoli",
    "url": "https://www.linkedin.com/in/sol-consoli-a4a624142",
    "company": "Milestone One",
    "position": "Senior Talent Acquisition and HR Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sol",
    "lastName": "de Castro Araujo",
    "url": "https://www.linkedin.com/in/msdecastroaraujo",
    "company": "FlyDevs",
    "position": "People & Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sol",
    "lastName": "Duran",
    "url": "https://www.linkedin.com/in/mar%C3%ADa-sol-duran",
    "company": "DataArt",
    "position": "IT Recruiter & HR",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sol",
    "lastName": "Morales Castillo",
    "url": "https://www.linkedin.com/in/sol-morales-castillo-4a382771",
    "company": "Revelo",
    "position": "International Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sol",
    "lastName": "Ocampos Medina",
    "url": "https://www.linkedin.com/in/sol-ocamposmedina",
    "company": "Profesional independiente",
    "position": "Career Coach & Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sol",
    "lastName": "Quiroga",
    "url": "https://www.linkedin.com/in/quirogasol",
    "company": "In All Media",
    "position": "IT Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sol",
    "lastName": "Tavolara",
    "url": "https://www.linkedin.com/in/soltavolara",
    "company": "GroWrk",
    "position": "People Operations Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sol",
    "lastName": "Yearson",
    "url": "https://www.linkedin.com/in/sol-yearson-0ab75127b",
    "company": "Argos Multilingual",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Solange",
    "lastName": "Nacach",
    "url": "https://www.linkedin.com/in/solangenacach1986",
    "company": "Autónomo",
    "position": "Talent Acquisition & HR Business Partner | Consultoría y Proyectos Freelance",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Solange",
    "lastName": "Vega",
    "url": "https://www.linkedin.com/in/solange-vega-929379197",
    "company": "YPF",
    "position": "Talent Acquisition | Atraccion y Seleccion",
    "keywords": [
      "talent acquisition",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Sole",
    "lastName": "Garay",
    "url": "https://www.linkedin.com/in/solegaray",
    "company": "Arc.dev",
    "position": "Lead Talent Partner - Arc Freelance",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Carranza",
    "url": "https://www.linkedin.com/in/soledad-carranza-20546b19",
    "company": "Profesional independiente",
    "position": "Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Heguy",
    "url": "https://www.linkedin.com/in/bairesdev",
    "company": "BairesDev",
    "position": "Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Herrera",
    "url": "https://www.linkedin.com/in/soledad-herrera-96194383",
    "company": "Freelance",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Herrera",
    "url": "https://www.linkedin.com/in/soledad-herrera-19735b217",
    "company": "MediaMonks",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Isern",
    "url": "https://www.linkedin.com/in/soledadisern",
    "company": "Profesional independiente",
    "position": "Selección de Personal Independiente",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Lopez Camps",
    "url": "https://www.linkedin.com/in/soledad-lopez-camps-2753a2236",
    "company": "Freelance (Self employed)",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Muzzachiodi",
    "url": "https://www.linkedin.com/in/soledadmuzzachiodi",
    "company": "Binit Tech",
    "position": "HC Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Quintas",
    "url": "https://www.linkedin.com/in/soledad-quintas",
    "company": "Stensul",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/soledadrodriguezrrhh",
    "company": "Nubilink",
    "position": "HR Generalist / People Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/soledad-sanchez-848101139",
    "company": "Perdif - Perfiles Dificiles",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Serna",
    "url": "https://www.linkedin.com/in/sserna",
    "company": "TIJE Travel Tech Group",
    "position": "People & Culture Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Soledad",
    "lastName": "Uribe",
    "url": "https://www.linkedin.com/in/soledaduribe",
    "company": "M47 Labs - Your AI Partner",
    "position": "Talent Acquisition Business Partner",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Solomiia",
    "lastName": "Kukhar",
    "url": "https://www.linkedin.com/in/solomiia-kukhar",
    "company": "Grid Dynamics",
    "position": "Recruiting Sourcer",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Soluciones y",
    "lastName": "Emprendimientos",
    "url": "https://www.linkedin.com/in/srrhh",
    "company": "S&E - Soluciones y Emprendientos S.R.L.",
    "position": "Búsqueda y Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Sona",
    "lastName": "Summerling",
    "url": "https://www.linkedin.com/in/sona-summerling-592b78128",
    "company": "MacroHealth",
    "position": "Manager, People Operations",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sonal",
    "lastName": "Lakhe",
    "url": "https://www.linkedin.com/in/sonal-lakhe",
    "company": "TechTiera Corporation",
    "position": "Senior APAC IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sonia",
    "lastName": "Langone",
    "url": "https://www.linkedin.com/in/sonia-langone-b5797226",
    "company": "Ryz Labs",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sonia",
    "lastName": "Valencia",
    "url": "https://www.linkedin.com/in/sonia-valencia-gonzalez",
    "company": "FullStack",
    "position": "IT Sourcer Specialist",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Sophia",
    "lastName": "Mendes",
    "url": "https://www.linkedin.com/in/sophiamendes",
    "company": "Payoneer",
    "position": "Senior Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Sophia",
    "lastName": "Williams",
    "url": "https://www.linkedin.com/in/recruitment-advancio",
    "company": "Advancio",
    "position": "Human Resources Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sorel",
    "lastName": "Izaguirre",
    "url": "https://www.linkedin.com/in/sorel-izaguirre-124120308",
    "company": "Clivi",
    "position": "People and Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sravani",
    "lastName": "K",
    "url": "https://www.linkedin.com/in/sravani-k-80b606140",
    "company": "New Era Technology",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Sreejisha",
    "lastName": "Bhaskaran",
    "url": "https://www.linkedin.com/in/sreejisha-bhaskaran-437a3260",
    "company": "Terrabit Consulting",
    "position": "Senior Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Stefani",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/stefani-fernandez-bba072b8",
    "company": "Mobile Computing",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Stefania",
    "lastName": "García",
    "url": "https://www.linkedin.com/in/stefania-garc%C3%ADa-7a117b195",
    "company": "Automóviles San Jorge",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Stefania",
    "lastName": "Gersicich",
    "url": "https://www.linkedin.com/in/stefania-gersicich-a827b21a3",
    "company": "PinApp",
    "position": "IT Recruiter | Tech Talent Acquisition Specialist",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Stefania",
    "lastName": "Ponce",
    "url": "https://www.linkedin.com/in/stefania-ponce",
    "company": "Grupo Faro Verde",
    "position": "Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Stefanía",
    "lastName": "Amato",
    "url": "https://www.linkedin.com/in/stefaniaamato",
    "company": "Syneos Health",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Stefanía",
    "lastName": "Rizzello Marcote",
    "url": "https://www.linkedin.com/in/stefan%C3%ADa-rizzello-marcote-91980993",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst - Cliente: ExxonMobil",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Stella Maris",
    "lastName": "Rossi",
    "url": "https://www.linkedin.com/in/stella-maris-rossi-41485982",
    "company": "Buda IT - Recruiting Community",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Stephania",
    "lastName": "Parisini",
    "url": "https://www.linkedin.com/in/stephania-parisini",
    "company": "Kenility",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Stephanie",
    "lastName": "Ore Baez",
    "url": "https://www.linkedin.com/in/orebaezs",
    "company": "SEIDOR",
    "position": "IT & Digital Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Stephen",
    "lastName": "Sinclair",
    "url": "https://www.linkedin.com/in/stephen-sinclair-a0b9a032",
    "company": "loanDepot",
    "position": "Technology Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Sudha",
    "lastName": "Devi",
    "url": "https://www.linkedin.com/in/sudha-devi-2176a41bb",
    "company": "AppSierra",
    "position": "Sr. Talent Acquisition Executive",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Sujay",
    "lastName": "Sarkar",
    "url": "https://www.linkedin.com/in/sujay-sarkar-626111169",
    "company": "PiplNow LLC",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Surai",
    "lastName": "Lopepe",
    "url": "https://www.linkedin.com/in/lopepesurai",
    "company": "ASAPP",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Surimana",
    "lastName": "Ponce",
    "url": "https://www.linkedin.com/in/surimana-ponce-moya",
    "company": "Digital Harbor Bolivia",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Susana",
    "lastName": "Arango",
    "url": "https://www.linkedin.com/in/susana-arango-835b99241",
    "company": "Committed Staff.AI",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Susana",
    "lastName": "Lütgebüter 🎮",
    "url": "https://www.linkedin.com/in/susanalutgebuter",
    "company": "ESL FACEIT Group [EFG]",
    "position": "Senior Recruiter – Commercial Division",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Susana Elena",
    "lastName": "Bechara",
    "url": "https://www.linkedin.com/in/susanabechara",
    "company": "Accenture",
    "position": "DIS Talent Acquisition Specialist LATAM",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "swapna",
    "lastName": "chandhini",
    "url": "https://www.linkedin.com/in/swapna-chandhini-6b14062a9",
    "company": "Firstsource",
    "position": "HR-Talent Acquisition Lateral Hiring",
    "keywords": [
      "talent acquisition",
      "hiring"
    ]
  },
  {
    "firstName": "Swapna",
    "lastName": "Mohan",
    "url": "https://www.linkedin.com/in/swapnamohanm",
    "company": "CENSOFT",
    "position": "Senior Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Syafirah",
    "lastName": "Rashid",
    "url": "https://www.linkedin.com/in/syafirahrashid",
    "company": "eSync Software Services",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Sylwia",
    "lastName": "Młynarczyk",
    "url": "https://www.linkedin.com/in/sylwia-m%C5%82ynarczyk-912077195",
    "company": "Engenious",
    "position": "Recruitment Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Taiana",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/taiana-gonzalez-220ab820b",
    "company": "DIPREM Global",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Talent IT",
    "lastName": "Recruitment",
    "url": "https://www.linkedin.com/in/talent-it-recruitment-bb03a9230",
    "company": "Talent IT",
    "position": "Recruiting Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Taline",
    "lastName": "Bacelar",
    "url": "https://www.linkedin.com/in/talinetb",
    "company": "AVANTTi",
    "position": "Tech Recruiter Sênior",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Talía",
    "lastName": "Ures Suárez",
    "url": "https://www.linkedin.com/in/tal%C3%ADa-ures-su%C3%A1rez-397292216",
    "company": "Monnet Payment Solutions",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tamara",
    "lastName": "Agudin",
    "url": "https://www.linkedin.com/in/tamiagudin",
    "company": "Kaseya",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tamara",
    "lastName": "Rojas",
    "url": "https://www.linkedin.com/in/tamara-rojas-49565b137",
    "company": "Flux IT",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tamara",
    "lastName": "Rojo",
    "url": "https://www.linkedin.com/in/tamara-rojo-30510a137",
    "company": "Contract Workplaces",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Tamara Lais",
    "lastName": "Romano",
    "url": "https://www.linkedin.com/in/tamara-lais-romano",
    "company": "CTL Information Technology",
    "position": "IT Talent Acquisition & Employer Branding",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tania",
    "lastName": "Aguirre",
    "url": "https://www.linkedin.com/in/taniaaguirre",
    "company": "atomic* HR",
    "position": "Recruiting Business Partner",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Tania",
    "lastName": "Bartra Brondi",
    "url": "https://www.linkedin.com/in/tania-bartra",
    "company": "Mace",
    "position": "Recruitment Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Tania",
    "lastName": "Berjis",
    "url": "https://www.linkedin.com/in/tania-berjis",
    "company": "Thaloz",
    "position": "Chief Recruitment Officer | Talent Acquisition",
    "keywords": [
      "recruiting/recruitment",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tania",
    "lastName": "Rovey",
    "url": "https://www.linkedin.com/in/tania-rovey",
    "company": "AGAPE RECLUTADORES",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tanissa",
    "lastName": "Augustin",
    "url": "https://www.linkedin.com/in/tanissa-augustin-85a51a178",
    "company": "Revelo",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tatiana",
    "lastName": "Coronel",
    "url": "https://www.linkedin.com/in/tatiana-co",
    "company": "CSTI Corp",
    "position": "Analista de Selección de Personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Tatiana",
    "lastName": "Gallo Hernández",
    "url": "https://www.linkedin.com/in/tatiana-gallo-hernandez",
    "company": "Global TalentSphere",
    "position": "CEO & Talent Director",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Tatiana",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/tati-rogo",
    "company": "Applica corp.",
    "position": "Hiring Manager",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "Tatiana",
    "lastName": "Schiavone",
    "url": "https://www.linkedin.com/in/tatiana-schiavone",
    "company": "IntermediaIT",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tatiana",
    "lastName": "Tolstyga",
    "url": "https://www.linkedin.com/in/tatiana-tolstyga-6596981a1",
    "company": "SaM Solutions",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tatyana",
    "lastName": "Kernei",
    "url": "https://www.linkedin.com/in/tatyana-kernei",
    "company": "Personalinvest",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Thais",
    "lastName": "Lima",
    "url": "https://www.linkedin.com/in/thaislimacsilva",
    "company": "NEORIS",
    "position": "Tech Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tim",
    "lastName": "Aydin",
    "url": "https://www.linkedin.com/in/tim-aydin",
    "company": "Asymmetric Research",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tina",
    "lastName": "Badala",
    "url": "https://www.linkedin.com/in/tinabadala",
    "company": "Gong",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tom",
    "lastName": "Paisley",
    "url": "https://www.linkedin.com/in/tpaisley",
    "company": "UBS",
    "position": "Senior Recruiter : Technology (IT) and Audit",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tomas",
    "lastName": "Boggio",
    "url": "https://www.linkedin.com/in/tomas-boggio",
    "company": "Aptitude Global",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tomas",
    "lastName": "Garbers",
    "url": "https://www.linkedin.com/in/tomas-garbers-691795102",
    "company": "Intelletec",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tomas",
    "lastName": "Mansilla",
    "url": "https://www.linkedin.com/in/tomas-mansilla-058b45206",
    "company": "IBM",
    "position": "Semi Senior en Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tomas",
    "lastName": "Rolhan",
    "url": "https://www.linkedin.com/in/almeidatomas",
    "company": "Ketos Delphin",
    "position": "Recruiting",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Tomas",
    "lastName": "Sonini",
    "url": "https://www.linkedin.com/in/tomas-sonini-b1514387",
    "company": "EY",
    "position": "Talent Attraction Recruiter - Supervising Associate",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tomas",
    "lastName": "Vilches",
    "url": "https://www.linkedin.com/in/tomasvilches",
    "company": "Remitee",
    "position": "Talent Acquisition & People Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tomas Francisco",
    "lastName": "Fernández",
    "url": "https://www.linkedin.com/in/fernandeztomasfrancisco",
    "company": "Global66",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tomasita",
    "lastName": "Chauca vela",
    "url": "https://www.linkedin.com/in/tomasita-chauca-vela-330427122",
    "company": "Valtx Perú",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tomás",
    "lastName": "Muñoz",
    "url": "https://www.linkedin.com/in/mtomas7",
    "company": "symphony.is",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tomás",
    "lastName": "Panebianco",
    "url": "https://www.linkedin.com/in/tomaspanebianco",
    "company": "Nexton",
    "position": "Principal Technical Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Tomás",
    "lastName": "Peña",
    "url": "https://www.linkedin.com/in/tomaspe%C3%B1a",
    "company": "Turismocity",
    "position": "Talent acquisition | HR Generalist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tomás Ignacio",
    "lastName": "Fernández",
    "url": "https://www.linkedin.com/in/tomasigfernandez",
    "company": "Mercado Libre",
    "position": "Regional IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Tomás Ignacio",
    "lastName": "Funes",
    "url": "https://www.linkedin.com/in/tom%C3%A1s-ignacio-funes",
    "company": "DEPT®",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Trang",
    "lastName": "Phan",
    "url": "https://www.linkedin.com/in/trang-p-8549729a",
    "company": "Hyperion360",
    "position": "Recruitment Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Triana Hilen",
    "lastName": "Francisco",
    "url": "https://www.linkedin.com/in/trianahilenfrancisco",
    "company": "The Agency",
    "position": "IT Recruiter & Career Mentor",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Tye",
    "lastName": "Tolentino",
    "url": "https://www.linkedin.com/in/tyetolentino",
    "company": "LMArena",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Usha",
    "lastName": "Kismath",
    "url": "https://www.linkedin.com/in/usha-kismath-030062117",
    "company": "Jobs Malaysia - Two95 HR HUB",
    "position": "Sr IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Valentin",
    "lastName": "Olmedo",
    "url": "https://www.linkedin.com/in/valentin-olmedo",
    "company": "Acciona IT",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Alisio",
    "url": "https://www.linkedin.com/in/valentina-a-351a99165",
    "company": "Taller",
    "position": "Talent Engagement Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Areco",
    "url": "https://www.linkedin.com/in/valeareco",
    "company": "Melon Inc",
    "position": "Talent Acquisition Specialist | Expert@ en Identificación y Desarrollo de Talento",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Bohorquez",
    "url": "https://www.linkedin.com/in/valentina-bohorquez-0ba1ab142",
    "company": "Sanofi",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Bolchini",
    "url": "https://www.linkedin.com/in/valentina-bolchini-9654751ab",
    "company": "Clever For Tech",
    "position": "Talent Acquisition & People Administrative",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Bordoli Schaffer",
    "url": "https://www.linkedin.com/in/valentina-bordoli-schaffer-b282221b5",
    "company": "Lancefleet",
    "position": "IT Recruiter | Talent Acquisition Specialist",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "C. Klimenko",
    "url": "https://www.linkedin.com/in/valentina-c-klimenko-67422313a",
    "company": "TEAM International",
    "position": "Talent Acquisition Specialist/ Head Hunter/ Human Resources/ I'm Hiring",
    "keywords": [
      "hiring",
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Cadena",
    "url": "https://www.linkedin.com/in/valentina-cadena-01975a156",
    "company": "TEAM International",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Cano",
    "url": "https://www.linkedin.com/in/valentina-cano",
    "company": "Qualitara",
    "position": "Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Cardiles",
    "url": "https://www.linkedin.com/in/valentina-cardiles-2a6046205",
    "company": "Logan Talent",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Cuan",
    "url": "https://www.linkedin.com/in/valentina-cuan-0b654a1ba",
    "company": "VML",
    "position": "Talent Acquisition & Planning Analyst",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Cáceres",
    "url": "https://www.linkedin.com/in/valentinac%C3%A1ceres",
    "company": "Inside Recruiters",
    "position": "HR Business Partner (HRBP) | Socio Estratégico de Capital Humano",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Gaspar",
    "url": "https://www.linkedin.com/in/valentina-gaspar",
    "company": "BA Global Talent",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Gentile",
    "url": "https://www.linkedin.com/in/valentina-gentile",
    "company": "Qubika",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Giraud",
    "url": "https://www.linkedin.com/in/valentina-giraud-7a2669159",
    "company": "Proxify",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Jaramillo",
    "url": "https://www.linkedin.com/in/valentina-jaramillo-6b386622b",
    "company": "TripleTen",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Lopez Salinas",
    "url": "https://www.linkedin.com/in/valentina-lopez-salinas-360051178",
    "company": "Jalasoft",
    "position": "People - Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Macchiavelli",
    "url": "https://www.linkedin.com/in/valentinamacchiavelli",
    "company": "CONEXIONHR - Recruiting Company",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Marquez",
    "url": "https://www.linkedin.com/in/valentina-marquez-b6839414",
    "company": "Consultant / Self-Employed",
    "position": "IT/Mining/Startup Headhunter Consultant",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Mora Quartara",
    "url": "https://www.linkedin.com/in/valentina-mora-quartara-90877322b",
    "company": "FYG",
    "position": "Talent Acquisition Leader",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Osorio",
    "url": "https://www.linkedin.com/in/valentinaosorio-recursoshumanos",
    "company": "Curv Group",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Peralta Prado",
    "url": "https://www.linkedin.com/in/valentina-peralta-prado-b116821b9",
    "company": "Pampa Talents",
    "position": "Global Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Tellechea",
    "url": "https://www.linkedin.com/in/valentina-tellechea",
    "company": "Ryz Labs",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Valentina",
    "lastName": "Zambrano",
    "url": "https://www.linkedin.com/in/valenzambrano",
    "company": "Chevron",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valentina Azul",
    "lastName": "Agosti",
    "url": "https://www.linkedin.com/in/valentinaagosti",
    "company": "Salution HR",
    "position": "Sr. Technical Talent Acquisition & Commercial Development",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Andreatta",
    "url": "https://www.linkedin.com/in/valeria-andreatta",
    "company": "Thaloz",
    "position": "Technical Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Brambilla",
    "url": "https://www.linkedin.com/in/valeria-bram",
    "company": "Concord",
    "position": "Global Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Calderón Montes De Oca",
    "url": "https://www.linkedin.com/in/valeria-calder%C3%B3n-montes-de-oca-7a1300190",
    "company": "Publicis Sapient",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Dabramo",
    "url": "https://www.linkedin.com/in/valeria-dabramo-681573145",
    "company": "Soho",
    "position": "Technical Talent Acquisition & People Care Sr",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Delgado",
    "url": "https://www.linkedin.com/in/valeria-delgado-49b464225",
    "company": "Freelance",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Dimotta",
    "url": "https://www.linkedin.com/in/valeria-dimotta-8aa220141",
    "company": "Freelance",
    "position": "IT RECRUITER",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Grillo",
    "url": "https://www.linkedin.com/in/valeria-grillo-54ba7ba3",
    "company": "Accenture",
    "position": "Recruitment Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Kraiselburd",
    "url": "https://www.linkedin.com/in/itrecruiter-valeria-kraiselburd",
    "company": "The Hackett Group Inc.",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Lafuente",
    "url": "https://www.linkedin.com/in/valeria-lafuente-talentacquisitionspecialist",
    "company": "Novacomp",
    "position": "Talent Acquisition Specialist II",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/valeria-rocio-rodriguez",
    "company": "Flexxus",
    "position": "Analista de Selección y RR.HH",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Toro",
    "url": "https://www.linkedin.com/in/valeriatoro",
    "company": "Accenture Argentina",
    "position": "IT Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Valeria",
    "lastName": "Vargas-Machuca Ramírez",
    "url": "https://www.linkedin.com/in/valeriavargasmachuca",
    "company": "Inetum",
    "position": "Head of Talent Acquisition & Development",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Valerie",
    "lastName": "Claros",
    "url": "https://www.linkedin.com/in/valerieclaros-hn",
    "company": "Price Benowitz Accident Injury Lawyers, LLP",
    "position": "Recruitment Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Valsala",
    "lastName": "Jeyaraj",
    "url": "https://www.linkedin.com/in/valsala-jeyaraj-8ab57aab",
    "company": "Verinon",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vandana",
    "lastName": "priya",
    "url": "https://www.linkedin.com/in/vandana-priya-bbb0b7217",
    "company": "Cerebral Works",
    "position": "Senior Executive Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Vanesa",
    "lastName": "Canella",
    "url": "https://www.linkedin.com/in/vanesa-canella",
    "company": "IT Data",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vanesa",
    "lastName": "Geist",
    "url": "https://www.linkedin.com/in/vanesa-geist",
    "company": "Lotus HR",
    "position": "Asistente de Selección de Personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Vanesa",
    "lastName": "Jaleh",
    "url": "https://www.linkedin.com/in/vanesajaleh",
    "company": "Sari Consulting",
    "position": "HR Consultant & Headhunter",
    "keywords": [
      "headhunter"
    ]
  },
  {
    "firstName": "Vanesa",
    "lastName": "Mangione",
    "url": "https://www.linkedin.com/in/vanesamangione",
    "company": "Webstarted",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vanesa",
    "lastName": "Montaldo",
    "url": "https://www.linkedin.com/in/vanesamontaldo",
    "company": "SixSides IT",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vanesa",
    "lastName": "Profeta",
    "url": "https://www.linkedin.com/in/vanesaprofeta",
    "company": "Accenture Argentina",
    "position": "Recruiting Associate en Accenture Argentina",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Vanesa",
    "lastName": "Rinaudo",
    "url": "https://www.linkedin.com/in/vanesarinaudo",
    "company": "LHH",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Vanessa",
    "lastName": "Boscan",
    "url": "https://www.linkedin.com/in/vanessa-boscan-butron",
    "company": "Advanced Medical Solutions",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Vanessa",
    "lastName": "Brito Montilla",
    "url": "https://www.linkedin.com/in/vanessabritomontilla",
    "company": "Remoters.me",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vanessa",
    "lastName": "Garcia",
    "url": "https://www.linkedin.com/in/vanessa-paola-garcia-895645161recruiter",
    "company": "Independiente (freelance)",
    "position": "Especialista en selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Vanessa",
    "lastName": "Paolini Chacin",
    "url": "https://www.linkedin.com/in/vanepaolini",
    "company": "HACK A BOSS",
    "position": "IT Recruitment Operations Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Vanessa",
    "lastName": "Pérez",
    "url": "https://www.linkedin.com/in/vanessa-p%C3%A9rez-2521b3167",
    "company": "NAEZ",
    "position": "IT Recruiter - Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vanessa",
    "lastName": "Romero",
    "url": "https://www.linkedin.com/in/veromero91",
    "company": "Jobsity",
    "position": "Head of Talent Acquisition",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Vanina",
    "lastName": "Bracking",
    "url": "https://www.linkedin.com/in/vanina-bracking-46bb75b6",
    "company": "PlatformX Solutions",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Vanina",
    "lastName": "Orellana",
    "url": "https://www.linkedin.com/in/vanina-orellana",
    "company": "Marsh",
    "position": "Head of People",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Vanina",
    "lastName": "Otero",
    "url": "https://www.linkedin.com/in/vanina-otero-2934ba82",
    "company": "MinData",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vanina",
    "lastName": "Terroni",
    "url": "https://www.linkedin.com/in/vaninat",
    "company": "Witbor",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Vanina Paula",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/vanina-paula-gonzalez-5ba77528",
    "company": "Accenture",
    "position": "HR Program & Operations Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Varun",
    "lastName": "Kumar",
    "url": "https://www.linkedin.com/in/varun-kumar-0500a524",
    "company": "TRC Companies, Inc.",
    "position": "Senior Talent Acquisition Lead - India",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Vera",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/vera-rodriguez",
    "company": "Olé life",
    "position": "People and Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Vera (Vira)",
    "lastName": "Spychka",
    "url": "https://www.linkedin.com/in/veraspichka",
    "company": "Ballast Lane Applications, LLC",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Verena",
    "lastName": "Arpellino",
    "url": "https://www.linkedin.com/in/verena-arpellino",
    "company": "Manage Resources Recursos Humanos",
    "position": "Recruiter IT freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Verona",
    "lastName": "Carmine",
    "url": "https://www.linkedin.com/in/veronacarmine",
    "company": "ALT Consultores",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Veronica",
    "lastName": "Condarco",
    "url": "https://www.linkedin.com/in/vcondarco",
    "company": "Unosquare",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Veronica",
    "lastName": "Contin",
    "url": "https://www.linkedin.com/in/veronica-contin-hr015",
    "company": "Bidcom",
    "position": "Talent, Development & Culture Lead – Tech Specialist",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Veronica Gisele",
    "lastName": "Lang",
    "url": "https://www.linkedin.com/in/veronica-gisele-lang-724986111",
    "company": "Softtek",
    "position": "Talent Attraction | IT Recruiter Jr",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Veronika",
    "lastName": "Solovieva",
    "url": "https://www.linkedin.com/in/veronika-solovieva-3a7483b5",
    "company": "Apply Digital",
    "position": "Talent Lead LATAM",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Almendro",
    "url": "https://www.linkedin.com/in/ver%C3%B3nica-almendro-450197220",
    "company": "Q2 IT Talent Acquisition Specialists. Argentina, Latam, USA & Europe",
    "position": "IT Talent Acquisition Lead | Argentina, Latam, USA, & Europe",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Bálsamo",
    "url": "https://www.linkedin.com/in/veronica-balsamo",
    "company": "HR Manager.",
    "position": "HR Consultant | Talent Acquisition Expert - freelance",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Cosco",
    "url": "https://www.linkedin.com/in/veronica-cosco",
    "company": "InvaRH Consultores",
    "position": "Tech Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Cuellar Mendieta",
    "url": "https://www.linkedin.com/in/ver%C3%B3nica-cuellar-mendieta-4590b6167",
    "company": "Digital Harbor Bolivia",
    "position": "People Care and Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Fernández Elizate",
    "url": "https://www.linkedin.com/in/ver%C3%B3nica-fern%C3%A1ndez-elizate",
    "company": "MAS Global Consulting",
    "position": "Senior Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Llanos",
    "url": "https://www.linkedin.com/in/veronicallanosf",
    "company": "Mistura RH",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Mieres",
    "url": "https://www.linkedin.com/in/vmrrhhconsulting",
    "company": "VM RRHH CONSULTING",
    "position": "HR Lead",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Miranda",
    "url": "https://www.linkedin.com/in/veromiranda1",
    "company": "ITR",
    "position": "IT Talent Acquisition SR",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Ramallo",
    "url": "https://www.linkedin.com/in/veronicaramallo",
    "company": "Editorial Perfil",
    "position": "Human Resources Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "Rueda Miranda",
    "url": "https://www.linkedin.com/in/ver%C3%B3nica-rueda-miranda",
    "company": "CodersLab",
    "position": "Sr. Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Verónica",
    "lastName": "S",
    "url": "https://www.linkedin.com/in/ver%C3%B3nica-s-77165454",
    "company": "Recruiter",
    "position": "Senior IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Verónica Gisel",
    "lastName": "Miranda",
    "url": "https://www.linkedin.com/in/veronicagmiranda",
    "company": "Phorest Salon Software",
    "position": "Talent Acquisition Partner",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Verónica. A",
    "lastName": "Tisera",
    "url": "https://www.linkedin.com/in/licvtisera",
    "company": "NowVertical ES (Formerly CoreBI)",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "VIBIN",
    "lastName": "C.P",
    "url": "https://www.linkedin.com/in/vibin-c-p-21b84830b",
    "company": "Novanex IT consulting",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vicente",
    "lastName": "Barrientos",
    "url": "https://www.linkedin.com/in/vicente-barrientos",
    "company": "Goodwin Recruiting",
    "position": "Recruiting Partner",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Vicky",
    "lastName": "D’Aiuto",
    "url": "https://www.linkedin.com/in/vicky-d%E2%80%99aiuto-2b880785",
    "company": "HD Consultores",
    "position": "Recruiter (IT & Non-IT) | HR Consultant (Freelance)",
    "keywords": [
      "hrbp/business partner",
      "recruiter"
    ]
  },
  {
    "firstName": "Victor",
    "lastName": "Orantes (He/Him)",
    "url": "https://www.linkedin.com/in/victor-orantes-he-him-b4a643219",
    "company": "ManpowerGroup",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Barrera",
    "url": "https://www.linkedin.com/in/victoriabarrerarrhh",
    "company": "SOOFT Technology",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Bernal Rivera",
    "url": "https://www.linkedin.com/in/victoria-bernal-rivera",
    "company": "Xenon arc",
    "position": "Global Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Bidner",
    "url": "https://www.linkedin.com/in/victoria-bidner-549318179",
    "company": "BEON Tech Studio",
    "position": "IT Senior Expert Recruiter & Career Advisor",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Bidner",
    "url": "https://www.linkedin.com/in/victoria-bidner",
    "company": "BEON Tech Studio",
    "position": "IT Senior Expert Recruiter & Career Advisor",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Biscayart",
    "url": "https://www.linkedin.com/in/victoria-biscayart-213b9395",
    "company": "Accenture",
    "position": "Recruiting Specialist",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Blau",
    "url": "https://www.linkedin.com/in/victoriablau",
    "company": "Journi",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Calderaro",
    "url": "https://www.linkedin.com/in/victoria-calderaro-744645152",
    "company": "TÜV Rheinland South America",
    "position": "Sr. Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Charra",
    "url": "https://www.linkedin.com/in/vickycharra",
    "company": "Talent Wind",
    "position": "Founder & Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Ciano",
    "url": "https://www.linkedin.com/in/victoriaciano",
    "company": "Profesional independiente",
    "position": "Global Technical Talent Acquisition Specialist | Startups & High-Growth Companies",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Córdoba",
    "url": "https://www.linkedin.com/in/kunan-talent",
    "company": "KUNAN S.A.",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Doyhenart",
    "url": "https://www.linkedin.com/in/victoria-doyhenart-a785141ba",
    "company": "JPMorganChase",
    "position": "Technology Sourcer & Attraction Associate",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Fernandez",
    "url": "https://www.linkedin.com/in/victoria---",
    "company": "Tether.io",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Fernández",
    "url": "https://www.linkedin.com/in/psico-victoriafernandez",
    "company": "The Flock",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Franco",
    "url": "https://www.linkedin.com/in/victoria-franco-5063551a2",
    "company": "BEON.tech",
    "position": "People and Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Guala",
    "url": "https://www.linkedin.com/in/victoria-guala-42a55b12a",
    "company": "Cloud(x);",
    "position": "Senior Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Illenzer",
    "url": "https://www.linkedin.com/in/victoria-illenzer-a50938203",
    "company": "Staffy",
    "position": "IT Recruiter - Mentora",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Lembo",
    "url": "https://www.linkedin.com/in/victoria-lembo-2582a714a",
    "company": "White Prompt",
    "position": "Senior Technical Recruiter and People Care Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Losada",
    "url": "https://www.linkedin.com/in/victoria-losada-a91094184",
    "company": "G&L Group",
    "position": "People Talent Acquisition Specialist IT Senior",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Maldonado",
    "url": "https://www.linkedin.com/in/victoria-mm",
    "company": "KellyOCG",
    "position": "Recruiting Coordinator",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Muriel",
    "url": "https://www.linkedin.com/in/victoria-muriel-b1ab451a1",
    "company": "Nubiral",
    "position": "IT Talent Acquisition | People & Culture",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Nardi",
    "url": "https://www.linkedin.com/in/victoria-nardi",
    "company": "Grupo Werthein",
    "position": "Selección y Atracción de Talento",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Racedo",
    "url": "https://www.linkedin.com/in/victoria-racedo-a32b1b162",
    "company": "Prediktive",
    "position": "Talent Sourcer Analyst",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Rios Ordoñez",
    "url": "https://www.linkedin.com/in/victoria-rios-ordo%C3%B1ez-57bba913a",
    "company": "Unilever",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Romera",
    "url": "https://www.linkedin.com/in/victoriaromera",
    "company": "peoplepath.io",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Ruarte",
    "url": "https://www.linkedin.com/in/victoriaruarte",
    "company": "Profesional independiente",
    "position": "Recruiter Freelance IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Sarmiento Laspiur",
    "url": "https://www.linkedin.com/in/victoria-sarmiento-laspiur-949993a0",
    "company": "Taller",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Taruselli",
    "url": "https://www.linkedin.com/in/mariavictoriataruselli",
    "company": "BetterEngineer",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Velasco",
    "url": "https://www.linkedin.com/in/vavelasco",
    "company": "Contabilium",
    "position": "Regional People Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Victoria",
    "lastName": "Zambrano",
    "url": "https://www.linkedin.com/in/mvzambrano",
    "company": "Montash",
    "position": "Senior Talent Acquisition & Business",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Victoria Belén",
    "lastName": "Pérez",
    "url": "https://www.linkedin.com/in/victoriaperez29",
    "company": "Sanatorio Cordoba",
    "position": "Administracion de personal y seleccion",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Victória",
    "lastName": "Novello",
    "url": "https://www.linkedin.com/in/victorianovello",
    "company": "Ambush",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Viera",
    "lastName": "G. 🇨🇱 🇺🇸",
    "url": "https://www.linkedin.com/in/viera-galleguillos",
    "company": "ActivePrime",
    "position": "Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Viktoria",
    "lastName": "Bondarenko",
    "url": "https://www.linkedin.com/in/viktoria-bondarenko-60820a3",
    "company": "Svitla Systems, Inc.",
    "position": "Global Recruitment Director",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Viktoria",
    "lastName": "Matveeva",
    "url": "https://www.linkedin.com/in/viktoriyamatveeva",
    "company": "Emphasoft",
    "position": "Recruitment Team Lead",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Vilma",
    "lastName": "Chuquihuanga",
    "url": "https://www.linkedin.com/in/vilmachuquihuanga",
    "company": "Sermaluc",
    "position": "Coordinadora de negocios, reclutamiento y selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Vinay",
    "lastName": "Muchalapuri",
    "url": "https://www.linkedin.com/in/vinay-muchalapuri-a16383149",
    "company": "Kolla Soft Inc",
    "position": "Senior/Lead US IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vinod Kumar",
    "lastName": "(VK)",
    "url": "https://www.linkedin.com/in/vinod-kumar-vk-5033a21a3",
    "company": "Realtek Consulting LLC",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Virginia",
    "lastName": "Bernarte",
    "url": "https://www.linkedin.com/in/virginiabernarte",
    "company": "Rooftop",
    "position": "IT Talent Acquisition Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Virginia",
    "lastName": "Castro",
    "url": "https://www.linkedin.com/in/virginia-castro",
    "company": "OCP TECH",
    "position": "Responsable de Selección para la Región",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Virginia",
    "lastName": "Molina",
    "url": "https://www.linkedin.com/in/virginia-molina-b35728b4",
    "company": "MobyDigital",
    "position": "Service Delivery Manager & Talent Partner",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Virginia",
    "lastName": "Ojeda",
    "url": "https://www.linkedin.com/in/mariavirginiaojeda",
    "company": "Toolbox",
    "position": "Jr. IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Virginia",
    "lastName": "Paynter",
    "url": "https://www.linkedin.com/in/virginia-paynter-661996214",
    "company": "Cecilia Presenza y Equipo",
    "position": "Freelance Talent Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Virginia",
    "lastName": "Yánez Saad",
    "url": "https://www.linkedin.com/in/virginia-y%C3%A1nez-saad",
    "company": "ITPS ONE",
    "position": "Senior IT Talent Acquisition | Client Consulting",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Viridiana",
    "lastName": "Campos",
    "url": "https://www.linkedin.com/in/viridiana-campos",
    "company": "Tight Line",
    "position": "Sourcer/ IT recruiter",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "Vita",
    "lastName": "Mygalyk",
    "url": "https://www.linkedin.com/in/vita-mygalyk",
    "company": "DataArt",
    "position": "Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Vita",
    "lastName": "Novoseltseva",
    "url": "https://www.linkedin.com/in/vita-novoseltseva",
    "company": "GoMining",
    "position": "Recruiter/ HR",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Vivian",
    "lastName": "Alves Gomes",
    "url": "https://www.linkedin.com/in/vivian-alves-gomes-",
    "company": "INTERA",
    "position": "Tech Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Viviana",
    "lastName": "Corea",
    "url": "https://www.linkedin.com/in/viviana-m-corea-001800233",
    "company": "Serendipia Consultora",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Viviana",
    "lastName": "Magallón",
    "url": "https://www.linkedin.com/in/viviana-magall%C3%B3n-5a9370130",
    "company": "Enroute",
    "position": "Sr IT Recruiter Specialist",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Viviana N.",
    "lastName": "Dominguez",
    "url": "https://www.linkedin.com/in/viviana-n-dominguez-62a68ab",
    "company": "consultor independiente",
    "position": "IT Recruiter - Freelance",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Víctor",
    "lastName": "Díaz",
    "url": "https://www.linkedin.com/in/v%C3%ADctor-d%C3%ADaz-23a412a5",
    "company": "Flux IT",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Wendy",
    "lastName": "Saltos Macías",
    "url": "https://www.linkedin.com/in/wendy-saltos",
    "company": "CDA Informática",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Werben HR",
    "lastName": "LLC",
    "url": "https://www.linkedin.com/in/werben-hr-llc-8166761ba",
    "company": "Werben HR",
    "position": "LATAM & Argentina Lead Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "William",
    "lastName": "Tribess",
    "url": "https://www.linkedin.com/in/william-tribess",
    "company": "K&K Talents",
    "position": "Team Lead of International Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Wladimir",
    "lastName": "Toro Trobok",
    "url": "https://www.linkedin.com/in/wladimir-toro-trobok-66514450",
    "company": "METRICA Chile",
    "position": "IT Talent Acquisition Specialist / Reclutador TI Senior",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "WorkWhise",
    "lastName": "­",
    "url": "https://www.linkedin.com/in/workwhise-a87784106",
    "company": "WorkWhise",
    "position": "Talent Recruiter HHRR",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ximena",
    "lastName": "Durán Correa",
    "url": "https://www.linkedin.com/in/ximenadc",
    "company": "FTO",
    "position": "Human Resources Project Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Ximena",
    "lastName": "Pane Rojas",
    "url": "https://www.linkedin.com/in/ximeprojas",
    "company": "Ah! Consultora en Selección IT",
    "position": "Recruiter IT.",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ximena",
    "lastName": "Ramos Arioni",
    "url": "https://www.linkedin.com/in/ximena-ramos-arioni-050a85b0",
    "company": "Endava",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ximena",
    "lastName": "Ubellart",
    "url": "https://www.linkedin.com/in/ximenaubellart",
    "company": "Bondy",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yamila",
    "lastName": "Casagrande Abiricha",
    "url": "https://www.linkedin.com/in/yamila-casagrande-abiricha",
    "company": "AccelRH",
    "position": "Responsable de reclutamiento y selección de personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Yamila",
    "lastName": "Gamietea",
    "url": "https://www.linkedin.com/in/yamila-gamietea-209a4454",
    "company": "Artax Advisors",
    "position": "Talent Acquisition & Culture Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yamila",
    "lastName": "Greco",
    "url": "https://www.linkedin.com/in/yamila-greco-a9a281172",
    "company": "Techunting.net",
    "position": "Talent Acquisition Manager & Corporate Culture",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yamila",
    "lastName": "Puleo",
    "url": "https://www.linkedin.com/in/yamila-puleo",
    "company": "Frigorifico Rioplatense",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Yamila",
    "lastName": "Quinteros",
    "url": "https://www.linkedin.com/in/yamila-q-74630a157",
    "company": "Find•Tec",
    "position": "Talent Acquisition Manager",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Yamila",
    "lastName": "Ranieri",
    "url": "https://www.linkedin.com/in/yamila-ranieri-a196a44a",
    "company": "Frávega Tech",
    "position": "Talent Acquisition Lead & People Partner",
    "keywords": [
      "talent acquisition",
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Yamila",
    "lastName": "Smith, SHRM-CP",
    "url": "https://www.linkedin.com/in/yamilalanzillotti",
    "company": "CompScience",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Yamila",
    "lastName": "Vallejo",
    "url": "https://www.linkedin.com/in/yamilavallejo",
    "company": "Qualitest",
    "position": "Talent Acquisition Team Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Yamila Belen",
    "lastName": "Lentini",
    "url": "https://www.linkedin.com/in/yamila-belen-lentini-385576112",
    "company": "Personal",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Yanci",
    "lastName": "Perez",
    "url": "https://www.linkedin.com/in/yanciperez",
    "company": "GoFasti",
    "position": "Talent Acquisition",
    "keywords": [
      "sourcer",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yanina",
    "lastName": "De Canio",
    "url": "https://www.linkedin.com/in/yanina-de-canio-40331079",
    "company": "ConecSI",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yanina",
    "lastName": "Martin",
    "url": "https://www.linkedin.com/in/yanimartin",
    "company": "Harness",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Yanina",
    "lastName": "Passarelli",
    "url": "https://www.linkedin.com/in/yanina-passarelli-96b128230",
    "company": "Manage Resources - España",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Yanina",
    "lastName": "Silvero",
    "url": "https://www.linkedin.com/in/yanina-silvero-2900b9111",
    "company": "Accenture",
    "position": "Talent Connector - Head Hunting Senior Analyst",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Yara",
    "lastName": "Pandolfo",
    "url": "https://www.linkedin.com/in/yara-pandolfo-308804236",
    "company": "Western Union",
    "position": "Recruiter - Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yazmin",
    "lastName": "Hassan",
    "url": "https://www.linkedin.com/in/yazmin-hassan-96636660",
    "company": "HR Oasis",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Yazmín",
    "lastName": "Muller",
    "url": "https://www.linkedin.com/in/yazm%C3%ADn-muller-5870a354",
    "company": "TransPerfect",
    "position": "Team Lead AI Recruitment",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Yeiseth",
    "lastName": "Coronil 🔎",
    "url": "https://www.linkedin.com/in/yeiseth-c-62b49a15b",
    "company": "Interfell",
    "position": "IT Talent Sourcer",
    "keywords": [
      "sourcer"
    ]
  },
  {
    "firstName": "Yelyzaveta",
    "lastName": "Androsova",
    "url": "https://www.linkedin.com/in/yelyzaveta-androsova-b14048378",
    "company": "dexola",
    "position": "Technical Recruiting Manager",
    "keywords": [
      "recruiting/recruitment",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Yesenia",
    "lastName": "Valencia",
    "url": "https://www.linkedin.com/in/yeseniavalenciay",
    "company": "Selectia",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Yesica",
    "lastName": "dos Santos",
    "url": "https://www.linkedin.com/in/yesicadossantos-recruiter",
    "company": "ELSA Consulting",
    "position": "Global Talent Acquisition | IT & Sales Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yesica",
    "lastName": "Moreno",
    "url": "https://www.linkedin.com/in/yesica-moreno-paredes",
    "company": "1950Labs",
    "position": "Talent Acquisition IT| Talent Attraction | IT Recruiter",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yesica",
    "lastName": "Soveron",
    "url": "https://www.linkedin.com/in/yesisoveron",
    "company": "InvGate",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Yndira",
    "lastName": "Rivodo",
    "url": "https://www.linkedin.com/in/yndira-rivodo",
    "company": "Find Me",
    "position": "Consultora en Selección / Selectora IT / IT Recruiter",
    "keywords": [
      "recruiter",
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "Yoana",
    "lastName": "Barreto",
    "url": "https://www.linkedin.com/in/yoana-barreto-966006225",
    "company": "Freelance",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yordanis",
    "lastName": "Chirino",
    "url": "https://www.linkedin.com/in/yordanis-chirino",
    "company": "skillhunters",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Yoselin",
    "lastName": "López Díaz",
    "url": "https://www.linkedin.com/in/yoselin-l%C3%B3pez-d%C3%ADaz-78702622",
    "company": "Synapse",
    "position": "Global Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yoshara",
    "lastName": "Sosa",
    "url": "https://www.linkedin.com/in/yoshara-sosa-a28890181",
    "company": "Free lance",
    "position": "IT RECRUITER",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Yoss.",
    "lastName": "Guevara",
    "url": "https://www.linkedin.com/in/yossguevara",
    "company": "Kavak.com",
    "position": "Talent Acquisition Central",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yuki",
    "lastName": "Tan",
    "url": "https://www.linkedin.com/in/yuki-tan-hr",
    "company": "fourtitude.asia",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Yulia",
    "lastName": "Asfoura Assaff",
    "url": "https://www.linkedin.com/in/yulia-asfoura-assaff",
    "company": "Mandala Tech",
    "position": "Recruiter IT | Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yulia",
    "lastName": "Mago",
    "url": "https://www.linkedin.com/in/yulia-mago-547052213",
    "company": "IT Hiring Central",
    "position": "Sr. IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Yulia",
    "lastName": "Mago Gil",
    "url": "https://www.linkedin.com/in/yulia-mago",
    "company": "M&G Consulting HR",
    "position": "IT Recruiting Sourcer Ssr LATAM (Profesional independiente)",
    "keywords": [
      "recruiting/recruitment",
      "sourcer"
    ]
  },
  {
    "firstName": "Yuliia",
    "lastName": "Kasianova",
    "url": "https://www.linkedin.com/in/yuliia-kasianova",
    "company": "Svitla Systems, Inc.",
    "position": "Senior International Talent Acquisition Consultant",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yuliia",
    "lastName": "Yushchenko",
    "url": "https://www.linkedin.com/in/yuliia-yushchenko-a15320223",
    "company": "Brainy Agency",
    "position": "Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Yuliya",
    "lastName": "Korzhovnik",
    "url": "https://www.linkedin.com/in/yuliya-korzhovnik",
    "company": "P2P.org",
    "position": "Senior Talent Acquisition Partner (Executive search focus)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yurmer Alejandra",
    "lastName": "Jiménez",
    "url": "https://www.linkedin.com/in/yurmeralejandra",
    "company": "Yummy",
    "position": "HRBP",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "Yvanna",
    "lastName": "Franco",
    "url": "https://www.linkedin.com/in/yvannafranco",
    "company": "RHT",
    "position": "Head Of Talent Acquisition | Business Partner & IT Talent Acquisition Leader",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "Yvonne",
    "lastName": "Bonnet",
    "url": "https://www.linkedin.com/in/ybonnet",
    "company": "Resilient Co.",
    "position": "Co-Founder & Global Talent Director | Strategic Hiring for Tech & Digital (EMEA, US & LATAM)",
    "keywords": [
      "hiring",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Zamantha",
    "lastName": "Chavez 🩷🌈🐱",
    "url": "https://www.linkedin.com/in/zamiicho",
    "company": "Lantern Sol",
    "position": "Global People & Culture Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Zaza",
    "lastName": "Nuredwina",
    "url": "https://www.linkedin.com/in/zaza-nuredwina-5086a99b",
    "company": "Nokia",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Zhanna",
    "lastName": "Diachenko",
    "url": "https://www.linkedin.com/in/zhanna-diachenko",
    "company": "EPAM Systems",
    "position": "Senior Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Zoila",
    "lastName": "Zelada Guevara",
    "url": "https://www.linkedin.com/in/zoiizelada",
    "company": "DriveTalent",
    "position": "Talent Manager",
    "keywords": [
      "people/talent leadership"
    ]
  },
  {
    "firstName": "Zully",
    "lastName": "Torres",
    "url": "https://www.linkedin.com/in/zully-t-8351aa18",
    "company": "freelance",
    "position": "IT Recruiter Freelance | Talent Acquisition",
    "keywords": [
      "recruiter",
      "talent acquisition"
    ]
  },
  {
    "firstName": "~ Ma Victoria",
    "lastName": "Juncos",
    "url": "https://www.linkedin.com/in/victoriajuncos",
    "company": "Accenture Argentina",
    "position": "Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "~ Melisa Gisel",
    "lastName": "Gimenez",
    "url": "https://www.linkedin.com/in/%7E-melisa-gisel-gimenez-01376634",
    "company": "TGV",
    "position": "Lider de Equipo de Reclutamiento IT Argentina",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "~Adriana",
    "lastName": "Civitate",
    "url": "https://www.linkedin.com/in/%7Eadriana-civitate-",
    "company": "CONEXIONHR - Recruiting Company",
    "position": "Tech Recruiter & Headhunter",
    "keywords": [
      "recruiter",
      "headhunter"
    ]
  },
  {
    "firstName": "~Agustina",
    "lastName": "Sanchez",
    "url": "https://www.linkedin.com/in/agustinasanchezrrhh",
    "company": "Accenture",
    "position": "Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "~Ileana",
    "lastName": "Zambrano",
    "url": "https://www.linkedin.com/in/%7Eileana-zambrano-b09389134",
    "company": "Ovidio IT Consulting",
    "position": "IT Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "~Karina",
    "lastName": "Folgueira",
    "url": "https://www.linkedin.com/in/karinafolgueira",
    "company": "Lighthouse Smart S.A.",
    "position": "Talent Acquisition Coordinator",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "~Luciano Francisco",
    "lastName": "Costa",
    "url": "https://www.linkedin.com/in/%7Eluciano-francisco-costa-02683920b",
    "company": "Profesional Independiente",
    "position": "IT Recruiter y Generalista | Español & Inglés",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "~Marcos",
    "lastName": "Tiani",
    "url": "https://www.linkedin.com/in/%7Emarcos-t-3237ab17b",
    "company": "Galicia Seguros",
    "position": "Analista de Empleos Sr - Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "~Patricia",
    "lastName": "Ferrari",
    "url": "https://www.linkedin.com/in/%7Epatricia-ferrari-607959175",
    "company": "Freelance (Self employed)",
    "position": "Global Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "»Gastón J.",
    "lastName": "Rodriguez",
    "url": "https://www.linkedin.com/in/gaston-j-rodriguez",
    "company": "Grid Dynamics",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "»Patricia",
    "lastName": "Fernández",
    "url": "https://www.linkedin.com/in/%C2%BBpatricia-fern%C3%A1ndez-b16668199",
    "company": "Atos",
    "position": "IT Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Álvaro",
    "lastName": "Ipucha",
    "url": "https://www.linkedin.com/in/alvaroipucha",
    "company": "Nexton",
    "position": "Technical Recruiting Analyst",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Álvaro",
    "lastName": "Vega Galán",
    "url": "https://www.linkedin.com/in/%C3%A1lvaro-vega-gal%C3%A1n-41b28b211",
    "company": "IZERTIS",
    "position": "IT Recruitment Consultant",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "Ángel",
    "lastName": "Armas",
    "url": "https://www.linkedin.com/in/angelarm5",
    "company": "PSRH Consulting. Digital Headhunting.",
    "position": "Information Technology Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "Ángel",
    "lastName": "Jorge Zoyo",
    "url": "https://www.linkedin.com/in/%C3%A1ngel-jorge-zoyo-261051b6",
    "company": "Prodware",
    "position": "IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Ángel Luis",
    "lastName": "Martínez Ortega",
    "url": "https://www.linkedin.com/in/%C3%A1ngel-luis-mart%C3%ADnez-ortega-8767a8127",
    "company": "UST",
    "position": "Senior IT Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "Катерина",
    "lastName": "Браницька",
    "url": "https://www.linkedin.com/in/%D0%BA%D0%B0%D1%82%D0%B5%D1%80%D0%B8%D0%BD%D0%B0-%D0%B1%D1%80%D0%B0%D0%BD%D0%B8%D1%86%D1%8C%D0%BA%D0%B0-5158271b8",
    "company": "Software Rocket",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "⋆Fer",
    "lastName": "Ogni⋆",
    "url": "https://www.linkedin.com/in/mariafernandaogni",
    "company": "BUSIT ARGENTINA",
    "position": "Tech Recruitment Specialist & Strategic Partner",
    "keywords": [
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "─ Simon",
    "lastName": "Tablante",
    "url": "https://www.linkedin.com/in/stablante",
    "company": "BA Global Talent",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "▪Patricia",
    "lastName": "Alvarez Araya▪",
    "url": "https://www.linkedin.com/in/patricia-alvarez-araya",
    "company": "Freelance",
    "position": "Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "◦ Debora",
    "lastName": "Pardo ◦",
    "url": "https://www.linkedin.com/in/debpardo",
    "company": "Gather HR",
    "position": "Recruiter & HR Analyst",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "◼ Daiana",
    "lastName": "Barroso",
    "url": "https://www.linkedin.com/in/daiana-barroso99",
    "company": "Hutrit",
    "position": "Freelance IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "★ Aylén D.",
    "lastName": "Moure",
    "url": "https://www.linkedin.com/in/aylenmoure",
    "company": "Infocus",
    "position": "IT Recruiting Manager & People Care",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "★ Christian",
    "lastName": "Rozen ★",
    "url": "https://www.linkedin.com/in/christian-rozen",
    "company": "Smart Hunters",
    "position": "Recruitment Lead",
    "keywords": [
      "people/talent leadership",
      "recruiting/recruitment"
    ]
  },
  {
    "firstName": "★ Lic.Romina",
    "lastName": "Cuiuli",
    "url": "https://www.linkedin.com/in/rominacuiuli",
    "company": "ITR",
    "position": "Talent Acquisition Lead",
    "keywords": [
      "people/talent leadership",
      "talent acquisition"
    ]
  },
  {
    "firstName": "★ Maria Luz",
    "lastName": "Casco",
    "url": "https://www.linkedin.com/in/marialuzcasco",
    "company": "Nosis",
    "position": "HR Business Partner",
    "keywords": [
      "hrbp/business partner"
    ]
  },
  {
    "firstName": "★ María Delfina",
    "lastName": "Rivolta",
    "url": "https://www.linkedin.com/in/drivolta",
    "company": "IT Resources S.A",
    "position": "Senior Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "★ Solange",
    "lastName": "Bulacio",
    "url": "https://www.linkedin.com/in/%E2%98%85solange-bulacio",
    "company": "Rootstrap",
    "position": "Talent Acquisition",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "★Lic.Mariana Fredzia",
    "lastName": "Pelaez",
    "url": "https://www.linkedin.com/in/marianafredziapelaez",
    "company": "EPAM Systems",
    "position": "IT Talent Acquisition Team Lead",
    "keywords": [
      "talent acquisition",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "★María Virginia",
    "lastName": "Quinteros",
    "url": "https://www.linkedin.com/in/mariavirginiaquinteros",
    "company": "Minimalart",
    "position": "Human Resources Manager | HRBP",
    "keywords": [
      "hrbp/business partner",
      "people/talent leadership"
    ]
  },
  {
    "firstName": "★Romina",
    "lastName": "Simkin",
    "url": "https://www.linkedin.com/in/romina-simkin-hr-manager",
    "company": "Asap Consulting S.A.",
    "position": "Gerente Recursos Humanos | Coordinación de Selección, Capacitación y Desarrollo |",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "★Vanesa",
    "lastName": "Salto",
    "url": "https://www.linkedin.com/in/%E2%98%85vanesa-salto-a3b6184",
    "company": "DevBase",
    "position": "Senior IT Recruiter & HRBP",
    "keywords": [
      "hrbp/business partner",
      "recruiter"
    ]
  },
  {
    "firstName": "★Yanina",
    "lastName": "Kallmann",
    "url": "https://www.linkedin.com/in/yaninakallmann",
    "company": "Asap Consulting S.A.",
    "position": "People Experience & Recruiter IT",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "♡ Magdalena",
    "lastName": "Claramunt",
    "url": "https://www.linkedin.com/in/magdalena-claramunt",
    "company": "Freelancer",
    "position": "Recruiter · Team Assistant · Event & Project Coordinator",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "✦Krissbey",
    "lastName": "Marrugo",
    "url": "https://www.linkedin.com/in/krissbey-marrugo",
    "company": "Tether.io",
    "position": "Senior Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "✪ Natalia",
    "lastName": "Trullenque",
    "url": "https://www.linkedin.com/in/natalia-trullenque",
    "company": "Grupo Gestión",
    "position": "Analista de Selección de Personal",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "✭ Matilde",
    "lastName": "Mercado",
    "url": "https://www.linkedin.com/in/matilde-mercado-mcmc",
    "company": "Oportunidades Lab IT",
    "position": "IT Freelance Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "➽ Lorena",
    "lastName": "Bincaz",
    "url": "https://www.linkedin.com/in/lorenabincaz",
    "company": "LoreAn RyS - Reclutamiento y Selección",
    "position": "Hiring Manager",
    "keywords": [
      "hiring"
    ]
  },
  {
    "firstName": "⭐Rocio",
    "lastName": "Puchuri",
    "url": "https://www.linkedin.com/in/rocio-puchuri",
    "company": "Inetum",
    "position": "Technical Talent Acquisition Specialist (Maternity Leave Cover)",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "🌟 Andrea",
    "lastName": "Videla Pietrasanta 💫",
    "url": "https://www.linkedin.com/in/andrea-belen-videla-pietrasanta-",
    "company": "Bartucci & Pantarotto - Búsqueda y Desarrollo de Talentos",
    "position": "Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "🍀Milagros",
    "lastName": "Sequera",
    "url": "https://www.linkedin.com/in/milagrossequera",
    "company": "Swiss Medical",
    "position": "Analista de Reclutamiento & Selección",
    "keywords": [
      "seleccion/reclutamiento"
    ]
  },
  {
    "firstName": "🏄🏽‍♂️ Raul",
    "lastName": "De la Mota (DevRev)",
    "url": "https://www.linkedin.com/in/delamota",
    "company": "DevRev",
    "position": "Sr. Talent Sourcer/Recruiter (GTM | Engineering | Corporate)",
    "keywords": [
      "recruiter",
      "sourcer"
    ]
  },
  {
    "firstName": "🐈Mayra",
    "lastName": "López Garay",
    "url": "https://www.linkedin.com/in/mayralgaray",
    "company": "CodersLink Talent",
    "position": "Technical Talent Acquisition Specialist",
    "keywords": [
      "talent acquisition"
    ]
  },
  {
    "firstName": "🐥 Paola",
    "lastName": "Gonzalez",
    "url": "https://www.linkedin.com/in/paoedithgonzalez",
    "company": "DataArt",
    "position": "Technical Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "👩🏻‍💻Yoana",
    "lastName": "Diaz",
    "url": "https://www.linkedin.com/in/yoana-natali-diaz",
    "company": "Kelsus, Inc.",
    "position": "IT Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "🚀 Laura",
    "lastName": "Lucena",
    "url": "https://www.linkedin.com/in/lucenalaura",
    "company": "Accenture",
    "position": "Senior IT Recruiter (México y Chile)",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "🚀 Luis Federico",
    "lastName": "Maček",
    "url": "https://www.linkedin.com/in/luismacek",
    "company": "NerdRabbit",
    "position": "Cloud Recruiter",
    "keywords": [
      "recruiter"
    ]
  },
  {
    "firstName": "🚀👽 Rob",
    "lastName": "Márquez",
    "url": "https://www.linkedin.com/in/%F0%9F%9A%80%F0%9F%91%BD-rob-m%C3%A1rquez-0b7207a5",
    "company": "Mobiik",
    "position": "IT Talent Acquisition Analyst",
    "keywords": [
      "talent acquisition"
    ]
  }
];
